/*
@license

dhtmlxSpreadsheet v.4.1.3 Professional

This software can be used only as part of dhtmlx.com site.
You are not allowed to use it on any other site

(c) XB Software.

*/
if (window.dhx && (window.dhx_legacy = dhx, delete window.dhx), function (t, e) {
    "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.dhx = e() : t.dhx = e()
}(window, function () {
    return n = {}, o.m = i = [function (t, o, n) {
        "use strict";
        (function (t) {
            Object.defineProperty(o, "__esModule", {value: !0});
            var e = n(84);

            function i(i) {
                function e(t) {
                    var e = t.el.offsetHeight, t = t.el.offsetWidth;
                    i(t, e)
                }

                var n = window.ResizeObserver;
                return n ? o.el("div.dhx-resize-observer", {
                    _hooks: {
                        didInsert: function (t) {
                            new n(function () {
                                return e(t)
                            }).observe(t.el)
                        }
                    }
                }) : o.el("iframe.dhx-resize-observer", {
                    _hooks: {
                        didInsert: function (t) {
                            t.el.contentWindow.onresize = function () {
                                return e(t)
                            }, e(t)
                        }
                    }
                })
            }

            o.el = e.defineElement, o.sv = e.defineSvgElement, o.view = e.defineView, o.create = e.createView, o.inject = e.injectView, o.KEYED_LIST = e.KEYED_LIST, o.disableHelp = function () {
                e.DEVMODE.mutations = !1, e.DEVMODE.warnings = !1, e.DEVMODE.verbose = !1, e.DEVMODE.UNKEYED_INPUT = !1
            }, o.resizer = i, o.resizeHandler = function (t, e) {
                return o.create({
                    render: function () {
                        return i(e)
                    }
                }).mount(t)
            }, o.awaitRedraw = function () {
                return new t(function (t) {
                    requestAnimationFrame(function () {
                        t()
                    })
                })
            }
        }).call(this, n(9))
    }, function (t, e, i) {
        "use strict";
        var o = this && this.__assign || function () {
            return (o = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(2), r = (new Date).valueOf();
        e.uid = function () {
            return "u" + r++
        }, e.extend = function t(e, i, n) {
            if (void 0 === n && (n = !0), i) for (var o in i) {
                var r = i[o], s = e[o];
                void 0 === r ? delete e[o] : !n || "object" != typeof s || s instanceof Date || s instanceof Array ? e[o] = r : t(s, r)
            }
            return e
        }, e.copy = function (t, e) {
            var i, n = {};
            for (i in t) e && i.startsWith("$") || (n[i] = t[i]);
            return n
        }, e.naturalSort = function (t) {
            return t.sort(function (t, e) {
                return "string" == typeof t ? t.localeCompare(e) : t - e
            })
        }, e.findIndex = function (t, e) {
            for (var i = t.length, n = 0; n < i; n++) if (e(t[n])) return n;
            return -1
        }, e.isEqualString = function (t, e) {
            if (t = t.toString(), e = e.toString(), t.length > e.length) return !1;
            for (var i = 0; i < t.length; i++) if (t[i].toLowerCase() !== e[i].toLowerCase()) return !1;
            return !0
        }, e.singleOuterClick = function (e) {
            var i = function (t) {
                e(t) && document.removeEventListener("click", i)
            };
            document.addEventListener("click", i)
        }, e.detectWidgetClick = function (e, i) {
            function t(t) {
                return i(n.locate(t, "dhx_widget_id") === e)
            }

            return document.addEventListener("click", t), function () {
                return document.removeEventListener("click", t)
            }
        }, e.unwrapBox = function (t) {
            return Array.isArray(t) ? t[0] : t
        }, e.wrapBox = function (t) {
            return Array.isArray(t) ? t : [t]
        }, e.isDefined = function (t) {
            return null != t
        }, e.range = function (t, e) {
            if (e < t) return [];
            for (var i = []; t <= e;) i.push(t++);
            return i
        }, e.isNumeric = function (t) {
            return !isNaN(t - parseFloat(t))
        }, e.downloadFile = function (t, e, i) {
            void 0 === i && (i = "text/plain");
            var n, o, i = new Blob([t], {type: i});
            window.navigator.msSaveOrOpenBlob ? window.navigator.msSaveOrOpenBlob(i, e) : (n = document.createElement("a"), o = URL.createObjectURL(i), n.href = o, n.download = e, document.body.appendChild(n), n.click(), setTimeout(function () {
                document.body.removeChild(n), window.URL.revokeObjectURL(o)
            }, 0))
        }, e.debounce = function (o, r, s) {
            var a;
            return function () {
                for (var t = this, e = [], i = 0; i < arguments.length; i++) e[i] = arguments[i];
                var n = s && !a;
                clearTimeout(a), a = setTimeout(function () {
                    a = null, s || o.apply(t, e)
                }, r), n && o.apply(this, e)
            }
        }, e.compare = function t(e, i) {
            for (var n in e) {
                if (e.hasOwnProperty(n) !== i.hasOwnProperty(n)) return !1;
                switch (typeof e[n]) {
                    case"object":
                        if (!t(e[n], i[n])) return !1;
                        break;
                    case"function":
                        if (void 0 === i[n] || "compare" !== n && e[n].toString() !== i[n].toString()) return !1;
                        break;
                    default:
                        if (e[n] !== i[n]) return !1
                }
            }
            for (var n in i) if (void 0 === e[n]) return !1;
            return !0
        }, e.isType = function (t) {
            return ((Object.prototype.toString.call(t).match(/^\[object (\S+?)\]$/) || [])[1] || "undefined").toLowerCase()
        }, e.isEmptyObj = function (t) {
            for (var e in t) return !1;
            return !0
        }, e.getMaxArrayNymber = function (t) {
            if (t.length) {
                for (var e = -1 / 0, i = 0, n = t.length; i < n; i++) t[i] > e && (e = t[i]);
                return e
            }
        }, e.getMinArrayNymber = function (t) {
            if (t.length) {
                for (var e = 1 / 0, i = 0, n = t.length; i < n; i++) t[i] < e && (e = t[i]);
                return e
            }
        }, e.getStringWidth = function (t, e) {
            e = o({font: "normal 14px Roboto", lineHeight: 20}, e);
            var i = document.createElement("canvas"), n = i.getContext("2d");
            e.font && (n.font = e.font);
            t = n.measureText(t).width;
            return i.remove(), t
        }
    }, function (t, e, i) {
        "use strict";
        var c = this && this.__assign || function () {
            return (c = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };

        function n(t, e, i) {
            for (void 0 === e && (e = "dhx_id"), void 0 === i && (i = "target"), t instanceof Event && (t = t[i]); t;) {
                if (t.getAttribute && t.getAttribute(e)) return t;
                t = t.parentNode
            }
        }

        Object.defineProperty(e, "__esModule", {value: !0}), e.toNode = function (t) {
            return "string" == typeof t ? document.getElementById(t) || document.querySelector(t) || document.body : t || document.body
        }, e.eventHandler = function (s, a, l) {
            var c = Object.keys(a);
            return function (t) {
                var e = s(t);
                if (void 0 !== e) {
                    var i = t.target;
                    t:for (; i;) {
                        var n = i.getAttribute && i.getAttribute("class") || "";
                        if (n.length) for (var o = n.split(" "), r = 0; r < c.length; r++) if (o.includes(c[r])) {
                            if (!1 === a[c[r]](t, e)) return !1;
                            break t
                        }
                        i = i.parentNode
                    }
                }
                return l && l(t), !0
            }
        }, e.locateNode = n, e.locate = function (t, e) {
            return void 0 === e && (e = "dhx_id"), (t = n(t, e)) ? t.getAttribute(e) : ""
        }, e.locateNodeByClassName = function (t, e) {
            for (t instanceof Element || (t = t.target); t;) {
                if (e) {
                    if (t.classList && t.classList.contains(e)) return t
                } else if (t.getAttribute && t.getAttribute("dhx_id")) return t;
                t = t.parentNode
            }
        }, e.getBox = function (t) {
            var e = t.getBoundingClientRect(), i = document.body, n = window.pageYOffset || i.scrollTop,
                t = window.pageXOffset || i.scrollLeft;
            return {
                top: e.top + n,
                left: e.left + t,
                right: i.offsetWidth - e.right,
                bottom: i.offsetHeight - e.bottom,
                width: e.right - e.left,
                height: e.bottom - e.top
            }
        };
        var o = -1;

        function r(t) {
            t = t.getBoundingClientRect();
            return {
                left: t.left + window.pageXOffset,
                right: t.right + window.pageXOffset,
                top: t.top + window.pageYOffset,
                bottom: t.bottom + window.pageYOffset
            }
        }

        function u() {
            return {
                rightBorder: window.pageXOffset + window.innerWidth,
                bottomBorder: window.pageYOffset + window.innerHeight
            }
        }

        function l(t, e) {
            var i, n, o, r = u(), s = r.rightBorder, a = r.bottomBorder - t.bottom - e.height, l = t.top - e.height;
            if ("bottom" === e.mode ? 0 <= a ? i = t.bottom : 0 <= l && (i = l) : 0 <= l ? i = l : 0 <= a && (i = t.bottom), a < 0 && l < 0) {
                if (e.auto) return d(t, c(c({}, e), {mode: "right", auto: !1}));
                i = l < a ? t.bottom : l
            }
            return {
                left: e.centering ? (n = t, o = e.width, r = s, a = (o - (n.right - n.left)) / 2, l = n.left - a, a = n.right + a, 0 <= l && a <= r ? l : l < 0 ? 0 : r - o) : (s = s - t.left - e.width, e = t.right - e.width, 0 <= s || !(0 <= e) && s < e ? t.left : e),
                top: i
            }
        }

        function d(t, e) {
            var i, n, o = u(), r = o.rightBorder, s = o.bottomBorder, a = r - t.right - e.width, o = t.left - e.width;
            if ("right" === e.mode ? 0 <= a ? n = t.right : 0 <= o && (n = o) : 0 <= o ? n = o : 0 <= a && (n = t.right), o < 0 && a < 0) {
                if (e.auto) return l(t, c(c({}, e), {mode: "bottom", auto: !1}));
                n = a < o ? o : t.right
            }
            return {
                left: n,
                top: e.centering ? (a = t, i = e.height, o = r, n = (i - (a.bottom - a.top)) / 2, r = a.top - n, n = a.bottom + n, 0 <= r && n <= o ? r : r < 0 ? 0 : o - i) : (i = t.bottom - e.height, !(0 <= (e = s - t.top - e.height)) && (0 < i || e < i) ? i : t.top)
            }
        }

        function s(t, e) {
            var i = ("bottom" === e.mode || "top" === e.mode ? l : d)(t, e), t = i.left, i = i.top;
            return {
                left: Math.round(t) + "px",
                top: Math.round(i) + "px",
                minWidth: Math.round(e.width) + "px",
                position: "absolute"
            }
        }

        e.getScrollbarWidth = function () {
            if (-1 < o) return o;
            var t = document.createElement("div");
            return document.body.appendChild(t), t.style.cssText = "position: absolute;left: -99999px;overflow:scroll;width: 100px;height: 100px;", o = t.offsetWidth - t.clientWidth, document.body.removeChild(t), o
        }, e.isIE = function () {
            var t = window.navigator.userAgent;
            return t.includes("MSIE ") || t.includes("Trident/")
        }, e.isSafari = function () {
            function t(t) {
                return t.test(window.navigator.userAgent)
            }

            var e = t(/Chrome/), i = t(/Firefox/);
            return !e && !i && t(/Safari/)
        }, e.getRealPosition = r, e.calculatePosition = s, e.fitPosition = function (t, e) {
            return s(r(t), e)
        }, e.getPageCss = function () {
            for (var t = [], e = 0; e < document.styleSheets.length; e++) for (var i = document.styleSheets[e], n = ("cssRules" in i ? i.cssRules : i.rules), o = 0; o < n.length; o++) {
                var r = n[o];
                "cssText" in r ? t.push(r.cssText) : t.push(r.selectorText + " {\n" + r.style.cssText + "\n}\n")
            }
            return t.join("\n")
        }, e.getLabelStyle = function (t) {
            var e = t.helpMessage, i = t.type, n = t.labelWidth, o = t.label, r = n && n.toString().startsWith("0"),
                t = "text" !== i && t.required;
            return !!(e || t || !(!o || o && r) || n && !r) && {
                style: (o || n) && !r && {
                    width: n,
                    "max-width": "100%"
                }, label: o && r ? null : o
            }
        }
    }, function (t, h, f) {
        "use strict";
        (function (e) {
            var v = this && this.__assign || function () {
                return (v = Object.assign || function (t) {
                    for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                    return t
                }).apply(this, arguments)
            };
            Object.defineProperty(h, "__esModule", {value: !0});
            var s = f(1), i = f(23);

            function n(t) {
                if (!t) return "";
                var e = (t = --t) % 26, e = String.fromCharCode(65 + e), t = Math.floor(t / 26);
                return 0 < t ? n(t) + e : e
            }

            function o(t) {
                return t ? (t = t.toUpperCase()).split("").reduce(function (t, e, i, n) {
                    return t += (e.charCodeAt(0) - 64) * Math.pow(26, n.length - (i + 1))
                }, 0) : -1
            }

            function r(t) {
                if (!t) return {};
                var e = t.match(/([a-zA-Z]*\d*):([a-zA-Z]*\d*)/);
                if (e) return {start: r(e[1]), end: r(e[2])};
                if (!a(t)) return {};
                e = i.str2pos(t), t = e[0];
                return {col: e[1], row: t}
            }

            function a(t) {
                t = t.match(/([a-zA-Z]*)(\d*)/);
                if (t && t[1] && t[2]) return {col: o(t[1]), row: parseInt(t[2], 10) - 1}
            }

            function u(t, e) {
                return "" + n(e) + (t + 1)
            }

            function l(t) {
                return new RegExp(/([A-Z]+\d+:[A-Z]+\d+)|(?:,)([A-Z]+\d+)/).test(t)
            }

            function d(t) {
                t = (t.includes(":") ? t.split(":") : t.split(",")).map(a);
                return {
                    start: {row: Math.min(t[0].row, t[1].row), col: Math.min(t[0].col, t[1].col)},
                    end: {row: Math.max(t[0].row, t[1].row), col: Math.max(t[0].col, t[1].col)}
                }
            }

            function c(t, e) {
                void 0 === e && (e = "row");
                var i = [], n = "row" === e ? "col" : "row";
                if (t) for (var t = d(t), o = t.start, r = t.end, s = o[e]; s <= r[e]; s++) for (var a = o[n]; a <= r[n]; a++) {
                    var l = "row" === e ? u(s, a) : u(a, s);
                    i.push(l)
                }
                return i
            }

            function m(t) {
                if (t) {
                    for (var e = {}, i = 0, n = t.split(";"); i < n.length; i++) {
                        var o = n[i];
                        o && ("height" !== (o = o.trim().split(":"))[0] && "width" !== o[0] && (e[o[0]] = o[1]))
                    }
                    return e
                }
            }

            h.getLetterFromNumber = n, h.getNumberFromLetter = o, h.getCellIds = r, h.getCellIndex = a, h.getCellNameByIndex = u, h.getCellNameById = function (t, e, i) {
                return e ? (e = t.data.getIndex(e) + 1, t = s.findIndex(t.config.columns, function (t) {
                    return i.toString() === t.id
                }), e < 0 || t < 0 ? void 0 : "" + n(t) + e) : ""
            }, h.getCellInfo = function (t, e) {
                var i = r(t);
                return i.start && (i = i.start), i && t ? e.getCell(i.row, i.col) || {} : {locked: !1}
            }, h.isRangeId = l, h.getRangeIndexes = d, h.getRangeArray = c, h.getRangeMatrix = function (t, e) {
                void 0 === e && (e = "row");
                var i = [], n = "row" === e ? "col" : "row";
                if (t) for (var o = (t = d(t)).start, r = t.end, s = o[e]; s <= r[e]; s++) {
                    for (var a = [], l = o[n]; l <= r[n]; l++) {
                        var c = "row" === e ? u(s, l) : u(l, s);
                        a.push(c)
                    }
                    i.push(a)
                }
                return i
            }, h.getNextRangeCell = function (t, e, i) {
                return void 0 === i && (i = "row"), (i = c(t, i))[i.indexOf(e) + 1] || i[0]
            }, h.getPrevRangeCell = function (t, e, i) {
                return void 0 === i && (i = "row"), (i = c(t, i))[i.indexOf(e) - 1] || i[i.length - 1]
            }, h.getCellsArray = function (t) {
                if (t) return t.split(",").reduce(function (t, e) {
                    return l(e = e.toUpperCase()) ? t = t.concat(c(e)) : t.push(e), t
                }, [])
            }, h.extendConfig = function (t, e, i) {
                for (var n in void 0 === t && (t = {}), void 0 === e && (e = {}), void 0 === i && (i = !0), t) {
                    var o = e[n], r = t[n];
                    r && "validate" in r && (e[n] = r.validate(o) ? o : r.default, t[n] = r.default)
                }
                return s.extend(t, e, i)
            }, h.isWasmSupported = function () {
                try {
                    if ("object" == typeof WebAssembly && "function" == typeof WebAssembly.instantiate) {
                        var t = new WebAssembly.Module(Uint8Array.of(0, 97, 115, 109, 1, 0, 0, 0));
                        if (t instanceof WebAssembly.Module) return new WebAssembly.Instance(t) instanceof WebAssembly.Instance
                    }
                } catch (t) {
                    return !1
                }
                return !1
            }, h.fetchFile = function (t, o, r) {
                return new e(function (e, i) {
                    var n = new XMLHttpRequest;
                    n.open(o, t, !0), n.responseType = r, n.onload = function () {
                        var t = n.response;
                        t ? e(t) : i(n)
                    }, n.onerror = function () {
                        return i(n)
                    }, n.send(null)
                })
            }, h.parseHtmlTable = function (t) {
                var e = t.substring(t.indexOf("<style"), t.indexOf("</style>")), i = {};
                if (e.includes(".x")) {
                    var n = e.substring(e.indexOf(".x"), e.indexOf("--\x3e")).split("\r\n.");
                    n[0] = n[0].substr(1);
                    for (var o = 0, r = n; o < r.length; o++) {
                        var s = r[o];
                        s && (i[s.substring(0, s.indexOf("\r\n\t"))] = m(s.substring(s.indexOf("{") + 1, s.indexOf("}")).trim()))
                    }
                }
                n = t.substring(t.indexOf("<table"), t.indexOf("</table>") + 8), (t = document.createElement("div")).innerHTML = n;
                for (var a = t.querySelector("table"), n = a.rows.length, t = a.rows[0].cells.length, l = [], c = [], u = 0; u < a.rows.length; u++) for (var d = a.rows[u], h = 0; h < d.cells.length; h++) {
                    var f = d.cells[h];
                    l.push(f.innerText.trim());
                    for (var p = {}, g = 0; g < f.classList.length; g++) {
                        var _ = f.classList[g];
                        i[_] && (p = v(v({}, p), i[_]))
                    }
                    p = v(v({}, p), m(f.getAttribute("style"))), c.push(p)
                }
                return {values: l, styles: c, rowsCount: n, colsCount: t}
            }, h.parseFromText = function (t) {
                for (var t = t.split(/\n/), e = [], i = 0, n = t; i < n.length; i++) var o = n[i].split(/\t/), e = e.concat(o);
                return {values: e, rowsCount: t.length, colsCount: t[0].split("\t").length}
            }
        }).call(this, f(9))
    }, function (t, e, i) {
        "use strict";
        var n;
        Object.defineProperty(e, "__esModule", {value: !0}), (n = e.GridEvents || (e.GridEvents = {})).scroll = "scroll", n.expand = "expand", n.filterChange = "filterChange", n.beforeResizeStart = "beforeResizeStart", n.resize = "resize", n.afterResizeEnd = "afterResizeEnd", n.cellClick = "cellClick", n.cellRightClick = "cellRightClick", n.cellMouseOver = "cellMouseOver", n.cellMouseDown = "cellMouseDown", n.cellDblClick = "cellDblClick", n.headerCellClick = "headerCellClick", n.footerCellClick = "footerCellClick", n.headerCellMouseOver = "headerCellMouseOver", n.footerCellMouseOver = "footerCellMouseOver", n.headerCellMouseDown = "headerCellMouseDown", n.footerCellMouseDown = "footerCellMouseDown", n.headerCellDblClick = "headerCellDblClick", n.footerCellDblClick = "footerCellDblClick", n.headerCellRightClick = "headerCellRightClick", n.footerCellRightClick = "footerCellRightClick", n.beforeEditStart = "beforeEditStart", n.afterEditStart = "afterEditStart", n.beforeEditEnd = "beforeEditEnd", n.afterEditEnd = "afterEditEnd", n.beforeKeyDown = "beforeKeyDown", n.afterKeyDown = "afterKeyDown", n.beforeColumnHide = "beforeColumnHide", n.afterColumnHide = "afterColumnHide", n.beforeColumnShow = "beforeColumnShow", n.afterColumnShow = "afterColumnShow", n.beforeRowHide = "beforeRowHide", n.afterRowHide = "afterRowHide", n.beforeRowShow = "beforeRowShow", n.afterRowShow = "afterRowShow", n.beforeRowDrag = "beforeRowDrag", n.dragRowStart = "dragRowStart", n.dragRowOut = "dragRowOut", n.dragRowIn = "dragRowIn", n.canRowDrop = "canRowDrop", n.cancelRowDrop = "cancelRowDrop", n.beforeRowDrop = "beforeRowDrop", n.afterRowDrop = "afterRowDrop", n.afterRowDrag = "afterRowDrag", n.beforeColumnDrag = "beforeColumnDrag", n.dragColumnStart = "dragColumnStart", n.dragColumnOut = "dragColumnOut", n.dragColumnIn = "dragColumnIn", n.canColumnDrop = "canColumnDrop", n.cancelColumnDrop = "cancelColumnDrop", n.beforeColumnDrop = "beforeColumnDrop", n.afterColumnDrop = "afterColumnDrop", n.afterColumnDrag = "afterColumnDrag", n.beforeRowResize = "beforeRowResize", n.afterRowResize = "afterRowResize", n.beforeSort = "beforeSort", n.afterSort = "afterSort", n.headerInput = "headerInput", (n = e.GridSystemEvents || (e.GridSystemEvents = {})).cellTouchMove = "cellTouchMove", n.cellTouchEnd = "cellTouchEnd", n.headerCellTouchMove = "headerCellTouchMove", n.headerCellTouchEnd = "headerCellTouchEnd", (e = e.GridSelectionEvents || (e.GridSelectionEvents = {})).beforeUnSelect = "beforeUnSelect", e.afterUnSelect = "afterUnSelect", e.beforeSelect = "beforeSelect", e.afterSelect = "afterSelect"
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = (o.prototype.on = function (t, e, i) {
            t = t.toLowerCase();
            this.events[t] = this.events[t] || [], this.events[t].push({callback: e, context: i || this.context})
        }, o.prototype.detach = function (t, e) {
            var t = t.toLowerCase(), i = this.events[t];
            if (e && i && i.length) for (var n = i.length - 1; 0 <= n; n--) i[n].context === e && i.splice(n, 1); else this.events[t] = []
        }, o.prototype.fire = function (t, e) {
            void 0 === e && (e = []);
            t = t.toLowerCase();
            return !this.events[t] || !this.events[t].map(function (t) {
                return t.callback.apply(t.context, e)
            }).includes(!1)
        }, o.prototype.clear = function () {
            this.events = {}
        }, o);

        function o(t) {
            this.events = {}, this.context = t || this
        }

        e.EventSystem = n, e.EventsMixin = function (t) {
            var e = new n(t = t || {});
            t.detachEvent = e.detach.bind(e), t.attachEvent = e.on.bind(e), t.callEvent = e.fire.bind(e)
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(1), o = i(2), i = (r.prototype.mount = function (t, e) {
            e && (this._view = e), t && this._view && this._view.mount && (this._container = o.toNode(t), this._container.tagName ? this._view.mount(this._container) : this._container.attach && this._container.attach(this))
        }, r.prototype.unmount = function () {
            var t = this.getRootView();
            t && t.node && (t.unmount(), this._view = null)
        }, r.prototype.getRootView = function () {
            return this._view
        }, r.prototype.getRootNode = function () {
            return this._view && this._view.node && this._view.node.el
        }, r.prototype.paint = function () {
            this._view && (this._view.node || this._container) && (this._doNotRepaint = !1, this._view.redraw())
        }, r);

        function r(t, e) {
            this.config = e || {}, this._uid = this.config.rootId || n.uid()
        }

        e.View = i, e.toViewLike = function (e) {
            return {
                getRootView: function () {
                    return e
                }, paint: function () {
                    return e.node && e.redraw()
                }, mount: function (t) {
                    return e.mount(t)
                }
            }
        }
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(13)), n(e(46)), n(e(91)), n(e(92)), n(e(18)), n(e(128)), n(e(14)), n(e(49)), n(e(48)), n(e(129)), n(e(47)), n(e(34))
    }, function (t, e, i) {
        "use strict";
        var n;
        Object.defineProperty(e, "__esModule", {value: !0}), (n = e.SpreadsheetEvents || (e.SpreadsheetEvents = {})).beforeValueChange = "beforeValueChange", n.afterValueChange = "afterValueChange", n.beforeStyleChange = "beforeStyleChange", n.afterStyleChange = "afterStyleChange", n.beforeFormatChange = "beforeFormatChange", n.afterFormatChange = "afterFormatChange", n.beforeSelectionSet = "beforeSelectionSet", n.afterSelectionSet = "afterSelectionSet", n.beforeRowAdd = "beforeRowAdd", n.afterRowAdd = "afterRowAdd", n.beforeRowDelete = "beforeRowDelete", n.afterRowDelete = "afterRowDelete", n.beforeColumnAdd = "beforeColumnAdd", n.afterColumnAdd = "afterColumnAdd", n.beforeColumnDelete = "beforeColumnDelete", n.afterColumnDelete = "afterColumnDelete", n.beforeFocusSet = "beforeFocusSet", n.afterFocusSet = "afterFocusSet", n.beforeEditStart = "beforeEditStart", n.afterEditStart = "afterEditStart", n.beforeEditEnd = "beforeEditEnd", n.afterEditEnd = "afterEditEnd", n.groupFill = "groupFill", n.beforeSheetAdd = "beforeSheetAdd", n.afterSheetAdd = "afterSheetAdd", n.beforeSheetRemove = "beforeSheetRemove", n.afterSheetRemove = "afterSheetRemove", n.beforeSheetRename = "beforeSheetRename", n.afterSheetRename = "afterSheetRename", n.beforeSheetChange = "beforeSheetChange", n.afterSheetChange = "afterSheetChange", n.editLineInput = "editLineInput", n.editLineFocus = "editLineFocus", n.editLineBlur = "editLineBlur", n.cellInput = "cellInput", n.gridRedraw = "gridRedraw", (e = e.Actions || (e.Actions = {})).setCellStyle = "setCellStyle", e.setCellValue = "setCellValue", e.setCellFormat = "setCellFormat", e.removeCellStyles = "removeCellStyles", e.lockCell = "lockCell", e.deleteRow = "deleteRow", e.addRow = "addRow", e.deleteColumn = "deleteColumn", e.addColumn = "addColumn", e.groupAction = "groupAction", e.groupRowAction = "groupRowAction", e.groupColAction = "groupColAction", e.addSheet = "addSheet", e.deleteSheet = "deleteSheet", e.renameSheet = "renameSheet"
    }, function (t, e, i) {
        (function (o, r) {
            !function () {
                var e = 1, i = {}, n = !1;

                function u(t) {
                    o.setImmediate ? r(t) : o.importScripts ? setTimeout(t) : (i[++e] = t, o.postMessage(e, "*"))
                }

                function d(t) {
                    "use strict";
                    if ("function" != typeof t && null != t) throw TypeError();
                    if ("object" != typeof this || this && this.then) throw TypeError();
                    var e, i, n = this, r = 0, s = 0, o = [];
                    (n.promise = n).resolve = function (t) {
                        return e = n.fn, i = n.er, r || (s = t, r = 1, u(c)), n
                    }, n.reject = function (t) {
                        return e = n.fn, i = n.er, r || (s = t, r = 2, u(c)), n
                    }, n._d = 1, n.then = function (t, e) {
                        if (1 != this._d) throw TypeError();
                        var i = new d;
                        return i.fn = t, i.er = e, 3 == r ? i.resolve(s) : 4 == r ? i.reject(s) : o.push(i), i
                    }, n.catch = function (t) {
                        return n.then(null, t)
                    };
                    var a = function (t) {
                        r = t || 4, o.map(function (t) {
                            3 == r && t.resolve(s) || t.reject(s)
                        })
                    };
                    try {
                        "function" == typeof t && t(n.resolve, n.reject)
                    } catch (t) {
                        n.reject(t)
                    }
                    return n;

                    function l(t, e, i, n) {
                        if (2 == r) return n();
                        if ("object" != typeof s && "function" != typeof s || "function" != typeof t) n(); else try {
                            var o = 0;
                            t.call(s, function (t) {
                                o++ || (s = t, e())
                            }, function (t) {
                                o++ || (s = t, i())
                            })
                        } catch (t) {
                            s = t, i()
                        }
                    }

                    function c() {
                        var t;
                        try {
                            t = s && s.then
                        } catch (t) {
                            return s = t, r = 2, c()
                        }
                        l(t, function () {
                            r = 1, c()
                        }, function () {
                            r = 2, c()
                        }, function () {
                            try {
                                1 == r && "function" == typeof e ? s = e(s) : 2 == r && "function" == typeof i && (s = i(s), r = 1)
                            } catch (t) {
                                return s = t, a()
                            }
                            s == n ? (s = TypeError(), a()) : l(t, function () {
                                a(3)
                            }, a, function () {
                                a(1 == r && 3)
                            })
                        })
                    }
                }

                (o = this).setImmediate || o.addEventListener("message", function (t) {
                    if (t.source == o) if (n) u(i[t.data]); else {
                        n = !0;
                        try {
                            i[t.data]()
                        } catch (t) {
                        }
                        delete i[t.data], n = !1
                    }
                }), d.resolve = function (e) {
                    if (1 != this._d) throw TypeError();
                    return e instanceof d ? e : new d(function (t) {
                        t(e)
                    })
                }, d.reject = function (i) {
                    if (1 != this._d) throw TypeError();
                    return new d(function (t, e) {
                        e(i)
                    })
                }, d.all = function (n) {
                    if (1 != this._d) throw TypeError();
                    if (!(n instanceof Array)) return d.reject(TypeError());
                    var o = new d;
                    return function i(t, e) {
                        return e ? o.resolve(e) : t ? o.reject(t) : (0 == n.reduce(function (t, e) {
                            return e && e.then ? t + 1 : t
                        }, 0) && o.resolve(n), void n.map(function (t, e) {
                            t && t.then && t.then(function (t) {
                                return n[e] = t, i(), t
                            }, i)
                        }))
                    }(), o
                }, d.race = function (n) {
                    if (1 != this._d) throw TypeError();
                    if (!(n instanceof Array)) return d.reject(TypeError());
                    if (0 == n.length) return new d;
                    var o = new d;
                    return function i(t, e) {
                        return e ? o.resolve(e) : t ? o.reject(t) : (0 == n.reduce(function (t, e) {
                            return e && e.then ? t + 1 : t
                        }, 0) && o.resolve(n), void n.map(function (t, e) {
                            t && t.then && t.then(function (t) {
                                i(null, t)
                            }, i)
                        }))
                    }(), o
                }, d._d = 1, t.exports = d
            }()
        }).call(this, i(31), i(77).setImmediate)
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(2), i = (o.prototype.getFocusId = function () {
            return this._activeWidgetId
        }, o.prototype.setFocusId = function (t) {
            this._activeWidgetId = t
        }, o);

        function o() {
            var e = this;
            this._initHandler = function (t) {
                return e._activeWidgetId = n.locate(t, "dhx_widget_id")
            }, document.addEventListener("click", this._initHandler)
        }

        e.focusManager = new i
    }, function (t, e, i) {
        "use strict";

        function o(t) {
            if ("#" === t.substr(0, 1)) return t;
            t = /(.*?)rgb[a]?\((\d+), *(\d+), *(\d+),* *([\d+.]*)\)/.exec(t);
            return t ? "#" + parseInt(t[2], 10).toString(16).padStart(2, "0") + parseInt(t[3], 10).toString(16).padStart(2, "0") + parseInt(t[4], 10).toString(16).padStart(2, "0") : ""
        }

        Object.defineProperty(e, "__esModule", {value: !0}), e.rgbToHex = o, e.transpose = function (t, e) {
            for (var i = [], n = 0; n < t.length; n++) for (var o = t[n], r = 0; r < o.length; r++) {
                i[r] = i[r] || [];
                var s = e ? e(o[r]) : o[r];
                i[r].push(s)
            }
            return i
        }, e.getStyleByClass = function (t, e, i, n) {
            return e = e.querySelector("." + i), i = e, i = "string" == typeof (t = '<div class="' + t + '"></div>') ? (i.insertAdjacentHTML("beforeend", t), i.lastChild) : (i.appendChild(t), t), t = {
                color: "rgb(0, 0, 0)" === (t = window.getComputedStyle(i)).color ? n.color : o(t.color),
                background: "rgba(0, 0, 0, 0)" === t.backgroundColor ? n.background : o(t.backgroundColor),
                fontSize: parseFloat(t.fontSize)
            }, e.removeChild(i), t.color === n.color && t.background === n.background && t.fontSize === n.fontSize ? null : t
        }, e.removeHTMLTags = function (t) {
            return "string" != typeof t && "number" != typeof t && "boolean" != typeof t ? "" : ("" + (null == t ? "" : t)).replace(/<[^>]*>/g, "").replace(/["]/g, "&quot;").trim()
        }, e.isCssSupport = function (e, i) {
            try {
                return CSS.supports(e, i)
            } catch (t) {
                var n = document.createElement("div");
                return n.style[e] = i, n.style[e] === i
            }
        }, e.isRowEmpty = function (i) {
            if (i) return Object.keys(i).reduce(function (t, e) {
                return "id" !== e && !e.startsWith("$") && t && void 0 !== i[e] && "" !== i[e] ? void 0 : t
            }, !0)
        }, e.isSortable = function (t, e) {
            return !1 !== e.sortable && t.sortable || e.sortable
        }, e.isAutoWidth = function (e, t) {
            if (t) return !1 !== t.autoWidth && e.autoWidth || t.autoWidth;
            var i = !1;
            return e.columns.map(function (t) {
                (!1 !== t.autoWidth && e.autoWidth || t.autoWidth) && (i = !0)
            }), i
        }, e.isTooltip = function (t, e) {
            return !1 !== e.tooltip && t.tooltip || e.tooltip
        }, e.isHtmlEnable = function (t, e) {
            return !1 !== e.htmlEnable && t.htmlEnable || e.htmlEnable
        }, e.getTotalWidth = function (t) {
            return t.reduce(function (t, e) {
                return t + (e.$width || 0)
            }, 0)
        }, e.getTotalHeight = function (t) {
            return t.reduce(function (t, e) {
                return t + (e.$height || 0)
            }, 0)
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        e.default = {
            undo: "Undo",
            redo: "Redo",
            textColor: "Text color",
            backgroundColor: "Background color",
            bold: "Bold",
            italic: "Italic",
            lockCell: "Lock cell",
            unlockCell: "Unlock cell",
            deleteSheet: "Delete",
            renameSheet: "Rename",
            format: "Format",
            edit: "Edit",
            clear: "Clear",
            clearValue: "Clear value",
            clearStyles: "Clear styles",
            clearAll: "Clear all",
            insert: "Insert",
            columns: "Columns",
            rows: "Rows",
            addColumn: "Add column",
            removeColumn: "Remove column",
            addRow: "Add row",
            removeRow: "Remove row",
            underline: "Underline",
            align: "Align",
            left: "Left",
            right: "Right",
            center: "Center",
            help: "Help",
            common: "Common",
            number: "Number",
            currency: "Currency",
            percent: "Percent",
            text: "Text",
            downloadAs: "Download as...",
            importAs: "Import as...",
            import: "Import",
            export: "Export",
            file: "File",
            numberFormat: "Number format"
        }
    }, function (t, e, i) {
        "use strict";
        var n;
        Object.defineProperty(e, "__esModule", {value: !0}), (n = e.TreeFilterType || (e.TreeFilterType = {})).all = "all", n.level = "level", n.leafs = "leafs", (n = e.DataEvents || (e.DataEvents = {})).afterAdd = "afteradd", n.beforeAdd = "beforeadd", n.removeAll = "removeall", n.beforeRemove = "beforeremove", n.afterRemove = "afterremove", n.change = "change", n.load = "load", n.loadError = "loaderror", n.beforeLazyLoad = "beforelazyload", n.afterLazyLoad = "afterlazyload", (n = e.DragEvents || (e.DragEvents = {})).beforeDrag = "beforeDrag", n.dragStart = "dragStart", n.dragOut = "dragOut", n.dragIn = "dragIn", n.canDrop = "canDrop", n.cancelDrop = "cancelDrop", n.beforeDrop = "beforeDrop", n.afterDrop = "afterDrop", n.afterDrag = "afterDrag", (e = e.DataDriver || (e.DataDriver = {})).json = "json", e.csv = "csv", e.xml = "xml"
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(18), o = i(47);
        e.isEqualObj = function (t, e) {
            for (var i in t) if (t[i] !== e[i] || Array.isArray(t[i])) return !1;
            return !0
        }, e.naturalCompare = function (t, e) {
            if (isNaN(t) || isNaN(e)) {
                var n = [], o = [];
                for (t.replace(/(\d+)|(\D+)/g, function (t, e, i) {
                    n.push([e || 1 / 0, i || ""])
                }), e.replace(/(\d+)|(\D+)/g, function (t, e, i) {
                    o.push([e || 1 / 0, i || ""])
                }); n.length && o.length;) {
                    var i = n.shift(), r = o.shift(), r = i[0] - r[0] || i[1].localeCompare(r[1]);
                    if (r) return r
                }
                return n.length - o.length
            }
            return t - e
        }, e.findByConf = function (t, e) {
            if ("function" == typeof e) {
                if (e.call(this, t)) return t
            } else if (e.by && e.match && t[e.by] === e.match) return t
        }, e.isDebug = function () {
            var t = window.dhx;
            if (void 0 !== t) return void 0 !== t.debug && t.debug
        }, e.dhxWarning = function (t) {
            console.warn(t)
        }, e.dhxError = function (t) {
            throw new Error(t)
        }, e.toProxy = function (t) {
            var e = typeof t;
            return "string" == e ? new n.DataProxy(t) : "object" == e ? t : void 0
        }, e.toDataDriver = function (t) {
            if ("string" == typeof t) {
                var e = window.dhx, e = e && e.dataDrivers || o.dataDrivers;
                if (e[t]) return new e[t];
                console.warn("Incorrect data driver type:", t), console.warn("Available types:", JSON.stringify(Object.keys(e)))
            } else if ("object" == typeof t) return t
        }, e.copyWithoutInner = function (t, e) {
            var i, n = {};
            for (i in t) i.startsWith("$") || e && e[i] || (n[i] = t[i]);
            return n
        }, e.isTreeCollection = function (t) {
            return Boolean(t.getRoot)
        }, e.hasJsonOrArrayStructure = function (t) {
            if ("object" == typeof t) return !0;
            if ("string" != typeof t) return !1;
            try {
                var e = JSON.parse(t);
                return "[object Object]" === Object.prototype.toString.call(e) || Array.isArray(e)
            } catch (t) {
                return !1
            }
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var v = i(1), b = i(11), n = i(24);

        function a(t, e) {
            t[e] && ("string" == typeof t[e] ? t[e] = [{text: "" + t[e]}] : t[e] = t[e].map(function (t) {
                return "string" == typeof t && (t = {text: t}), t
            }))
        }

        e.normalizeColumns = function (t) {
            for (var e = t.columns, i = t.htmlEnable, n = 0, o = e; n < o.length; n++) {
                var r = o[n];
                r.$htmlEnable = !(!r.htmlEnable && !i), r.$cellCss = r.$cellCss || {}, a(r, "header"), a(r, "footer"), r.header.reduce(function (t, e) {
                    return t || !!e.content
                }, !1) && (r.$uniqueData = []);
                var s = r.minWidth || 100;
                r.width && (s = r.maxWidth && r.minWidth ? r.width >= r.minWidth && r.width <= r.maxWidth ? r.width : r.width >= r.maxWidth ? r.maxWidth : r.minWidth : r.maxWidth ? r.width <= r.maxWidth ? r.width : 100 < r.maxWidth ? r.maxWidth : 100 : !r.minWidth || r.width >= r.minWidth ? r.width : r.minWidth), r.$width = r.$width || s, r.$width > r.maxWidth && (r.$width = r.maxWidth), r.$width < r.minWidth && (r.$width = r.minWidth)
            }
        }, e.countColumns = function (t, e) {
            var n = 0, o = 0, r = 0, s = !1, i = 0, a = !1;
            return e.forEach(function (t) {
                if (n = Math.max(n, t.header.length), r += t.$width, t.footer && (o = Math.max(o, t.footer.length), a = a || !0), !s) for (var e = 0, i = t.header; e < i.length; e++) if (i[e].colspan) return void (s = !0)
            }), e.forEach(function (t) {
                if (t.header.length < n) for (var e = 0; e < n; e++) t.header[e] = t.header[e] || {text: ""};
                if (a && (t.footer = t.footer || []), t.footer && t.footer.length < o) for (e = 0; e < o; e++) t.footer[e] = t.footer[e] || {text: ""};
                t.header = t.header.map(function (t) {
                    return "object" != typeof t && (t = {text: t}), t.css = t.css || "", t.text || t.css.includes("dhx_cell-empty") || (t.css += " dhx_cell-empty dxi dxi-select-all"), t
                }), "" === t.header[0].text && i++
            }), t.$totalWidth = r, t.$headerLevel = n, t.$footerLevel = o, t.$colspans = s, t.$footer = a, i
        }, e.calculatePositions = function (t, e, i, n, o) {
            for (var r = n.columns || [], s = r.length, a = o || [], l = a.length, c = -1 / 0, u = 0; u < s; u++) r[u].$width > c && (c = r[u].$width);
            for (var d = 1 / 0, u = 0; u < s; u++) r[u].$width < d && (d = r[u].$width);
            for (var h = -1 / 0, u = 0; u < l; u++) a[u].$height > h && (h = a[u].$height);
            for (var f = n.rowHeight, o = Math.round(c / d), f = Math.round(h / f), p = n.$totalWidth / s, t = Math.round(t / p), g = n.$totalHeight / l, e = Math.round(e / g), _ = 0, v = i.left, m = 0; m < r.length; m++) {
                if (!(0 < (v -= r[m].$width) + p / 2)) break;
                _++
            }
            for (var y = 0, b = i.top, m = 0; m < a.length; m++) {
                if (!(0 < (b -= a[m].$height) + g / 2)) break;
                y++
            }
            return {xStart: 0 <= _ - o ? _ - o : 0, xEnd: _ + t + o, yStart: 0 <= y - f ? y - f : 0, yEnd: y + e + f}
        }, e.getUnique = function (t, e) {
            return t.map(function (t) {
                return t[e]
            }).filter(function (t, e, i) {
                return i.indexOf(t) === e
            }).sort()
        }, e.getMaxRowHeight = function (t, e, i) {
            void 0 === i && (i = {font: "20px Roboto", lineHeight: 20});
            var n = document.createElement("canvas"), o = n.getContext("2d", {alpha: !1});
            o.font = i.font;
            for (var r = {}, s = e.length, a = 0; a < s; a++) e[a].template ? r[e[a].id] = {
                width: e[a].$width || 0,
                htmlEnable: e[a].$htmlEnable,
                template: e[a].template,
                cols: e[a]
            } : r[e[a].id] = {width: e[a].$width || 0, htmlEnable: e[a].$htmlEnable};
            for (var l = [], c = [], u = 0, d = Object.entries(t); u < d.length; u++) {
                var h, f = d[u], p = f[0], g = f[1];
                !r[p] || "id" === p || "height" === p || p.startsWith("$") || "string" != typeof g && "number" != typeof g || (h = "", h = null !== (f = r[p]) && void 0 !== f && f.template ? (f = r[p].template(g, t, r[p].cols), r[p].htmlEnable ? b.removeHTMLTags(f) : f) : "string" == typeof g ? r[p].htmlEnable ? b.removeHTMLTags(g) : g : g.toString(), l.push(h.split("\n").length), c.push(Math.round(o.measureText(h).width / (null === (p = r[p]) || void 0 === p ? void 0 : p.width))))
            }
            var _ = Math.max(v.getMaxArrayNymber(l), v.getMaxArrayNymber(c));
            return n.remove(), _ * i.lineHeight
        }, e.getCalculatedRowHeight = function (t, e) {
            void 0 === e && (e = {rowHeight: 40, padding: 8});
            var i = e.rowHeight < 40 ? t : t + 2 * e.padding;
            return t < e.rowHeight ? e.rowHeight : i
        }, e.getTreeCellWidthOffset = function (t) {
            return 20 + 20 * t.$level - (t.$items ? 20 : 0)
        }, e.getMaxColsWidth = function (t, e, i, n) {
            if (void 0 === i && (i = {font: "normal 14.4px Arial"}), t.length && e.length) {
                var o = document.createElement("canvas"), r = o.getContext("2d", {alpha: !1});
                r.font = i.font;
                for (var s = {}, a = e.length, l = 0; l < a; l++) e[l].template && "data" === n ? s[e[l].id] = {
                    width: 20,
                    htmlEnable: e[l].$htmlEnable,
                    template: e[l].template,
                    cols: e[l]
                } : s[e[l].id] = {width: 20, htmlEnable: e[l].$htmlEnable};
                for (var c = t.length, l = 0; l < c; l++) for (var u = 0, d = Object.entries(t[l]); u < d.length; u++) {
                    var h, f = d[u], p = f[0], g = f[1];
                    !s[p] || "id" === p || "height" === p || p.startsWith("$") || "string" != typeof g && "number" != typeof g || (h = void 0, h = "function" == typeof (null === (f = s[p]) || void 0 === f ? void 0 : f.template) ? (f = s[p].template(g, t[l], s[p].cols), s[p].htmlEnable ? b.removeHTMLTags(f) : f) : s[p].htmlEnable ? b.removeHTMLTags(g) : g.toString(), (h = r.measureText(h).width) > s[p].width && (s[p].width = h))
                }
                o.remove();
                for (var _ = {}, v = 0, m = Object.entries(s); v < m.length; v++) {
                    var y = m[v], p = y[0], g = y[1];
                    _[p] = Math.ceil(g.width)
                }
                return _
            }
        }, e.toFormat = function (r, t, s) {
            if (!r && "number" != typeof r) return r;
            switch (t) {
                case"number":
                case"percent":
                    return s = s || "#", v.isDefined(r) && !isNaN(Number(r)) ? function (t) {
                        r = r.toString();
                        var e = s.replace(/#+/g, "#").split("#").filter(function (t) {
                            return t
                        });
                        r = "percent" === t ? (100 * Number(r)).toString() : r;
                        var i = Math.trunc(Number(r)).toString(), n = s.match(/0/g) && s.match(/0/g).length,
                            o = e.find(function (t) {
                                return !t.includes("0")
                            }), o = o ? i.replace(/(\d)(?=(\d{3})+(\D|$))/g, "$1" + o) : i;
                        return n && (i = e.find(function (t) {
                            return t.includes("0")
                        }).replace(/0+/g, ""), e = r.split(".")[1] || "0", o += i + Number("0." + e).toFixed(n).toString().split(".")[1].padEnd(n, "0")), "percent" === t ? o + "%" : o
                    }(t) : r;
                case"date":
                    return s = s || "%M %d %Y", "string" == typeof r ? r = n.getFormattedDate(s, n.stringToDate(r, s)) : "object" == typeof r && (r = n.getFormattedDate(s, r)), r;
                default:
                    return r
            }
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(1), o = i(12), r = {}, l = [], s = {decimal: ".", thousands: ","}, a = "$",
            c = "(\\[\\$[\\w\\W]*?\\]|[\\$]{0,1})", u = "([,. ]{0,1})", i = "([#0]*)",
            d = new RegExp("\\[\\$([\\w\\W]*?)\\]|(\\$)"), h = new RegExp(c + i + u + i + u + i + "([%]{0,1})" + c),
            f = {};

        function p() {
            return l
        }

        function g(e) {
            return l[n.findIndex(l, function (t) {
                return t.id === e
            })]
        }

        function _(t) {
            return !isNaN(t - parseFloat(t))
        }

        function v(t) {
            if (t && "string" == typeof t) {
                if (f[t]) return f[t];
                var e, i = t.match(h), i = {
                    currencyBefore: (i = i)[1],
                    digits: i[2],
                    thousandsSeparator: i[3],
                    optionalDigits: i[4],
                    decimalSeparator: i[5],
                    decimalDigits: i[6],
                    percent: i[7],
                    currencyAfter: i[8],
                    decimalLength: 0
                };
                return !i.decimalSeparator && i.thousandsSeparator && (i.decimalSeparator = i.thousandsSeparator, i.decimalDigits = i.optionalDigits, i.thousandsSeparator = "", i.optionalDigits = ""), i.currencyBefore && (e = i.currencyBefore.match(d), i.currencyBefore = e[1] || e[2]), i.currencyAfter && (e = i.currencyAfter.match(d), i.currencyAfter = e[1] || e[2]), i.percent && (i.currencyBefore = "", i.currencyAfter = ""), i.decimalLength = i.decimalDigits ? i.decimalDigits.split("0").length - 1 : i.decimalLength, "common" === t && (i.decimalSeparator = ".", i.decimalLength = "", i.thousandsSeparator = ","), f[t] = i
            }
        }

        function m(t, e) {
            if (!e) return t;
            if (!_(t)) return t;
            var i = "";
            e.currencyBefore && (i += e.currencyBefore);
            var n = parseFloat(t), o = n < 0;
            o && (n = Math.abs(n));
            t = n.toString();
            e.percent && (n *= 100), e.digits && (t = n.toFixed(e.decimalLength || 2));
            var r = (null == e ? void 0 : e.digits) + (null == e ? void 0 : e.optionalDigits), n = t.split(".");
            if (r && r.length > n[0].length) {
                for (var s = n[0].split(""), a = n[0], l = 0, c = r.length - 1; -1 < c; c--) {
                    var u = r[c], d = s[l];
                    "0" !== u || d || (a = "0" + a), l++
                }
                t = a + (1 < n.length ? "." + n[1] : "")
            }
            return i += e.digits ? function (t, e, i, n) {
                void 0 === e && (e = ""), void 0 === n && (n = 3);
                for (var o = t.toString().split("."), r = [], s = 1, a = o[0].length - 1; -1 < a; a--) r.push(o[0][a]), s === n && a ? (r.push(e), s = 1) : s++;
                return o[0] = r.reverse().join(""), o.join(i)
            }(t, e.thousandsSeparator, e.decimalSeparator, e.optionalDigits.length) : t, i += e.percent, e.currencyAfter && (i += e.currencyAfter), o && (i = "-" + i), i
        }

        function y(t) {
            var e = s, i = (l.filter(function (t) {
                return t.mask.startsWith("[$")
            }) || []).map(function (t) {
                return t.mask.substring(2, t.mask.indexOf("]"))
            });
            if (i.length) for (var n = 0; n < i.length; n++) {
                var o = i[n];
                if (t.toString().startsWith(o)) return y(("" + t).substr(o.length))
            }
            return ("" + t).replace(new RegExp("[" + e.thousands + "$%s]", "g"), "").replace(new RegExp("[" + e.decimal + "]", "g"), ".")
        }

        e.getDefaultFormats = p, e.getFormat = g, e.isNumeric = _, e.initFormat = function (t) {
            r = t.config, l = [{
                name: o.default.common,
                id: "common",
                mask: "",
                example: "1500.31"
            }, {name: o.default.number, id: "number", mask: "#,##0.00", example: "1500.31"}, {
                name: o.default.percent,
                id: "percent",
                mask: "#,##0.00%",
                example: "15.0031"
            }, {name: o.default.currency, id: "currency", mask: "$#,##0.00", example: "1500.31"}, {
                name: o.default.text,
                id: "text",
                mask: "@",
                example: "some text"
            }], r.formats.forEach(function (e) {
                var t = n.findIndex(l, function (t) {
                    return t.id === e.id
                });
                0 <= t ? l[t] = e : l.push(e)
            }), t = v(g("number").mask), s = {
                decimal: t.decimalSeparator,
                thousands: t.thousandsSeparator
            }, t = v(g("currency").mask), a = t.currency || a, (r.formats = l).forEach(function (t) {
                v(t.mask)
            })
        }, e.getDefaultFormatsMap = function () {
            return l.reduce(function (t, e) {
                return t[e.mask] = e.id, t
            }, {})
        }, e.getPureNumber = function (t) {
            var e = "string" == typeof t && t.includes("%"), t = parseFloat(("" + t).replace(/[^.\d]/g, ""));
            return e ? t / 100 : t
        }, e.getCleanValue = y, e.getUnformattedValue = function (t, e) {
            return "common" === e ? t : (t = y(t), "percent" === e ? (parseFloat(t) / 100).toFixed(4) : t)
        }, e.detectCellFormat = function (t) {
            if (!_(y(t))) return "";
            var e = "" + t, i = e.indexOf("%"), n = 0 === e.indexOf("$");
            if (0 === i || i === e.length - 1) return g("percent").mask;
            if (n) return g("currency").mask;
            var o = l.filter(function (t) {
                return t.mask.startsWith("[$")
            }) || [], r = o.map(function (t) {
                return t.mask.substring(2, t.mask.indexOf("]"))
            });
            if (r.length) for (var s = 0; s < r.length; s++) {
                var a = r[s];
                if (t.toString().startsWith(a)) return o[s].mask
            }
            return g("number").mask
        }, e.getFormattedValue = function (t, e) {
            return e && "@" !== e ? m(t, v(e)) : t
        }
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(75)), n(e(76)), n(e(80)), n(e(43)), n(e(30))
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(34), i = (o.prototype.updateUrl = function (t, e) {
            for (var i in void 0 === e && (e = {}), this._url = this.url = t || this._url, this.url += this.url.includes("?") ? "&" : "?", e) this.config[i] = e[i], this.url += i + "=" + encodeURIComponent(e[i]) + "&";
            this.url = this.url.slice(0, -1)
        }, o.prototype.load = function () {
            return n.ajax.get(this.url, null, {responseType: "text"})
        }, o.prototype.save = function (t, e) {
            switch (e) {
                case"delete":
                    return n.ajax.delete(this.url, t);
                case"update":
                case"insert":
                default:
                    return n.ajax.post(this.url, t)
            }
        }, o);

        function o(t, e) {
            this.url = this._url = t, this.config = e
        }

        e.DataProxy = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(10), s = i(2);

        function a(t) {
            for (var e = t.toLowerCase().match(/\w+/g), i = 0, n = "", o = 0; o < e.length; o++) {
                var r = e[o];
                "ctrl" === r ? i += 4 : "shift" === r ? i += 2 : "alt" === r ? i += 1 : n = r
            }
            return i + n
        }

        var l = {
            Up: "arrowUp",
            Down: "arrowDown",
            Right: "arrowRight",
            Left: "arrowLeft",
            Esc: "escape",
            Spacebar: "space"
        }, i = (n.prototype.destructor = function () {
            document.removeEventListener("keydown", this._initHandler), this.removeHotKey()
        }, n.prototype.addHotKey = function (t, e) {
            t = a(t);
            this._keysStorage[t] || (this._keysStorage[t] = []), this._keysStorage[t].push({handler: e})
        }, n.prototype.removeHotKey = function (t, i) {
            var n, o, r = this;
            t ? t && i ? (n = a(t), o = function (t) {
                return t.toString().replace(/\n/g, "").replace(/\s/g, "")
            }, this._keysStorage[n].forEach(function (t, e) {
                o(t.handler) === o(i) && (delete r._keysStorage[n][e], r._keysStorage[n] = r._keysStorage[n].filter(function (t) {
                    return t
                }))
            })) : (t = a(t), delete this._keysStorage[t]) : this._keysStorage = {}
        }, n.prototype.exist = function (t) {
            t = a(t);
            return !!this._keysStorage[t]
        }, n);

        function n(t) {
            var o = this;
            this._keysStorage = {}, this._initHandler = function (t) {
                var e;
                e = 48 <= t.which && t.which <= 57 || 65 <= t.which && t.which <= 90 ? String.fromCharCode(t.which) : (e = 32 === t.which ? t.code : t.key, s.isIE() && l[e] || e);
                var i = o._keysStorage[(t.ctrlKey || t.metaKey ? 4 : 0) + (t.shiftKey ? 2 : 0) + (t.altKey ? 1 : 0) + (e && e.toLowerCase())];
                if (i) for (var n = 0; n < i.length; n++) {
                    if (o._beforeCall && !1 === o._beforeCall(t, r.focusManager.getFocusId())) return;
                    i[n].handler(t)
                }
            }, t && (this._beforeCall = t), document.addEventListener("keydown", this._initHandler)
        }

        e.KeyManager = i
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(108)), n(e(52))
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(131)), n(e(132)), n(e(39))
    }, function (t, e, i) {
        "use strict";
        var o = this && this.__assign || function () {
            return (o = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(0);
        e.getCount = function (t, e, i) {
            var n = {
                danger: " dhx_navbar-count--color_danger",
                secondary: " dhx_navbar-count--color_secondary",
                primary: " dhx_navbar-count--color_primary",
                success: " dhx_navbar-count--color_success"
            }[t.countColor] || " dhx_navbar-count--color_danger";
            return r.el(".dhx_navbar-count", {class: e + n + (!i && 99 < parseInt(t.count, 10) ? " dhx_navbar-count--overlimit" : "")}, i && 99 < parseInt(t.count, 10) ? "99+" : t.count)
        }, e.getIcon = function (t, e) {
            return void 0 === t && (t = ""), t.startsWith("dxi") && (t = "dxi " + t), r.el("span", {
                class: "dhx_" + e + "__icon " + t,
                "aria-hidden": "true"
            })
        };
        var s = function (t, e, i) {
            var n = "", o = "", o = (n = i ? "dhx_menu-item" : "dhx_" + t + "__item") + (e.css ? " " + e.css : "");
            return "spacer" !== e.type && "separator" !== e.type || (o += " " + n + "--" + e.type), "button" !== e.type || "sidebar" !== t || e.icon || (o += " dhx_navbar-item--colapse_hidden"), o
        };
        e.navbarComponentMixin = function (t, e, i, n) {
            var i = s(t, e, i), t = "ribbon" === t && ("navItem" === e.type || "imageButton" === e.type);
            return r.el("li", o({
                _key: e.id,
                class: i + (e.icon && !e.value && t ? " dhx_ribbon__item--icon" : "") + (e.src && !e.value && t ? " dhx_ribbon__item--icon" : "") + (e.size && t ? " dhx_ribbon__item--" + e.size : ""),
                ".innerHTML": "customHTML" === e.type ? e.html : void 0,
                dhx_id: "customHTML" === e.type ? e.id : void 0
            }, (i = e.type, t = {role: "none"}, "separator" === i && (t.role = "separator", t["aria-orientation"] = "vertical"), t)), "customHTML" !== e.type ? [n] : void 0)
        }, e.getNavbarButtonCSS = function (t, e) {
            var i = t.color, n = t.size, o = t.view, r = t.full, s = t.icon, a = t.circle, l = t.loading, c = t.value,
                t = t.active;
            return ({
                danger: " dhx_button--color_danger",
                secondary: " dhx_button--color_secondary",
                primary: " dhx_button--color_primary",
                success: " dhx_button--color_success"
            }[i] || " dhx_button--color_primary") + ({
                small: " dhx_button--size_small",
                medium: " dhx_button--size_medium"
            }[n] || " dhx_button--size_medium") + ({
                flat: " dhx_button--view_flat",
                link: " dhx_button--view_link"
            }[o] || " dhx_button--view_flat") + (r ? " dhx_button--width_full" : "") + (a ? " dhx_button--circle" : "") + (l ? " dhx_button--loading" : "") + (t ? " dhx_button--active" : "") + (s && !c ? " dhx_button--icon" : "")
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var y, n = {1: "#ERROR", 2: "#ERROR", 3: "#REF!"}, c = function () {
            return (c = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };

        function v(t, e, i) {
            return i + 64 * e + 64 * t * 4096
        }

        function m(t) {
            return [t < 2147483648 ? t >> 18 : t / 262144 & 16777215, t >> 6 & 4095, 63 & t]
        }

        function b(t) {
            return t < 2147483648 ? t >> 18 : t / 262144 & 16777215
        }

        function o(t) {
            return 63 & t
        }

        function r(t, e, i) {
            for (var n = m(t), o = n[0], n = n[1], e = m(e), r = e[0] - o, s = e[1] - n, a = 0; a <= r; a++) for (var l = 0; l <= s; l++) i(t + 64 * l + 4096 * a * 64)
        }

        function x(t, e) {
            for (var i, n, o, r = t.code, s = t.source, a = "", l = r.length, c = 0; c < l; c += 3) switch (r[c]) {
                case 5:
                    var u = void 0;
                    9 === r[c + 6] && (u = e.pageName(63 & r[c + 7])), a += (-1 !== (u = u || t.source.substr(r[c + 1], r[c + 2])).indexOf(" ") ? "'" + u + "'" : u) + "!";
                    break;
                case 7:
                    a += d(i = (o = m(r[c + 4]))[0], n = o[1], r[c + 5]);
                    break;
                case 4:
                    a += s.substr(r[c + 1], r[c + 2]).toUpperCase();
                    break;
                case 8:
                    i = (u = m(r[c + 4]))[0], n = u[1], u = (o = m(r[c + 7]))[0], o = o[1], a += d(i, n, r[c + 5]), a += ":", a += d(u, o, r[c + 8]);
                    break;
                case 9:
                    break;
                case 2:
                    a += "{{" + s.substr(r[c + 1], r[c + 2]) + "}}";
                    break;
                case 3:
                    a += "#REF!";
                    break;
                case 1:
                    a += '"' + s.substr(r[c + 1], r[c + 2]) + '"';
                    break;
                default:
                    a += s.substr(r[c + 1], r[c + 2])
            }
            return a
        }

        function d(t, e, i) {
            var n = "";
            2 & i && (n += "$");
            var o = "";
            for (e += 1; 0 < e;) {
                var r = e % 26;
                0 === r && (r = 26), o = String.fromCharCode(64 + r) + o, e = (e - r) / 26
            }
            return n += o, 1 & i && (n += "$"), n + (t + 1)
        }

        function w(t) {
            return t <= 122 ? 65 <= t || 35 === t || 36 === t : 191 < t
        }

        function C(t) {
            t = t.charCodeAt(0);
            return 48 <= t && t <= 57
        }

        function S(t) {
            return " " === t || "\t" === t || "\n" === t || "\r" === t
        }

        function E(t, e, i) {
            for (var n = t.length, o = !0, r = e, s = !1, a = !1, l = !1, c = 0; r < n; r++) {
                var u = t[r];
                if ("'" !== u) {
                    if (!s) {
                        l = !0;
                        var d = u.charCodeAt(0);
                        if (w(d)) d <= 122 ? 97 <= d && (a = !0) : o = !1, 1 == c && c++; else {
                            if (!C(u)) break;
                            0 == c && c++
                        }
                    }
                } else {
                    if (l) break;
                    if (s) {
                        r++;
                        break
                    }
                    s = !0
                }
            }
            var h = t[r], f = e, p = r - e;
            return s && ((p -= 1 + ("'" === t[r - 1] ? 1 : 0)) < 0 && (p = 0), f++, i = 5), 0 === i && (":" === h && o ? (i = 8, a && (y = !0)) : "!" === h ? i = "#" === t[f] ? 3 : 5 : "(" === h ? ((e = t.substr(f, p)).toUpperCase() !== e && (y = !0), i = 4) : "}" === h ? i = 2 : 1 === c && o ? (i = 7, a && (y = !0)) : i = 6), [f, p, r, i]
        }

        function k(t, e, i) {
            for (var n = 0, o = 0, r = 1, s = 1, a = 0, l = !1, c = e.length - 1; 0 <= c; c--) {
                var u = e[c].charCodeAt(0);
                36 !== u ? u < 58 ? (o += (u - 48) * r, r *= 10) : (l || (n = o, l = !(o = 0), s += r = 1), o += (u - (96 < u ? 96 : 64)) * r, r *= 26) : a += s
            }
            t.push(9, v(n - 1, o - 1, i), a)
        }

        function s(t, e) {
            var i = [];
            y = !1;
            for (var n, o = -1, r = 0; r < t.length; r++) {
                var s, a, l, c, u, d, h, f, p, g, _, v = t[r];
                '"' != v ? -1 < o || ("{" != v || "{" != t[r + 1] ? "'" == v || w(v.charCodeAt(0)) ? (p = (l = E(t, r, 0))[0], g = l[1], s = l[2], h = l[3], a = i.length, 7 !== h && 8 !== h || 5 !== i[i.length - 3] ? (n = e.z, i.push(h, p, g)) : (u = "'" === t[p - 2] ? 1 : 0, l = i[a - 2], c = i[a - 1], void 0 === (n = e.page(t.substr(l, c))) && (i.push(3, 0, 0), n = 0), i.push(h, p - c - 2 * u - 1, g + c + 2 * u + 1)), r = s - 1, 6 === h ? e.name(i, t, e) : 8 === h ? (c = i.length, k(i, t.substr(p, g), n), p = (u = E(t, r + 2, 0))[0], g = u[1], s = u[2], 5 === (h = u[3]) && (p = (d = E(t, s + 1, 0))[0], g = d[1], s = d[2], h = d[3]), 7 === h ? (k(i, t.substr(p, g), n), u = i[c + 1], ((d = i[c + 4]) < u || b(u) > b(d)) && (i[c + 1] = d, i[c + 4] = u), i[c - 1] += g + 1, r = s - 1) : i[c - 3] = 7) : 7 === h ? k(i, t.substr(p, g), n) : 3 !== h && 5 !== h || r++) : r = S(v) ? (h = function (t, e) {
                    for (var i; i = t[++e], S(i);) ;
                    return e
                }(t, r), i.push(12, r, h - r), h - 1) : C(v) ? (f = function (t, e) {
                    for (var i; e++, i = t.charCodeAt(e), 48 <= i && i <= 57;) ;
                    return e
                }(t, r), i.push(11, r, f - r), f - 1) : (v = void 0, "<" === (f = t)[_ = r] ? ">" !== (v = f[_ + 1]) && "=" !== v || _++ : ">" === f[_] && "=" === f[_ + 1] && _++, _ = _ + 1, i.push(10, r, _ - r), _ - 1) : (p = (_ = E(t, r + 2, 2))[0], g = _[1], _ = _[2], i.push(2, p, g), r = _ + 2 - 1)) : o = -1 < o ? (i.push(1, o + 1, r - o - 1), -1) : r
            }
            var m = {code: i, source: t, exec: null, broken: 0, triggers: null};
            return y && (m.source = x(m, e)), m
        }

        var h = [">", "<", "=", "+"];

        function a(u) {
            var t = function () {
                for (var t, e = u.code, i = u.source, n = "", o = e.length, r = 0; r < o; r += 3) switch (e[r]) {
                    case 4:
                        n += "ctx.m." + i.substr(e[r + 1], e[r + 2]).toUpperCase();
                        break;
                    case 1:
                        n += '"' + i.substr(e[r + 1], e[r + 2]) + '"';
                        break;
                    case 2:
                        n += 'ctx.p("' + i.substr(e[r + 1], e[r + 2]) + '")';
                        break;
                    case 6:
                    case 7:
                        var s = void 0, a = void 0;
                        if (10 === e[r - 3] ? s = r - 3 : 12 === e[r - 3] && 10 === e[r - 6] && (s = r - 6), 10 === e[r + 6] ? a = r + 6 : 12 === e[r + 6] && 10 === e[r + 9] && (a = r + 9), s || a) {
                            var l = s ? i[e[s + 1]] : null, c = a ? i[e[a + 1]] : null;
                            if ("&" == l || "&" == c) {
                                n += "(ctx.v(" + e[r + 4] + ') === null ? "" : ctx.v(' + e[r + 4] + "))";
                                break
                            }
                            if (-1 != h.indexOf(l) || -1 != h.indexOf(c)) {
                                n += "(ctx.v(" + e[r + 4] + ") === null ? 0 : ctx.v(" + e[r + 4] + "))";
                                break
                            }
                        }
                        n += "ctx.v(" + e[r + 4] + ")";
                        break;
                    case 8:
                        n += "ctx.r(" + e[r + 4] + ", " + e[r + 7] + ")";
                        break;
                    case 10:
                        1 === e[r + 2] ? n += "&" === (t = i[e[r + 1]]) ? '+""+' : "=" === t ? "==" : ";" === t ? "," : t : 2 === e[r + 2] ? n += "<>" === (t = i.substr(e[r + 1], e[r + 2])) ? "!=" : t : n += i.substr(e[r + 1], e[r + 2]);
                        break;
                    case 11:
                        n += i.substr(e[r + 1], e[r + 2]);
                        break;
                    case 3:
                        return ""
                }
                return n
            }();
            if (!t) return u.broken = 3, void (u.exec = null);
            try {
                u.exec = new Function("ctx", "return " + t)
            } catch (t) {
                u.broken = 1, u.exec = null
            }
        }

        function l(t) {
            var e = new Date(t.getFullYear(), 0, 0),
                t = t.valueOf() - e.valueOf() + 60 * (e.getTimezoneOffset() - t.getTimezoneOffset()) * 1e3;
            return Math.floor(t / 864e5)
        }

        function u(t) {
            t = new Date(Math.round(86400 * (t - 25569) * 1e3));
            return new Date(t.getTime() + 6e4 * t.getTimezoneOffset())
        }

        function f(t) {
            return 25569 + (t.getTime() - 6e4 * t.getTimezoneOffset()) / 864e5
        }

        function p(t) {
            return !(!t && 0 !== t || (t *= 1, isNaN(t))) && t
        }

        function g(t) {
            for (var e = [], i = 0; i < t.length; i++) e = e.concat(t[i]);
            return e
        }

        function _(t) {
            return !t && 0 !== t
        }

        function M(t) {
            return 0 < t ? Math.floor(t) : Math.ceil(t)
        }

        function I(t) {
            return t < 0 ? Math.floor(t) : Math.ceil(t)
        }

        var D = Object.freeze({
                __proto__: null, SUM: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    for (var i = 0, n = g(t), o = 0; o < n.length; o++) {
                        var r = p(n[o]);
                        "number" == typeof r && (i += r)
                    }
                    return i
                }, AVERAGE: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    for (var i = 0, n = 0, o = g(t), r = 0; r < o.length; r++) {
                        var s = p(o[r]);
                        "number" == typeof s && (i += s, n++)
                    }
                    return i / n
                }, COUNT: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    for (var i = 0, n = g(t), o = 0; o < n.length; o++) "number" == typeof p(n[o]) && i++;
                    return i
                }, COUNTA: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    for (var i = 0, n = g(t), o = 0; o < n.length; o++) n[o] && 0 != +n[o] && i++;
                    return i
                }, COUNTBLANK: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    for (var i = 0, n = g(t), o = 0; o < n.length; o++) 0 === n[o] || n[o] || i++;
                    return i
                }, MAX: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    for (var i = -1 / 0, n = g(t), o = 0; o < n.length; o++) {
                        var r = p(n[o]);
                        "number" == typeof r && i < r && (i = r)
                    }
                    return i === -1 / 0 ? 0 : i
                }, MIN: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    for (var i = 1 / 0, n = g(t), o = 0; o < n.length; o++) {
                        var r = p(n[o]);
                        "number" == typeof r && r < i && (i = r)
                    }
                    return i === 1 / 0 ? 0 : i
                }, PRODUCT: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    for (var i = !1, n = 1, o = g(t), r = 0; r < o.length; r++) {
                        var s = p(o[r]);
                        "number" == typeof s && (i = !0, n *= s)
                    }
                    return i ? n : null
                }, SUMPRODUCT: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    var i = t[0].length;
                    for (o in t) if (t[o].length !== i) return;
                    for (var n = 0, o = 0; o < t[0].length; o++) {
                        var r, s = !1, a = 1;
                        for (r in t) {
                            var l = p(t[r][o]);
                            "number" == typeof l && (a *= l, s = !0)
                        }
                        s && (n += a)
                    }
                    return n
                }, SUMSQ: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    for (var i = 0, n = g(t), o = 0; o < n.length; o++) {
                        var r = p(n[o]);
                        "number" == typeof r && (i += Math.pow(r, 2))
                    }
                    return i
                }, VARP: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    for (var i = g(t), n = this.COUNT(i), o = this.AVERAGE(i), r = 0, s = 0; s < i.length; s++) {
                        var a = p(i[s]);
                        "number" == typeof a && (r += Math.pow(a - o, 2))
                    }
                    return r / n
                }, STDEVP: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    var i = g(t);
                    return Math.sqrt(this.VARP(i))
                }, POWER: function (t, e) {
                    t = p(t), e = p(e);
                    if ("number" == typeof t && "number" == typeof e) return Math.pow(t, e)
                }, QUOTIENT: function (t, e) {
                    t = p(t), e = p(e);
                    if ("number" == typeof t && "number" == typeof e) return M(t / e)
                }, SQRT: function (t) {
                    t = p(t);
                    if ("number" == typeof t && 0 <= t) return Math.sqrt(t)
                }, ABS: function (t) {
                    t = p(t);
                    if ("number" == typeof t) return Math.abs(t)
                }, RAND: function () {
                    return Math.random()
                }, PI: function () {
                    return Math.PI
                }, INT: function (t) {
                    t = p(t);
                    if ("number" == typeof t) return Math.floor(t)
                }, ROUND: function (t, e) {
                    t = p(t), e = p(e) || 0;
                    if ("number" == typeof t && "number" == typeof e) return parseFloat(t.toFixed(e))
                }, ROUNDDOWN: function (t, e) {
                    t = p(t), e = p(e) || 0;
                    if ("number" == typeof t && "number" == typeof e) return Math.floor(t * Math.pow(10, e)) / Math.pow(10, e)
                }, ROUNDUP: function (t, e) {
                    t = p(t), e = p(e) || 0;
                    if ("number" == typeof t && "number" == typeof e) return Math.ceil(t * Math.pow(10, e)) / Math.pow(10, e)
                }, TRUNC: function (t) {
                    t = p(t);
                    if ("number" == typeof t) return M(t)
                }, EVEN: function (t) {
                    var e = p(t);
                    if ("number" == typeof e) {
                        t = I(e);
                        return t % 2 ? t + Math.sign(e) : t
                    }
                }, ODD: function (t) {
                    var e = p(t);
                    if ("number" == typeof e) {
                        t = I(e);
                        return t % 2 ? t : t + Math.sign(e)
                    }
                }
            }), O = Object.freeze({
                __proto__: null, CONCATENATE: function () {
                    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                    return g(t).join("")
                }, LEFT: function (t, e) {
                    return _(t) ? "" : t.toString().substring(0, e)
                }, MID: function (t, e, i) {
                    return _(t) ? "" : t.toString().substring(e, e + i)
                }, RIGHT: function (t, e) {
                    return _(t) ? "" : t.toString().substring(t.length - e)
                }, LOWER: function (t) {
                    return _(t) ? "" : t.toString().toLowerCase()
                }, UPPER: function (t) {
                    return _(t) ? "" : t.toString().toUpperCase()
                }, PROPER: function (t) {
                    if (_(t)) return "";
                    var e, i = t.toString().toLowerCase().split(" ");
                    for (e in t = "", i) t += (t ? " " : "") + i[e].substring(0, 1).toUpperCase() + i[e].substring(1);
                    return t
                }, TRIM: function (t) {
                    return _(t) ? "" : t.toString().trim()
                }, LEN: function (t) {
                    return _(t) ? 0 : t.toString().length
                }
            }), A = Object.freeze({
                __proto__: null, DATE: function (t, e, i) {
                    return f(new Date(t, e - 1, i))
                }, TIME: function (t, e, i) {
                    return f(new Date(1900, 0, 1, t, e, i))
                }, DAY: function (t) {
                    return u(t).getDate()
                }, MONTH: function (t) {
                    return u(t).getMonth() + 1
                }, YEAR: function (t) {
                    return u(t).getFullYear()
                }, HOUR: function (t) {
                    return u(t).getHours()
                }, MINUTE: function (t) {
                    return u(t).getMinutes()
                }, SECOND: function (t) {
                    return u(t).getSeconds()
                }, NOW: function () {
                    return f(new Date)
                }, DATEDIF: function (t, e, i) {
                    if ("D" === i) return e - t;
                    var n, o, r = u(t), s = u(e);
                    switch (i) {
                        case"Y":
                            return s.getFullYear() - r.getFullYear();
                        case"M":
                            return (n = 12 * (s.getFullYear() - r.getFullYear())) + s.getMonth() - r.getMonth();
                        case"D":
                            return Math.floor(e - t);
                        case"MD":
                            if ((o = s.getDate() - r.getDate()) < 0) {
                                var a = new Date(r.getFullYear(), r.getMonth() + 1, 0).getDate();
                                return s.getDate() + a - r.getDate()
                            }
                            return o;
                        case"YM":
                            return (n = s.getMonth() - r.getMonth()) < 0 ? 12 + n : n;
                        case"YD":
                            return (o = l(s) - l(r)) < 0 ? 365 + o : o
                    }
                }
            }), P = Object.freeze({
                __proto__: null, IF: function (t, e, i) {
                    return t ? e : i
                }
            }), T = {number: D, string: O, date: A, other: P}, R = c(c(c(c({}, D), O), A), P), L = Math.pow(10, 8),
            H = (F.prototype.setValue = function (t, e, i, n) {
                "" === e && (e = null), this._setter(t, e, i) && (this._removeTriggers(t, null), n || this.trigger(t))
            }, F.prototype.clean = function (t) {
                this._removeTriggers(t, null)
            }, F.prototype.getValue = function (t) {
                return this._getter(t)
            }, F.prototype.setPlaceholder = function (i, t) {
                var n = this;
                "*" === i ? Object.entries(t).forEach(function (t) {
                    return n.setPlaceholder(t[0], t[1])
                }) : (null === t ? delete this._holders[i] : this._holders[i] = t, this.each(function (t, e) {
                    !function (t, e, i) {
                        for (var n = 0; n < t.length; n += 3) if (2 === t[n] && e.substr(t[n + 1], t[n + 2]) == i) return 1
                    }(e.code, e.source, i) || n.setMath(t, e.source, n._parseContext)
                }))
            }, F.prototype.getPlaceholder = function (t) {
                if ("*" === t) return this._holders;
                t = this._holders[t];
                return void 0 === t ? null : t
            }, F.prototype.setMath = function (t, e, i, n) {
                i = this._generate(e, i), i = this._setMathAt(t, i);
                n || this._execAndTrigger(i)
            }, F.prototype.refresh = function (t) {
                this._execAndTrigger(t)
            }, F.prototype.getMath = function (t) {
                return this._data.get(t)
            }, F.prototype.trigger = function (t, e) {
                var i = this._triggers.get(t);
                if (i) {
                    if (e) {
                        var n = e[t] || 0;
                        if (!(n < 100)) return;
                        e[t] = n + 1
                    } else (n = {})[t] = 1, e = n;
                    for (var o = 0; o < i.length; o++) this._execAndTrigger(i[o], e)
                }
            }, F.prototype._setMathAt = function (t, e) {
                if (this._removeTriggers(t, e)) {
                    if (e.triggers) if (-1 === e.triggers.indexOf(t)) for (var i = 0; i < e.triggers.length; i++) {
                        var n = e.triggers[i], o = this._triggers.get(n);
                        void 0 === o && (o = [], this._triggers.set(n, o)), o.push(t)
                    } else e = c(c({}, e), {broken: 3});
                    return this._data.set(t, e), t
                }
            }, F.prototype._removeTriggers = function (e, t) {
                var i = this._data.get(e);
                if (!i) return !0;
                if (i === t) return !1;
                var n = i.triggers;
                if (n && 3 !== i.broken) for (var o = 0; o < n.length; o++) {
                    var r = n[o], s = this._triggers.get(r), r = s.findIndex(function (t) {
                        return t === e
                    });
                    s.splice(r, 1)
                }
                return this._data.delete(e), !0
            }, F.prototype.parse = function (t, e) {
                return this._parser(t, e || this._parseContext)
            }, F.prototype.exec = function (t, e) {
                e = this._generate(t, e);
                return this._exec(e)
            }, F.prototype.each = function (e) {
                var i = this;
                Array.from(this._data.keys()).forEach(function (t) {
                    return e(t, i._data.get(t))
                })
            }, F.prototype.setLogger = function (t) {
                this._err_handler = t
            }, F.prototype._setErr = function (t, e) {
                return t.broken = 2, e && this._err_handler && this._err_handler(e), n[t.broken]
            }, F.prototype._exec = function (e) {
                if (0 < e.broken && 2 !== e.broken) return n[e.broken];
                try {
                    var t = e.exec(this._context);
                    return e.broken = 0, "number" == typeof t ? isFinite(t) ? Math.round(t * L) / L : this._setErr(e) : t
                } catch (t) {
                    return this._setErr(e, t)
                }
            }, F.prototype.toString = function (t, e) {
                return x(t, e || this._parseContext)
            }, F.prototype.regenerate = function (r, s, a) {
                var l = this;
                a = c({}, a || this._parseContext), Array.from(this._data.keys()).forEach(function (t) {
                    var e = !1, i = l._data.get(t), n = 63 & t;
                    if (s && n === r) l._removeTriggers(t, null); else {
                        for (var o = 0; o < i.code.length; o += 3) if (9 === i.code[o] && (63 & i.code[o + 1]) === r) {
                            e = !0;
                            break
                        }
                        e && (a.z = n, s ? l.setMath(t, i.source, a) : (i.source = x(i, a), i.code = l._parser(i.source, a).code))
                    }
                })
            }, F.prototype.recalculate = function (i, n) {
                var o = this;
                n = c({}, n || this._parseContext), this.each(function (t) {
                    if (i) {
                        var e = o._data.get(t);
                        if (e.broken && 2 !== e.broken) return n.z = 63 & t, void o.setMath(t, e.source, n)
                    }
                    o._execAndTrigger(t)
                })
            }, F.prototype._generate = function (t, e, i) {
                var o = i || this._parser(t, e || this._parseContext);
                return this._printer(o), o.triggers = function () {
                    for (var e = [], t = o.code, i = t.length, n = 0; n < i; n += 3) switch (t[n]) {
                        case 7:
                        case 6:
                            e.push(t[n + 4]);
                            break;
                        case 8:
                            r(t[n + 4], t[n + 7], function (t) {
                                return e.push(t)
                            })
                    }
                    return e.length ? e : null
                }(), o
            }, F.prototype._execAndTrigger = function (t, e) {
                var i = this._data.get(t);
                if (!i) return !1;
                i = this._exec(i);
                return this._setter && this._setter(t, i) && this.trigger(t, e), !0
            }, F.prototype.debug = function (t) {
                console.log(function (t) {
                    for (var e = t.code, i = t.source, n = "", o = e.length, r = 0; r < o; r += 3) {
                        var s = e[r], a = void 0;
                        switch (s) {
                            case 4:
                                a = "method";
                                break;
                            case 1:
                                a = "text";
                                break;
                            case 5:
                                a = "page";
                                break;
                            case 2:
                                a = "holder";
                                break;
                            case 6:
                                a = "name";
                                break;
                            case 7:
                                a = "arg";
                                break;
                            case 8:
                                a = "range";
                                break;
                            case 9:
                                a = "data";
                                break;
                            case 10:
                                a = "op";
                                break;
                            case 11:
                                a = "number";
                                break;
                            case 3:
                                a = "error";
                                break;
                            case 12:
                                a = "extra"
                        }
                        n += 9 === s ? "              " + e[r + 1] + " x " + e[r + 2] + ")\n" : "[" + a + "]" + "              ".substr(0, 10 - a.length) + i.substr(e[r + 1], e[r + 2]) + "\n"
                    }
                    return n
                }(this.parse(t)))
            }, F.prototype.transpose = function (t, a, l, c) {
                var u = this;
                c = c || this._parseContext;
                var t = m(t), d = t[0], h = t[1], f = t[2], p = [], g = new Map, _ = new Map;
                Array.from(this._data.keys()).forEach(function (t) {
                    var e = m(t), i = e[0], n = e[1], o = e[2], r = u._data.get(t), s = u._transpose(r, d, h, a, l, c),
                        e = t;
                    o === f && (h <= n || d <= i) && (e = v(d <= i ? i + a : i, h <= n ? n + l : n, o)), r === s && t === e || (_.set(t, s), o === f && (l < 0 && h <= n && n < h - l || a < 0 && d <= i && i < d - a) || (g.set(e, s), p.push(e)))
                }), Array.from(g.keys()).forEach(function (t) {
                    return u._setMathAt(t, g.get(t))
                }), Array.from(_.keys()).forEach(function (t) {
                    g.has(t) || u._removeTriggers(t, null)
                });
                for (var e = 0; e <= p.length; e++) this._execAndTrigger(p[e]) || this.trigger(p[e])
            }, F.prototype.transposeMath = function (t, e, i, n) {
                return "string" == typeof t && (t = this.parse(t, n)), this._transpose(t, -1, -1, e, i, n || this._parseContext).source
            }, F.prototype._transpose = function (t, e, i, n, o, r) {
                for (var s = !0, a = t.code, l = !(e < 0 || i < 0), c = 0; c < a.length; c += 3) if (7 === a[c]) {
                    var u = m(a[c + 4]), d = u[0], h = u[1], f = u[2];
                    if (r.z !== f) continue;
                    var p = a[c + 5];
                    if (!l && 3 == p) continue;
                    (l || 0 == (1 & p)) && e <= d && (s && (a = [].concat(a), s = !1), ((d += n) < e || d < 0) && (a[c] = 3)), (l || 0 == (2 & p)) && i <= h && (s && (a = [].concat(a), s = !1), ((h += o) < i || h < 0) && (a[c] = 3)), s || (a[c + 4] = v(d, h, f)), c += 3
                } else if (8 === a[c]) {
                    var g = a[c + 5], _ = a[c + 8];
                    if (!l && 3 === g && 3 === _) continue;
                    u = m(a[c + 4]), p = u[0], d = u[1], h = (f = u[2], m(a[c + 7])), u = h[0], h = h[1];
                    if (r.z !== f) continue;
                    n && ((l || 0 == (1 & g)) && (0 < n ? e <= p : e < p) && (s && (a = [].concat(a), s = !1), (p += n) < 0 && (a[c] = 3)), (l || 0 == (1 & _)) && e <= u && (s && (a = [].concat(a), s = !1), (u += n) < p && (a[c] = 3))), o && ((l || 0 == (2 & g)) && (0 < o ? i <= d : i < d) && (s && (a = [].concat(a), s = !1), (d += o) < 0 && (a[c] = 3)), (l || 0 == (2 & _)) && i <= h && (s && (a = [].concat(a), s = !1), (h += o) < d && (a[c] = 3))), s || (a[c + 4] = v(p, d, f), a[c + 7] = v(u, h, f)), c += 6
                }
                if (s) return t;
                t = {
                    code: a,
                    broken: t.broken,
                    source: t.source,
                    triggers: null,
                    exec: null
                }, t = this._parser(x(t, r), r);
                return this._generate(t.source, r, t)
            }, F);

        function F(t) {
            var n = this;
            (t = t || {
                get: null,
                set: null
            }) && (this._getter = t.get, this._setter = t.set), this._parser = s, this._printer = a, this._parseContext = {
                name: function () {
                }, pageName: function () {
                    return ""
                }, pageObj: function () {
                    return null
                }, page: function () {
                    return 0
                }, z: 0
            }, this._data = new Map, this._triggers = new Map, this._holders = {}, this._context = {
                v: function (t) {
                    if (-1 === t) throw new Error;
                    t = n._getter(t);
                    return void 0 === t ? null : t
                }, r: function (t, e) {
                    var i = [];
                    return r(t, e, function (t) {
                        return i.push(n._getter(t))
                    }), i
                }, m: R, e: function (t) {
                    throw t
                }, p: function (t) {
                    return n.getPlaceholder(t)
                }
            }
        }

        var j = (N.prototype.getMeta = function () {
            return this._meta
        }, N.prototype.setMeta = function (t) {
            this._meta = c(c({}, this._meta), t)
        }, N.prototype.getID = function () {
            return this._id
        }, N.prototype.cellID = function (t, e) {
            return v(t, e, this._id)
        }, N.prototype.getSize = function () {
            var t = this._data.length, e = 0;
            return this._data.forEach(function (t) {
                t && t.length > e && (e = t.length)
            }), [t, e]
        }, N.prototype.getContext = function () {
            return this._parseContext
        }, N.prototype.addRow = function (t, e) {
            this._data.splice.apply(this._data, $(t, e)), this._store.transpose(v(t, 0, this._id), e, 0, this._parseContext)
        }, N.prototype.removeRow = function (t, e) {
            this._data.splice(t, e), this._store.transpose(v(t, 0, this._id), -e, 0, this._parseContext)
        }, N.prototype.addColumn = function (t, e) {
            var i = $(t, e);
            this._data.forEach(function (t) {
                t && t.splice.apply(t, i)
            }), this._store.transpose(v(0, t, this._id), 0, e, this._parseContext)
        }, N.prototype.removeColumn = function (e, i) {
            this._data.forEach(function (t) {
                t && t.splice(e, i)
            }), this._store.transpose(v(0, e, this._id), 0, -i, this._parseContext)
        }, N.prototype.setCell = function (t, e, i) {
            var n = this._data[t], o = (n = n || (this._data[t] = []))[e];
            n[e] = o ? c(c(c({}, o), i), {value: o.value}) : i, void 0 !== i.value && this.setValue(t, e, i.value)
        }, N.prototype.setValue = function (t, e, i, n) {
            "string" == typeof i && 1 < i.length && "=" === i[0] ? this._store.setMath(v(t, e, this._id), i.substr(1), this._parseContext) : this._store.setValue(v(t, e, this._id), i, n)
        }, N.prototype.getCell = function (t, e, i) {
            var n = this._data[t], o = n ? n[e] : null;
            return o || !i || ((o = (n = n || (this._data[t] = []))[e]) || (o = n[e] = {value: ""})), o
        }, N.prototype.getValue = function (t, e, i) {
            if (i) {
                i = this._store.getMath(v(t, e, this._id));
                if (i) return "=" + i.source
            }
            e = this.getCell(t, e, !1);
            return e ? e.value : null
        }, N.prototype.getRange = function (t, e, i, n) {
            for (var o = [], r = t; r <= i; r++) for (var s = e; s <= n; s++) o.push(this.getValue(r, s, !1));
            return o
        }, N.prototype.getCellRange = function (t, e, i, n) {
            for (var o = [], r = t; r <= i; r++) for (var s = e; s <= n; s++) o.push(this.getCell(r, s));
            return o
        }, N.prototype.eachCell = function (n) {
            this._data.forEach(function (t, i) {
                t && t.forEach(function (t, e) {
                    t && n(i, e, t)
                })
            })
        }, N.prototype.serialize = function (o) {
            var r = this, s = [];
            return this.eachCell(function (t, e, i) {
                var n;
                i = c({}, i), o && (n = r._store.getMath(v(t, e, r.getID()))) && (i.value = "=" + n.source), s.push([t, e, i])
            }), s
        }, N.prototype.parse = function (t, s) {
            var a = this;
            this._store.each(function (t) {
                (63 & t) === a._id && a._store.clean(t)
            }), this._data = [], t.forEach(function (t) {
                var e, i = t[0], n = t[1], o = t[2], r = (o = (a._data[i] || (a._data[i] = []))[n] = c({}, o)).value;
                r && ("string" == typeof r && "=" === r[0] ? (e = v(i, n, a._id), t = r.substr(1), a._store.setMath(e, t, a.getContext())) : s && (o.value = null, e = v(i, n, a._id), a._store.setValue(e, r)))
            }), this._store.each(function (t, e) {
                e.triggers && (63 & t) !== a._id && e.triggers.find(function (t) {
                    return (63 & t) === a._id
                }) && a._store.refresh(t)
            })
        }, N);

        function N(t, e, i) {
            this._data = [], this._id = t, this._store = e, this._meta = {}, this._parseContext = c(c({}, i), {z: t})
        }

        function $(t, e) {
            for (var i = [t, 0], n = 0; n < e; n++) i.push(null);
            return i
        }

        var V = (z.prototype.get = function (t) {
            return this._store.getMath(this._ranges.get(t))
        }, z.prototype.toId = function (t) {
            return this._ranges.get(t)
        }, z.prototype.add = function (t, e) {
            var i = this._ranges.get(t) || this._next_id();
            this._store.setMath(i, e, this._page.getContext()), this._ranges.set(t, i), this._refresh(t)
        }, z.prototype.remove = function (t) {
            this._ranges.delete(t), this._counter = 1, this._refresh(t)
        }, z.prototype.serialize = function () {
            var e = this;
            return Array.from(this._ranges.keys()).map(function (t) {
                return [t, e.get(t).source]
            })
        }, z.prototype.parse = function (t) {
            var e = this;
            t.forEach(function (t) {
                return e.add(t[0], t[1])
            })
        }, z.prototype._refresh = function (n) {
            var o = this, t = n.indexOf("!"), r = "";
            -1 !== t && (r = n.substr(0, t), n = n.substr(t + 1)), this._store.each(function (t, e) {
                var i;
                !function (t, e, i, n) {
                    for (var o = 0; o < t.length; o += 3) if (6 === t[o]) {
                        if ("" !== i) {
                            if (5 === t[o - 3] && e.substr(t[o - 2], t[o - 1]) !== i) continue;
                            return 1
                        }
                        if (e.substr(t[o + 1], t[o + 2]) === n) return 1
                    }
                }(e.code, e.source, r, n) || (i = 63 & t, o._store.setMath(t, e.source, o._pageGetter(i).getContext()))
            })
        }, z.prototype._next_id = function () {
            for (; this._rangeOrder[this._counter];) this._counter++;
            return this._rangeOrder[this._counter] = !0, v(this._counter, 0, this._page.getID())
        }, z.prototype.renamePage = function (n, o) {
            var r = this;
            n += "!", o && (o += "!"), this._ranges.forEach(function (t, e, i) {
                0 === e.indexOf(n) && (o ? i.set(e.replace(n, o), t) : r._store.clean(t), i.delete(e))
            })
        }, z);

        function z(t, e, i) {
            this._ranges = new Map, this._counter = 1, this._rangeOrder = [], this._store = t, this._page = e, this._pageGetter = i
        }

        W.prototype.addPage = function (t) {
            for (; this._pages[this._pCounter];) this._pCounter++;
            var e = this._pCounter, i = new j(e, this._store, this._parseContext);
            return this._pageName2ID.set(t, e), this._pages[e] = i, this._pageNames[e] = t, i
        }, W.prototype.renamePage = function (t, e) {
            var i;
            t !== e && (i = this._pageName2ID.get(t), this._pageName2ID.delete(t), this._pageName2ID.set(e, i), this._pageNames[i] = e, this._ranges.renamePage(t, e), e = this._pages[i].getContext(), this._store.regenerate(i, !1, e))
        }, W.prototype.removePage = function (t) {
            var e = this._pageName2ID.get(t), i = this._pages[e].getContext();
            this._pageName2ID.delete(t), this._pages[e] = this._pageNames[e] = null, this._pCounter = 0, this._ranges.renamePage(t, null), this._store.regenerate(e, !0, i)
        }, W.prototype.getPage = function (t) {
            return "string" == typeof t && (t = this._pageName2ID.get(t)), this._pages[t]
        }, W.prototype.getRanges = function () {
            return this._ranges
        }, W.prototype.getStore = function () {
            return this._store
        }, P = W;

        function W() {
            var s = this;
            this._pages = [], this._pageNames = [], this._pageName2ID = new Map, this._pCounter = 0, this._parseContext = {
                page: function (t) {
                    return s._pageName2ID.get(t)
                }, pageName: function (t) {
                    return s._pageNames[t]
                }, pageObj: function (t) {
                    return s._pages[t]
                }, name: function (t, e, i) {
                    var n = t.length, o = e.substr(t[n - 2], t[n - 1]);
                    o = 5 === t[n - 6] ? (n = e.substr(t[n - 5], t[n - 4]), s._ranges.toId(n + "!" + o) || s._ranges.toId(o)) : s._ranges.toId(i.pageName(i.z) + "!" + o) || s._ranges.toId(o), t.push(9, o || -1, 0)
                }, z: 0
            }, this._store = new H({
                get: function (t) {
                    var e = m(t), i = e[0], t = e[1], e = e[2];
                    return s._pages[e].getValue(i, t)
                }, set: function (t, e, i) {
                    var n = m(t), o = n[0], r = n[1], t = n[2], n = s._pages[t], t = n.getCell(o, r, !0);
                    return void 0 === i && (i = t.$format || 0), t.$format = i, "string" == typeof e && 1 != i && e && parseFloat(e) == e && (e = parseFloat(e)), n.getValue(o, r, !0) !== e && (t.value = e, !0)
                }
            });
            var t = this._pages[63] = new j(63, this._store, this._parseContext);
            this._ranges = new V(this._store, t, this.getPage.bind(this))
        }

        e.D_COMMON = 0, e.D_STRING = 1, e.DataPage = j, e.DataStore = P, e.Store = H, e.T_ARG = 7, e.T_DATA = 9, e.T_ERROR = 3, e.T_METHOD = 4, e.T_NAME = 6, e.T_NUMBER = 11, e.T_OPERATOR = 10, e.T_PAGE = 5, e.T_PLACEHOLDER = 2, e.T_RANGE = 8, e.T_SPACE = 12, e.T_TEXT = 1, e.addMethod = function (t, e) {
            R[t] = e
        }, e.column = function (t) {
            return t >> 6 & 4095
        }, e.fromId = m, e.methodGroups = T, e.methods = R, e.page = o, e.row = b, e.str2id = function (t) {
            var e = [];
            return k(e, t, 0), e[1]
        }, e.str2pos = function (t) {
            var e = [];
            return k(e, t, 0), m(e[1]).slice(0, 2)
        }, e.str2range = function (t) {
            var e = [];
            t.split(":").map(function (t) {
                return k(e, t, 0)
            });
            var i = m(e[1]), n = i[0], t = i[1], i = m(e[4]);
            return [n, t, i[0], i[1]]
        }, e.toId = v
    }, function (t, n, e) {
        "use strict";
        Object.defineProperty(n, "__esModule", {value: !0});
        var i = e(1), o = e(1);
        n.locale = {
            monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Monday"],
            cancel: "Cancel"
        };
        var v, r = {
            "%d": function (t) {
                t = t.getDate();
                return t < 10 ? "0" + t : t
            }, "%j": function (t) {
                return t.getDate()
            }, "%l": function (t) {
                return n.locale.days[t.getDay()]
            }, "%D": function (t) {
                return n.locale.daysShort[t.getDay()]
            }, "%m": function (t) {
                t = t.getMonth() + 1;
                return t < 10 ? "0" + t : t
            }, "%n": function (t) {
                return t.getMonth() + 1
            }, "%M": function (t) {
                return n.locale.monthsShort[t.getMonth()]
            }, "%F": function (t) {
                return n.locale.months[t.getMonth()]
            }, "%y": function (t) {
                return t.getFullYear().toString().slice(2)
            }, "%Y": function (t) {
                return t.getFullYear()
            }, "%h": function (t) {
                t = t.getHours() % 12;
                return 0 === t && (t = 12), t < 10 ? "0" + t : t
            }, "%g": function (t) {
                t = t.getHours() % 12;
                return 0 === t && (t = 12), t
            }, "%H": function (t) {
                t = t.getHours();
                return t < 10 ? "0" + t : t
            }, "%G": function (t) {
                return t.getHours()
            }, "%i": function (t) {
                t = t.getMinutes();
                return t < 10 ? "0" + t : t
            }, "%s": function (t) {
                t = t.getSeconds();
                return t < 10 ? "0" + t : t
            }, "%a": function (t) {
                return 12 <= t.getHours() ? "pm" : "am"
            }, "%A": function (t) {
                return 12 <= t.getHours() ? "PM" : "AM"
            }, "%u": function (t) {
                return t.getMilliseconds()
            }
        }, m = {
            "%d": function (t, e) {
                /(^([0-9][0-9])$)/i.test(e) ? t.setDate(Number(e)) : t.setDate(Number(1))
            }, "%j": function (t, e) {
                /(^([0-9]?[0-9])$)/i.test(e) ? t.setDate(Number(e)) : t.setDate(Number(1))
            }, "%m": function (t, e) {
                /(^([0-9][0-9])$)/i.test(e) ? t.setMonth(Number(e) - 1) : t.setMonth(Number(0))
            }, "%n": function (t, e) {
                /(^([0-9]?[0-9])$)/i.test(e) ? t.setMonth(Number(e) - 1) : t.setMonth(Number(0))
            }, "%M": function (t, e) {
                var i = o.findIndex(n.locale.monthsShort, function (t) {
                    return t === e
                });
                -1 === i ? t.setMonth(0) : t.setMonth(i)
            }, "%F": function (t, e) {
                var i = o.findIndex(n.locale.months, function (t) {
                    return t === e
                });
                -1 === i ? t.setMonth(0) : t.setMonth(i)
            }, "%y": function (t, e) {
                /(^([0-9][0-9])$)/i.test(e) ? t.setFullYear(Number("20" + e)) : t.setFullYear(Number("2000"))
            }, "%Y": function (t, e) {
                /(^([0-9][0-9][0-9][0-9])$)/i.test(e) ? t.setFullYear(Number(e)) : t.setFullYear(Number("2000"))
            }, "%h": function (t, e, i) {
                /(^0[1-9]|1[0-2]$)/i.test(e) && "pm" === i || "PM" === i ? t.setHours(Number(e)) : t.setHours(Number(0))
            }, "%g": function (t, e, i) {
                /(^[1-9]$)|(^0[1-9]|1[0-2]$)/i.test(e) && "pm" === i || "PM" === i ? t.setHours(Number(e)) : t.setHours(Number(0))
            }, "%H": function (t, e) {
                /(^[0-2][0-9]$)/i.test(e) ? t.setHours(Number(e)) : t.setHours(Number(0))
            }, "%G": function (t, e) {
                /(^[1-9][0-9]?$)/i.test(e) ? t.setHours(Number(e)) : t.setHours(Number(0))
            }, "%i": function (t, e) {
                /(^([0-5][0-9])$)/i.test(e) ? t.setMinutes(Number(e)) : t.setMinutes(Number(0))
            }, "%s": function (t, e) {
                /(^([0-5][0-9])$)/i.test(e) ? t.setSeconds(Number(e)) : t.setSeconds(Number(0))
            }, "%a": function (t, e) {
                "pm" === e && t.setHours(t.getHours() + 12)
            }, "%A": function (t, e) {
                "PM" === e && t.setHours(t.getHours() + 12)
            }
        };

        function y(t) {
            for (var e = [], i = "", n = 0; n < t.length; n++) "%" === t[n] ? (0 < i.length && (e.push({
                type: v.separator,
                value: i
            }), i = ""), e.push({type: v.datePart, value: t[n] + t[n + 1]}), n++) : i += t[n];
            return 0 < i.length && e.push({type: v.separator, value: i}), e
        }

        function s(t, e, i) {
            if ("string" == typeof t) {
                for (var n, o = [], r = 0, s = null, a = 0, l = y(e); a < l.length; a++) {
                    var c = l[a];
                    if (c.type === v.separator) {
                        var u = t.indexOf(c.value, r);
                        if (-1 === u) {
                            if (i) return !1;
                            throw new Error("Incorrect date, see docs: https://docs.dhtmlx.com/suite/calendar__api__calendar_dateformat_config.html")
                        }
                        s && (o.push({formatter: s, value: t.slice(r, u)}), s = null), r = u + c.value.length
                    } else c.type === v.datePart && (s = c.value)
                }
                "%A" === s || "%a" === s ? o.unshift({formatter: s, value: t.slice(r)}) : s && o.push({
                    formatter: s,
                    value: t.slice(r)
                }), o.reverse();
                for (var d = 0, h = o; d < h.length; d++) "%A" !== (_ = h[d]).formatter && "%a" !== _.formatter || (n = _.value);
                for (var f = new Date(0), p = 0, g = o; p < g.length; p++) {
                    var _ = g[p];
                    m[_.formatter] && m[_.formatter](f, _.value, n)
                }
                return !!i || f
            }
        }

        (e = v = v || {})[e.separator = 0] = "separator", e[e.datePart = 1] = "datePart", n.getFormattedDate = function (t, i) {
            return y(t).reduce(function (t, e) {
                return e.type === v.separator ? t + e.value : r[e.value] ? t + r[e.value](i) : t
            }, "")
        }, n.stringToDate = s;
        a.copy = function (t) {
            return new Date(t)
        }, a.fromYear = function (t) {
            return new Date(t, 0, 1)
        }, a.fromYearAndMonth = function (t, e) {
            return new Date(t, e, 1)
        }, a.weekStart = function (t, e) {
            e = (t.getDay() + 7 - e) % 7;
            return new Date(t.getFullYear(), t.getMonth(), t.getDate() - e)
        }, a.monthStart = function (t) {
            return new Date(t.getFullYear(), t.getMonth(), 1)
        }, a.yearStart = function (t) {
            return new Date(t.getFullYear(), 0, 1)
        }, a.dayStart = function (t) {
            return new Date(t.getFullYear(), t.getMonth(), t.getDate())
        }, a.addDay = function (t, e) {
            return void 0 === e && (e = 1), new Date(t.getFullYear(), t.getMonth(), t.getDate() + e)
        }, a.addMonth = function (t, e) {
            return void 0 === e && (e = 1), new Date(t.getFullYear(), t.getMonth() + e)
        }, a.addYear = function (t, e) {
            return void 0 === e && (e = 1), new Date(t.getFullYear() + e, t.getMonth())
        }, a.withHoursAndMinutes = function (t, e, i, n) {
            return void 0 === n || !n && 12 === e || n && 12 !== e ? new Date(t.getFullYear(), t.getMonth(), t.getDate(), e, i) : n && 12 === e ? new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, i) : new Date(t.getFullYear(), t.getMonth(), t.getDate(), e + 12, i)
        }, a.setMonth = function (t, e) {
            t.setMonth(e)
        }, a.setYear = function (t, e) {
            t.setFullYear(e)
        }, a.mergeHoursAndMinutes = function (t, e) {
            return new Date(t.getFullYear(), t.getMonth(), t.getDate(), e.getHours(), e.getMinutes())
        }, a.isWeekEnd = function (t) {
            return 0 === t.getDay() || 6 === t.getDay()
        }, a.getTwelweYears = function (t) {
            t = t.getFullYear(), t -= t % 12;
            return i.range(t, 11 + t)
        }, a.getWeekNumber = function (t) {
            6 !== t.getDay() && (t = a.addDay(t, 6 - t.getDay()));
            var e = (t.valueOf() - a.yearStart(t).valueOf()) / 864e5;
            return Math.floor((e - t.getDay() + 10) / 7)
        }, a.isSameDay = function (t, e) {
            return t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth() && t.getDate() === e.getDate()
        }, a.toDateObject = function (t, e) {
            return "string" == typeof t ? s(t, e) : new Date(t)
        }, a.nullTimestampDate = new Date(0), e = a;

        function a() {
        }

        n.DateHelper = e
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(103)), n(e(26))
    }, function (t, e, i) {
        "use strict";
        var n;
        Object.defineProperty(e, "__esModule", {value: !0}), (n = e.LayoutEvents || (e.LayoutEvents = {})).beforeShow = "beforeShow", n.afterShow = "afterShow", n.beforeHide = "beforeHide", n.afterHide = "afterHide", n.beforeResizeStart = "beforeResizeStart", n.resize = "resize", n.afterResizeEnd = "afterResizeEnd", n.beforeAdd = "beforeAdd", n.afterAdd = "afterAdd", n.beforeRemove = "beforeRemove", n.afterRemove = "afterRemove", n.beforeCollapse = "beforeCollapse", n.afterCollapse = "afterCollapse", n.beforeExpand = "beforeExpand", n.afterExpand = "afterExpand", (e = e.resizeMode || (e.resizeMode = {}))[e.unknown = 0] = "unknown", e[e.percents = 1] = "percents", e[e.pixels = 2] = "pixels", e[e.mixedpx1 = 3] = "mixedpx1", e[e.mixedpx2 = 4] = "mixedpx2", e[e.mixedperc1 = 5] = "mixedperc1", e[e.mixedperc2 = 6] = "mixedperc2"
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), (e = e.SelectionEvents || (e.SelectionEvents = {})).beforeUnSelect = "beforeunselect", e.afterUnSelect = "afterunselect", e.beforeSelect = "beforeselect", e.afterSelect = "afterselect"
    }, function (t, r, e) {
        "use strict";
        var s = this && this.__assign || function () {
            return (s = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(r, "__esModule", {value: !0});
        var a = e(1), l = e(8), i = e(145), n = e(146), o = e(147), c = e(148), u = e(149), d = e(150), h = e(151),
            f = e(152), p = e(153), g = e(154), _ = e(155), v = e(156), m = e(157), y = e(158), e = e(159);
        r.actions = {
            setCellStyle: y.SetCellStyle,
            setCellValue: e.SetCellValue,
            setCellFormat: m.SetCellFormat,
            removeCellStyles: _.RemoveCellStyles,
            lockCell: g.LockCell,
            deleteRow: u.DeleteRow,
            addRow: n.AddRow,
            deleteColumn: c.DeleteColumn,
            addColumn: i.AddColumn,
            groupAction: h.GroupAction,
            groupRowAction: p.GroupRowAction,
            groupColAction: f.GroupColAction,
            addSheet: o.AddSheet,
            deleteSheet: d.DeleteSheet,
            renameSheet: v.RenameSheet
        };
        b.prototype.execute = function (t, e) {
            if (Array.isArray(t)) {
                i = (i = t, n = this._config, o = i.map(function (t) {
                    var e = t.groupAction || t.action;
                    if (e) return new r.actions[e](s(s({}, t), n))
                }), {
                    do: function () {
                        o.map(function (t) {
                            return t.do()
                        })
                    }, undo: function () {
                        o.map(function (t) {
                            return t.undo()
                        })
                    }
                });
                return i.do(), this._actions.push(i), void this._sheets.push(this._config.spreadsheet.activeSheetName)
            }
            var i, n, o;
            a.extend(e, this._config), r.actions[t] && ((t = new r.actions[t](e)).do(), e.action === l.Actions.addSheet || e.action === l.Actions.deleteSheet || e.action === l.Actions.renameSheet ? this._sheets.push(null) : this._sheets.push(this._config.spreadsheet.activeSheetName), this._actions.push(t))
        }, b.prototype.undo = function () {
            var t, e, i = this._actions.pop();
            i && (i.undo(), (t = this._sheets.pop()) && (e = this._dataStore.getPage(t), this._config.spreadsheet._changeSheet(e.getMeta().toolbarId)), this._redoActions.push(i), this._redoSheets.push(t))
        }, b.prototype.redo = function () {
            var t, e, i = this._redoActions.pop();
            i && (i.do(), (t = this._redoSheets.pop()) && (e = this._dataStore.getPage(t), this._config.spreadsheet._changeSheet(e.getMeta().toolbarId)), this._actions.push(i), this._sheets.push(t))
        }, v = b;

        function b(t) {
            this._config = t, this._actions = [], this._redoActions = [], this._sheets = [], this._redoSheets = [], this._dataStore = t.dataStore
        }

        r.ActionsManager = v
    }, function (t, e, i) {
        "use strict";
        var c = this && this.__assign || function () {
            return (c = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(12), u = i(16), o = i(3);

        function d(t, e) {
            return '<div class="dxi dxi-' + e + ' dhx_toolbar-button__icon dhx_toolbar-button__colorpicker" style="border-bottom: solid 3px ' + t + '"></div>'
        }

        function r(t, e, i) {
            void 0 === i && (i = "1500.31");
            e = u.getFormattedValue(i, e);
            return '<div class="dhx_format-item"><span class="dhx_format-name">' + (n.default[t] || t) + ' </span><span class="dhx_format-helper">' + e + "</span></div>"
        }

        e.getColorpickerTemplate = d, e.updateToolbar = function (i, t) {
            var e = [];
            (t = c({locked: !1, format: "common"}, t)).css && (e = "string" == typeof t.css ? t.css.split(" ") : t.css);
            for (var n, o = {}, r = 0, s = e; r < s.length; r++) var a = s[r], o = c(c({}, o), dhx.css.get(a));
            for (n in !function (t) {
                for (var e in t) switch (e) {
                    case"color":
                        i.data.update(e, {html: d(t[e] || "#4C4C4C", "format-color-text")});
                        break;
                    case"background":
                    case"background-color":
                        i.data.update("background", {html: d(t[e] || "#FFF", "format-color-fill")});
                        break;
                    case"text-align":
                        i.data.update("align-left", {active: "left" === t[e]}), i.data.update("align-right", {active: "right" === t[e]}), i.data.update("align-center", {active: "center" === t[e]});
                        break;
                    case"font-weight":
                        i.data.update("font-weight-bold", {active: "bold" == t[e] || "700" == t[e]});
                        break;
                    case"font-style":
                        i.data.update("font-style-italic", {active: "italic" === t[e]});
                        break;
                    case"text-decoration":
                        i.data.update("text-decoration-underline", {active: "underline" === t[e]})
                }
            }(c({
                color: "#4C4C4C",
                background: "#FFF",
                "text-align": "left",
                "font-style": "",
                "font-weight": "",
                "text-decoration": ""
            }, o)), (e = i.data.getItem("format")) && e.items.map(function (t) {
                return t.active = !1
            }), t) switch (n) {
                case"locked":
                    i.data.getItem("lock") && i.data.update("lock", {active: t[n]});
                    break;
                case"format":
                    var l = u.getDefaultFormatsMap()[t[n]] || "common";
                    i.data.getItem("format") && i.data.update("format", {value: u.getFormat(l).name || l}), i.data.getItem(l) && i.data.update(l, {active: !0})
            }
        }, e.getToggledValue = function (t, e, i, n) {
            return t = o.getCellInfo(e, t), (dhx.css.get(t.css) || {})[i] ? "" : n
        }, e.getFormatItem = r, e.getFormatsDropdown = function (t) {
            return t.formats.map(function (t) {
                return {id: t.id, css: "dhx_format-name-wrap", html: r(t.name, t.mask, t.example)}
            })
        }
    }, function (t, e, i) {
        "use strict";
        var n;
        Object.defineProperty(e, "__esModule", {value: !0}), (n = e.RealPosition || (e.RealPosition = {})).left = "left", n.right = "right", n.top = "top", n.bottom = "bottom", n.center = "center", (n = e.Position || (e.Position = {})).right = "right", n.bottom = "bottom", n.center = "center", (e = e.MessageContainerPosition || (e.MessageContainerPosition = {})).topLeft = "top-left", e.topRight = "top-right", e.bottomLeft = "bottom-left", e.bottomRight = "bottom-right"
    }, function (t, e) {
        "use strict";
        var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        }, n = function () {
            return this
        }();
        try {
            n = n || new Function("return this")()
        } catch (t) {
            "object" === ("undefined" == typeof window ? "undefined" : i(window)) && (n = window)
        }
        t.exports = n
    }, function (t, e, i) {
        "use strict";

        function n(t) {
            t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, e, i, n) {
                return e + e + i + i + n + n
            });
            t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
            return t ? {r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16)} : null
        }

        function o(t) {
            var e, i, n, o = t.r / 255, r = t.g / 255, s = t.b / 255, a = Math.max(o, r, s), l = a - Math.min(o, r, s),
                c = function (t) {
                    return (a - t) / 6 / l + .5
                };
            return 0 == l ? e = i = 0 : (i = l / a, n = c(o), t = c(r), c = c(s), o === a ? e = c - t : r === a ? e = 1 / 3 + n - c : s === a && (e = 2 / 3 + t - n), e < 0 ? e += 1 : 1 < e && --e), {
                h: Math.floor(360 * e),
                s: i,
                v: a
            }
        }

        Object.defineProperty(e, "__esModule", {value: !0}), e.HSVtoRGB = function (t) {
            var e, i = {r: 0, g: 0, b: 0}, n = t.h / 60, o = t.s, r = t.v, t = Math.floor(n) % 6, n = n - Math.floor(n),
                s = 255 * r * (1 - o), a = 255 * r * (1 - o * n), l = 255 * r * (1 - o * (1 - n));
            switch (r *= 255, t) {
                case 0:
                    i.r = r, i.g = l, i.b = s;
                    break;
                case 1:
                    i.r = a, i.g = r, i.b = s;
                    break;
                case 2:
                    i.r = s, i.g = r, i.b = l;
                    break;
                case 3:
                    i.r = s, i.g = a, i.b = r;
                    break;
                case 4:
                    i.r = l, i.g = s, i.b = r;
                    break;
                case 5:
                    i.r = r, i.g = s, i.b = a
            }
            for (e in i) i[e] = Math.round(i[e]);
            return i
        }, e.RGBToHex = function (i) {
            return Object.keys(i).reduce(function (t, e) {
                e = i[e].toString(16).toUpperCase();
                return t + (e = 1 === e.length ? "0" + e : e)
            }, "#")
        }, e.HexToRGB = n, e.RGBToHSV = o, e.HexToHSV = function (t) {
            return o(n(t))
        }, e.isHex = function (t) {
            return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        e.default = {
            cancel: "Cancel",
            select: "Select",
            rightClickToDelete: "Right click to delete",
            customColors: "Custom colors",
            addNewColor: "Add new color"
        }
    }, function (t, e, i) {
        "use strict";
        (function (c) {
            Object.defineProperty(e, "__esModule", {value: !0});
            var u = i(13), d = i(14);

            function h(t) {
                return t ? t.includes("json") ? "json" : t.includes("xml") ? "xml" : "text" : "text"
            }

            function n(o, r, s, t, a) {
                var n, l = t || {};
                return a && (l.Accept = "application/" + a), "GET" !== s && (l["Content-Type"] = l["Content-Type"] || "application/json"), "GET" === s && ((t = r && "object" == typeof r ? (n = r, Object.keys(n).reduce(function (t, e) {
                    var i = "object" == typeof n[e] ? JSON.stringify(n[e]) : n[e];
                    return t.push(e + "=" + encodeURIComponent(i)), t
                }, []).join("&")) : r && "string" == typeof r ? r : "") && (o += o.includes("?") ? "&" : "?", o += t), r = null), window.fetch ? window.fetch(o, {
                    method: s,
                    body: r ? JSON.stringify(r) : null,
                    headers: l
                }).then(function (e) {
                    if (!e.ok) return e.text().then(function (t) {
                        return c.reject({status: e.status, statusText: e.statusText, message: t})
                    });
                    var t = a || h(e.headers.get("Content-Type"));
                    if ("raw" === t) return {
                        headers: Object.fromEntries(e.headers.entries()),
                        url: e.url,
                        body: e.body
                    };
                    if (204 !== e.status) switch (t) {
                        case"json":
                            return e.json();
                        case"xml":
                            var i = d.toDataDriver(u.DataDriver.xml);
                            return i ? e.text().then(function (t) {
                                return i.toJsonObject(t)
                            }) : e.text();
                        default:
                            return e.text()
                    }
                }) : new c(function (t, e) {
                    var i, n = new XMLHttpRequest;
                    for (i in n.onload = function () {
                        200 <= n.status && n.status < 300 ? ("raw" === a && t({
                            url: n.responseURL,
                            headers: n.getAllResponseHeaders().trim().split(/[\r\n]+/).reduce(function (t, e) {
                                e = e.split(": ");
                                return t[e[0]] = e[1], t
                            }, {}),
                            body: n.response
                        }), 204 === n.status ? t() : t(function (t, e) {
                            switch (e) {
                                case"json":
                                    return JSON.parse(t);
                                case"text":
                                    return t;
                                case"xml":
                                    var i = d.toDataDriver(u.DataDriver.xml);
                                    return i ? i.toJsonObject(t) : {parseError: "Incorrect data driver type: 'xml'"};
                                default:
                                    return t
                            }
                        }(n.responseText, a || h(n.getResponseHeader("Content-Type"))))) : e({
                            status: n.status,
                            statusText: n.statusText
                        })
                    }, n.onerror = function () {
                        e({status: n.status, statusText: n.statusText, message: n.responseText})
                    }, n.open(s, o), l) n.setRequestHeader(i, l[i]);
                    switch (s) {
                        case"POST":
                        case"DELETE":
                        case"PUT":
                            n.send(void 0 !== r ? JSON.stringify(r) : "");
                            break;
                        case"GET":
                        default:
                            n.send()
                    }
                })
            }

            e.ajax = {
                get: function (t, e, i) {
                    return n(t, e, "GET", i && i.headers, void 0 !== i ? i.responseType : void 0)
                }, post: function (t, e, i) {
                    return n(t, e, "POST", i && i.headers, void 0 !== i ? i.responseType : void 0)
                }, put: function (t, e, i) {
                    return n(t, e, "PUT", i && i.headers, void 0 !== i ? i.responseType : void 0)
                }, delete: function (t, e, i) {
                    return n(t, e, "DELETE", i && i.headers, void 0 !== i ? i.responseType : void 0)
                }
            }
        }).call(this, i(9))
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(50)), n(e(126)), n(e(4)), n(e(37));
        var o = e(36);
        i.getTreeCell = o.getTreeCell, n(e(15)), n(e(11))
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var S = i(1), E = i(0), k = i(37), p = i(11), n = i(4), g = i(95), l = i(2), _ = i(15);

        function o(t, e, i, n, o) {
            e = l.locateNodeByClassName(o.target, "dhx_grid-fixed-cols-wrap") ? 0 : e;
            var r, s, a = l.locateNodeByClassName(o.target, "dhx_grid-cell");
            a && n && (r = (s = a.parentNode).parentNode, a = Array.prototype.indexOf.call(s.childNodes, a), a = i.columns.filter(function (t) {
                return !t.hidden
            })[e + a], s = Array.prototype.indexOf.call(r.childNodes, s), s = i.data[t + s], (n.toLocaleLowerCase().includes("touch") ? i._events : i.events).fire(n, [s, a, o]))
        }

        function v(t) {
            var e = t.id;
            if (t.header && t.header.length) for (var i = t.header.length - 1; 0 <= i;) {
                var n = t.header[i];
                if (n && n.text) {
                    e = n.text;
                    break
                }
                --i
            }
            return e
        }

        function m(t, e, i, n) {
            var o = n.$editable && n.$editable.row === e.id && n.$editable.col === i.id, r = "",
                s = i.align ? " dhx_align-" + i.align : "dhx_align-left";
            n.dragMode && "row" === n.dragItem && (r += (e.$drophere && !o ? " dhx_grid-cell--drophere" : "") + (e.$dragtarget && !o ? " dhx_grid-cell--dragtarget" : "") + (o ? "" : " dhx_grid-cell--drag"));
            var a = _.getTreeCellWidthOffset(e);
            return E.el(".dhx_grid-cell", {
                class: "dhx_tree-cell " + (i.$cellCss[e.id] || "") + " " + (e.$items ? "dhx_grid-expand-cell" : "") + " " + (o ? "dhx_tree-editing-cell" : "") + " " + r + s,
                style: {width: i.$width, height: e.$height, padding: e.$items ? 0 : "0 0 0 " + a + "px"},
                dhx_col_id: i.id,
                role: "gridcell",
                "aria-colindex": 1,
                "aria-label": v(i)
            }, [e.$items ? E.el(".dhx_grid-expand-cell-icon", {
                class: e.$opened ? "dxi dxi-chevron-up" : "dxi dxi-chevron-down",
                dhx_id: e.id,
                role: "button",
                "aria-label": e.$opened ? "Collapse group" : "Expand group",
                style: {padding: e.$level ? "0 0 0 " + (4 + a) + "px" : "0 0 0 4px"}
            }) : null, E.el(".dhx_tree-cell", {class: s + (n.autoHeight ? " dhx_tree-cell_auto-height" : "")}, [t])])
        }

        e.getHandlers = function (t, e, i) {
            return {
                onclick: [o, t, e, i, n.GridEvents.cellClick],
                onmouseover: [o, t, e, i, n.GridEvents.cellMouseOver],
                onmousedown: [o, t, e, i, n.GridEvents.cellMouseDown],
                ondblclick: [o, t, e, i, n.GridEvents.cellDblClick],
                oncontextmenu: [o, t, e, i, n.GridEvents.cellRightClick],
                ontouchstart: [o, t, e, i, n.GridEvents.cellMouseDown],
                ontouchmove: [o, t, e, i, n.GridSystemEvents.cellTouchMove],
                ontouchend: [o, t, e, i, n.GridSystemEvents.cellTouchEnd]
            }
        }, e.getTreeCell = m, e.getCells = function (h) {
            if (!h.data || !h.columns) return [];
            var f = h.$positions, n = h.data ? h.data.slice(f.yStart, f.yEnd) : [],
                o = h.columns.slice(f.xStart, f.xEnd);
            return n.map(function (d, t) {
                var e = n.length - 1 === t, i = "";
                return h.rowCss && (i = h.rowCss(d)), d.$css && (i += d.$css), E.el(".dhx_grid-row", {
                    style: {height: e ? d.$height + 1 : d.$height},
                    dhx_id: d.id,
                    class: i,
                    _key: d.id,
                    _flags: E.KEYED_LIST,
                    role: "row",
                    "aria-rowindex": f.yStart + t + 1
                }, d.$customRender ? [d.$customRender(d, h)] : o.map(function (t, e) {
                    if (!t.hidden) {
                        var i = _.toFormat(d[t.id], t.type, t.format),
                            n = t.template ? t.template(i, d, t) : "boolean" != typeof (u = i) && "boolean" !== t.type || "string" == typeof u ? u || 0 === u ? u : "" : "" + Boolean(u);
                        "string" == typeof n && (n = p.isHtmlEnable(h, t) ? E.el("div.dhx_grid-cell__content", {
                            role: "button",
                            "aria-label": "Edit content",
                            ".innerHTML": n
                        }) : n);
                        var o = ((t.$cellCss && t.$cellCss[d.id] || "") + " dhx_" + t.type + "-cell").replace(/\s+/g, " "),
                            r = t.$width, s = h.$editable && h.$editable.row === d.id && h.$editable.col === t.id;
                        return ((s || "boolean" === t.type && (h.editable || t.editable)) && (h.leftSplit && h.columns.length !== h.leftSplit && h.columns.indexOf(t) < h.leftSplit || (a = d, l = t, c = h, n = g.getEditor(a, l, c).toHTML(), o += " dhx_grid-cell__editable", h.leftSplit === h.columns.indexOf(t) + 1 && --r)), "tree" === h.type && h.firstColId === t.id) ? m(n, d, t, h) : (h.dragMode && "row" === h.dragItem && (o += (d.$drophere && !s ? " dhx_grid-cell--drophere" : "") + (d.$dragtarget && !s ? " dhx_grid-cell--dragtarget" : "") + (s ? "" : " dhx_grid-cell--drag")), t.align && (o += " dhx_align-" + t.align), h.autoHeight && (o += " dhx_grid-cell__content_auto-height"), E.el(".dhx_grid-cell", {
                            class: o,
                            style: {width: r, height: d.$height + "px"},
                            _key: t.id,
                            dhx_col_id: t.id,
                            role: "gridcell",
                            "aria-colindex": f.xStart + e + 1,
                            "aria-label": v(t)
                        }, [n]))
                    }
                    var a, l, c, u
                }))
            })
        }, e.getSpans = function (m, y) {
            var b = [], x = m.columns, w = m.data;
            if (!x.length || !m.spans) return null;
            for (var C = m.spans.sort(function (t, e) {
                return "string" == typeof t.row && "string" == typeof e.row ? t.row.localeCompare(e.row) : t.row - e.row
            }), t = 0; t < C.length; t++) !function (t) {
                var e = C[t].row, i = C[t].column, n = C[t].rowspan, o = C[t].colspan, r = C[t].css;
                if (1 === n) return;
                var s = S.findIndex(x, function (t) {
                    return "" + t.id == "" + i
                }), a = S.findIndex(w, function (t) {
                    return "" + t.id == "" + e
                });
                if (s < 0 || a < 0) return;
                if (!0 === y && ((o || 1) + s > m.leftSplit || s + 1 > m.leftSplit)) return;
                var l = x[s], c = w[a];
                if (l.hidden) return;
                var u = C[t].text || (void 0 === c[i] ? "" : c[i]);
                u = "string" == typeof (u = (l.template || function (t, e, i) {
                    return t || 0 === t ? t : ""
                })(u, c, l)) ? E.el("div.dhx_span-cell-content", {".innerHTML": u}) : u;
                for (var d = 0, h = 0; h < a; h++) d += w[h].$height;
                for (var f = d - 1, p = 0, g = s - 1; 0 <= g; g--) p += x[g].$width;
                var _ = s === x.length - 1, v = s + o === x.length,
                    t = l.header[0].text ? " dhx_span-cell" : " dhx_span-cell dhx_span-cell--title";
                t += r ? " " + r : "", t += 0 === a ? " dhx_span-first-row" : "", t += 0 === s ? " dhx_span-first-col" : "", t += _ || v ? " dhx_span-last-col" : "", t += o ? " dhx_span-string-cell" : " dhx_span-" + (l.type || "string") + "-cell", t += l.align ? " dhx_align-" + l.align : " dhx_align-left";
                l = 1 < o ? k.getWidth(x, o, s) : l.$width, c = 1 < n ? k.getHeight(w, n, a) : c.$height;
                b.push(E.el("div", {
                    class: t,
                    style: {width: l, height: c, top: f, left: p},
                    dhx_col_id: i,
                    dhx_id: e,
                    "aria-hidden": "true"
                }, [u]))
            }(t);
            return b
        }, e.getShifts = function (t) {
            var e = t.columns.slice(0, t.$positions.xStart), t = t.data.slice(0, t.$positions.yStart);
            return {x: p.getTotalWidth(e), y: p.getTotalHeight(t)}
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), e.getWidth = function (t, n, o) {
            return t = t.filter(function (t) {
                return !t.hidden
            }), n ? t.reduce(function (t, e, i) {
                e = e.$width;
                return t += o <= i && i < o + n ? e : 0
            }, 0) : t[o].$width
        }, e.getHeight = function (t, n, o) {
            return t = t.filter(function (t) {
                return !t.hidden
            }), n ? t.reduce(function (t, e, i) {
                e = e.$height;
                return t += o <= i && i < o + n ? e : 0
            }, 0) : t[o].$height
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), (e = e.ListEvents || (e.ListEvents = {})).click = "click", e.doubleClick = "doubleclick", e.focusChange = "focuschange", e.beforeEditStart = "beforeEditStart", e.afterEditStart = "afterEditStart", e.beforeEditEnd = "beforeEditEnd", e.afterEditEnd = "afterEditEnd", e.itemRightClick = "itemRightClick", e.itemMouseOver = "itemMouseOver", e.contextmenu = "contextmenu"
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        i = i(7);
        e.DataEvents = i.DataEvents, (e = e.NavigationBarEvents || (e.NavigationBarEvents = {})).inputCreated = "inputCreated", e.click = "click", e.openMenu = "openmenu", e.beforeHide = "beforeHide", e.afterHide = "afterHide", e.inputFocus = "inputfocus", e.inputBlur = "inputblur"
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(1), i = (o.prototype.update = function () {
            this._styleCont.innerHTML !== this._generateCss() && (document.head.appendChild(this._styleCont), this._styleCont.innerHTML = this._generateCss())
        }, o.prototype.remove = function (t) {
            delete this._classes[t], this.update()
        }, o.prototype.add = function (t, e, i) {
            void 0 === i && (i = !1);
            var n = this._toCssString(t), t = this._findSameClassId(n);
            return t && e && e !== t ? (this._classes[e] = this._classes[t], e) : t || this._addNewClass(n, e, i)
        }, o.prototype.get = function (t) {
            if (this._classes[t]) {
                for (var e = {}, i = 0, n = this._classes[t].split(";"); i < n.length; i++) {
                    var o = n[i];
                    o && (e[(o = o.split(":"))[0]] = o[1])
                }
                return e
            }
            return null
        }, o.prototype.destructor = function () {
            this._classes = this._styleCont = null
        }, o.prototype._findSameClassId = function (t) {
            for (var e in this._classes) if (t === this._classes[e]) return e;
            return null
        }, o.prototype._addNewClass = function (t, e, i) {
            e = e || "dhx_generated_class_" + n.uid();
            return this._classes[e] = t, i || this.update(), e
        }, o.prototype._toCssString = function (t) {
            var e, i = "";
            for (e in t) {
                var n = t[e];
                i += e.replace(/[A-Z]{1}/g, function (t) {
                    return "-" + t.toLowerCase()
                }) + ":" + n + ";"
            }
            return i
        }, o.prototype._generateCss = function () {
            var t, e = "";
            for (t in this._classes) e += "." + t + "{" + this._classes[t] + "}\n";
            return e
        }, o);

        function o() {
            this._classes = {};
            var t = document.createElement("style");
            t.id = "dhx_generated_styles", this._styleCont = document.head.appendChild(t)
        }

        e.CssManager = i, e.cssManager = new i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        e.default = {apply: "apply", reject: "reject"}
    }, function (t, e, i) {
        "use strict";

        function n(t) {
            var e = document.activeElement;
            e.classList.contains("dhx_alert__confirm-reject") || e.classList.contains("dhx_alert__confirm-aply") || t.preventDefault()
        }

        Object.defineProperty(e, "__esModule", {value: !0}), e.blockScreen = function (t) {
            var e = document.createElement("div");
            return e.className = "dhx_alert__overlay " + (t || ""), document.body.appendChild(e), document.addEventListener("keydown", n), function () {
                document.body.removeChild(e), document.removeEventListener("keydown", n)
            }
        }
    }, function (t, e, i) {
        "use strict";
        var n = this && this.__assign || function () {
            return (n = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = i(2), u = i(30), d = 750, h = 200;

        function c(t, e, i, n) {
            var o, r, s;
            switch (e) {
                case u.Position.center:
                    return (r = t.left + window.pageXOffset + (t.width - i) / 2) + 8 < window.pageXOffset && (r = t.left + window.pageXOffset), {
                        left: r,
                        top: s = t.top + window.pageYOffset + (t.height - n) / 2,
                        pos: o = u.RealPosition.center
                    };
                case u.Position.right:
                    return o = u.RealPosition.right, (r = t.right + window.pageXOffset) + i + 8 > window.innerWidth + window.pageXOffset && (r = window.pageXOffset + t.left - i, o = u.RealPosition.left), {
                        left: r,
                        top: s = window.pageYOffset + t.top + (t.height - n) / 2,
                        pos: o
                    };
                case u.Position.bottom:
                default:
                    return (r = window.pageXOffset + t.left + (t.width - i) / 2) + i > window.innerWidth + window.pageXOffset ? r = window.innerWidth + window.pageXOffset - i : r < 0 && (r = 0), o = u.RealPosition.bottom, (s = window.pageYOffset + t.bottom) + n + 8 > window.innerHeight + window.pageYOffset && (s = window.pageYOffset + t.top - n, o = u.RealPosition.top), {
                        left: r,
                        top: s,
                        pos: o
                    }
            }
        }

        e.findPosition = c;
        var f = document.createElement("div"), p = document.createElement("span");
        p.className = "dhx_tooltip__text", f.appendChild(p), f.setAttribute("role", "tooltip"), f.style.position = "absolute";
        var g, _ = null, v = !1, m = null, y = null;

        function b(t) {
            return t && t.classList.contains("dhx_popup--window") && t.classList.contains("dhx_popup--window_active") ? 2147483647 : t && t.classList.contains("dhx_popup--window") ? 2147483646 : t && t.offsetParent ? b(t.offsetParent) : null
        }

        function x(t, e, i, n, o, r) {
            void 0 === o && (o = !1);
            var s = t.getBoundingClientRect();
            r ? p.innerHTML = e : p.textContent = e, document.body.appendChild(f), f.className = "dhx_widget dhx_tooltip" + (o ? " dhx_tooltip--forced" : "");
            var e = f.getBoundingClientRect(), e = c(s, i, e.width, e.height), a = e.left, l = e.top, e = e.pos,
                t = b(t);
            switch (t && (f.style.zIndex = t.toString()), e) {
                case u.RealPosition.bottom:
                case u.RealPosition.top:
                case u.RealPosition.left:
                case u.RealPosition.right:
                case u.RealPosition.center:
                    f.style.left = a + "px", f.style.top = l + "px"
            }
            f.className += " dhx_tooltip--" + e + " " + (n || ""), v = !0, o || setTimeout(function () {
                f.className += " dhx_tooltip--animate"
            })
        }

        function r(e, t, i) {
            var n = i.force, o = i.showDelay, r = i.hideDelay, s = i.position, a = i.css, l = i.htmlEnable;
            n || (y = setTimeout(function () {
                x(e, t, s || u.Position.bottom, a, !1, l)
            }, o || d));
            var c = function () {
                var t;
                v && (t = r, _ && (m = setTimeout(function () {
                    document.body.removeChild(f), v = !1, m = null
                }, t || h))), clearTimeout(y), e.removeEventListener("mouseleave", c), e.removeEventListener("blur", c), document.removeEventListener("mousedown", c), g = _ = null
            };
            n && x(e, t, s, a, n, l), e.addEventListener("mouseleave", c), e.addEventListener("blur", c), document.addEventListener("mousedown", c), g = c
        }

        function s(t, e) {
            var i = o.toNode(e.node);
            i !== _ && (g && (g(), g = null), _ = i, m ? (clearTimeout(m), m = null, r(i, t, n(n({}, e), {force: !0}))) : r(i, t, e))
        }

        function a(t) {
            t = o.locateNode(t, "dhx_tooltip_text");
            t && s(t.getAttribute("dhx_tooltip_text"), {
                position: t.getAttribute("dhx_tooltip_position") || u.Position.bottom,
                node: t
            })
        }

        e.getZIndex = b, e.tooltip = s, e.enableTooltip = function () {
            document.addEventListener("mousemove", a)
        }, e.disableTooltip = function () {
            document.removeEventListener("mousemove", a)
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), e.grayShades = ["#000000", "#4C4C4C", "#666666", "#808080", "#999999", "#B3B3B3", "#CCCCCC", "#E6E6E6", "#F2F2F2", "#FFFFFF"], e.palette = [["#D4DAE4", "#B0B8CD", "#949DB1", "#727A8C", "#5E6677", "#3F4757", "#1D2534"], ["#FFCDD2", "#FE9998", "#F35C4E", "#E94633", "#D73C2D", "#CA3626", "#BB2B1A"], ["#F9E6AD", "#F4D679", "#EDB90F", "#EAA100", "#EA8F00", "#EA7E00", "#EA5D00"], ["#BCE4CE", "#90D2AF", "#33B579", "#36955F", "#247346", "#1D5B38", "#17492D"], ["#BDF0E9", "#92E7DC", "#02D7C5", "#11B3A5", "#018B80", "#026B60", "#024F43"], ["#B3E5FC", "#81D4FA", "#29B6F6", "#039BE5", "#0288D1", "#0277BD", "#01579B"], ["#AEC1FF", "#88A3F9", "#5874CD", "#2349AE", "#163FA2", "#083596", "#002381"], ["#C5C0DA", "#9F97C1", "#7E6BAD", "#584A8F", "#4F4083", "#473776", "#3A265F"], ["#D6BDCC", "#C492AC", "#A9537C", "#963A64", "#81355A", "#6E3051", "#4C2640"], ["#D2C5C1", "#B4A09A", "#826358", "#624339", "#5D4037", "#4E342E", "#3E2723"]]
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), (e = e.ColorpickerEvents || (e.ColorpickerEvents = {})).change = "change", e.apply = "apply", e.cancelClick = "cancelClick", e.modeChange = "modeChange", e.selectClick = "selectClick", e.colorChange = "colorChange", e.viewChange = "viewChange"
    }, function (t, e, i) {
        "use strict";
        var a = this && this.__assign || function () {
            return (a = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        }, n = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = i(5), r = i(87), s = i(90), l = i(18), c = i(14), u = i(13), p = i(1),
            i = (d.prototype._reset = function () {
                this._order = [], this._pull = {}, this._changes = {order: []}, this._initOrder = null, this._meta = new WeakMap, this._loaded = !1
            }, d.prototype.add = function (t, i) {
                var n = this;
                if (this.events.fire(u.DataEvents.beforeAdd, [t])) {
                    t = Array.isArray(t) ? t.map(function (t, e) {
                        return 0 !== e && (i += 1), n._add(t, i)
                    }) : this._add(t, i);
                    return this._applySmart(), t
                }
            }, d.prototype.remove = function (t) {
                var e = this;
                t && (t instanceof Array ? n(t).map(function (t) {
                    e._remove(t)
                }) : this._remove(t))
            }, d.prototype.removeAll = function () {
                this._reset(), this.events.fire(u.DataEvents.removeAll), this.events.fire(u.DataEvents.change)
            }, d.prototype.exists = function (t) {
                return !!this._pull[t]
            }, d.prototype.getNearId = function (t) {
                if (!this._pull[t]) return this._order[0].id || ""
            }, d.prototype.getItem = function (t) {
                return this._pull[t]
            }, d.prototype.update = function (t, e, i) {
                var n = this.getItem(t);
                n ? c.isEqualObj(e, n) || (e.id && t !== e.id ? (c.dhxWarning("this method doesn't allow change id"), c.isDebug()) : (e.parent && n.parent && e.parent !== n.parent && this.move(t, -1, this, e.parent), p.extend(this._pull[t], e, !1), this.config.update && this.config.update(this._pull[t]), i || this._onChange("update", t, this._pull[t])), this._applySmart()) : c.dhxWarning("item not found")
            }, d.prototype.getIndex = function (e) {
                if (!e) return -1;
                var t = p.findIndex(this._order, function (t) {
                    return t && t.id.toString() === e.toString()
                });
                return this._pull[e] && 0 <= t ? t : void 0
            }, d.prototype.getId = function (t) {
                if (this._order[t]) return this._order[t].id
            }, d.prototype.getLength = function () {
                return this._order.length
            }, d.prototype.isDataLoaded = function (t, e) {
                return void 0 === t && (t = 0), void 0 === e && (e = this._order.length), p.isNumeric(t) && p.isNumeric(e) ? 0 === this._order.slice(t, e).filter(function (t) {
                    return t && t.$empty
                }).length : (this._loaded || (this._loaded = !this.find(function (t) {
                    return t.$empty
                })), !!this._loaded)
            }, d.prototype.filter = function (t, e) {
                var i;
                this.isDataLoaded() ? (e && e.add || (this._order = this._initOrder || this._order, this._initOrder = null), !t || "function" == typeof t || void 0 !== (i = t).by && void 0 !== i.match && (t = i.compare ? function (t) {
                    return i.compare(t[i.by], i.match, t)
                } : function (t) {
                    return t[i.by] == i.match
                }), this._filter = e && e.smartFilter ? t : null, this._applyFilters(t), this.events.fire(u.DataEvents.change)) : c.dhxWarning("the method doesn't work with lazyLoad")
            }, d.prototype.find = function (t) {
                for (var e in this._pull) {
                    var i = c.findByConf(this._pull[e], t);
                    if (i) return i
                }
                return null
            }, d.prototype.findAll = function (t) {
                var e, i = [];
                for (e in this._pull) {
                    var n = c.findByConf(this._pull[e], t);
                    n && i.push(n)
                }
                return i
            }, d.prototype.sort = function (t, e) {
                this.isDataLoaded() ? (e && e.smartSorting && (this._sorter = t), t && this._applySorters(t), this.events.fire(u.DataEvents.change)) : c.dhxWarning("the method doesn't work with lazyLoad")
            }, d.prototype.copy = function (t, i, n, o) {
                var r = this;
                return t instanceof Array ? t.map(function (t, e) {
                    return r._copy(t, i, n, o, e)
                }) : this._copy(t, i, n, o)
            }, d.prototype.move = function (t, i, n, o) {
                var r = this;
                return t instanceof Array ? t.map(function (t, e) {
                    return r._move(t, i, n, o, e)
                }) : this._move(t, i, n, o)
            }, d.prototype.forEach = function (t) {
                for (var e = 0; e < this._order.length; e++) t.call(this, this._order[e], e, this._order)
            }, d.prototype.load = function (t, e) {
                return "string" == typeof t && (this.dataProxy = t = new l.DataProxy(t)), this.dataProxy = t, this._loader.load(t, e)
            }, d.prototype.parse = function (t, e) {
                return this._reset(), this._loader.parse(t, e)
            }, d.prototype.$parse = function (t) {
                var e = this.config.approximate;
                e && (t = this._approximate(t, e.value, e.maxNum)), this._parse_data(t), this._applySmart(), this.events.fire(u.DataEvents.change, ["load"]), this.events.fire(u.DataEvents.load)
            }, d.prototype.save = function (t) {
                "string" == typeof t && (t = new l.DataProxy(t)), this._loader.save(t)
            }, d.prototype.changeId = function (t, e, i) {
                var n;
                void 0 === e && (e = p.uid()), i || this.isDataLoaded() ? (n = this.getItem(t)) ? (n.id = e, p.extend(this._pull[t], n), this._pull[e] = this._pull[t], i || this._onChange("update", e, this._pull[e]), delete this._pull[t]) : c.dhxWarning("item not found") : c.dhxWarning("the method doesn't work with lazyLoad")
            }, d.prototype.isSaved = function () {
                return !this._changes.order.length
            }, d.prototype.map = function (t) {
                for (var e = [], i = 0; i < this._order.length; i++) e.push(t.call(this, this._order[i], i, this._order));
                return e
            }, d.prototype.mapRange = function (t, e, i) {
                t < 0 && (t = 0), e > this._order.length - 1 && (e = this._order.length - 1);
                for (var n = this._order.slice(t, e), o = [], r = t; r <= e; r++) o.push(i.call(this, this._order[r], r, n));
                return o
            }, d.prototype.reduce = function (t, e) {
                for (var i = 0; i < this._order.length; i++) e = t.call(this, e, this._order[i], i);
                return e
            }, d.prototype.serialize = function (t) {
                void 0 === t && (t = u.DataDriver.json);
                var e = this.map(function (t) {
                    var e = a({}, t);
                    return Object.keys(e).forEach(function (t) {
                        t.startsWith("$") && delete e[t]
                    }), e
                }), t = c.toDataDriver(t);
                if (t) return t.serialize(e)
            }, d.prototype.getInitialData = function () {
                return this._initOrder
            }, d.prototype.setMeta = function (t, e, i) {
                var n;
                t && ((n = this._meta.get(t)) || (n = {}, this._meta.set(t, n)), n[e] = i)
            }, d.prototype.getMeta = function (t, e) {
                t = this._meta.get(t);
                return t ? t[e] : null
            }, d.prototype.getMetaMap = function (t) {
                return this._meta.get(t)
            }, d.prototype.setRange = function (t, e) {
                this._range = e ? [t, e] : null
            }, d.prototype.getRawData = function (t, e, i, n) {
                if (i = i || this._order, 1 === n) return i;
                var o;
                if (this._range && (t = this._range[0] + t, e = -1 === e || t + (o = e - t) > this._range[1] ? this._range[1] : t + o), !e || 0 === t && (-1 === e || e === i.length)) return i;
                if (t >= i.length) return [];
                (-1 === e || e > i.length) && (e = i.length);
                i = i.slice(t, e);
                return 0 !== i.filter(function (t) {
                    return t.$empty
                }).length && this.events.fire("dataRequest", [t, e]), i
            }, d.prototype._add = function (t, e) {
                if (this.isDataLoaded()) {
                    e = this._addCore(t, e);
                    return this._onChange("add", t.id, t), this.events.fire(u.DataEvents.afterAdd, [t]), e
                }
                c.dhxWarning("the method doesn't work with lazyLoad")
            }, d.prototype._remove = function (t) {
                if (this.isDataLoaded()) {
                    var e = this._pull[t];
                    if (e) {
                        if (!this.events.fire(u.DataEvents.beforeRemove, [e])) return;
                        this._removeCore(e.id), this._onChange("remove", t, e)
                    }
                    this.events.fire(u.DataEvents.afterRemove, [e])
                } else c.dhxWarning("the method doesn't work with lazyLoad")
            }, d.prototype._copy = function (t, e, i, n, o) {
                if (this.isDataLoaded()) {
                    if (!this.exists(t)) return null;
                    var r = p.uid();
                    return (o && (e = -1 === e ? -1 : e + o), i) ? i instanceof d || !n ? i.exists(t) ? (i.add(a(a({}, c.copyWithoutInner(this.getItem(t))), {id: r}), e), r) : (i.add(c.copyWithoutInner(this.getItem(t)), e), t) : void i.add(c.copyWithoutInner(this.getItem(t)), e) : (this.add(a(a({}, c.copyWithoutInner(this.getItem(t))), {id: r}), e), r)
                }
                c.dhxWarning("the method doesn't work with lazyLoad")
            }, d.prototype._move = function (t, e, i, n, o) {
                if (this.isDataLoaded()) {
                    if (o && (e = -1 === e ? -1 : e + o), i && i !== this && this.exists(t)) {
                        var r = p.copy(this.getItem(t), !0);
                        return i.exists(t) && (r.id = p.uid()), n && (r.parent = n), i.add(r, e), this.remove(t), r.id
                    }
                    if (this.getIndex(t) === e) return null;
                    r = this._order.splice(this.getIndex(t), 1)[0];
                    return -1 === e && (e = this._order.length), this._order.splice(e, 0, r), this.events.fire(u.DataEvents.change, [t, "update", this.getItem(t)]), t
                }
                c.dhxWarning("the method doesn't work with lazyLoad")
            }, d.prototype._addCore = function (t, e) {
                return this.config.init && (t = this.config.init(t)), t.id = t.id ? t.id.toString() : p.uid(), this._pull[t.id] && c.dhxError("Item already exist"), this._initOrder && this._initOrder.length && this._addToOrder(this._initOrder, t, e), this._addToOrder(this._order, t, e), t.id
            }, d.prototype._removeCore = function (e) {
                0 <= this.getIndex(e) && (this._order = this._order.filter(function (t) {
                    return t.id !== e
                }), delete this._pull[e]), this._initOrder && this._initOrder.length && (this._initOrder = this._initOrder.filter(function (t) {
                    return t.id !== e
                }), delete this._pull[e])
            }, d.prototype._parse_data = function (t) {
                var e = this._order.length;
                this.config.prep && (t = this.config.prep(t));
                for (var i = 0, n = t; i < n.length; i++) {
                    var o = n[i];
                    this._addCore(o, e++)
                }
            }, d.prototype._approximate = function (t, e, i) {
                for (var n = t.length, o = e.length, r = Math.floor(n / i), s = Array(Math.ceil(n / r)), a = 0, l = 0; l < n; l += r) {
                    for (var c = p.copy(t[l]), u = Math.min(n, l + r), d = 0; d < o; d++) {
                        for (var h = 0, f = l; f < u; f++) h += t[f][e[d]];
                        c[e[d]] = h / (u - l)
                    }
                    s[a++] = c
                }
                return s
            }, d.prototype._onChange = function (t, e, i) {
                for (var n = 0, o = this._changes.order; n < o.length; n++) if ((s = o[n]).id === e && !s.saving) {
                    s.error && (s.error = !1);
                    var r = this._changes.order.indexOf(s), s = a(a({}, s), {obj: i, status: t});
                    return this._changes.order.splice(r, 1, s), this._loader.updateChanges(this._changes), void this.events.fire(u.DataEvents.change, [e, t, i])
                }
                this._changes.order.push({
                    id: e,
                    status: t,
                    obj: a({}, i),
                    saving: !1
                }), this._loader.updateChanges(this._changes), this.events.fire(u.DataEvents.change, [e, t, i])
            }, d.prototype._addToOrder = function (t, e, i) {
                0 <= i && t[i] ? (this._pull[e.id] = e, t.splice(i, 0, e)) : (this._pull[e.id] = e, t.push(e))
            }, d.prototype._applySmart = function () {
                this._filter && this._applyFilters(), this._sorter && this._applySorters()
            }, d.prototype._applySorters = function (t) {
                this._sort.sort(this._order, t, this._sorter), this._initOrder && this._initOrder.length && this._sort.sort(this._initOrder, t, this._sorter)
            }, d.prototype._applyFilters = function (e) {
                var t, i = this._filter;
                e === i && (e = null), (e || i) && (t = this._order.filter(function (t) {
                    return (!e || e(t)) && (!i || i(t))
                }), this._initOrder || (this._initOrder = this._order), this._order = t)
            }, d);

        function d(t, e) {
            var n = this;
            this._changes = {order: []}, this.config = t || {}, this._sort = new s.Sort, this._loader = new r.Loader(this, this._changes), this.events = e || new o.EventSystem(this), this.events.on("dataRequest", function (t, e) {
                var i = n.dataProxy;
                i && i.updateUrl && (i.updateUrl(null, {from: t, limit: i.config.limit || e - t}), n.load(i))
            }), this.events.on(u.DataEvents.loadError, function (t) {
                "string" != typeof t ? c.dhxError(t) : c.dhxWarning(t)
            }), this._reset()
        }

        e.DataCollection = i
    }, function (t, e, i) {
        "use strict";
        var n = this && this.__assign || function () {
            return (n = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = i(48), r = i(49), i = i(88);
        e.dataDrivers = {
            json: o.JsonDriver,
            csv: r.CsvDriver
        }, e.dataDriversPro = n(n({}, e.dataDrivers), {xml: i.XMLDriver})
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = (o.prototype.toJsonArray = function (t) {
            return this.getRows(t)
        }, o.prototype.serialize = function (t) {
            return t
        }, o.prototype.getFields = function (t) {
            return t
        }, o.prototype.getRows = function (t) {
            return "string" == typeof t ? JSON.parse(t) : t
        }, o);

        function o() {
        }

        e.JsonDriver = n
    }, function (t, e, i) {
        "use strict";
        var n = this && this.__assign || function () {
            return (n = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = (r.prototype.getFields = function (t, e) {
            for (var i = t.trim().split(this.config.columnDelimiter), n = {}, o = 0; o < i.length; o++) n[e ? e[o] : o + 1] = isNaN(Number(i[o])) ? i[o] : parseFloat(i[o]);
            return n
        }, r.prototype.getRows = function (t) {
            return t.trim().split(this.config.rowDelimiter)
        }, r.prototype.toJsonArray = function (t) {
            var e = this, i = this.getRows(t), n = this.config.names;
            return this.config.skipHeader && (t = i.splice(0, this.config.skipHeader), this.config.nameByHeader && (n = t[0].trim().split(this.config.columnDelimiter))), i.map(function (t) {
                return e.getFields(t, n)
            })
        }, r.prototype.serialize = function (t, e) {
            var i = t[0] ? Object.keys(t[0]).filter(function (t) {
                    return !t.startsWith("$")
                }).join(this.config.columnDelimiter) + this.config.columnDelimiter + this.config.rowDelimiter : "",
                t = this._serialize(t);
            return e ? t : i + t
        }, r.prototype._serialize = function (t) {
            var o = this;
            return t.reduce(function (t, n) {
                var e = Object.keys(n).reduce(function (t, e, i) {
                    return e.startsWith("$") || "items" === e ? t : "" + t + n[e] + (i === n.length - 1 ? "" : o.config.columnDelimiter)
                }, "");
                return n.items ? t + (t ? "\n" : "") + e + o._serialize(n.items) : "" + t + (t ? o.config.rowDelimiter : "") + e
            }, "")
        }, r);

        function r(t) {
            this.config = n(n({}, {
                skipHeader: 0,
                nameByHeader: !1,
                rowDelimiter: "\n",
                columnDelimiter: ","
            }), t), this.config.nameByHeader && (this.config.skipHeader = 1)
        }

        e.CsvDriver = o
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), g = this && this.__assign || function () {
            return (g = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var a, l = i(0), r = i(5), c = i(2), p = i(1), u = i(19), s = i(6), d = i(7), h = i(93), v = i(15), m = i(11),
            f = i(94), _ = i(4), y = i(51), b = i(24), x = i(123), w = i(124), C = i(17), S = i(125), E = i(10),
            o = (a = s.View, o(k, a), k.prototype.destructor = function () {
                this._destroyContent(), this.keyManager && this.keyManager.destructor(), this.events.events = {}, this.events.context = null, this._activeFilters = this._filterData = this._scroll = this.content = null, this.unmount()
            }, k.prototype.setColumns = function (t) {
                this.config.columns = t, this._parseColumns(), this._adjustColumns(), this._checkFilters(), this._checkMarks(), this.paint()
            }, k.prototype.addRowCss = function (t, e) {
                var i = this.data.getItem(t), t = i.$css || "";
                t.match(new RegExp(e, "g")) || (i.$css = t + " " + e, this.paint())
            }, k.prototype.removeRowCss = function (t, e) {
                t = this.data.getItem(t), e = t.$css ? t.$css.replace(e, "") : "";
                t.$css = e, this.paint()
            }, k.prototype.addCellCss = function (t, e, i) {
                e = this._getColumn(e);
                e && (e.$cellCss[t] ? e.$cellCss[t] += e.$cellCss[t].match(new RegExp(i, "g")) ? "" : " " + i : this.data.getItem(t) && (e.$cellCss[t] = i + " "), this.paint())
            }, k.prototype.removeCellCss = function (t, e, i) {
                e = this._getColumn(e);
                e && (e.$cellCss[t] ? (e.$cellCss[t] = e.$cellCss[t].replace(i, ""), this.paint()) : this.data.getItem(t) && (e.$cellCss[t] = ""))
            }, k.prototype.showColumn = function (t) {
                var e = this._getColumn(t);
                e && e.hidden && this.events.fire(_.GridEvents.beforeColumnShow, [e]) && (e.hidden = !1, this.config.$totalWidth += e.$width, (t = this._hiddenFilters && this._hiddenFilters[e.id]) && (this._activeFilters[e.id] = t, delete this._hiddenFilters[e.id]), this.paint(), this._checkFilters(), this.events.fire(_.GridEvents.afterColumnShow, [e]))
            }, k.prototype.hideColumn = function (t) {
                var e = this._getColumn(t);
                e && !e.hidden && this.events.fire(_.GridEvents.beforeColumnHide, [e]) && (e.hidden = !0, this.config.$totalWidth -= e.$width, (t = this._activeFilters && this._activeFilters[e.id]) && (this._hiddenFilters || (this._hiddenFilters = {}), this._hiddenFilters[e.id] = t, delete this._activeFilters[e.id], this.data.filter()), this.paint(), this._checkFilters(), this.events.fire(_.GridEvents.afterColumnHide, [e]))
            }, k.prototype.isColumnHidden = function (t) {
                t = this._getColumn(t);
                if (t) return !!t.hidden
            }, k.prototype.showRow = function (t) {
                var e;
                t && (e = t.toString(), (t = this.data.getItem(e)) && t.hidden && this.events.fire(_.GridEvents.beforeRowShow, [t]) && (this.data.update(e, {hidden: !1}), this.data.filter(function (t) {
                    return !t.hidden
                }), this.events.fire(_.GridEvents.afterRowShow, [t])))
            }, k.prototype.hideRow = function (t) {
                var e;
                t && (e = t.toString(), (t = this.data.getItem(e)) && this.events.fire(_.GridEvents.beforeRowHide, [t]) && (this.data.update(e, {hidden: !0}), this.data.filter(function (t) {
                    return !t.hidden
                }), this.events.fire(_.GridEvents.afterRowHide, [t])))
            }, k.prototype.isRowHidden = function (t) {
                if (t) {
                    t = this.data.getItem(t.toString());
                    return t ? !!t.hidden : void 0
                }
            }, k.prototype.getScrollState = function () {
                return {x: this._scroll.left, y: this._scroll.top}
            }, k.prototype.scroll = function (t, e) {
                var i = this.getRootView().refs.grid_body.el;
                i.scrollLeft = "number" == typeof t ? t : i.scrollLeft, i.scrollTop = "number" == typeof e ? e : i.scrollTop, this.paint()
            }, k.prototype.scrollTo = function (e, i) {
                var t = this.selection.getCell(), n = this.config.columns.filter(function (t) {
                        return !t.hidden
                    }), o = p.findIndex(n, function (t) {
                        return t.id === i
                    }), r = t ? t.column : this.config.columns[0], s = p.findIndex(n, function (t) {
                        return t.id === r.id
                    }), a = this.config.leftSplit ? m.getTotalWidth(n.slice(0, this.config.leftSplit)) : 0,
                    l = m.getTotalWidth(n.slice(0, o)) - (o - s < 0 ? a : 0), c = this.data.getRawData(0, -1),
                    u = p.findIndex(c, function (t) {
                        return t.id.toString() === e
                    }), d = m.getTotalHeight(c.slice(0, u)), h = this.getScrollState(), f = this.config.width + h.x,
                    t = this.config.height + h.y - this.config.headerRowHeight * this.config.$headerLevel,
                    s = d - h.y - c[u].$height, a = l - h.x - n[o].$width, t = d + 2 * c[u].$height + 18 - t,
                    f = l + 2 * n[o].$width + 18 - f, t = 0 < s && t < 0 ? 0 : s < 0 ? s : t,
                    f = 0 < a && f < 0 ? 0 : a < 0 ? a : f;
                this.scroll(f + h.x, t + h.y)
            }, k.prototype.adjustColumnWidth = function (e, t) {
                void 0 === t && (t = !0);
                var i = this.config.columns.filter(function (t) {
                    return !t.hidden
                }), n = i.filter(function (t) {
                    return t.id === e
                }), r = this._adjustColumnsWidth(this.config.data, n, t);
                this.config.$totalWidth = i.reduce(function (t, e) {
                    var i, n, o;
                    return r[e.id] && (e.$fixed = !0, i = e.maxWidth, n = e.minWidth, o = r[e.id], e.$width = o, i && i < o && (e.$width = i), n && e.$width < n && (e.$width = n)), t + e.$width
                }, 0), this.paint()
            }, k.prototype.getCellRect = function (e, i) {
                var t = this.config.columns.filter(function (t) {
                    return !t.hidden
                }), n = this.data.getRawData(0, -1), o = p.findIndex(t, function (t) {
                    return t.id === i
                }), r = p.findIndex(n, function (t) {
                    return t.id === e
                });
                return {
                    x: m.getTotalWidth(t.slice(0, o)),
                    y: m.getTotalHeight(n.slice(0, r)),
                    height: n[r] ? n[r].$height : 0,
                    width: t[o] ? t[o].$width : 0
                }
            }, k.prototype.getColumn = function (e) {
                var t = p.findIndex(this.config.columns, function (t) {
                    return t.id === e
                });
                if (0 <= t) return this.config.columns[t]
            }, k.prototype.addSpan = function (e) {
                this.config.spans = this.config.spans || [];
                var t = p.findIndex(this.config.spans, function (t) {
                    return "" + t.row == "" + e.row && "" + t.column == "" + e.column
                });
                0 <= t ? this.config.spans[t] = e : this.config.spans.push(e)
            }, k.prototype.getSpan = function (e, i) {
                if (this.config.spans) {
                    var t = p.findIndex(this.config.spans, function (t) {
                        return "" + t.row == "" + e && "" + t.column == "" + i
                    });
                    return this.config.spans[t]
                }
            }, k.prototype.removeSpan = function (e, i) {
                var t;
                this.config.spans && (t = p.findIndex(this.config.spans, function (t) {
                    return "" + t.row == "" + e && "" + t.column == "" + i
                }), this.config.spans.splice(t, 1))
            }, k.prototype.editCell = function (t, e, i) {
                var n = this.data.getItem(t), o = this.getColumn(e), r = o.editorType;
                n && void 0 !== n[e] ? (i || ("date" === o.type && (i = "datePicker"), "boolean" === o.type && (i = "checkbox"), r && (i = r)), this.events.fire(_.GridEvents.beforeEditStart, [n, o, i]) && (this.config.$editable && this.config.$editable.row === t && this.config.$editable.col === e && this.config.$editable.editorType === i || (this.config.$editable = {
                    row: t,
                    col: e,
                    editorType: i
                }, this.selection.config.disabled || this.selection.setCell(t.toString(), e.toString()), this.paint(), this.events.fire(_.GridEvents.afterEditStart, [n, o, i])))) : d.dhxWarning("item not found")
            }, k.prototype.editEnd = function (t) {
                this.config.$editable && this.config.$editable.editor && this.config.$editable.editor.endEdit(t)
            }, k.prototype.getSortingState = function () {
                return {dir: this._sortDir, by: this._sortBy}
            }, k.prototype.getHeaderFilter = function (i) {
                var n = this, t = this.getColumn(i);
                if (t) {
                    var o = null;
                    return t.header.forEach(function (t) {
                        var e;
                        t.content && (e = n.content[t.content].element[i], o = "comboFilter" === t.content ? e : n.getRootView().refs[i + "_filter"].el)
                    }), o
                }
            }, k.prototype.edit = function (t, e, i) {
                this.editCell(t, e, i)
            }, k.prototype._parseColumns = function () {
                v.normalizeColumns(this.config);
                var t = this.config.columns.filter(function (t) {
                    return !t.hidden
                });
                v.countColumns(this.config, t)
            }, k.prototype._parseData = function () {
                this.config.data = this._prepareData(this.data), this._detectColsTypes(), this._checkFilters(), this._checkMarks(), this._render()
            }, k.prototype._createCollection = function (t) {
                this.data = new d.DataCollection({prep: t}, this.events)
            }, k.prototype._getRowIndex = function (t) {
                return this.data.getIndex(t)
            }, k.prototype._setEventHandlers = function () {
                function i(t) {
                    return 1
                }

                var r = this;
                this.data.events.on(d.DataEvents.load, function () {
                    r.data.filter(function (t) {
                        return t
                    }), r._parseData(), r._checkFilters()
                }), this.data.events.on(d.DataEvents.change, function (t, e, i) {
                    if ("remove" !== e || !i.$emptyRow) if ("setPage" !== e) {
                        if ("add" !== e && "update" !== e && "remove" !== e || (r.config.data = r._prepareData(r.data)), t && (r._filterData = r.data.map(function (t) {
                            return t
                        }) || [], r._checkFilters()), r._detectColsTypes(), r._removeMarks(), r._checkMarks(), r.config.autoEmptyRow && (!r._activeFilters || p.isEmptyObj(r._activeFilters))) {
                            e = r.data.find({by: "$emptyRow", match: !0});
                            if (e) {
                                if (e.id === t) return;
                                r.data.move(e.id, r.data.getLength() - 1)
                            } else r._addEmptyRow()
                        }
                        r._render()
                    } else l.awaitRedraw().then(function () {
                        r.scrollTo(r.data.getId(i[0]), r.config.columns[0].id.toString()), r._render()
                    })
                }), this.data.events.on(d.DataEvents.removeAll, function () {
                    r.config.columns.map(function (e) {
                        e.header.map(function (t) {
                            !t.content || "selectFilter" !== t.content && "comboFilter" !== t.content || (e.$uniqueData = [])
                        })
                    })
                }), this.events.on(d.DragEvents.beforeDrag, function (t, e) {
                    return r.data.getItem(t.start) ? r.events.fire(_.GridEvents.beforeRowDrag, [t, e]) : "column" === r.config.dragItem ? r.events.fire(_.GridEvents.beforeColumnDrag, [t, e]) : void 0
                }), this.events.on(d.DragEvents.dragStart, function (t, e) {
                    i({$dragtarget: !0}), r.data.getItem(t.start) ? r.events.fire(_.GridEvents.dragRowStart, [t, e]) : "column" === r.config.dragItem && r.events.fire(_.GridEvents.dragColumnStart, [t, e])
                }), this.events.on(d.DragEvents.dragIn, function (t, e) {
                    r.data.getItem(t.start) ? r.events.fire(_.GridEvents.dragRowIn, [t, e]) : "column" === r.config.dragItem && r.events.fire(_.GridEvents.dragColumnIn, [t, e])
                }), this.events.on(d.DragEvents.dragOut, function (t, e) {
                    r.data.getItem(t.start) ? r.events.fire(_.GridEvents.dragRowOut, [t, e]) : "column" === r.config.dragItem && r.events.fire(_.GridEvents.dragColumnOut, [t, e])
                }), this.events.on(d.DragEvents.canDrop, function (t, e) {
                    i({$drophere: !0}), r.data.getItem(t.start) ? r.events.fire(_.GridEvents.canRowDrop, [t, e]) : "column" === r.config.dragItem && r.events.fire(_.GridEvents.canColumnDrop, [t, e])
                }), this.events.on(d.DragEvents.cancelDrop, function (t, e) {
                    i({$drophere: void 0}), r.data.getItem(t.start) ? r.events.fire(_.GridEvents.cancelRowDrop, [t, e]) : "column" === r.config.dragItem && r.events.fire(_.GridEvents.cancelColumnDrop, [t, e])
                }), this.events.on(d.DragEvents.beforeDrop, function (t, e) {
                    return "row" !== r.config.dragItem || "both" !== r.config.dragMode && "target" !== r.config.dragMode ? "column" === r.config.dragItem ? r.events.fire(_.GridEvents.beforeColumnDrop, [t, e]) : void 0 : r.events.fire(_.GridEvents.beforeRowDrop, [t, e])
                }), this.events.on(d.DragEvents.afterDrop, function (t, e) {
                    r.data.getItem(t.start) ? r.events.fire(_.GridEvents.afterRowDrop, [t, e]) : "column" === r.config.dragItem && r.events.fire(_.GridEvents.afterColumnDrop, [t, e]), r.config.data = r._prepareData(r.data.map(function (t) {
                        return t
                    })), r.data.parse(r.config.data)
                }), this.events.on(d.DragEvents.afterDrag, function (t, e) {
                    i({$dragtarget: void 0}), r.data.getItem(t.start) ? r.events.fire(_.GridEvents.afterRowDrag, [t, e]) : "column" === r.config.dragItem && r.events.fire(_.GridEvents.afterColumnDrag, [t, e]), r.config.data = r._prepareData(r.data.map(function (t) {
                        return t
                    })), r.data.parse(r.config.data)
                }), this.events.on(_.GridEvents.cellMouseDown, function (t, e, i) {
                    i.targetTouches ? (r._touch.timer = setTimeout(function () {
                        r._dragStart(i)
                    }, r._touch.duration), r._touch.timeStamp ? (r._touch.dblDuration >= r._touch.timeStamp - +i.timeStamp.toFixed() && ((!1 !== e.editable && r.config.editable || e.editable) && r.editCell(t.id, e.id, e.editorType), i.preventDefault(), r.events.fire(_.GridEvents.cellDblClick, [t, e, i])), r._touch.timeStamp = null) : r._touch.timeStamp = +i.timeStamp.toFixed(), setTimeout(function () {
                        r._touch.timeStamp = null
                    }, r._touch.dblDuration)) : r._dragStart(i)
                }), this._events.on(_.GridSystemEvents.cellTouchMove, function (t, e, i) {
                    r._touch.start && i.preventDefault(), r._clearTouchTimer()
                }), this._events.on(_.GridSystemEvents.cellTouchEnd, function () {
                    r._touch.start = !1, r._clearTouchTimer()
                }), this.events.on(_.GridEvents.headerInput, function (t, e, i) {
                    var n, o;
                    for (o in !r.config.autoEmptyRow || (n = r.data.find({
                        by: "$emptyRow",
                        match: !0
                    })) && r.data.remove(n.id), r._activeFilters || (r._activeFilters = {}), t ? r._activeFilters[e] = {
                        by: e,
                        match: t,
                        compare: r.content[i].match
                    } : delete r._activeFilters[e], r.data.filter(function (t) {
                        return t
                    }), r._activeFilters) r.data.filter(r._activeFilters[o], {add: !0})
                }), this.events.on(_.GridEvents.filterChange, function (t, e, i) {
                    var n, o;
                    for (o in !r.config.autoEmptyRow || (n = r.data.find({
                        by: "$emptyRow",
                        match: !0
                    })) && r.data.remove(n.id), r._activeFilters || (r._activeFilters = {}), t ? r._activeFilters[e] = {
                        by: e,
                        match: t,
                        compare: r.content[i].match
                    } : delete r._activeFilters[e], r.data.filter(function (t) {
                        return t
                    }), r._activeFilters) r.data.filter(r._activeFilters[o], {add: !0})
                }), this.events.on(_.GridEvents.scroll, function (t) {
                    r._scroll = {top: t.y, left: t.x}, r.editEnd(), r.paint()
                }), this.events.on(_.GridEvents.cellDblClick, function (t, e) {
                    (!1 !== e.editable && r.config.editable || e.editable) && r.editCell(t.id, e.id, e.editorType)
                }), this.events.on(_.GridEvents.afterEditEnd, function (t, e, i) {
                    var n,
                        e = r.config.$editable ? (n = r.config.$editable.row, r.config.$editable.col) : (n = e.id, i.id),
                        i = r.data.getItem(n);
                    delete i.$emptyRow, void 0 !== t && r.data.update(n, g(g({}, i), ((i = {})[e] = t, i))), r.config.$editable = null, r._checkFilters(), r.paint()
                }), this.events.on(_.GridEvents.headerCellMouseDown, function (t, e) {
                    var i = e.target.getAttribute("dhx_resized");
                    i && r.events.fire(_.GridEvents.beforeResizeStart, [t, e]) && w.startResize(r, i.toString(), e, function () {
                        r.paint(), r.config.$resizing = null, r.events.fire(_.GridEvents.afterResizeEnd, [t, e])
                    }), e.targetTouches && (r._touch.timeStamp ? (r._touch.dblDuration >= r._touch.timeStamp - +e.timeStamp.toFixed() && (e.preventDefault(), r.events.fire(_.GridEvents.headerCellDblClick, [t, e])), r._touch.timeStamp = null) : r._touch.timeStamp = +e.timeStamp.toFixed(), setTimeout(function () {
                        r._touch.timeStamp = null
                    }, r._touch.dblDuration))
                }), this.events.on(_.GridEvents.footerCellDblClick, function (t, e) {
                    e.targetTouches && (r._touch.timeStamp ? (r._touch.dblDuration >= r._touch.timeStamp - +e.timeStamp.toFixed() && (e.preventDefault(), r.events.fire(_.GridEvents.footerCellDblClick, [t, e])), r._touch.timeStamp = null) : r._touch.timeStamp = +e.timeStamp.toFixed(), setTimeout(function () {
                        r._touch.timeStamp = null
                    }, r._touch.dblDuration))
                }), this.events.on(_.GridEvents.resize, function () {
                    r._parseColumns(), r._checkFilters()
                })
            }, k.prototype._addEmptyRow = function () {
                var t = this.data.getId(this.data.getLength() - 1), e = this.data.getItem(t),
                    t = this.config.columns.filter(function (t) {
                        return !t.hidden
                    });
                m.isRowEmpty(e) || this.data.add(t.reduce(function (t, e) {
                    return t[e.id] = "", t
                }, {$emptyRow: !0}))
            }, k.prototype._sort = function (i, t) {
                var n = this;
                t ? this._sortDir = t : this._sortBy === i ? this._sortDir = "asc" === this._sortDir ? "desc" : "asc" : this._sortDir = "asc", this._sortBy = i, this.data.sort({
                    by: i,
                    dir: this._sortDir,
                    as: function (t) {
                        var e = n.getColumn(i);
                        return t && "date" === e.type ? ("string" == typeof t ? b.stringToDate(t, e.format) : t).getTime() : t ? "" + t : ""
                    }
                }), this.events.fire(_.GridEvents.afterSort, [this.getColumn(i), this._sortDir])
            }, k.prototype._clearTouchTimer = function () {
                this._touch.timer && (clearTimeout(this._touch.timer), this._touch.timer = null)
            }, k.prototype._checkFilters = function () {
                var n = this, i = this._filterData;
                this.config.columns.forEach(function (e) {
                    e.header.forEach(function (t) {
                        !t.content || "selectFilter" !== t.content && "comboFilter" !== t.content || (t = v.getUnique(i, e.id), e.$uniqueData && e.$uniqueData.length > t.length ? t.forEach(function (t) {
                            e.$uniqueData.includes(t) || e.$uniqueData.push(t)
                        }) : e.$uniqueData = t)
                    })
                });
                var t, o = this;
                for (t in this._activeFilters) !function (e) {
                    var t = o.config.columns.find(function (t) {
                        return t.id === e
                    }), i = t.header.find(function (t) {
                        return !!t.content
                    });
                    !i || "selectFilter" !== i.content && "comboFilter" !== i.content || t.$uniqueData.find(function (t) {
                        return t.toString() === n._activeFilters[e].match
                    }) ? o.data.filter(o._activeFilters[e], {add: !0}) : (delete o._activeFilters[e], o.data.filter())
                }(t)
            }, k.prototype._adjustColumns = function () {
                var t, r, e, i = this;
                "boolean" == typeof this.config.adjust || "data" === this.config.adjust || "header" === this.config.adjust || "footer" === this.config.adjust ? (e = this.config.columns.filter(function (t) {
                    return !t.hidden
                })).length && (t = this.config.data && this.config.data.length ? this.config.data : this.data.map(function (t) {
                    return t
                }), r = this._adjustColumnsWidth(t, e), this.config.$totalWidth = e.reduce(function (t, e) {
                    e.$fixed = !0;
                    var i = e.maxWidth, n = e.minWidth, o = r[e.id];
                    return e.$width = o, i && i < o && (e.$width = i), n && e.$width < n && (e.$width = n), t + e.$width
                }, 0)) : (e = this.config.columns.filter(function (t) {
                    return !t.hidden && t.adjust
                })).length && e.forEach(function (t) {
                    i.adjustColumnWidth(t.id, t.adjust)
                })
            }, k.prototype._prepareData = function (t) {
                var e = this;
                return this.config.autoHeight && (this.config.autoHeight = !1), this._adjustColumns(), t.map(function (t) {
                    return t.$height = t.height || e.config.rowHeight, t
                })
            }, k.prototype._adjustColumnsWidth = function (t, e, i) {
                void 0 === i && (i = this.config.adjust);
                var n = {};
                if ("header" === i || !0 === i) {
                    var o = e.filter(function (t) {
                        return t.header
                    });
                    if (u = v.getMaxColsWidth(this._prepareColumnData(o, "header"), o, {font: "bold 14.4px Arial"}, "header")) for (var r = 0, s = Object.entries(u); r < s.length; r++) var a = s[r], l = a[0], c = a[1], n = Object.assign(n, ((a = {})[l] = +c + (m.isSortable(this.config, this.getColumn(l)) ? 36 : 16), a))
                }
                if ("footer" === i || !0 === i) {
                    var u, o = e.filter(function (t) {
                        return t.footer
                    });
                    if (u = v.getMaxColsWidth(this._prepareColumnData(o, "footer"), o, {font: "bold 14.4px Arial"}, "footer")) for (var d = 0, h = Object.entries(u); d < h.length; d++) {
                        var f = h[d], l = f[0], c = f[1];
                        (n[l] && n[l] < +c + 16 || !n[l]) && (n = Object.assign(n, ((f = {})[l] = +c + 16, f)))
                    }
                }
                if (("data" === i || !0 === i) && (u = v.getMaxColsWidth(t, e, {font: "normal 14.4px Arial"}, "data"))) for (var p = 0, g = Object.entries(u); p < g.length; p++) {
                    var _ = g[p], l = _[0], c = _[1];
                    (n[l] && n[l] < +c + 16 || !n[l]) && (n = Object.assign(n, ((_ = {})[l] = +c + 16, _)))
                }
                return n
            }, k.prototype._prepareColumnData = function (t, e) {
                for (var i, n, o = [], r = 0; r < t.length; r++) {
                    for (var s = [], a = 0; a < (null === (i = t[a]) || void 0 === i ? void 0 : i[e].length); a++) {
                        var l = {};
                        null !== (i = null === (i = t[r]) || void 0 === i ? void 0 : i[e][a]) && void 0 !== i && i.text ? (l[t[r].id] = (null === (n = null === (n = t[r]) || void 0 === n ? void 0 : n[e][a]) || void 0 === n ? void 0 : n.text) || "", s.push(l)) : null !== (n = null === (n = t[r]) || void 0 === n ? void 0 : n[e][a]) && void 0 !== n && n.content && (l[t[r].id] = this.content[null === (n = null === (n = t[r]) || void 0 === n ? void 0 : n[e][a]) || void 0 === n ? void 0 : n.content].toHtml(this.getColumn(t[r].id), this.config) || "", s.push(l))
                    }
                    for (var c = 0; c < s.length; c++) for (var u = 0, d = Object.entries(s[c]); u < d.length; u++) {
                        var h = d[u], f = h[0], p = h[1];
                        o[c] = g({}, o[c]) || {}, o[c] = Object.assign(o[c], ((h = {})[f] = p, h))
                    }
                }
                return o
            }, k.prototype._dragStart = function (t) {
                if (this.config.dragMode && "row" === this.config.dragItem && !this.config.$editable) {
                    var e = c.locateNode(t, "dhx_id"), i = e && e.getAttribute("dhx_id");
                    return t.targetTouches && (this._touch.start = !0), d.dragManager.onMouseDown(t, [i], [e])
                }
            }, k.prototype._getColumn = function (t) {
                for (var e = 0, i = this.config.columns; e < i.length; e++) {
                    var n = i[e];
                    if (n.id === t) return n
                }
            }, k.prototype._init = function () {
                this.events = new r.EventSystem(this), this._events = new r.EventSystem(this), this._attachDataCollection(), this.export = new h.Exporter(this), this._setEventHandlers()
            }, k.prototype._attachDataCollection = function () {
                var e = this;
                if (this.config.data instanceof d.DataCollection) return this.data = this.config.data, void (this.config.data = this.data.serialize());
                this._createCollection(function (t) {
                    return t.spans && (e.config.spans = t.spans, t = t.data), t
                })
            }, k.prototype._setMarks = function (n, o) {
                for (var t = this.data.map(function (t) {
                    return {id: t.id, data: t[n.id], row: t}
                }), r = this.data.map(function (t) {
                    return t[n.id]
                }), e = 0, i = t; e < i.length; e++) !function (t) {
                    var e, i = o(t.data, r, t.row, n);
                    i && (n.$cellCss = n.$cellCss || {}, e = (n.$cellCss[t.id] || "").split(" "), i.split(" ").map(function (t) {
                        e.includes(t) || e.push(t)
                    }), n.$cellCss[t.id] = e.join(" "))
                }(i[e])
            }, k.prototype._checkMarks = function () {
                var e = this;
                this.config.columns.map(function (t) {
                    var o = t.mark;
                    o && ("function" == typeof o ? e._setMarks(t, o) : e._setMarks(t, function (t, e) {
                        var i = [];
                        e.forEach(function (t) {
                            null != t && "" !== t && i.push(parseFloat(t))
                        });
                        var n = p.getMinArrayNymber(i), e = p.getMaxArrayNymber(i);
                        return o.max && e === parseFloat(t) ? o.max : !(!o.min || n !== parseFloat(t)) && o.min
                    }))
                })
            }, k.prototype._removeMarks = function () {
                this.config.columns.forEach(function (t) {
                    t.mark && (t.$cellCss = {})
                })
            }, k.prototype._detectColsTypes = function () {
                this.config.columns.forEach(function (t) {
                    return t.type ? t : t.format ? (t.type = "number", t) : void (t.type || (t.type = "string"))
                })
            }, k.prototype._destroyContent = function () {
                for (var t in this.content) "comboFilter" === t && this.content[t].destroy()
            }, k.prototype._render = function () {
                this.paint()
            }, k.prototype._initHotKey = function () {
                var t, e = S.getKeysHandlers(this);
                for (t in e) this.keyManager.addHotKey(t, e[t]);
                for (t in this.config.hotkeys) this.keyManager.addHotKey(t, this.config.hotkeys[t])
            }, k);

        function k(t, e) {
            var r = a.call(this, t, e) || this;
            r._touch = {
                duration: 350,
                dblDuration: 300,
                timer: null,
                start: !1,
                timeStamp: null
            }, r.config = p.extend({
                rowHeight: 40,
                headerRowHeight: 40,
                footerRowHeight: 40,
                keyNavigation: !0,
                sortable: !0,
                columns: [],
                data: [],
                tooltip: !0,
                rootParent: "string" == typeof t && t || r._uid,
                headerSort: !0
            }, e), r.content = x.getContent(), r._scroll = {
                top: 0,
                left: 0
            }, r.config.autoWidth = r.config.autoWidth || r.config.fitToContainer, r.config.adjust = r.config.adjust || r.config.columnsAutoWidth, r.config.editable = r.config.editable || r.config.editing, r.config.leftSplit = r.config.leftSplit || r.config.splitAt, r.config.sortable && r.config.headerSort || (r.config.sortable = !1), r.config.columns.forEach(function (t) {
                t.format = t.format || t.dateFormat
            });

            function n(t, e, i) {
                var n;
                t && e && m.isTooltip(r.config, e) && (n = v.toFormat(t[e.id], e.type, e.format), e.tooltipTemplate ? n = e.tooltipTemplate(n, t, e) : n && e.template && (n = e.template(n, t, e)), n && C.tooltip(n, {
                    css: "dhx_grid_tooltip",
                    node: i,
                    htmlEnable: m.isHtmlEnable(r.config, e)
                }))
            }

            function i(t, e) {
                var i;
                e && m.isTooltip(r.config, e) && ((i = t.target.querySelector(".dhx_grid-header-cell-text span") && t.target.querySelector(".dhx_grid-header-cell-text span").textContent || t.target.querySelector(".dhx_grid-footer-cell-text span") && t.target.querySelector(".dhx_grid-footer-cell-text span").textContent || "") && C.tooltip(i, {
                    css: "dhx_grid_tooltip",
                    node: t.target,
                    htmlEnable: m.isHtmlEnable(r.config, e)
                }))
            }

            var o = {
                onclick: c.eventHandler(function (t) {
                    return c.locate(t)
                }, {
                    "dhx_grid-header-cell--sortable": function (t, e) {
                        var i = t.target.getAttribute("dhx_resized"), t = r._getColumn(e);
                        t && m.isSortable(r.config, t) && !i && r.events.fire(_.GridEvents.beforeSort, [t, r._sortDir ? "asc" : "desc"]) && r._sort(e)
                    }, "dhx_grid-expand-cell": function (t, e) {
                        t.target.classList.contains("dhx_grid-expand-cell-icon") && r.events.fire(_.GridEvents.expand, [e])
                    }
                }), onscroll: function (t) {
                    r.events.fire(_.GridEvents.scroll, [{y: t.target.scrollTop, x: t.target.scrollLeft}])
                }, onmouseover: {
                    ".dhx_grid-cell": function (t) {
                        var e = r.data.getItem(t.composedPath()[1].getAttribute("dhx_id")),
                            i = r._getColumn(t.target.getAttribute("dhx_col_id"));
                        n(e, i, t.target)
                    },
                    ".dhx_grid-cell:not(.dhx_tree-cell) .dhx_grid-cell__content, .dhx_tree-cell :not(.dhx_grid-cell__content)": function (t) {
                        var e = t.composedPath(), i = r.data.getItem(e[2].getAttribute("dhx_id")),
                            e = r._getColumn(e[1].getAttribute("dhx_col_id"));
                        n(i, e, t.target)
                    },
                    ".dhx_grid-cell.dhx_tree-cell .dhx_grid-cell__content": function (t) {
                        var e = t.composedPath(), i = r.data.getItem(e[3].getAttribute("dhx_id")),
                            t = r._getColumn(e[2].getAttribute("dhx_col_id"));
                        n(i, t, e[2])
                    },
                    ".dhx_span-cell:not(.dhx_grid-header-cell)": function (t) {
                        var e, i = r.data.getItem(t.target.getAttribute("dhx_id")),
                            n = r._getColumn(t.target.getAttribute("dhx_col_id")), o = r.getSpan(i.id, n.id);
                        i && o && m.isTooltip(r.config, o) && (e = o.text || v.toFormat(i[n.id], n.type, n.format), o.tooltipTemplate ? e = o.tooltipTemplate(e, o) : n.template && (e = n.template(e, i, n)), e && C.tooltip(e, {
                            css: "dhx_grid_tooltip",
                            node: t.target,
                            htmlEnable: !0
                        }))
                    },
                    ".dhx_grid-header-cell:not(.dhx_span-cell)": function (t) {
                        var e = r._getColumn(t.target.getAttribute("dhx_id"));
                        i(t, e)
                    },
                    ".dhx_grid-footer-cell:not(.dhx_span-cell)": function (t) {
                        var e = r._getColumn(t.target.getAttribute("dhx_id"));
                        i(t, e)
                    },
                    ".dhx_grid-header-cell.dhx_span-cell": function (t) {
                        var e = r._getColumn(t.target.getAttribute("dhx_id")), i = e && e.header.find(function (t) {
                            return !(!t.rowspan && !t.colspan)
                        });
                        e && i && m.isTooltip(r.config, e) && ((i = i.text || "") && C.tooltip(i, {
                            css: "dhx_grid_tooltip",
                            node: t.target,
                            htmlEnable: m.isHtmlEnable(r.config, e)
                        }))
                    },
                    ".dhx_grid-header-cell-text_content": function (t) {
                        var e = t.composedPath(), i = r._getColumn(e[1].getAttribute("dhx_id"));
                        i && m.isTooltip(r.config, i) && ((t = e[2].querySelector(".dhx_grid-header-cell-text_content") && e[2].querySelector(".dhx_grid-header-cell-text_content").textContent || "") && C.tooltip(t, {
                            css: "dhx_grid_tooltip",
                            node: e[1],
                            htmlEnable: m.isHtmlEnable(r.config, i)
                        }))
                    }
                }
            };
            (r.config.dragMode || r.config.dragItem) && (d.dragManager.setItem(r._uid, r), r.config.dragItem || (r.config.dragItem = "row"), r.config.dragMode || (r.config.dragMode = "both")), r._init(), r.config.columns && r._parseColumns(), r.config.data && r.config.data instanceof Array && r.config.data.length && r.config.columns && r.data.parse(r.config.data), r.selection = new f.Selection(r, {disabled: !r.config.selection}, r.events), r.config.keyNavigation && (r.keyManager = new u.KeyManager(function (t, e) {
                return !(e !== r._uid || !r.events.fire(_.GridEvents.beforeKeyDown, [t])) && (r.events.fire(_.GridEvents.afterKeyDown, [t]), !0)
            }), r._initHotKey(), E.focusManager.setFocusId(r._uid));
            var s = l.create({
                render: function (t, e) {
                    return y.render(t, e, o, r.selection, r._uid)
                }
            }, r);
            return r.mount(t, s), r.config.autoWidth && r.config.autoHeight && r._prepareData(r.config.data), e.autoEmptyRow && 0 === r.data.getLength() && (r._addEmptyRow(), r.paint()), r
        }

        e.Grid = o
    }, function (t, e, i) {
        "use strict";
        var v = this && this.__assign || function () {
            return (v = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var m = i(0), d = i(2), a = i(15), y = i(11), b = i(36), x = i(122), w = i(61), h = i(1), C = 2;

        function S(t, e, i) {
            var n = t.config, o = n.columns.filter(function (t) {
                    return !t.hidden
                }), r = a.calculatePositions(i.width, i.height, t._scroll, n, e), s = o.slice(r.xStart, r.xEnd),
                i = e.slice(r.yStart, r.yEnd);
            return v(v({}, n), {
                data: e,
                columns: o,
                scroll: t._scroll,
                $positions: r,
                headerHeight: n.$headerLevel * n.headerRowHeight,
                footerHeight: n.$footerLevel * n.footerRowHeight,
                firstColId: o[0] && o[0].id,
                events: t.events,
                _events: t._events,
                currentColumns: s,
                currentRows: i,
                sortBy: t._sortBy,
                sortDir: t._sortDir,
                content: t.content,
                gridId: t._uid
            })
        }

        function E(t) {
            if (t && (t.tagName || (t = t._parent._container), t)) {
                var e = t.currentStyle || window.getComputedStyle(t),
                    i = parseFloat(e.paddingLeft) + parseFloat(e.paddingRight) || 0,
                    e = parseFloat(e.paddingTop) + parseFloat(e.paddingBottom) || 0;
                return {width: t.clientWidth - i, height: t.clientHeight - e}
            }
        }

        function k(o, t) {
            var e, i = b.getCells(o), n = b.getSpans(o), r = o.columns;
            o.$resizing && (a = h.findIndex(r, function (t) {
                return t.id === o.$resizing
            }), l = y.getTotalWidth(r.slice(0, a)) + r[a].$width, e = m.el(".dhx_grid-resize-line", {
                style: {
                    top: 0,
                    left: l,
                    height: o.$totalHeight
                }
            }));
            var s,
                a = "string" == typeof (a = o.selection ? o.selection.toHTML() : null) ? m.el("div.dhx_selection", {".innerHTML": a}) : a,
                l = o.$positions, c = {};
            if (o.eventHandlers) for (var u in o.eventHandlers) o.eventHandlers.hasOwnProperty(u) && (s = o.eventHandlers[u], c[u] = d.eventHandler(function (t) {
                return e = t, i = d.locate(e, "dhx_id"), n = d.locate(e, "dhx_col_id"), t = o.currentRows.filter(function (t) {
                    return t.id === i
                })[0], e = o.currentColumns.filter(function (t) {
                    return t.id === n
                })[0], {row: i ? t : {}, col: n ? e : {}};
                var e, i, n
            }, v({}, s)));
            return m.el(".dhx_data-wrap", v({
                style: {
                    height: o.$totalHeight,
                    width: o.$totalWidth,
                    "padding-left": t.x,
                    "padding-top": t.y
                }, role: "presentation"
            }, c), [m.el(".dhx_grid_data", v(v({_flags: m.KEYED_LIST}, b.getHandlers(l.yStart, l.xStart, o)), {role: "rowgroup"}), i), m.el(".dhx_span-spans", {role: "presentation"}, n), m.el(".dhx_grid_selection", {
                _ref: "selection",
                "aria-hidden": "true"
            }, [a, e])])
        }

        function M(e, t, o, r) {
            void 0 === o && (o = !0), void 0 === r && (r = !1);
            var s, i = e.$totalHeight >= t.height - e.headerRowHeight ? d.getScrollbarWidth() : 0, a = t.width - C - i,
                n = e.columns.filter(function (t) {
                    return !t.hidden
                }), i = n.filter(function (t) {
                    return !t.width && !t.$fixed && y.isAutoWidth(e, t)
                }), l = y.getTotalWidth(n.filter(function (t) {
                    return t.width || t.$fixed || !y.isAutoWidth(e, t)
                })), c = i.reduce(function (t, e) {
                    return t + (e.gravity || 1)
                }, 0);
            a < e.$totalWidth ? (s = i.reduce(function (t, e) {
                return t + (e.maxWidth || e.$width)
            }, 0), 1 < i.length && i.forEach(function (t) {
                var e = 0,
                    i = (e = o ? Math.abs(a - s) * ((t.gravity || 1) / c) : Math.abs(a - l) * ((t.gravity || 1) / c)) < t.minWidth,
                    n = e > t.maxWidth;
                i || n ? i ? (l += t.$width - e, t.$fixed = !0) : n && (t.$width = t.maxWidth, t.$fixed = !0) : t.$width = e
            })) : i.forEach(function (t) {
                var e = Math.abs(a - l) * ((t.gravity || 1) / c), i = e < t.minWidth, n = e > t.maxWidth;
                i || n ? i ? (l += t.$width - e, r && (t.$fixed = !0)) : n && (t.$width = t.maxWidth, r && (t.$fixed = !0)) : t.$width = e, !o && t.$fixed && delete t.$fixed
            }), o && M(e, t, !1)
        }

        e.getRenderConfig = S, e.render = function (t, e, i, n, o) {
            e._container || (e.config.width = 1, e.config.height = 1), t && t.node && t.node.parent && t.node.parent.el && (p = E(t.node.parent.el), e.config.width = p.width, e.config.height = p.height);
            var r = e.config;
            if (!r) return m.el("div");
            if (!r.columns.length) return m.el(".dhx_grid");
            var s = e.data.getRawData(0, -1, null, 2);
            r.columns.reduce(function (t, e) {
                return e.hidden && t
            }, !0) ? r.$totalHeight = 0 : r.$totalHeight = s.reduce(function (t, e) {
                return t + (e.$height || 0)
            }, 0);
            var a = E(e._container), l = {width: r.width || a && a.width || 0, height: r.height || a && a.height || 0};
            y.isAutoWidth(r) && (M(r, l), r.$totalWidth = y.getTotalWidth(r.columns.filter(function (t) {
                return !t.hidden
            }))), r.width = l.width, r.height = l.height;
            var c = S(e, s, l);
            c.selection = n, c.datacollection = e.data;
            var u, d, h = b.getShifts(c), f = y.isCssSupport("position", "sticky"),
                a = (_ = c, g = (g = l).height - C, g = (p = f) ? g : g - _.headerHeight, !_.$footer || p ? g : g - _.footerHeight),
                s = {wrapper: l, sticky: f, shifts: h, gridBodyHeight: a},
                n = w.getFixedRows(c, v(v({}, s), {name: "header", position: "top"})),
                p = c.$footer ? w.getFixedRows(c, v(v({}, s), {name: "footer", position: "bottom"})) : null,
                g = c.$totalWidth + C < l.width ? "dhx_grid-less-width" : "",
                _ = c.$totalHeight + C < l.height ? "dhx_grid-less-height" : "";
            return t.node || (t = e.getScrollState(), u = t.x, d = t.y, m.awaitRedraw().then(function () {
                e.scroll(u, d)
            })), m.el(".dhx_grid.dhx_widget", {
                class: (c.css || "") + (f ? "" : " dhx_grid_border") + (r.multiselection ? " dhx_no-select--pointer" : ""),
                dhx_widget_id: o,
                dhx_root_id: r.rootParent,
                role: "grid",
                "aria-rowcount": c.data.length,
                "aria-colcount": r.columns.filter(function (t) {
                    return !t.hidden
                }).length
            }, [m.resizer(function (t) {
                return y.isAutoWidth(e.config) && t && (r.$totalWidth = 0, M(r, l, !0, !0)), e.paint()
            }), m.el(".dhx_grid-content", {
                style: v({}, l),
                onclick: i.onclick,
                onmouseover: i.onmouseover,
                class: (g + " " + _).trim(),
                role: "presentation"
            }, [f ? null : n, m.el(".dhx_grid-body", {
                style: {height: a, width: l.width - C},
                onscroll: i.onscroll,
                _ref: "grid_body",
                role: "presentation"
            }, [m.el("div", {}, [f ? n : null, k(c, h), f ? p : null])]), x.getFixedColsHeader(c, s), x.getFixedCols(c, s), f ? null : p])])
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), (e = e.PopupEvents || (e.PopupEvents = {})).beforeHide = "beforeHide", e.beforeShow = "beforeShow", e.afterHide = "afterHide", e.afterShow = "afterShow", e.click = "click"
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), (e = e.SliderEvents || (e.SliderEvents = {})).change = "change", e.mousedown = "mousedown", e.mouseup = "mouseup"
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), (e = e.TimepickerEvents || (e.TimepickerEvents = {})).change = "change", e.beforeApply = "beforeApply", e.afterApply = "afterApply", e.beforeClose = "beforeClose", e.afterClose = "afterClose", e.apply = "apply", e.close = "close", e.save = "save"
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), (e = e.CalendarEvents || (e.CalendarEvents = {})).change = "change", e.beforeChange = "beforechange", e.modeChange = "modeChange", e.monthSelected = "monthSelected", e.yearSelected = "yearSelected", e.cancelClick = "cancelClick", e.dateMouseOver = "dateMouseOver", e.dateHover = "dateHover"
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(114)), n(e(60))
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(116)), n(e(58)), n(e(38))
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(27), o = i(7), i = (r.prototype.enable = function () {
            this.config.disabled = !1
        }, r.prototype.disable = function () {
            this.remove(), this.config.disabled = !0
        }, r.prototype.getId = function () {
            return this.config.multiselection ? this._selected : this._selected[0]
        }, r.prototype.getItem = function () {
            var e = this;
            return this.config.multiselection ? this._selected.map(function (t) {
                return e._data.getItem(t)
            }) : this._selected.length ? this._data.getItem(this._selected[0]) : null
        }, r.prototype.contains = function (t) {
            return t ? this._selected.includes(t) : 0 < this._selected.length
        }, r.prototype.remove = function (t) {
            var e = this;
            t ? this._unselectItem(t) : (this._selected.forEach(function (t) {
                return e._unselectItem(t)
            }), this._selected = [])
        }, r.prototype.add = function (t, e, i, n) {
            var o, r = this;
            this.config.disabled || (void 0 !== t ? (o = this.config.multiselection, i && this._selected.length && o ? this._addMulti(t, n) : this._addSingle(t, o && ("ctrlClick" !== o || e), n)) : this._data.serialize().filter(function (t) {
                t = t.id;
                return !r._selected.includes(t)
            }).forEach(function (t) {
                t = t.id;
                r._addMulti(t, n)
            }))
        }, r.prototype.destructor = function () {
            var e = this;
            this._selected.forEach(function (t) {
                return e._unselectItem(t, !0)
            })
        }, r.prototype._addMulti = function (t, e) {
            var i = this._selected[this._selected.length - 1], n = this._data.getIndex(i), o = this._data.getIndex(t);
            for (o < n && (n = (t = [o, n])[0], o = t[1]); n <= o; n++) {
                var r = this._data.getId(n);
                this._selectItem(r, e)
            }
        }, r.prototype._addSingle = function (e, t, i) {
            var n = this;
            t || this._selected.forEach(function (t) {
                t != e && n._unselectItem(t)
            }), t && this._selected.includes(e) ? this._unselectItem(e, i) : this._selectItem(e, i)
        }, r.prototype._selectItem = function (t, e) {
            var i = this._data.getItem(t);
            i && !this._data.getMeta(i, "selected") && (e || this.events.fire(n.SelectionEvents.beforeSelect, [t])) && (this._selected.push(t), this._data.setMeta(i, "selected", !0), e || this.events.fire(n.SelectionEvents.afterSelect, [t]))
        }, r.prototype._unselectItem = function (e, t) {
            (t || this.events.fire(n.SelectionEvents.beforeUnSelect, [e])) && (this._selected = this._selected.filter(function (t) {
                return t !== e
            }), this._data.setMeta(this._data.getItem(e), "selected", !1), t || this.events.fire(n.SelectionEvents.afterUnSelect, [e]))
        }, r);

        function r(t, e, i) {
            var n = this;
            this.config = t, this.events = i, this._data = e, this._selected = [], this._data.events.on(o.DataEvents.removeAll, function () {
                n._selected = []
            }), "string" == typeof this.config.multiselection && (["click", "ctrlClick"].includes(this.config.multiselection) || (this.config.multiselection = !1)), this._data.events.on(o.DataEvents.beforeRemove, function (t) {
                var e;
                n._nextSelection = null, 1 === n._selected.length && (e = n._data.getIndex(t.id), 1 < (t = n._data.getLength()) && (e = t == e - 1 ? e - 1 : e + 1, n._nextSelection = n._data.getId(e)))
            }), this._data.events.on(o.DataEvents.afterRemove, function (t) {
                t = n._selected.indexOf(t.id);
                -1 !== t && n._selected.splice(t, 1), n._nextSelection && (n.add(n._nextSelection), n._nextSelection = null)
            })
        }

        e.Selection = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), e.default = {
            notFound: "Not Found",
            selectAll: "Select All",
            unselectAll: "Unselect All",
            selectedItems: "selected items"
        }
    }, function (t, e, i) {
        "use strict";
        var n;
        Object.defineProperty(e, "__esModule", {value: !0}), (n = e.ComboboxEvents || (e.ComboboxEvents = {})).change = "change", n.open = "open", n.input = "input", n.beforeClose = "beforeClose", n.afterClose = "afterClose", n.close = "close", (e = e.ComboState || (e.ComboState = {}))[e.default = 0] = "default", e[e.error = 1] = "error", e[e.success = 2] = "success"
    }, function (t, e, i) {
        "use strict";
        var m = this && this.__assign || function () {
            return (m = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        }, a = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var y = i(0), b = i(37), x = i(11), n = i(4);

        function o(t, e, i, n) {
            i && (i.toLocaleLowerCase().includes("touch") ? e._events : e.events).fire(i, [t, n])
        }

        function v(t, e, i) {
            return {
                onclick: [o, t, i, n.GridEvents[e + "CellClick"]],
                onmouseover: [o, t, i, n.GridEvents[e + "CellMouseOver"]],
                onmousedown: [o, t, i, n.GridEvents[e + "CellMouseDown"]],
                ontouchstart: [o, t, i, n.GridEvents[e + "CellMouseDown"]],
                ondblclick: [o, t, i, n.GridEvents[e + "CellDblClick"]],
                oncontextmenu: [o, t, i, n.GridEvents[e + "CellRightClick"]],
                ontouchmove: [o, t, i, n.GridSystemEvents[e + "CellTouchMove"]],
                ontouchend: [o, t, i, n.GridSystemEvents[e + "CelltouchEnd"]]
            }
        }

        function w(t, e, i, n, o, r, s) {
            void 0 === o && (o = "");
            var a = i[n + "RowHeight"] || 40, l = e.type ? "dhx_" + e.type + "-cell" : "dhx_string_cell",
                t = i.content[t.content] && i.content[t.content].toHtml(e, i), c = {};
            return i.columns.forEach(function (t) {
                var e = !!i.content[t[n][s].content];
                c[t.id] = e && i.content[t[n][s].content].toHtml(t, i) || t[n][s].text
            }), y.el(".dhx_grid-" + n + "-cell.dhx_grid-custom-content-cell." + l, m(m({
                class: o,
                style: {width: e.$width, height: a + "px"}
            }, v(e, n, i)), {
                dhx_id: e.id, role: "gridcell", "aria-colindex": r, "aria-label": function (t) {
                    var e = t.id;
                    if (t.header && t.header.length) for (var i = t.header.length - 1; 0 <= i;) {
                        var n = t.header[i];
                        if (n && n.text) {
                            e = n.text;
                            break
                        }
                        --i
                    }
                    return e
                }(e)
            }), [t && ("string" == typeof t || "number" == typeof t ? y.el("div", {
                class: "dhx_grid-footer-cell-text",
                role: "presentation",
                ".innerHTML": e.template && "string" == typeof t ? e.template(t, c, e) : t
            }) : t)])
        }

        function l(d, t) {
            if (!d.data || !d.columns) return [];
            var e, h = d.$positions, f = t.name, p = d.currentColumns, g = d[f + "RowHeight"] || 40,
                _ = (e = f, t = (t = p).map(function (t) {
                    return t[e] || [{}]
                }), x.transpose(t));
            return _.map(function (t, u) {
                return y.el(".dhx_" + f + "-row", {
                    style: {height: g},
                    role: "row",
                    "aria-rowindex": u + 1
                }, t.map(function (t, e) {
                    var i = t.css || "", n = p[e], o = h.xStart + e + 1, r = "dxi dxi-sort-variant dhx_grid-sort-icon",
                        s = "none";
                    d.sortBy && "" + n.id === d.sortBy && !t.content && (r += " dhx_grid-sort-icon--" + (c = d.sortDir || "asc"), i += " dhx_grid-" + f + "-cell--sorted ", s = "asc" === c ? "ascending" : "descending");
                    var a = x.isSortable(d, n) && t.text && "footer" !== f;
                    a && (i += " dhx_grid-header-cell--sortable");
                    var l = 0 === e ? "dhx_first-column-cell" : "",
                        c = e === p.length - 1 ? "dhx_last-column-cell" : "";
                    t.content || (t.align ? i += " dhx_grid-header-cell--align_" + t.align + " " : i += " dhx_grid-header-cell--" + ("number" === n.type || "percent" === n.type || "date" === n.type ? "align_right" : "align_left") + " "), i += l + " " + c;
                    l = (void 0 !== n.resizable ? n : d).resizable;
                    if (l && (l = y.el("div", {
                        class: "dhx_resizer_grip_wrap",
                        "aria-hidden": "true"
                    }, [y.el("div", {
                        class: "dhx_resizer_grip",
                        dhx_resized: n.id,
                        style: {height: 100 * _.length + "%"}
                    }, [y.el("div", {class: "dhx_resizer_grip_line"})])]), ("footer" === f || 0 < u) && (l = null)), t.align && (i += " dhx_align-" + t.align), t.content) return w(t, n, d, f, i, o, u);
                    c = {
                        role: "columnheader",
                        "aria-colindex": o,
                        "aria-sort": s,
                        "aria-label": t.text
                    }, o = {role: "button", "aria-label": "Click to sort by"};
                    "footer" === f && (c.role = "gridcell", delete c["aria-sort"], delete c["aria-label"], delete o.role, delete o["aria-label"]);
                    s = "dhx_grid-header-cell-text_content";
                    return d.autoHeight && (s += " dhx_grid-header-cell-text_content-auto-height"), y.el(".dhx_grid-" + f + "-cell", m(m({
                        class: i.trim(),
                        dhx_id: n.id,
                        _key: e,
                        style: {width: n.$width, height: g + "px"}
                    }, v(n, f, d)), c), [y.el("div.dhx_grid-header-cell-text", {role: "presentation"}, [y.el("span", m({
                        class: s,
                        style: {lineHeight: g + "px"},
                        ".innerHTML": t.text
                    }, o)), l || null]), a && y.el("div", {class: r, "aria-hidden": "true"})])
                }))
            })
        }

        function c(d, h) {
            var f = d.columns, t = x.transpose(f.map(function (t) {
                return t[h.name] || []
            })), p = d[h.name + "RowHeight"] || 40, g = h.name, _ = d.$positions, v = 0;
            return t.map(function (t, u) {
                return v = 0, y.el(".dhx_span-row", {
                    style: {top: p * u + "px", height: p},
                    class: "dhx_header-row",
                    "aria-hidden": "true"
                }, t.map(function (t, e) {
                    var i = f[e], n = _.xStart + e + 1;
                    v += i.hidden ? 0 : i.$width;
                    var o = 0 === e ? "dhx_first-column-cell" : "",
                        r = e === f.length - 1 || (t.colspan || 0) + (e - 1) >= f.length - 1 ? "dhx_last-column-cell" : "",
                        s = p;
                    t.rowspan && (s = s * t.rowspan - 1);
                    var a = x.isSortable(d, i) && t.rowspan && t.text && "footer" !== h.name,
                        l = "dxi dxi-sort-variant dhx_grid-sort-icon";
                    d.sortBy && "" + i.id === d.sortBy && !t.content && (l += " dhx_grid-sort-icon--" + (d.sortDir || "asc"));
                    var c = i.align ? "dhx_align-" + i.align : "number" !== i.type && "percent" !== i.type && "date" !== i.type || t.colspan ? "dhx_align-left" : "dhx_align-right",
                        o = "dhx_grid-header-cell " + o + " " + r + " " + (t.rowspan ? "dhx_span-cell__rowspan" : "") + " " + (t.align ? "dhx_align-" + t.align : c) + " " + (t.css || "");
                    a && (o += " dhx_grid-header-cell--sortable"), t.content || (t.align ? o += " dhx_grid-header-cell--align_" + t.align + " " : o += " dhx_grid-header-cell--" + ("number" === i.type || "percent" === i.type || "date" === i.type ? "align_right" : "align_left") + " ");
                    r = null;
                    t.content && ((r = w(t, i, d, g, o, n, u)).attrs.style = m(m({}, r.attrs.style), {
                        width: "100%",
                        borderRight: "0"
                    }));
                    c = "";
                    0 < v - i.$width && (c = "1px solid #e4e4e4");
                    n = "dhx_grid-header-cell-text_content";
                    return d.autoHeight && (n += " dhx_grid-header-cell-text_content-auto-height"), t.colspan || t.rowspan ? y.el(".dhx_span-cell", {
                        style: {
                            width: b.getWidth(f, t.colspan, e),
                            height: s,
                            left: v - i.$width,
                            borderLeft: c,
                            top: p * u
                        }, class: o.trim(), dhx_id: i.id
                    }, [r || y.el("span", {class: n, ".innerHTML": t.text}), a && y.el("div", {class: l})]) : null
                }).filter(function (t) {
                    return t
                }))
            })
        }

        e.getRows = l, e.getFixedSpans = c, e.getFixedRows = function (t, e) {
            var i = l(t, e), n = c(t, e), o = null;
            "footer" !== e.name || e.sticky || (o = 0 <= t.leftSplit && l(m(m({}, t), {
                currentColumns: t.columns.slice(0, t.leftSplit),
                $positions: m(m({}, t.$positions), {xStart: 0, xEnd: t.leftSplit})
            }), e));
            var r, s = ((s = {position: "sticky"})[e.position] = 0, s);
            return e.sticky || (s.left = -t.scroll.left, r = -t.scroll.left, s.position = "relative"), y.el(".dhx_" + e.name + "-wrapper", {
                class: e.sticky ? "" : "dhx_compatible-" + e.name,
                style: m(m({}, s), {
                    left: e.sticky ? r : 0,
                    height: t[e.name + "Height"],
                    width: e.sticky ? t.$totalWidth : e.wrapper.width - 2
                }),
                role: "presentation"
            }, [y.el(".dhx_grid-" + e.name, {
                style: {
                    height: t[e.name + "Height"],
                    left: r,
                    paddingLeft: e.shifts.x,
                    width: t.$totalWidth
                }, role: "presentation"
            }, [y.el(".dhx_" + e.name + "-rows", {
                role: "rowgroup",
                "aria-rowcount": a(i).length
            }, a(i)), y.el(".dhx_" + e.name + "-spans", {
                style: {marginLeft: -e.shifts.x},
                class: "dhx_" + e.name + "-rows",
                role: "presentation"
            }, n), o && y.el(".dhx_" + e.name + "-fixed-cols", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: t.scroll.left + "px",
                    height: "100%"
                }
            }, o)]), y.el("div", {style: {width: t.$totalWidth}, role: "presentation"})])
        }
    }, function (t, i, e) {
        "use strict";
        Object.defineProperty(i, "__esModule", {value: !0}), function (t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }(e(130))
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var p = i(16), o = i(3);

        function g(t, e) {
            var i = o.getCellIndex(t), t = o.getCellIndex(e), e = t.col - i.col, i = t.row - i.row;
            return {x: e, y: i, isLargerByX: Math.abs(e) > Math.abs(i)}
        }

        function _(t) {
            var e = t.map(function (t) {
                return parseFloat(t)
            }), i = e.reduce(function (t, e) {
                return t + e
            }, 0), t = e.length;
            return (i / t * 2 - 2 * e[0]) / (t - 1)
        }

        e.getCellsDiff = g, e.getLastCopyingCell = function (t, e) {
            o.isRangeId(t) && (t = t.split(":")[1]);
            var i = o.getCellIndex(t), t = (n = g(t, e)).x, e = n.y, n = n.isLargerByX, e = i.row + e, t = i.col + t,
                t = n ? t : i.col, e = n ? i.row : e;
            return o.getCellNameByIndex(e, t)
        }, e.getProgressionStep = _, e.getAutoFilledCells = function (r, t, e, s) {
            var a = r.filter(function (t) {
                return p.isNumeric(t)
            });
            1 === a.length && a.push(+a[0] + 1);
            var l = o.getCellsArray(t), c = _(a), u = parseFloat(a[a.length - 1]), d = 0, i = (n = t.split(":"))[0],
                t = n[1], n = e.split(":")[0], h = g(i === n ? t : i, n).isLargerByX, f = function (t, e) {
                    t = o.getCellIndex(t), e = o.getCellIndex(e);
                    return t.row === e.row ? t.col > e.col : t.row > e.row
                }(i, n);
            return f && (c = -c, u = parseFloat(a[0]), d = a.length - 1), n = o.getCellsArray(e).filter(function (t) {
                return !l.includes(t)
            }), e = n.map(function (t, e) {
                var i, n,
                    o = f ? (n = r[r.length + d].toString().startsWith("="), r[r.length + d]) : (n = r[d].toString().startsWith("="), r[d]);
                return n && (n = i = 0, e = f ? -1 * (e + d + l.length + 1) : e - d + l.length, h ? n = e : i = e, o = s.transposeMath(o, i, n)), p.isNumeric(o) && (o = (u += c).toFixed(5)), d = f ? void 0 !== r[r.length + d - 1] ? d - 1 : a.length - 1 : void 0 !== r[d + 1] ? d + 1 : 0, o
            }), f && (e = e.reverse()), {cells: n[0] + ":" + n[n.length - 1], value: e}
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), (e = e.WindowEvents || (e.WindowEvents = {})).resize = "resize", e.headerDoubleClick = "headerdoubleclick", e.move = "move", e.afterShow = "aftershow", e.afterHide = "afterhide", e.beforeShow = "beforeshow", e.beforeHide = "beforehide"
    }, function (t, e, i) {
        i(66), i(67), i(68), i(69), i(70), i(71), t.exports = i(73)
    }, function (t, e) {
        Object.values = Object.values || function (e) {
            var t = Object.prototype.toString.call(e);
            if (null == e) throw new TypeError("Cannot convert undefined or null to object");
            if (~["[object String]", "[object Object]", "[object Array]", "[object Function]"].indexOf(t)) {
                if (Object.keys) return Object.keys(e).map(function (t) {
                    return e[t]
                });
                var i, n = [];
                for (i in e) e.hasOwnProperty(i) && n.push(e[i]);
                return n
            }
            return []
        }, Object.assign || Object.defineProperty(Object, "assign", {
            enumerable: !1,
            configurable: !0,
            writable: !0,
            value: function (t) {
                "use strict";
                for (var e = [], i = 1; i < arguments.length; i++) e[i - 1] = arguments[i];
                if (null == t) throw new TypeError("Cannot convert first argument to object");
                for (var n = Object(t), o = 0; o < e.length; o++) {
                    var r = e[o];
                    if (null != r) for (var s = Object.keys(Object(r)), a = 0, l = s.length; a < l; a++) {
                        var c = s[a], u = Object.getOwnPropertyDescriptor(r, c);
                        void 0 !== u && u.enumerable && (n[c] = r[c])
                    }
                }
                return n
            }
        })
    }, function (t, e) {
        Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
            value: function (t, e) {
                if (null == this) throw new TypeError('"this" is null or not defined');
                var i = Object(this), n = i.length >>> 0;
                if (0 == n) return !1;
                var o, r, e = 0 | e, s = Math.max(0 <= e ? e : n - Math.abs(e), 0);
                for (; s < n;) {
                    if ((o = i[s]) === (r = t) || "number" == typeof o && "number" == typeof r && isNaN(o) && isNaN(r)) return !0;
                    s++
                }
                return !1
            }, configurable: !0, writable: !0
        }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
            value: function (t) {
                if (null == this) throw new TypeError('"this" is null or not defined');
                var e = Object(this), i = e.length >>> 0;
                if ("function" != typeof t) throw new TypeError("predicate must be a function");
                for (var n = arguments[1], o = 0; o < i;) {
                    var r = e[o];
                    if (t.call(n, r, o, e)) return r;
                    o++
                }
            }, configurable: !0, writable: !0
        }), Array.prototype.findIndex || (Array.prototype.findIndex = function (t) {
            if (null == this) throw new TypeError("Array.prototype.findIndex called on null or undefined");
            if ("function" != typeof t) throw new TypeError("predicate must be a function");
            for (var e, i = Object(this), n = i.length >>> 0, o = arguments[1], r = 0; r < n; r++) if (e = i[r], t.call(o, e, r, i)) return r;
            return -1
        })
    }, function (t, e) {
        String.prototype.includes || (String.prototype.includes = function (t, e) {
            "use strict";
            return "number" != typeof e && (e = 0), !(e + t.length > this.length) && -1 !== this.indexOf(t, e)
        }), String.prototype.endsWith || Object.defineProperty(String.prototype, "endsWith", {
            value: function (t, e) {
                var i = this.toString();
                (void 0 === e || e > i.length) && (e = i.length), e -= t.length;
                t = i.indexOf(t, e);
                return -1 !== t && t === e
            }
        }), String.prototype.startsWith || Object.defineProperty(String.prototype, "startsWith", {
            enumerable: !1,
            configurable: !0,
            writable: !0,
            value: function (t, e) {
                return e = e || 0, this.indexOf(t, e) === e
            }
        }), String.prototype.padStart || (String.prototype.padStart = function (t, e) {
            return t >>= 0, e = String(e || " "), this.length > t ? String(this) : ((t -= this.length) > e.length && (e += e.repeat(t / e.length)), e.slice(0, t) + String(this))
        }), String.prototype.padEnd || (String.prototype.padEnd = function (t, e) {
            return t >>= 0, e = String(e || " "), this.length > t ? String(this) : ((t -= this.length) > e.length && (e += e.repeat(t / e.length)), String(this) + e.slice(0, t))
        })
    }, function (t, e) {
        var i, n, o, r;
        Element && !Element.prototype.matches && ((i = Element.prototype).matches = i.matchesSelector || i.mozMatchesSelector || i.msMatchesSelector || i.oMatchesSelector || i.webkitMatchesSelector), "classList" in SVGElement.prototype || Object.defineProperty(SVGElement.prototype, "classList", {
            get: function () {
                var i = this;
                return {
                    contains: function (t) {
                        return -1 !== i.className.baseVal.split(" ").indexOf(t)
                    }, add: function (t) {
                        return i.setAttribute("class", i.getAttribute("class") + " " + t)
                    }, remove: function (t) {
                        var e = i.getAttribute("class").replace(new RegExp("(\\s|^)".concat(t, "(\\s|$)"), "g"), "$2");
                        i.classList.contains(t) && i.setAttribute("class", e)
                    }, toggle: function (t) {
                        this.contains(t) ? this.remove(t) : this.add(t)
                    }
                }
            }, configurable: !0
        }), Object.entries || (n = Function.bind.call(Function.call, Array.prototype.reduce), o = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable), r = Function.bind.call(Function.call, Array.prototype.concat), Object.entries = function (i) {
            return n(Object.keys(i), function (t, e) {
                return r(t, "string" == typeof e && o(i, e) ? [[e, i[e]]] : [])
            }, [])
        }), Event.prototype.composedPath || (Event.prototype.composedPath = function () {
            if (this.path) return this.path;
            var t = this.target;
            for (this.path = []; null !== t.parentNode;) this.path.push(t), t = t.parentNode;
            return this.path.push(document, window), this.path
        })
    }, function (t, e) {
        Math.sign = Math.sign || function (t) {
            return 0 === (t = +t) || isNaN(t) ? t : 0 < t ? 1 : -1
        }
    }, function (t, e, i) {
        "use strict";
        i.r(e);
        var n, o = i(40), e = i(72),
            r = [];
        n = r, function (t) {
            for (; --t;) n.push(n.shift())
        }(435);

        function s(t, e) {
            return r[t -= 137]
        }

        e = s

    }, function (t, e, i) {
    }, function (t, o, e) {
        "use strict";
        Object.defineProperty(o, "__esModule", {value: !0});
        var i = e(40);
        o.css = i.cssManager;
        var n = e(12);
        e(74);
        var r = e(17);
        o.message = r.message;
        r = window.dhx = window.dhx || {};
        o.i18n = r.i18n || {}, o.i18n.setLocale = function (t, e) {
            var i, n = o.i18n[t];
            for (i in e) n[i] = e[i]
        }, o.i18n.spreadsheet = o.i18n.spreadsheet || n.default, r.css = r.css || i.cssManager;
        e = e(81);
        o.Spreadsheet = e.Spreadsheet
    }, function (t, e, i) {
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(2), s = i(30), a = new WeakMap, l = new Map;

        function c(t, e) {
            var i = document.createElement("div");
            return i.setAttribute("data-position", e), i.className = "dhx_message-container dhx_message-container--" + e + (t === document.body ? " dhx_message-container--in-body" : ""), i
        }

        function u(t, e) {
            e && clearTimeout(a.get(t));
            var i = t.parentNode, n = i.getAttribute("data-position"), o = i.parentNode, e = l.get(o);
            e && (!(e = e[n]) || -1 !== (e = (n = e.stack).indexOf(t)) && (i.removeChild(t), n.splice(e, 1), 0 === n.length && o.removeChild(i)))
        }

        e.message = function (t) {
            "string" == typeof t && (t = {text: t}), t.position = t.position || s.MessageContainerPosition.topRight;
            var e = document.createElement("div");
            e.className = "dhx_widget dhx_message " + (t.css || ""), e.setAttribute("role", "alert"), t.text && e.setAttribute("aria-describedby", "dhx_alert__content"), t.html ? e.innerHTML = t.html : e.innerHTML = '<span class="dhx_message__text">' + t.text + "</span>\n\t\t" + (t.icon ? '<span class="dhx_message__icon dxi ' + t.icon + '"></span>' : "");
            var i = t.node ? r.toNode(t.node) : document.body;
            "static" === getComputedStyle(i).position && (i.style.position = "relative"), (o = l.get(i)) ? o[t.position] || (o[t.position] = {
                stack: [],
                container: c(i, t.position)
            }) : l.set(i, ((n = {})[t.position] = {stack: [], container: c(i, t.position)}, n));
            var n = (o = l.get(i)[t.position]).stack, o = o.container;
            0 === n.length && i.appendChild(o), n.push(e), o.appendChild(e), t.expire && (t = setTimeout(function () {
                return u(e)
            }, t.expire), a.set(e, t)), e.onclick = function () {
                return u(e, !0)
            }
        }
    }, function (t, i, n) {
        "use strict";
        (function (t) {
            Object.defineProperty(i, "__esModule", {value: !0});
            var e = n(41), r = n(42);
            i.alert = function (i) {
                var n = i.buttons && i.buttons[0] ? i.buttons[0] : e.default.apply, o = r.blockScreen(i.blockerCss);
                return new t(function (t) {
                    var e = document.createElement("div");
                    e.setAttribute("role", "alert"), e.setAttribute("aria-modal", "true"), i.text && e.setAttribute("aria-describedby", "dhx_alert__content"), i.header && e.setAttribute("aria-labelledby", "dhx_alert__header"), e.className = "dhx_widget dhx_alert " + (i.css || "");
                    e.innerHTML = "\n\t\t\t" + (i.header ? '<div id="dhx_alert__header" class="dhx_alert__header"> ' + i.header + " </div>" : "") + "\n\t\t\t" + (i.text ? '<div id="dhx_alert__content" class="dhx_alert__content">' + i.text + "</div>" : "") + '\n\t\t\t<div class="dhx_alert__footer ' + (i.buttonsAlignment ? "dhx_alert__footer--" + i.buttonsAlignment : "") + '">\n\t\t\t\t<button type="button" aria-label="confirm" class="dhx_alert__apply-button dhx_button dhx_button--view_flat dhx_button--color_primary dhx_button--size_medium">' + n + "</button>\n\t\t\t</div>", document.body.appendChild(e), e.querySelector(".dhx_alert__apply-button").focus(), e.querySelector("button").addEventListener("click", function () {
                        o(), document.body.removeChild(e), t(!0)
                    }), e.addEventListener("keydown", function (t) {
                        "Escape" !== t.key && "Esc" !== t.key && " " !== t.key || (t.preventDefault(), e.querySelector("button").click())
                    })
                })
            }
        }).call(this, n(9))
    }, function (t, o, r) {
        (function (t) {
            var e = void 0 !== t && t || "undefined" != typeof self && self || window, i = Function.prototype.apply;

            function n(t, e) {
                this._id = t, this._clearFn = e
            }

            o.setTimeout = function () {
                return new n(i.call(setTimeout, e, arguments), clearTimeout)
            }, o.setInterval = function () {
                return new n(i.call(setInterval, e, arguments), clearInterval)
            }, o.clearTimeout = o.clearInterval = function (t) {
                t && t.close()
            }, n.prototype.unref = n.prototype.ref = function () {
            }, n.prototype.close = function () {
                this._clearFn.call(e, this._id)
            }, o.enroll = function (t, e) {
                clearTimeout(t._idleTimeoutId), t._idleTimeout = e
            }, o.unenroll = function (t) {
                clearTimeout(t._idleTimeoutId), t._idleTimeout = -1
            }, o._unrefActive = o.active = function (t) {
                clearTimeout(t._idleTimeoutId);
                var e = t._idleTimeout;
                0 <= e && (t._idleTimeoutId = setTimeout(function () {
                    t._onTimeout && t._onTimeout()
                }, e))
            }, r(78), o.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, o.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate
        }).call(this, r(31))
    }, function (t, e, i) {
        (function (t, p) {
            !function (i, n) {
                "use strict";
                var o, r, s, a, l, c, e, u, t;

                function d(t) {
                    delete r[t]
                }

                function h(t) {
                    if (s) setTimeout(h, 0, t); else {
                        var e = r[t];
                        if (e) {
                            s = !0;
                            try {
                                !function (t) {
                                    var e = t.callback, i = t.args;
                                    switch (i.length) {
                                        case 0:
                                            e();
                                            break;
                                        case 1:
                                            e(i[0]);
                                            break;
                                        case 2:
                                            e(i[0], i[1]);
                                            break;
                                        case 3:
                                            e(i[0], i[1], i[2]);
                                            break;
                                        default:
                                            e.apply(n, i)
                                    }
                                }(e)
                            } finally {
                                d(t), s = !1
                            }
                        }
                    }
                }

                function f(t) {
                    t.source === i && "string" == typeof t.data && 0 === t.data.indexOf(u) && h(+t.data.slice(u.length))
                }

                i.setImmediate || (o = 1, s = !(r = {}), a = i.document, t = (t = Object.getPrototypeOf && Object.getPrototypeOf(i)) && t.setTimeout ? t : i, l = "[object process]" === {}.toString.call(i.process) ? function (t) {
                    p.nextTick(function () {
                        h(t)
                    })
                } : function () {
                    if (i.postMessage && !i.importScripts) {
                        var t = !0, e = i.onmessage;
                        return i.onmessage = function () {
                            t = !1
                        }, i.postMessage("", "*"), i.onmessage = e, t
                    }
                }() ? (u = "setImmediate$" + Math.random() + "$", i.addEventListener ? i.addEventListener("message", f, !1) : i.attachEvent("onmessage", f), function (t) {
                    i.postMessage(u + t, "*")
                }) : i.MessageChannel ? ((e = new MessageChannel).port1.onmessage = function (t) {
                    h(t.data)
                }, function (t) {
                    e.port2.postMessage(t)
                }) : a && "onreadystatechange" in a.createElement("script") ? (c = a.documentElement, function (t) {
                    var e = a.createElement("script");
                    e.onreadystatechange = function () {
                        h(t), e.onreadystatechange = null, c.removeChild(e), e = null
                    }, c.appendChild(e)
                }) : function (t) {
                    setTimeout(h, 0, t)
                }, t.setImmediate = function (t) {
                    "function" != typeof t && (t = new Function("" + t));
                    for (var e = new Array(arguments.length - 1), i = 0; i < e.length; i++) e[i] = arguments[i + 1];
                    return t = {callback: t, args: e}, r[o] = t, l(o), o++
                }, t.clearImmediate = d)
            }("undefined" == typeof self ? void 0 === t ? this : t : self)
        }).call(this, i(31), i(79))
    }, function (t, e) {
        var i, n, t = t.exports = {};

        function o() {
            throw new Error("setTimeout has not been defined")
        }

        function r() {
            throw new Error("clearTimeout has not been defined")
        }

        function s(e) {
            if (i === setTimeout) return setTimeout(e, 0);
            if ((i === o || !i) && setTimeout) return i = setTimeout, setTimeout(e, 0);
            try {
                return i(e, 0)
            } catch (t) {
                try {
                    return i.call(null, e, 0)
                } catch (t) {
                    return i.call(this, e, 0)
                }
            }
        }

        !function () {
            try {
                i = "function" == typeof setTimeout ? setTimeout : o
            } catch (t) {
                i = o
            }
            try {
                n = "function" == typeof clearTimeout ? clearTimeout : r
            } catch (t) {
                n = r
            }
        }();
        var a, l = [], c = !1, u = -1;

        function d() {
            c && a && (c = !1, a.length ? l = a.concat(l) : u = -1, l.length && h())
        }

        function h() {
            if (!c) {
                var t = s(d);
                c = !0;
                for (var e = l.length; e;) {
                    for (a = l, l = []; ++u < e;) a && a[u].run();
                    u = -1, e = l.length
                }
                a = null, c = !1, function (e) {
                    if (n === clearTimeout) return clearTimeout(e);
                    if ((n === r || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);
                    try {
                        n(e)
                    } catch (t) {
                        try {
                            return n.call(null, e)
                        } catch (t) {
                            return n.call(this, e)
                        }
                    }
                }(t)
            }
        }

        function f(t, e) {
            this.fun = t, this.array = e
        }

        function p() {
        }

        t.nextTick = function (t) {
            var e = new Array(arguments.length - 1);
            if (1 < arguments.length) for (var i = 1; i < arguments.length; i++) e[i - 1] = arguments[i];
            l.push(new f(t, e)), 1 !== l.length || c || s(h)
        }, f.prototype.run = function () {
            this.fun.apply(null, this.array)
        }, t.title = "browser", t.browser = !0, t.env = {}, t.argv = [], t.version = "", t.versions = {}, t.on = p, t.addListener = p, t.once = p, t.off = p, t.removeListener = p, t.removeAllListeners = p, t.emit = p, t.prependListener = p, t.prependOnceListener = p, t.listeners = function (t) {
            return []
        }, t.binding = function (t) {
            throw new Error("process.binding is not supported")
        }, t.cwd = function () {
            return "/"
        }, t.chdir = function (t) {
            throw new Error("process.chdir is not supported")
        }, t.umask = function () {
            return 0
        }
    }, function (t, o, r) {
        "use strict";
        (function (e) {
            Object.defineProperty(o, "__esModule", {value: !0});
            var i = r(41), n = r(42);
            o.confirm = function (t) {
                t.buttonsAlignment = t.buttonsAlignment || "right";
                var a = t.buttons && t.buttons[1] ? t.buttons[1] : i.default.apply,
                    l = t.buttons && t.buttons[0] ? t.buttons[0] : i.default.reject, c = n.blockScreen(t.blockerCss);
                return new e(function (e) {
                    var i, n = document.createElement("div");
                    n.setAttribute("role", "alertdialog"), n.setAttribute("aria-modal", "true"), t.text && n.setAttribute("aria-describedby", "dhx_alert__content"), t.header && n.setAttribute("aria-labelledby", "dhx_alert__header");

                    function o(t) {
                        c(), n.removeEventListener("click", r), document.removeEventListener("keydown", s), document.body.removeChild(n), e(t)
                    }

                    var r = function (t) {
                        "BUTTON" === t.target.tagName && o(t.target.classList.contains("dhx_alert__confirm-aply"))
                    }, s = function (t) {
                        "Escape" === t.key || "Esc" === t.key ? (n.querySelector(".dhx_alert__confirm-aply").focus(), o(t.target.classList.contains("dhx_alert__confirm-reject"))) : "Tab" === t.key && ("aply" === i ? (i = "reject", n.querySelector(".dhx_alert__confirm-reject").focus()) : (i = "aply", n.querySelector(".dhx_alert__confirm-aply").focus()), t.preventDefault())
                    };
                    n.className = "dhx_widget dhx_alert dhx_alert--confirm" + (t.css ? " " + t.css : ""), n.innerHTML = "\n\t\t" + (t.header ? '<div class="dhx_alert__header"> ' + t.header + " </div>" : "") + "\n\t\t" + (t.text ? '<div class="dhx_alert__content">' + t.text + "</div>" : "") + '\n\t\t\t<div class="dhx_alert__footer ' + (t.buttonsAlignment ? "dhx_alert__footer--" + t.buttonsAlignment : "") + '">\n\t\t\t\t<button type="button" aria-label="reject" class="dhx_alert__confirm-reject dhx_button dhx_button--view_link dhx_button--color_primary dhx_button--size_medium">' + l + '</button>\n\t\t\t\t<button type="button"  aria-label="aply"class="dhx_alert__confirm-aply dhx_button dhx_button--view_flat dhx_button--color_primary dhx_button--size_medium">' + a + "</button>\n\t\t\t</div>", document.body.appendChild(n), i = "aply", n.querySelector(".dhx_alert__confirm-aply").focus(), n.addEventListener("click", r), document.addEventListener("keydown", s)
                })
            }
        }).call(this, r(9))
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), u = this && this.__assign || function () {
            return (u = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r, s = i(82), v = i(0), a = i(5), g = i(2), l = i(6), _ = i(7), c = i(35), d = i(25), h = i(62), f = i(142),
            p = i(28), m = i(160), y = i(161), b = i(162), x = i(163), w = i(165), C = i(166), S = i(167), E = i(16),
            k = i(3), M = i(63), I = i(29), D = i(168), O = i(12), A = i(169), P = i(8), T = i(20), R = i(21), L = i(1),
            H = i(171), F = i(172), j = i(173), N = i(174), $ = i(23), V = i(64), z = i(175), W = i(178), B = i(10),
            o = (r = l.View, o(G, r), G.prototype.destructor = function () {
                this.unmount(), this._layout.unmount(), this.contextMenu.destructor(), this.menu.destructor(), this.toolbar.destructor(), this._editLine.destructor(), this._tabbar.destructor()
            }, G.prototype.paint = function () {
                this.config.rowsCount === this._sizes.rowsCount && this.config.colsCount === this._sizes.colsCount || this._generateGridStruct(), this._layout.paint(), this._grid.paint()
            }, G.prototype.load = function (t, e) {
                var i = this;
                if ("xlsx" !== e) return _.toProxy(t).load().then(function (t) {
                    i.parse(t, e)
                });
                if (!k.isWasmSupported()) throw new Error("WebAssembly is not supported by your browser");
                return this._xlsxProxy = this._xlsxProxy || new j.XlsxProxy(this), this._xlsxProxy.load(t).then(function (t) {
                    i.parse(t, e)
                })
            }, G.prototype.parse = function (t, e) {
                var i = this;
                "csv" === e && (e = new S.CustomCsvDriver), "xlsx" === e && (e = new F.XlsxDriver), t = _.toDataDriver(e || "json").toJsonArray(t), this._grid.config.columns.map(function (t) {
                    t.$cellCss = {}
                });
                var n = {sheets: []};
                if ("sheets" in t) {
                    this._sheets.forEach(function (t) {
                        "add-sheet" !== t.id && (i._dataStore.removePage(t.value), i._sheets.remove(t.id))
                    });
                    for (var o = 0; o < (this.config.multiSheets ? t.sheets.length : 1); o++) {
                        var r = (d = t.sheets[o]).name || this._generateNewSheetName();
                        d.name || (d.name = r), n.sheets.push(d), this._sheets.add({
                            value: r,
                            id: d.id
                        }), this._dataStore.addPage(r)
                    }
                } else "data" in t && n.sheets.push({data: t.data, name: this._activeSheetName.name});
                if ("styles" in t) {
                    var s, a = t.styles;
                    for (s in a) {
                        var l = a[s];
                        dhx.css.add(l, s)
                    }
                    dhx.css.update()
                }
                Array.isArray(t) && n.sheets.push({data: t, name: this._activeSheetName.name});
                for (var c = 0, u = n.sheets; c < u.length; c++) for (var d = u[c], h = this._dataStore.getPage(d.name), f = this, p = 0, g = d.data; p < g.length; p++) !function (e) {
                    var t = k.getCellIds(e.cell.toUpperCase()), i = t.row, n = t.col, o = E.getCleanValue(e.value),
                        r = E.isNumeric(o), s = void 0, a = void 0,
                        t = "General" === e.format ? f.config.formats.find(function (t) {
                            return "common" === t.id
                        }) : f.config.formats.find(function (t) {
                            return t.id === e.format
                        });
                    e.format = t ? t.mask : E.detectCellFormat(e.value), s = r && "@" !== (null == t ? void 0 : t.mask) ? (a = e.format, f.config.autoFormat && a.includes("%") ? e.value === o ? parseFloat(o).toFixed(4) : +(parseFloat(o) / 100).toFixed(4) : +o) : (a = e.format || "General", e.value), h.setValue(i, n, s, "@" === a ? 1 : 0), h.setCell(i, n, {
                        format: a,
                        css: e.css
                    })
                }(g[p]);
                this._grid.data.events.fire(_.DataEvents.change), this._changeSheet(this._sheets.getId(this.config.multiSheets && !this.config.readonly ? 1 : 0)), this._grid.paint(), this.config && !this.config.readonly && this.selection.setSelectedCell("A1")
            }, G.prototype.serialize = function () {
                var c = this, u = {}, d = [];
                this._sheets.forEach(function (t) {
                    if ("add-sheet" !== t.id) {
                        for (var t = t.value, e = {
                            name: t,
                            data: []
                        }, i = 0, n = c._dataStore.getPage(t).serialize(!0); i < n.length; i++) {
                            var o, r, s = n[i],
                                a = k.getCellNameById(c._grid, (s[0] + 1).toString(), (s[1] + 1).toString()), l = s[2];
                            l && (o = l.value, r = {cell: a}, l.css && (r.css = l.css, u[r.css] = dhx.css.get(r.css)), void 0 !== l.format && (s = E.getFormat(E.getDefaultFormatsMap()[l.format]), r.format = s && s.id || l.format), !o && "number" != typeof o || (r.value = o), a && (r.value || "number" == typeof r.value || r.css) && e.data.push(r))
                        }
                        d.push(e)
                    }
                });
                var t = this._grid.config.columns.reduce(function (t, e, i) {
                    return 0 !== i && 120 !== e.width && (t[i] = {width: e.width}), t
                }, {});
                return {sheets: d, styles: u, columns: t, formats: this.config.formats}
            }, G.prototype.setValue = function (t, e) {
                if (t && (this._checkForMissedCells(t), this.events.fire(P.SpreadsheetEvents.beforeValueChange, [t, e]) && t)) {
                    var i = this._activePage;
                    if (t.includes("!")) {
                        var n = t.split("!");
                        if (t = n[1], !(i = this._dataStore.getPage(n[0]))) return
                    }
                    n = k.getCellIds(t);
                    this._callAction({
                        row: n.row,
                        col: n.col,
                        cell: t,
                        val: e,
                        action: P.Actions.setCellValue,
                        groupAction: P.Actions.groupAction,
                        dataStore: this._dataStore,
                        page: i
                    }), this._grid.paint()
                }
            }, G.prototype.getValue = function (t) {
                if (t) {
                    var i = this._activePage;
                    if (t.includes("!")) {
                        var e = t.split("!");
                        if (t = e[1], !(i = this._dataStore.getPage(e[0]))) return
                    }
                    if (t = t.toUpperCase(), k.isRangeId(t)) {
                        var n = [];
                        return this.eachCell(function (t, e) {
                            t = k.getCellIds(t);
                            n.push(i.getValue(t.row, t.col))
                        }, t), n
                    }
                    t = k.getCellIds(t);
                    return i.getValue(t.row, t.col)
                }
            }, G.prototype.getCellIndex = function (t) {
                return k.getCellIds(t)
            }, G.prototype.getFormula = function (t) {
                var e = this, i = this._activePage;
                if (t.includes("!")) {
                    var n = t.split("!");
                    if (t = n[1], !(i = this._dataStore.getPage(n[0]))) return
                }
                if (t = t.toUpperCase(), k.isRangeId(t)) {
                    var o = [];
                    return this.eachCell(function (t) {
                        o.push(e._getMath(t, i) || "")
                    }, t), o
                }
                t = this._getMath(t, i);
                return t ? t.source : ""
            }, G.prototype.getSheets = function () {
                var e = [];
                return this._sheets.forEach(function (t) {
                    "add-sheet" !== t.id && e.push({name: t.value, id: t.id})
                }), e
            }, G.prototype._getMath = function (t, e) {
                if (void 0 === e && (e = this._activePage), t) {
                    var i = k.getCellIds(t), t = i.row, i = i.col, e = $.toId(t, i, e.getID());
                    return this._math.getMath(e) || null
                }
            }, G.prototype.eachCell = function (t, e) {
                e = e || this.selection.getSelectedCell();
                for (var i = 0, n = k.getCellsArray(e); i < n.length; i++) {
                    var o = n[i], r = k.getCellIds(o), s = r.row, r = r.col;
                    t(o, this._activePage.getValue(s, r))
                }
            }, G.prototype.getStyle = function (t) {
                if (t) {
                    var e = this._activePage;
                    if (t.includes("!")) {
                        var i = t.split("!");
                        if (t = i[1], !(e = this._dataStore.getPage(i[0]))) return
                    }
                    if (k.isRangeId(t)) {
                        var n = [];
                        return this.eachCell(function (t) {
                            t = k.getCellInfo(t, e);
                            n.push(dhx.css.get(t.css))
                        }, t), n
                    }
                    i = k.getCellInfo(t, this._activePage), t = [];
                    i.css && (t = "string" == typeof i.css ? i.css.split(" ") : i.css);
                    for (var o = {}, r = 0, s = t; r < s.length; r++) var a = s[r], o = u(u({}, o), dhx.css.get(a));
                    return o
                }
            }, G.prototype.setStyle = function (t, e) {
                if (t && e && this.events.fire(P.SpreadsheetEvents.beforeStyleChange, [t, e])) {
                    var i = this._activePage;
                    if (t.includes("!")) {
                        var n = t.split("!");
                        if (t = n[1], !(i = this._dataStore.getPage(n[0]))) return
                    }
                    var o = k.getCellIds(t), n = o.row, o = o.col;
                    Object.keys(e).length ? this._callAction({
                        val: e,
                        row: n,
                        col: o,
                        cell: t,
                        action: P.Actions.setCellStyle,
                        groupAction: P.Actions.groupAction,
                        dataStore: this._dataStore,
                        page: i
                    }) : this._callAction({
                        row: n,
                        col: o,
                        cell: t,
                        action: P.Actions.removeCellStyles,
                        groupAction: P.Actions.groupAction,
                        dataStore: this._dataStore,
                        page: i
                    })
                }
            }, G.prototype.getFormat = function (t) {
                if (t) {
                    var e = this._activePage;
                    if (t.includes("!")) {
                        var i = t.split("!");
                        if (t = i[1], !(e = this._dataStore.getPage(i[0]))) return
                    }
                    if (k.isRangeId(t)) {
                        var n = [];
                        return this.eachCell(function (t) {
                            n.push(k.getCellInfo(t, e).format || "")
                        }, t), n
                    }
                    t = k.getCellInfo(t, e).format;
                    return E.getDefaultFormatsMap()[t] || t
                }
            }, G.prototype.setFormat = function (t, e) {
                if (t) {
                    var i = this._activePage;
                    if (t.includes("!")) {
                        var n = t.split("!");
                        if (t = n[1], !(i = this._dataStore.getPage(n[0]))) return
                    }
                    this._callAction({
                        val: e,
                        cell: t,
                        action: P.Actions.setCellFormat,
                        groupAction: P.Actions.groupAction,
                        dataStore: this._dataStore,
                        page: i
                    })
                }
            }, G.prototype.isLocked = function (t) {
                if (t) {
                    var e = this._activePage;
                    if (t.includes("!")) {
                        var i = t.split("!");
                        if (t = i[1], !(e = this._dataStore.getPage(i[0]))) return
                    }
                    if ("start" in k.getCellIds(t)) {
                        var n = !1;
                        return this.eachCell(function (t) {
                            n || (t = k.getCellInfo(t, e).locked, n = t)
                        }, t), n
                    }
                    return !!k.getCellInfo(t, e).locked
                }
            }, G.prototype.lock = function (t) {
                if (t) {
                    var e = this._activePage;
                    if (t.includes("!")) {
                        var i = t.split("!");
                        if (t = i[1], !(e = this._dataStore.getPage(i[0]))) return
                    }
                    i = k.getCellIds(t);
                    this._callAction({
                        row: i.row,
                        col: i.col,
                        val: !0,
                        cell: t,
                        action: P.Actions.lockCell,
                        groupAction: P.Actions.groupAction,
                        dataStore: this._dataStore,
                        page: e
                    }), this._grid.paint()
                }
            }, G.prototype.unlock = function (t) {
                if (t) {
                    var e = this._activePage;
                    if (t.includes("!")) {
                        var i = t.split("!");
                        if (t = i[1], !(e = this._dataStore.getPage(i[0]))) return
                    }
                    i = k.getCellIds(t);
                    this._callAction({
                        row: i.row,
                        col: i.col,
                        val: !1,
                        cell: t,
                        action: P.Actions.lockCell,
                        groupAction: P.Actions.groupAction,
                        dataStore: this._dataStore,
                        page: e
                    }), this._grid.paint()
                }
            }, G.prototype.addRow = function (t) {
                this.events.fire(P.SpreadsheetEvents.beforeRowAdd, [t]) && (k.isRangeId(t) && (t = t.split(":")[0]), this._callAction({
                    cell: t,
                    action: P.Actions.addRow,
                    groupAction: P.Actions.groupRowAction,
                    dataStore: this._dataStore
                }), this.events.fire(P.SpreadsheetEvents.afterRowAdd, [t]))
            }, G.prototype.deleteRow = function (t) {
                var e;
                this.events.fire(P.SpreadsheetEvents.beforeRowDelete, [t]) && (e = k.getCellIds(t), this._callAction({
                    row: e.row,
                    col: e.col,
                    cell: t,
                    action: P.Actions.deleteRow,
                    groupAction: P.Actions.groupRowAction,
                    dataStore: this._dataStore
                }), this.events.fire(P.SpreadsheetEvents.afterRowDelete, [t]))
            }, G.prototype.addColumn = function (t) {
                this.events.fire(P.SpreadsheetEvents.beforeColumnAdd, [t]) && (k.isRangeId(t) && (t = t.split(":")[0]), this._callAction({
                    cell: t,
                    action: P.Actions.addColumn,
                    groupAction: P.Actions.groupColAction,
                    dataStore: this._dataStore
                }), this.events.fire(P.SpreadsheetEvents.afterColumnAdd, [t]))
            }, G.prototype.deleteColumn = function (t) {
                this.events.fire(P.SpreadsheetEvents.beforeColumnDelete, [t]) && (this._callAction({
                    cell: t,
                    action: P.Actions.deleteColumn,
                    groupAction: P.Actions.groupColAction,
                    dataStore: this._dataStore
                }), this.events.fire(P.SpreadsheetEvents.afterColumnDelete, [t]))
            }, G.prototype.undo = function () {
                this._actionsManager.undo()
            }, G.prototype.redo = function () {
                this._actionsManager.redo()
            }, G.prototype.startEdit = function (t, e) {
                if (!this.config.readonly && !this._range.mode) {
                    if (this._editMode) return this._editLine.setValueAtRedactor(e);
                    var i, n, o = this.selection.getFocusedCell();
                    t = (t = t || o).toUpperCase(), this._checkForMissedCells(t), this.events.fire(P.SpreadsheetEvents.beforeEditStart, [t, e]) && (this.isLocked(t) || (o !== t && (this.endEdit(!0), this.selection.setSelectedCell(t)), k.getCellInfo(t, this._activePage).edited || (i = (n = k.getCellIds(t)).row, o = n.col, n = $.toId(i, o, this._activePage.getID()), (n = this._math.getMath(n)) && (e = "=" + n.source), this._activePage.setCell(i, o, {
                        edited: !0,
                        nextValue: e,
                        editorValue: e
                    }), e && this._editLine.setValue(e), this.events.fire(P.SpreadsheetEvents.afterEditStart, [t, e]))))
                }
            }, G.prototype.endEdit = function (t) {
                var e, i = this.selection.getFocusedCell(), n = k.getCellInfo(i, this._activePage);
                n.edited && this.events.fire(P.SpreadsheetEvents.beforeEditEnd, [i, n.nextValue]) && (n.nextValue && this._activePage.setMeta({inserted: !0}), t || void 0 === n.nextValue || this.setValue(i, n.nextValue), t = (e = k.getCellIds(i)).row, e = e.col, this._activePage.setCell(t, e, {
                    nextValue: void 0,
                    edited: !1
                }), this._editLine.setValue(this.getValue(i)), this._editLine.blur(), this.events.fire(P.SpreadsheetEvents.afterEditEnd, [i, n.nextValue]))
            }, G.prototype.addSheet = function (t) {
                if (this.config.multiSheets && this.events.fire(P.SpreadsheetEvents.beforeSheetAdd, [])) {
                    var e = (e = t) || this._generateNewSheetName();
                    return this._callAction({
                        val: e,
                        action: P.Actions.addSheet,
                        groupAction: P.Actions.groupAction,
                        dataStore: this._dataStore,
                        sheets: this._sheets,
                        prev: this._tabbar.getSelected()[0]
                    }), this._sheets.find(function (t) {
                        return t.value === e
                    }).id
                }
            }, G.prototype.removeSheet = function (t) {
                t = this._sheets.getItem(t);
                !t || !this.config.multiSheets || this.config.multiSheets && 2 === this._sheets.getLength() || this.events.fire(P.SpreadsheetEvents.beforeSheetRemove, [{
                    name: t.value,
                    id: t.id
                }]) && (this._callAction({
                    action: P.Actions.deleteSheet,
                    groupAction: P.Actions.groupAction,
                    dataStore: this._dataStore,
                    sheets: this._sheets,
                    prev: t.id,
                    val: t.value
                }), this.events.fire(P.SpreadsheetEvents.afterSheetRemove, [{name: t.value, id: t.id}]))
            }, G.prototype.getActiveSheet = function () {
                return this._activeSheetName
            }, G.prototype._renameSheet = function (t, e) {
                var i = this._sheets.getItem(t);
                i && e && i.prevValue !== e && this.events.fire(P.SpreadsheetEvents.beforeSheetRename, [{
                    name: i.value,
                    id: i.id
                }, e]) && (this._callAction({
                    val: e,
                    action: P.Actions.renameSheet,
                    groupAction: P.Actions.groupAction,
                    dataStore: this._dataStore,
                    sheets: this._sheets,
                    prev: t
                }), this.events.fire(P.SpreadsheetEvents.afterSheetRename, [{name: i.value, id: i.id}]))
            }, G.prototype._changeSheet = function (t) {
                var e, i, n, o, r, s, a, l, c = this;
                !t || (a = this._sheets.getItem(t)) && this.events.fire(P.SpreadsheetEvents.beforeSheetChange, [this._activeSheetName]) && (e = this._activePage, i = this._grid.getScrollState(), e && e.setMeta({scroll: i}), n = this._activeSheetName ? this._activeSheetName.name : null, o = this._editLine.isCellExpected("A1", !1, this._range.inline && this._range.editor || null), r = this.selection && this.selection.getFocusedCell(), (s = k.getCellInfo(r, this._activePage)) && s.edited && !o && this.endEdit(), this._activePage = this._dataStore.getPage(a.value), this._activeSheetName = {
                    name: a.value,
                    id: t
                }, this._tabbar.select(t), a = this._activePage && this._activePage.getMeta(), this._activePage && !a.toolbarId && this._activePage.setMeta({toolbarId: t}), o && !this._editMode || o && this._editMode.page !== this._activePage ? (this._activePage.setMeta({
                    selectedCells: null,
                    focusedCell: null
                }), this._editMode = this._editMode || {
                    page: e,
                    cell: r,
                    pageName: n
                }) : o && this._editMode && this._editMode.page === this._activePage ? (l = this._editLine.getValue(), this._editMode = null, this._editLine.setValue(l), v.awaitRedraw().then(function () {
                    c._editLine.focus(), c.events.fire(P.SpreadsheetEvents.editLineInput, [l]), c._editLine.setCursor(o)
                })) : (this._editLine.setCellMath(), this._editMode = null), this.events.fire(P.SpreadsheetEvents.afterSheetChange, [this._activeSheetName]), this._grid.paint(), v.awaitRedraw().then(function () {
                    B.focusManager.setFocusId(c._uid);
                    var t = c._activePage.getMeta().scroll, e = t.x, t = t.y;
                    i && c._grid.scroll(e, t)
                }))
            }, G.prototype._callAction = function (t) {
                t && !this.config.readonly && (Array.isArray(t) ? this._actionsManager.execute(t) : k.isRangeId(t.cell) ? this._actionsManager.execute(t.groupAction, t) : this._actionsManager.execute(t.action, t))
            }, G.prototype._initLayout = function () {
                this._grid = new c.Grid(null, {
                    rowHeight: 32,
                    headerRowHeight: 32,
                    headerSort: !1,
                    leftSplit: 1 + (this.config.leftSplit || 0)
                }), this.menu = new f.Menu(null, {navigationType: "click"}), this.menu.data.parse(y.getMenuStruct(this.config)), this.toolbar = new h.Toolbar;
                var t = b.getToolbarStruct(this.config.toolbarBlocks, this.config);
                this.toolbar.data.parse(t), this.contextMenu = new f.ContextMenu, this.contextMenu.data.parse(m.getContextMenuStruct()), this.sheetContextMenu = new f.ContextMenu, this.sheetContextMenu.data.parse(m.getSheetsContextMenuStruct(this.config.multiSheets)), this._tabbar = new h.Toolbar(null, {css: "dhx-sheets-toolbar"}), this._sheets = this._tabbar.data, this._sheets.parse([{value: "sheet1"}]), this._dataStore = N.initMathStore(this._sheets), this._math = this._dataStore.getStore(), this._editLine = new x.EditLine(null, {
                    events: this.events,
                    grid: this._grid,
                    store: this._activePage,
                    spreadsheet: this,
                    math: this._math
                }), this.config.multiSheets && !this.config.readonly && this._sheets.add({
                    icon: "dxi dxi-plus",
                    id: "add-sheet"
                }, 0);
                var e = this._layout = new d.Layout(null, {
                    height: "100%",
                    rows: [{id: "menu", css: "menu_wrapper", height: "content"}, {
                        id: "toolbar",
                        css: "toolbar_wrapper",
                        height: "content"
                    }, {id: "editLine", css: "editLine_wrapper", height: "content"}, {
                        id: "grid",
                        css: "dhx-spreadsheet-grid dhx_layout-cell--gravity"
                    }, {id: "tabbar", css: "sheetbar_wrapper", height: "content"}]
                });
                e.getCell("menu").attach(this.menu, this), e.getCell("toolbar").attach(this.toolbar, this), e.getCell("grid").attach(this._grid, this), e.getCell("editLine").attach(this._editLine, this), e.getCell("tabbar").attach(this._tabbar, this);
                var i = this.config.multiSheets && !this.config.readonly ? 1 : 0;
                this._dataStore.getPage(this._sheets.getItem(this._sheets.getId(i)).value).setMeta({leftSplit: this.config.leftSplit}), this._changeSheet(this._sheets.getId(i)), this.config.editLine && !this.config.readonly || e.getCell("editLine").hide(), this.config.menu && !this.config.readonly || e.getCell("menu").hide(), !this.config.readonly && t && t.length || e.getCell("toolbar").hide(), this.config.multiSheets || e.getCell("tabbar").hide()
            }, G.prototype._generateGridStruct = function () {
                for (var d = this, t = this.serialize(), e = this.config, i = e.rowsCount, n = e.colsCount, o = [], r = 1; r <= i; r++) {
                    for (var s = {id: "" + r, $index: r}, a = 1; a <= n; a++) s[a] = "";
                    o.push(s)
                }

                function h(t) {
                    var i = t.el;
                    d._range.editor = i, d._range.inline = 1, i.focus(), i.setSelectionRange(i.value.length, i.value.length), d._range.cursor = i.value.length, i.addEventListener("blur", function (t) {
                        var e;
                        d._range.cursor = i.selectionStart, e = t, requestAnimationFrame(function () {
                            c && d._restoreFocus(e)
                        })
                    }), i.addEventListener("focus", function () {
                        d._range.inline = 1
                    }), c = !0
                }

                function f() {
                    d._range.editor = null, c = !1
                }

                function p(t, e) {
                    c && d.events.fire(P.SpreadsheetEvents.cellInput, [t, e.target.value])
                }

                var g, l = [{
                    id: "$index",
                    width: 40,
                    header: [{text: ""}],
                    htmlEnable: !0,
                    align: "right",
                    template: function (t, e, i) {
                        return d._grid.data.getIndex(e.id) + 1
                    }
                }], c = !1;
                this.events.on(P.SpreadsheetEvents.gridRedraw, function () {
                    g = null
                });
                for (var u = function (t, e, i) {
                    g = g || d.selection.getFocusedCell();
                    var n = i.$letter + e.$index, o = k.getCellIds(n), r = d._activePage.getCell(o.row, o.col) || {},
                        s = r.locked, a = r.edited, l = r.nextValue, c = r.css, i = dhx.css.get(c), e = r.format || "",
                        r = d._activePage.getValue(o.row, o.col, r.format && "@" === r.format), r = null == l ? r : l;
                    if (g && a) return v.el("input.dhx_cell_input", {
                        oninput: [p, n],
                        _hooks: {didInsert: h, didRemove: f},
                        class: c,
                        _key: "selection_input",
                        dhx_id: "cell_input",
                        value: null == l ? e ? E.getFormattedValue(r, e) : r : l
                    });
                    var r = e ? E.getFormattedValue(r, e) : r, u = null;
                    if (i && i["text-align"]) switch (i["text-align"]) {
                        case"left":
                            u = "flex-start";
                            break;
                        case"center":
                            u = "center";
                            break;
                        case"right":
                            u = "flex-end"
                    }
                    return v.el(".dhx_spreadsheet_cell.dhx_noselect", {
                        style: {"justify-content": u},
                        class: c
                    }, [s && v.el(".dhx_lock_icon.dxi.dxi-key"), r])
                }, r = 1; r <= n; r++) {
                    var _ = k.getLetterFromNumber(r);
                    l.push({
                        id: "" + r,
                        width: 120,
                        $letter: _,
                        type: "string",
                        header: [{text: w.getHeaderCell(_, r), align: "center"}],
                        htmlEnable: !0,
                        template: u
                    })
                }
                this._grid.setColumns(l), this._grid.data.parse(o), this.parse(t), this._sizes.rowsCount = this.config.rowsCount, this._sizes.colsCount = this.config.colsCount
            }, G.prototype._checkForMissedCells = function (t) {
                t.includes("!") && (t = t.split("!")[1]);
                t = k.isRangeId(t) ? k.getRangeIndexes(t).end : k.getCellIndex(t);
                (t.row > this.config.rowsCount || t.col > this.config.colsCount) && (this.config.rowsCount = Math.max(this.config.rowsCount, t.row + 1), this.config.colsCount = Math.max(this.config.colsCount, t.col), this._generateGridStruct())
            }, G.prototype._generateNewSheetName = function () {
                var t = this._sheets.findAll(function (t) {
                    return t.value && t.value.startsWith("sheet")
                });
                return t.length ? (t = t.map(function (t) {
                    return +t.value.split("sheet")[1]
                }).filter(function (t) {
                    return !!t
                }), "sheet" + (Math.max.apply(Math, t) + 1)) : "sheet1"
            }, G.prototype._updateGridSizes = function () {
                var t = this._activePage.getSize(), e = t[0], i = t[1], t = !1;
                if (e > this.config.rowsCount) {
                    t = !0;
                    var n, o = this._grid.data, r = u({}, o.getItem(o.getId(o.getLength() - 1)));
                    for (n in r) r[n] = "";
                    for (var s = this.config.rowsCount + 1; s <= e; s++) o.add(u(u({}, r), {id: "" + s}));
                    this.config.rowsCount = o.getLength(), w.updateRowsIndex(o)
                }
                if (i > this.config.colsCount) {
                    t = !0;
                    for (var a = [], l = this._grid.config.columns, s = this.config.colsCount + 1; s <= i; s++) {
                        var c = k.getLetterFromNumber(s);
                        a.push(u(u({}, l[1]), {id: "" + s, $cellCss: {}, width: 120, $letter: c}))
                    }
                    l.push.apply(l, a), this.config.colsCount = l.length - 1, w.updateColumns(this._grid.config)
                }
                t && this._grid.paint()
            }, G.prototype._updateToolbar = function (t) {
                t === this.selection.getFocusedCell() && (t = k.getCellInfo(t, this._activePage), I.updateToolbar(this.toolbar, t))
            }, G.prototype._setEventsHandlers = function () {
                var n = this;
                this.events.on(P.SpreadsheetEvents.editLineInput, function (t) {
                    B.focusManager.setFocusId(n._uid);
                    var e = n.selection.getFocusedCell();
                    n.events.fire(P.SpreadsheetEvents.cellInput, [e, t])
                }), this.events.on(P.SpreadsheetEvents.editLineFocus, function () {
                    var t = n.selection.getFocusedCell();
                    n.startEdit(t), n._range.inline = 0, requestAnimationFrame(function () {
                        n._editLine.focus()
                    })
                }), this.events.on(P.SpreadsheetEvents.cellInput, function (t, e) {
                    var i;
                    n.isLocked(t) || (t = (i = k.getCellIds(t)).row, i = i.col, n._activePage.setCell(t, i, {nextValue: e}), n._grid.paint())
                }), this._grid.events.on(c.GridEvents.cellMouseDown, function () {
                    n.contextMenu._close(), n.sheetContextMenu._close()
                }), this.events.on(P.SpreadsheetEvents.beforeSelectionSet, function (t) {
                    var e = n._range;
                    if (e.mode) return !0;
                    t = n._editLine.isCellExpected(t, !1, e.inline && e.editor || null);
                    return 0 < t ? (e.cursor = t, e.cell = n.selection.getFocusedCell(), e.mode = 1, !0) : !n.config.readonly && void (n._editMode || n.endEdit())
                }), this.events.on(P.SpreadsheetEvents.afterSelectionSet, function (t) {
                    var e = n._range;
                    !e.mode && n._editMode && n._editLine.setCellMath(), 1 === e.mode && (e.mode = 2, n._editMode || n.selection.setSelectedCell(e.cell), e.mode = 0, e.cell = "", e.cursor = n._editLine.isCellExpected(t, !0, e.inline ? e.editor : null)), n._grid.paint()
                }), this.events.on(P.SpreadsheetEvents.afterFocusSet, function (t) {
                    var e, i;
                    n._range.mode || n._editMode || (e = (i = k.getCellIds(t)).row, i = i.col, e = n._activePage.getValue(e, i, !0), E.isNumeric(e) || e || (e = ""), i = k.getCellInfo(t, n._activePage), I.updateToolbar(n.toolbar, i), "percent" === n.getFormat(t) ? n._editLine.setValue(E.getFormattedValue("" + e, i.format)) : n._editLine.setValue(e.toString()), i && i.locked && n._editLine.lock(), n._grid.paint())
                }), this.events.on(P.SpreadsheetEvents.afterStyleChange, function (t) {
                    n._updateToolbar(t)
                }), this.events.on(P.SpreadsheetEvents.afterFormatChange, function (t, e) {
                    n._updateToolbar(t)
                }), this.events.on(P.SpreadsheetEvents.afterEditStart, function () {
                    n._grid.paint()
                }), this.events.on(P.SpreadsheetEvents.afterEditEnd, function () {
                    n._grid.paint()
                }), this._tabbar.events.on(R.NavigationBarEvents.click, function (t) {
                    "add-sheet" === t ? n.addSheet() : n._changeSheet(t)
                }), this.sheetContextMenu.events.on(R.NavigationBarEvents.click, function (t) {
                    var i;
                    "delete" === t ? n.removeSheet(n._focusedSheet) : (i = n._tabbar.data.getItem(n._focusedSheet), n._tabbar.data.update(i.id, {type: "input"}), v.awaitRedraw().then(function () {
                        var e = n._tabbar.getRootNode().querySelector("input");
                        e.focus(), e.onkeyup = function (t) {
                            "Enter" === t.key && e.blur(), "Escape" === t.key && n._sheets.update(i.id, {
                                type: "navItem",
                                value: i.prevValue
                            })
                        }
                    }))
                }), this.sheetContextMenu.events.on(R.NavigationBarEvents.afterHide, function () {
                    n._focusedSheet = null
                }), this._tabbar.events.on(R.NavigationBarEvents.inputFocus, function (t) {
                    var e = n._sheets.getItem(t);
                    n._sheets.update(t, {prevValue: e.value})
                }), this._tabbar.events.on(R.NavigationBarEvents.inputBlur, function (t) {
                    var e = n._sheets.getItem(t), i = e.value;
                    if (n._sheets.find(function (t) {
                        return t.value === i && t.id !== e.id
                    })) return n._getErrorWindow(), n._errorAlert.attachHTML("<p>A sheet with the name <b>" + i + "</b> already exists. Please enter another name. </p>"), n._errorAlert.show(), n._errorAlert.footer.events.on(R.NavigationBarEvents.click, function () {
                        return n._errorAlert.hide()
                    }), n._errorAlert.events.on(V.WindowEvents.afterHide, function () {
                        n._sheets.update(e.id, {value: e.prevValue}), n._tabbar.getRootNode().querySelector("input").focus()
                    }), !1;
                    n._sheets.update(t, {type: "navItem", value: e.prevValue}), n._renameSheet(t, i)
                }), this.toolbar.events.on(R.NavigationBarEvents.click, function (t, e) {
                    n._handleAction(t, e)
                }), this.contextMenu.events.on(R.NavigationBarEvents.click, function (t, e) {
                    n._handleAction(t, e)
                }), this.menu.events.on(R.NavigationBarEvents.click, function (t, e) {
                    n._handleAction(t, e)
                }), this._colorpicker.events.on(s.ColorpickerEvents.change, function (t) {
                    n._colorpickerPopup.hide();
                    var e = n.selection.getSelectedCell();
                    n._silencedColorChange || n.setStyle(e, ((e = {})[n._colorpickerTarget] = t, e)), n._silencedColorChange = !1, requestAnimationFrame(function () {
                        B.focusManager.setFocusId(n._uid), n._activeInput && (n._activeInput.focus(), n._activeInput = null)
                    })
                }), this.events.on(P.SpreadsheetEvents.editLineBlur, function (t, e) {
                    n._restoreFocus(e)
                }), this.events.on(P.SpreadsheetEvents.groupFill, function (t, e) {
                    n._fillCells(t, e)
                })
            }, G.prototype._getErrorWindow = function () {
                return this._errorAlert || (this._errorAlert = new z.Window({
                    footer: !0,
                    modal: !0,
                    closable: !0,
                    width: 350,
                    height: 240,
                    title: "There was a problem"
                }), this._errorAlert.footer.data.parse([{
                    type: "button",
                    view: "flat",
                    size: "medium",
                    color: "primary",
                    value: "Ok",
                    id: "ok"
                }])), this._errorAlert
            }, G.prototype._handleAction = function (e, t) {
                var i, n = this.selection.getSelectedCell(), o = this.selection.getFocusedCell(), r = "";
                switch (-1 !== L.findIndex(this.config.formats, function (t) {
                    return t.id === e
                }) && (r = e, e = "format"), e) {
                    case"undo":
                        this._actionsManager.undo();
                        break;
                    case"redo":
                        this._actionsManager.redo();
                        break;
                    case"color":
                    case"background":
                        this._colorpickerTarget = e;
                        var s = k.getCellInfo(n, this._activePage),
                            s = (dhx.css.get(s.css) || {})[e] || {background: "#FFFFFF", color: "#4C4C4C"}[e];
                        this._silencedColorChange = !0, this._colorpicker.setValue("white" === s ? "#FFFFFF" : s);
                        s = g.locateNode(t, "dhx_id");
                        this._colorpickerPopup.show(s);
                        break;
                    case"align-left":
                    case"align-right":
                    case"align-center":
                    case"align-justify":
                        var a = e.split("-")[1];
                        this.setStyle(n, {"text-align": a});
                        break;
                    case"font-weight-bold":
                    case"font-style-italic":
                    case"text-decoration-underline":
                        for (var a = e.split("-"), l = a.pop(), c = a.join("-"), u = 0, d = n.split(","); u < d.length; u++) {
                            var h = d[u], l = I.getToggledValue(this._activePage, h, c, l);
                            this.setStyle(h, ((i = {})[c] = l, i))
                        }
                        break;
                    case"clear-value":
                        this.setValue(n, "");
                        break;
                    case"clear-styles":
                        this.setStyle(n, {});
                        break;
                    case"clear-all":
                        this._callAction([{
                            cell: n,
                            action: P.Actions.setCellStyle,
                            groupAction: k.isRangeId(n) ? P.Actions.groupAction : null,
                            val: "",
                            dataStore: this._dataStore,
                            page: this._activePage
                        }, {
                            cell: n,
                            action: P.Actions.setCellValue,
                            groupAction: k.isRangeId(n) ? P.Actions.groupAction : null,
                            val: "",
                            page: this._activePage,
                            dataStore: this._dataStore
                        }]);
                        break;
                    case"lock":
                        for (var f = 0, p = n.split(","); f < p.length; f++) {
                            h = p[f];
                            this.isLocked(h) ? this.unlock(h) : this.lock(h)
                        }
                        break;
                    case"remove-row":
                        this.deleteRow(o);
                        break;
                    case"add-row":
                        this.addRow(o);
                        break;
                    case"remove-col":
                        this.deleteColumn(o);
                        break;
                    case"add-col":
                        this.addColumn(o);
                        break;
                    case"help":
                        window.open("https://docs.dhtmlx.com/spreadsheet/user_guide.html");
                        break;
                    case"format":
                        this.setFormat(n, r), this.paint();
                        break;
                    case"export-xlsx":
                        this.export.xlsx();
                        break;
                    case"import-xlsx":
                        this.load("", "xlsx")
                }
            }, G.prototype._fillCells = function (t, e) {
                var i, a = this, n = [t], l = [e];
                k.isRangeId(t) && (i = M.getCellsDiff(t.split(":")[1], e.split(":")[1]).isLargerByX ? "row" : "col", n = k.getRangeMatrix(t, i).map(function (t) {
                    return 1 < t.length ? t[0] + ":" + t[t.length - 1] : t[0]
                }), l = k.getRangeMatrix(e, i).map(function (t) {
                    return 1 < t.length ? t[0] + ":" + t[t.length - 1] : t[0]
                }));
                n = n.reduce(function (i, t, e) {
                    var n;
                    k.isRangeId(t) ? (n = [], a.eachCell(function (t) {
                        var e = a._getMath(t);
                        n.push(e ? "=" + e.source : a.getValue(t))
                    }, t)) : (o = a._getMath(t), n = o ? "=" + o.source : a.getValue(t));
                    var o = l[e];
                    if (Array.isArray(n)) {
                        if (t === o) return i;
                        var r = M.getAutoFilledCells(n, t, o, a._math), o = r.cells;
                        n = r.value
                    }
                    var s, e = a.getStyle(t), r = a.getFormat(t);
                    return i.push({
                        cell: o,
                        action: P.Actions.setCellFormat,
                        groupAction: k.isRangeId(o) ? P.Actions.groupAction : null,
                        val: r,
                        page: a._activePage
                    }, {
                        cell: o,
                        action: P.Actions.setCellStyle,
                        groupAction: k.isRangeId(o) ? P.Actions.groupAction : null,
                        val: e,
                        page: a._activePage
                    }), "string" == typeof n && n.startsWith("=") ? (s = k.getCellIds(t), a.eachCell(function (t) {
                        var e = k.getCellIds(t), e = a._math.transposeMath(n, e.row - s.row, e.col - s.col);
                        i.push({
                            cell: t,
                            action: P.Actions.setCellValue,
                            groupAction: null,
                            val: e,
                            page: a._activePage
                        })
                    }, o)) : i.push({
                        cell: o,
                        action: P.Actions.setCellValue,
                        groupAction: k.isRangeId(o) ? P.Actions.groupAction : null,
                        val: n,
                        page: a._activePage
                    }), i
                }, []);
                this._callAction(n)
            }, G.prototype._restoreFocus = function (t) {
                var e = this, i = this._editLine.getRootView().node, n = i && i.el,
                    o = this._range.cell || this.selection.getFocusedCell(),
                    i = k.getCellIds(o).col <= this.config.leftSplit;
                if (!o || k.getCellInfo(o, this._activePage).edited && !i) {
                    i = B.focusManager.getFocusId();
                    if (i !== this._uid && i !== this._grid._uid && this._editLine._suggest._list && i !== this._editLine._suggest._list._uid && i !== this._tabbar._uid) return this._colorpickerTarget ? void (this._activeInput = t.target) : void this.endEdit();
                    var r, i = t.target, t = t.relatedTarget;
                    n && n.contains(t) || n && n.contains(i) && t && "cell_input" === t.getAttribute("dhx_id") || ((r = i).focus(), setTimeout(function () {
                        var t = e._range.cursor || r.value.length;
                        r.selectionStart > t && r.setSelectionRange(t, t)
                    }, 100))
                }
            }, G.prototype._initHotkeys = function () {
                var i = this;
                if (!this.config.readonly) {
                    this.keyManager = new D.KeyManager(function (t, e) {
                        return e === i._uid || e === i._grid._uid || e === i.toolbar._uid
                    });
                    var t, e = W.getKeysHandlers(this, this._grid, this._buffer, this._editLine);
                    for (t in e) this.keyManager.addHotKey(t, e[t]);
                    for (t in this.config.hotkeys) this.keyManager.addHotKey(t, this.config.hotkeys[t])
                }
            }, G.prototype._render = function () {
                return v.el(".dhx_widget.dhx-spreadsheet", {
                    dhx_widget_id: this._uid,
                    _key: this._uid
                }, [v.inject(this._layout.getRootView())])
            }, G);

        function G(t, e) {
            var o = r.call(this, t, e) || this;
            o.container = null === t ? t : g.toNode(t), o._sizes = {
                rowsCount: 1e3,
                colsCount: 200
            }, o.config = k.extendConfig({
                rowsCount: {
                    validate: function (t) {
                        return 0 <= t
                    }, default: 1e3
                }, colsCount: {
                    validate: function (t) {
                        return 0 <= t
                    }, default: 25
                }, menu: {
                    validate: function (t) {
                        return "boolean" == typeof t
                    }, default: !1
                }, editLine: {
                    validate: function (t) {
                        return "boolean" == typeof t
                    }, default: !0
                }, readonly: {
                    validate: function (t) {
                        return "boolean" == typeof t
                    }, default: !1
                }, autoFormat: {
                    validate: function (t) {
                        return "boolean" == typeof t
                    }, default: !0
                }, importModulePath: {
                    validate: function (t) {
                        return "string" == typeof t
                    }, default: "https://cdn.dhtmlx.com/libs/excel2json/1.1/worker.js"
                }, exportModulePath: {
                    validate: function (t) {
                        return "string" == typeof t
                    }, default: "https://cdn.dhtmlx.com/libs/json2excel/1.0/worker.js"
                }, multiSheets: {
                    validate: function (t) {
                        return "boolean" == typeof t
                    }, default: !0
                }, formats: {
                    validate: function (t) {
                        return t instanceof Array
                    }, default: []
                }
            }, o.config), o._range = {
                cell: "",
                mode: 0,
                cursor: 0,
                editor: null,
                inline: 0
            }, o.events = new a.EventSystem, E.initFormat(o), o._initLayout(), o._colorpicker = new s.Colorpicker(null), o._colorpickerPopup = new T.Popup, o._colorpickerPopup.attach(o._colorpicker), o._setEventsHandlers(), o._actionsManager = new p.ActionsManager({
                spreadsheet: o,
                editLine: o._editLine,
                grid: o._grid,
                dataStore: o._dataStore
            }), o._buffer = new C.BufferManager(o, o._grid, o._callAction, o._activePage, o._dataStore), o.selection = new A.Selection(o, o._grid, o._buffer, o._activePage);
            var i = o._grid.getRootView();
            i.hooks = i.hooks || {}, i.hooks.didMount = function (t) {
                o._updateGridSizes();
                var e = o.selection.getFocusedCell(), e = o.getValue(e);
                o._editLine.setValue(e), o.config.readonly || t.node.el.addEventListener("contextmenu", function (t) {
                    o.contextMenu.data.update("lock", {value: o.isLocked(o.selection.getSelectedCell()) ? O.default.unlockCell : O.default.lockCell}), o.contextMenu.showAt(t), t.preventDefault()
                }), o.container = o._layout.getRootView().node.el, i.hooks.didRedraw = function (t) {
                    o._updateGridSizes(), o.events.fire(P.SpreadsheetEvents.gridRedraw, [t])
                }
            }, o._initHotkeys();
            e = o._tabbar.getRootView();
            e.hooks = e.hooks || {};

            function n(t) {
                t.node.el.addEventListener("contextmenu", function (t) {
                    o.endEdit();
                    var e, i, n = g.locate(t);
                    n && "add-sheet" !== n && !o.config.readonly && (e = o._sheets.getLength(), i = o.sheetContextMenu.data, o.config.multiSheets && 2 === e ? i.update("delete", {disabled: !0}) : o.config.multiSheets && 2 < e && i.getItem("delete").disabled && i.update("delete", {disabled: !1}), o.sheetContextMenu.showAt(t.target, "right"), o._focusedSheet = n, t.preventDefault())
                })
            }

            e.hooks.didMount = function (t) {
                t.node && t.node.el && t.node.el.addEventListener("dblclick", function (t) {
                    var e = g.locate(t);
                    e && "add-sheet" !== e && !o.config.readonly && (t.preventDefault(), o._focusedSheet = e, o.sheetContextMenu.events.fire(R.NavigationBarEvents.click, ["rename", t]), v.awaitRedraw().then(function () {
                        B.focusManager.setFocusId(null)
                    }))
                }), n(t)
            }, e.hooks.didRedraw = n, o._generateGridStruct(), o.export = new H.Exporter(o, o._grid);
            e = v.create({
                render: function () {
                    return o._render()
                }
            });
            return o.mount(t, e), B.focusManager.setFocusId(o._uid), o
        }

        e.Spreadsheet = o
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(83)), n(e(45)), n(e(44)), n(e(32));
        e = e(33);
        i.locale = e.default
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), r = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var s, a = i(0), l = i(5), c = i(2), u = i(6), d = i(1), h = i(32), f = i(44), p = i(33), g = i(45), _ = i(43),
            v = i(17), m = i(85), y = i(86), o = (s = u.View, o(b, s), b.prototype.destructor = function () {
                this.events && this.events.clear(), this.config = this.events = this._selected = this._handlers = this._pickerState = this._inputTimeout = null, this.unmount()
            }, b.prototype.clear = function () {
                this._selected = "", this.events.fire(g.ColorpickerEvents.change, [this._selected]), this.paint()
            }, b.prototype.setValue = function (t) {
                this._focusColor(t) && (this.paint(), this.events.fire(g.ColorpickerEvents.change, [this._selected]), this.events.fire(g.ColorpickerEvents.colorChange, [this._selected]))
            }, b.prototype.setFocus = function (t) {
                this._focusColor(t) && this.paint()
            }, b.prototype.getValue = function () {
                return this._selected || ""
            }, b.prototype.getCustomColors = function () {
                return this.config.customColors
            }, b.prototype.setCustomColors = function (t) {
                this.config.customColors = t.map(function (t) {
                    return t.toUpperCase()
                }), this.paint()
            }, b.prototype.setCurrentMode = function (t) {
                "palette" !== t && "picker" !== t || (this.config.mode = t, this.events.fire(g.ColorpickerEvents.modeChange, [t]), this.events.fire(g.ColorpickerEvents.viewChange, [t]), this.paint())
            }, b.prototype.getCurrentMode = function () {
                return this.config.mode
            }, b.prototype.getView = function () {
                return this.getCurrentMode()
            }, b.prototype.setView = function (t) {
                this.setCurrentMode(t)
            }, b.prototype.focusValue = function (t) {
                this.setFocus(t)
            }, b.prototype._setHandlers = function () {
                var i = this;
                this._handlers = {
                    click: {".dhx_palette__cell": this._onColorClick}, mousedown: function (t) {
                        i._pickerMove(t)
                    }, touchstart: function (t) {
                        i._pickerMove(t)
                    }, buttonsClick: function (t) {
                        i.setCurrentMode("palette"), "cancel" !== t ? "apply" !== t || i.config.customColors.includes(i._pickerState.background) || (i.setValue(i._pickerState.background), i.events.fire(g.ColorpickerEvents.apply, []), i.events.fire(g.ColorpickerEvents.selectClick, [])) : i.events.fire(g.ColorpickerEvents.cancelClick, [])
                    }, customColorClick: function () {
                        i.setView("picker")
                    }, oninput: function (e) {
                        i._inputTimeout && clearTimeout(i._inputTimeout), i._inputTimeout = setTimeout(function () {
                            var t = e.target.value;
                            -1 === t.indexOf("#") && (t = "#" + t), i._pickerState.customHex = t, h.isHex(t) && (i._pickerState.hsv = h.HexToHSV(t), i.paint())
                        }, 100)
                    }, contextmenu: {
                        ".dhx_palette__cell": function (t, e) {
                            t.preventDefault();
                            e = i.config.customColors.indexOf(e.data.color);
                            -1 !== e && i._removeCustomColor(e), i.paint()
                        }
                    }, mouseover: {
                        ".dhx_palette__cell": function (t) {
                            t.target && _.tooltip(p.default.rightClickToDelete, {
                                node: t.target,
                                position: v.Position.bottom
                            })
                        }, ".dhx_colorpicker-custom-colors__picker": function (t) {
                            t.target && _.tooltip(p.default.addNewColor, {node: t.target, position: v.Position.bottom})
                        }
                    }
                }, this.events.on(g.ColorpickerEvents.change, function () {
                    i.paint()
                }), this.events.on(g.ColorpickerEvents.colorChange, function () {
                    i.paint()
                })
            }, b.prototype._pickerMove = function (t) {
                var e = c.locate(t);
                this._pickerState.customHex = "", "picker_palette" === e ? this._setPaletteGrip(t) : this._setRangeGrip(t);
                var i = "picker_palette" === e ? this._setPaletteGrip : this._setRangeGrip,
                    n = t.targetTouches ? "touchmove" : "mousemove", t = t.targetTouches ? "touchend" : "mouseup";
                document.addEventListener(n, i), document.addEventListener(t, function () {
                    document.removeEventListener(n, i)
                }), this.paint()
            }, b.prototype._focusColor = function (t) {
                if (void 0 === t || t.length < 4) return !1;
                var i = t.toUpperCase();
                if (!h.isHex(i)) return !1;
                var e = this.config.palette.reduce(function (e, t) {
                    return e || (t.forEach(function (t) {
                        t.toUpperCase() === i && (e = !0)
                    }), e)
                }, !1), t = f.grayShades.includes(i);
                return e || t || ((t = this.getCustomColors()).includes(i.toUpperCase()) || t.push(i.toUpperCase())), this._selected = i || null, this._pickerState.hsv = h.HexToHSV(i), !0
            }, b.prototype._removeCustomColor = function (t) {
                this.config.customColors.splice(t, 1)
            }, b.prototype._getCells = function (t, n) {
                var o = this;
                return void 0 === n && (n = ""), t.reduce(function (t, e) {
                    var i = (o._selected || "").toUpperCase() === e.toUpperCase() ? "dhx_palette__cell--selected" : "";
                    return t.push(a.el(".dhx_palette__cell", {
                        class: i + " " + n,
                        _data: {color: e},
                        style: "background:" + e
                    })), t
                }, [])
            }, b.prototype._getGrayShades = function () {
                return a.el(".dhx_palette__row", this._getCells(f.grayShades))
            }, b.prototype._getPalette = function () {
                var i = this;
                return this.config.palette.reduce(function (t, e) {
                    return t.push(a.el(".dhx_palette__col", i._getCells(e))), t
                }, [])
            }, b.prototype._getContent = function () {
                var t = !this.config.pickerOnly && "palette" === this.config.mode ? r([this.config.grayShades && this._getGrayShades()], this._getPalette(), [!this.config.paletteOnly && a.el(".dhx_colorpicker-custom-colors", {onmouseover: this._handlers.mouseover}, [a.el(".dhx_colorpicker-custom-colors__header", [p.default.customColors]), a.el(".dhx_palette--custom.dhx_palette__row", r(this._getCells(this.config.customColors, "dhx_custom-color__cell"), [a.el(".dhx_colorpicker-custom-colors__picker", {
                    class: "dxi dxi-plus",
                    onclick: this._handlers.customColorClick,
                    onmouseover: this._handlers.mouseover
                })]))])]) : [m.getPicker(this, this._pickerState, this._handlers)];
                return a.el(".dhx_widget.dhx_colorpicker", {
                    class: this.config.css,
                    style: {width: this.config.width}
                }, [a.el(".dhx_palette", {onclick: this._handlers.click, oncontextmenu: this._handlers.contextmenu}, t)])
            }, b);

        function b(t, e) {
            var n = s.call(this, t, e) || this;
            n._setPaletteGrip = function (t) {
                var e = n.getRootView().refs.picker_palette.el.getBoundingClientRect(),
                    i = (t.targetTouches ? t.targetTouches[0] : t).clientX,
                    t = (t.targetTouches ? t.targetTouches[0] : t).clientY - e.top, i = i - e.left,
                    t = y.calculatePaletteGrip(e, t, i), i = t.s, t = t.v;
                n._pickerState.hsv.s = i, n._pickerState.hsv.v = t, n.paint()
            }, n._setRangeGrip = function (t) {
                var e = n.getRootView().refs.hue_range.el.getBoundingClientRect(),
                    t = (t.targetTouches ? t.targetTouches[0] : t).clientX - e.left, e = y.calculateRangeGrip(e, t),
                    t = e.h, e = e.rangeLeft;
                n._pickerState.hsv.h = t, n._pickerState.rangeLeft = e, n.paint()
            }, n._onColorClick = function (t, e) {
                n._selected = e.data.color.toUpperCase(), n.events.fire(g.ColorpickerEvents.change, [n._selected]), n.events.fire(g.ColorpickerEvents.colorChange, [n._selected])
            }, n._container = t, n.config = d.extend({
                css: "",
                grayShades: !0,
                pickerOnly: !1,
                paletteOnly: !1,
                customColors: [],
                palette: f.palette,
                width: "238px",
                mode: "palette"
            }, n.config), n.config.palette || (n.config.palette = f.palette), n.config.customColors && (n.config.customColors = n.config.customColors.map(function (t) {
                return t.toUpperCase()
            })), n._pickerState = {
                hsv: {h: 0, s: 1, v: 1},
                customHex: ""
            }, n.events = new l.EventSystem(n), n._setHandlers();
            t = a.create({
                render: function () {
                    return n._getContent()
                }
            });
            return n.mount(n._container, t), n
        }

        e.Colorpicker = o
    }, function (t, e, i) {
        /**
         * Copyright (c) 2017, Leon Sorokin
         * All rights reserved. (MIT Licensed)
         *
         * domvm.js (DOM ViewModel)
         * A thin, fast, dependency-free vdom view layer
         * @preserve https://github.com/leeoniya/domvm (v3.2.6, micro build)
         */
        t.exports = function () {
            "use strict";
            var M = 1, l = 2, I = 3, D = 4, O = 5, t = typeof window !== "undefined", e,
                r = (t ? window : {}).requestAnimationFrame, c = {};

            function i() {
            }

            var p = Array.isArray;

            function u(t) {
                return t != null
            }

            function s(t) {
                return t != null && t.constructor === Object
            }

            function o(t, e, i, n) {
                t.splice.apply(t, [i, n].concat(e))
            }

            function a(t) {
                var e = typeof t;
                return e === "string" || e === "number"
            }

            function d(t) {
                return typeof t === "function"
            }

            function h(t) {
                return typeof t === "object" && d(t.then)
            }

            function f(t) {
                var e = arguments;
                for (var i = 1; i < e.length; i++) for (var n in e[i]) t[n] = e[i][n];
                return t
            }

            function g(t, e, i) {
                var n;
                while (n = e.shift()) if (e.length === 0) t[n] = i; else t[n] = t = t[n] || {}
            }

            function _(t, e) {
                var i = [];
                for (var n = e; n < t.length; n++) i.push(t[n]);
                return i
            }

            function v(t, e) {
                for (var i in t) if (t[i] !== e[i]) return false;
                return true
            }

            function m(t, e) {
                var i = t.length;
                if (e.length !== i) return false;
                for (var n = 0; n < i; n++) if (t[n] !== e[n]) return false;
                return true
            }

            function y(t) {
                if (!r) return t;
                var e, i, n;

                function o() {
                    e = 0;
                    t.apply(i, n)
                }

                return function () {
                    i = this;
                    n = arguments;
                    if (!e) e = r(o)
                }
            }

            function b(t, e, i) {
                return function () {
                    return t.apply(i, e)
                }
            }

            function x(t) {
                var e = t.slice();
                var i = [];
                i.push(0);
                var n;
                var o;
                for (var r = 0, s = t.length; r < s; ++r) {
                    var a = i[i.length - 1];
                    if (t[a] < t[r]) {
                        e[r] = a;
                        i.push(r);
                        continue
                    }
                    n = 0;
                    o = i.length - 1;
                    while (n < o) {
                        var l = (n + o) / 2 | 0;
                        if (t[i[l]] < t[r]) n = l + 1; else o = l
                    }
                    if (t[r] < t[i[n]]) {
                        if (n > 0) e[r] = i[n - 1];
                        i[n] = r
                    }
                }
                n = i.length;
                o = i[n - 1];
                while (n-- > 0) {
                    i[n] = o;
                    o = e[o]
                }
                return i
            }

            function w(t, e) {
                var i = 0;
                var n = e.length - 1;
                var o;
                var r = n <= 2147483647 ? true : false;
                if (r) while (i <= n) {
                    o = i + n >> 1;
                    if (e[o] === t) return o; else if (e[o] < t) i = o + 1; else n = o - 1
                } else while (i <= n) {
                    o = Math.floor((i + n) / 2);
                    if (e[o] === t) return o; else if (e[o] < t) i = o + 1; else n = o - 1
                }
                return i == e.length ? null : i
            }

            function C(t) {
                return t[0] === "o" && t[1] === "n"
            }

            function S(t) {
                return t[0] === "_"
            }

            function E(t) {
                return t === "style"
            }

            function k(t) {
                t && t.el && t.el.offsetHeight
            }

            function A(t) {
                return t.node != null && t.node.el != null
            }

            function P(t, e) {
                switch (e) {
                    case"value":
                    case"checked":
                    case"selected":
                        return true
                }
                return false
            }

            function T(t) {
                t = t || c;
                while (t.vm == null && t.parent) t = t.parent;
                return t.vm
            }

            function R() {
            }

            var n = R.prototype = {
                constructor: R,
                type: null,
                vm: null,
                key: null,
                ref: null,
                data: null,
                hooks: null,
                ns: null,
                el: null,
                tag: null,
                attrs: null,
                body: null,
                flags: 0,
                _class: null,
                _diff: null,
                _dead: false,
                _lis: false,
                idx: null,
                parent: null
            };

            function L(t) {
                var e = new R;
                e.type = l;
                e.body = t;
                return e
            }

            var H = {}, F = /\[(\w+)(?:=(\w+))?\]/g;

            function j(t) {
                {
                    var e = H[t];
                    if (e == null) {
                        var i, n, o, r;
                        H[t] = e = {
                            tag: (i = t.match(/^[-\w]+/)) ? i[0] : "div",
                            id: (n = t.match(/#([-\w]+)/)) ? n[1] : null,
                            class: (o = t.match(/\.([-\w.]+)/)) ? o[1].replace(/\./g, " ") : null,
                            attrs: null
                        };
                        while (r = F.exec(t)) {
                            if (e.attrs == null) e.attrs = {};
                            e.attrs[r[1]] = r[2] || ""
                        }
                    }
                    return e
                }
            }

            var N = 1, $ = 2, V = 4, z = 8;

            function W(t, e, i, n) {
                var o = new R;
                o.type = M;
                if (u(n)) o.flags = n;
                o.attrs = e;
                var r = j(t);
                o.tag = r.tag;
                if (r.id || r.class || r.attrs) {
                    var s = o.attrs || {};
                    if (r.id && !u(s.id)) s.id = r.id;
                    if (r.class) {
                        o._class = r.class;
                        s.class = r.class + (u(s.class) ? " " + s.class : "")
                    }
                    if (r.attrs) for (var a in r.attrs) if (!u(s[a])) s[a] = r.attrs[a];
                    o.attrs = s
                }
                var l = o.attrs;
                if (u(l)) {
                    if (u(l._key)) o.key = l._key;
                    if (u(l._ref)) o.ref = l._ref;
                    if (u(l._hooks)) o.hooks = l._hooks;
                    if (u(l._data)) o.data = l._data;
                    if (u(l._flags)) o.flags = l._flags;
                    if (!u(o.key)) if (u(o.ref)) o.key = o.ref; else if (u(l.id)) o.key = l.id; else if (u(l.name)) o.key = l.name + (l.type === "radio" || l.type === "checkbox" ? l.value : "")
                }
                if (i != null) o.body = i;
                return o
            }

            function B(t, e, i) {
                var n = ["refs"].concat(e.split("."));
                g(t, n, i)
            }

            function G(t) {
                while (t = t.parent) t.flags |= N
            }

            function U(t, e, i, n) {
                if (t.type === O || t.type === D) return;
                t.parent = e;
                t.idx = i;
                t.vm = n;
                if (t.ref != null) B(T(t), t.ref, t);
                var o = t.hooks, r = n && n.hooks;
                if (o && (o.willRemove || o.didRemove) || r && (r.willUnmount || r.didUnmount)) G(t);
                if (p(t.body)) Y(t); else ;
            }

            function Y(t) {
                var e = t.body;
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    if (n === false || n == null) e.splice(i--, 1); else if (p(n)) o(e, n, i--, 1); else {
                        if (n.type == null) e[i] = n = L("" + n);
                        if (n.type === l) if (n.body == null || n.body === "") e.splice(i--, 1); else if (i > 0 && e[i - 1].type === l) {
                            e[i - 1].body += n.body;
                            e.splice(i--, 1)
                        } else U(n, t, i, null); else U(n, t, i, null)
                    }
                }
            }

            var K = {
                animationIterationCount: true,
                boxFlex: true,
                boxFlexGroup: true,
                boxOrdinalGroup: true,
                columnCount: true,
                flex: true,
                flexGrow: true,
                flexPositive: true,
                flexShrink: true,
                flexNegative: true,
                flexOrder: true,
                gridRow: true,
                gridColumn: true,
                order: true,
                lineClamp: true,
                borderImageOutset: true,
                borderImageSlice: true,
                borderImageWidth: true,
                fontWeight: true,
                lineHeight: true,
                opacity: true,
                orphans: true,
                tabSize: true,
                widows: true,
                zIndex: true,
                zoom: true,
                fillOpacity: true,
                floodOpacity: true,
                stopOpacity: true,
                strokeDasharray: true,
                strokeDashoffset: true,
                strokeMiterlimit: true,
                strokeOpacity: true,
                strokeWidth: true
            };

            function X(t, e) {
                return !isNaN(e) && !K[t] ? e + "px" : e
            }

            function q(t, e) {
                var i = (t.attrs || c).style;
                var n = e ? (e.attrs || c).style : null;
                if (i == null || a(i)) t.el.style.cssText = i; else {
                    for (var o in i) {
                        var r = i[o];
                        if (n == null || r != null && r !== n[o]) t.el.style[o] = X(o, r)
                    }
                    if (n) for (var s in n) if (i[s] == null) t.el.style[s] = ""
                }
            }

            var J = [];

            function Z(t, e, i, n, o) {
                if (t != null) {
                    var r = i.hooks[e];
                    if (r) if (e[0] === "d" && e[1] === "i" && e[2] === "d") o ? k(i.parent) && r(i, n) : J.push([r, i, n]); else return r(i, n)
                }
            }

            function Q(t) {
                if (J.length) {
                    k(t.node);
                    var e;
                    while (e = J.shift()) e[0](e[1], e[2])
                }
            }

            var tt = t ? document : null;

            function et(t) {
                while (t._node == null) t = t.parentNode;
                return t._node
            }

            function it(t, e) {
                if (e != null) return tt.createElementNS(e, t);
                return tt.createElement(t)
            }

            function nt(t) {
                return tt.createTextNode(t)
            }

            function ot(t) {
                return tt.createComment(t)
            }

            function rt(t) {
                return t.nextSibling
            }

            function st(t) {
                return t.previousSibling
            }

            function at(t) {
                var e = t.vm;
                var i = e != null && Z(e.hooks, "willUnmount", e, e.data);
                var n = Z(t.hooks, "willRemove", t);
                if ((t.flags & N) === N && p(t.body)) for (var o = 0; o < t.body.length; o++) at(t.body[o]);
                return i || n
            }

            function lt(t, e, i) {
                var n = e._node, o = n.vm;
                if (p(n.body)) if ((n.flags & N) === N) for (var r = 0; r < n.body.length; r++) lt(e, n.body[r].el); else ut(n);
                delete e._node;
                t.removeChild(e);
                Z(n.hooks, "didRemove", n, null, i);
                if (o != null) {
                    Z(o.hooks, "didUnmount", o, o.data, i);
                    o.node = null
                }
            }

            function ct(t, e) {
                var i = e._node;
                if (i._dead) return;
                var n = at(i);
                if (n != null && h(n)) {
                    i._dead = true;
                    n.then(b(lt, [t, e, true]))
                } else lt(t, e)
            }

            function ut(t) {
                var e = t.body;
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    delete n.el._node;
                    if (n.vm != null) n.vm.node = null;
                    if (p(n.body)) ut(n)
                }
            }

            function dt(t) {
                var e = t.el;
                if ((t.flags & N) === 0) {
                    p(t.body) && ut(t);
                    e.textContent = null
                } else {
                    var i = e.firstChild;
                    do {
                        var n = rt(i);
                        ct(e, i)
                    } while (i = n)
                }
            }

            function ht(t, e, i) {
                var n = e._node, o = e.parentNode != null;
                var r = e === i || !o ? n.vm : null;
                if (r != null) Z(r.hooks, "willMount", r, r.data);
                Z(n.hooks, o ? "willReinsert" : "willInsert", n);
                t.insertBefore(e, i);
                Z(n.hooks, o ? "didReinsert" : "didInsert", n);
                if (r != null) Z(r.hooks, "didMount", r, r.data)
            }

            function ft(t, e, i) {
                ht(t, e, i ? rt(i) : null)
            }

            var pt = {};

            function gt(t) {
                f(pt, t)
            }

            function _t(t) {
                var e = this, i = e, n = _(arguments, 1).concat(i, i.data);
                do {
                    var o = e.onemit, o = o ? o[t] : null;
                    if (o) {
                        o.apply(e, n);
                        break
                    }
                } while (e = e.parent());
                if (pt[t]) pt[t].apply(e, n)
            }

            var vt = i;

            function mt(t) {
                vt = t.onevent || vt;
                if (t.onemit) gt(t.onemit)
            }

            function yt(t, e, i) {
                t[e] = i
            }

            function bt(t, e, i, n, o) {
                var r = t.apply(o, e.concat([i, n, o, o.data]));
                o.onevent(i, n, o, o.data, e);
                vt.call(null, i, n, o, o.data, e);
                if (r === false) {
                    i.preventDefault();
                    i.stopPropagation()
                }
            }

            function xt(t) {
                var e = et(t.target);
                var i = T(e);
                var n = t.currentTarget._node.attrs["on" + t.type], o, r;
                if (p(n)) {
                    o = n[0];
                    r = n.slice(1);
                    bt(o, r, t, e, i)
                } else for (var s in n) if (t.target.matches(s)) {
                    var a = n[s];
                    if (p(a)) {
                        o = a[0];
                        r = a.slice(1)
                    } else {
                        o = a;
                        r = []
                    }
                    bt(o, r, t, e, i)
                }
            }

            function wt(t, e, i, n) {
                if (i === n) return;
                var o = t.el;
                if (i == null || d(i)) yt(o, e, i); else if (n == null) yt(o, e, xt)
            }

            function Ct(t, e, i) {
                if (e[0] === ".") {
                    e = e.substr(1);
                    i = true
                }
                if (i) t.el[e] = ""; else t.el.removeAttribute(e)
            }

            function St(t, e, i, n, o) {
                var r = t.el;
                if (i == null) !o && Ct(t, e, false); else if (t.ns != null) r.setAttribute(e, i); else if (e === "class") r.className = i; else if (e === "id" || typeof i === "boolean" || n) r[e] = i; else if (e[0] === ".") r[e.substr(1)] = i; else r.setAttribute(e, i)
            }

            function Et(t, e, i) {
                var n = t.attrs || c;
                var o = e.attrs || c;
                if (n === o) ; else {
                    for (var r in n) {
                        var s = n[r];
                        var a = P(t.tag, r);
                        var l = a ? t.el[r] : o[r];
                        if (s === l) ; else if (E(r)) q(t, e); else if (S(r)) ; else if (C(r)) wt(t, r, s, l); else St(t, r, s, a, i)
                    }
                    for (var r in o) !(r in n) && !S(r) && Ct(t, r, P(t.tag, r) || C(r))
                }
            }

            function kt(t, e, i, n) {
                if (t.type === D) {
                    e = t.data;
                    i = t.key;
                    n = t.opts;
                    t = t.view
                }
                return new Ut(t, e, i, n)
            }

            function Mt(t) {
                for (var e = 0; e < t.body.length; e++) {
                    var i = t.body[e];
                    var n = i.type;
                    if (n <= I) ht(t.el, It(i)); else if (n === D) {
                        var o = kt(i.view, i.data, i.key, i.opts)._redraw(t, e, false);
                        n = o.node.type;
                        ht(t.el, It(o.node))
                    } else if (n === O) {
                        var o = i.vm;
                        o._redraw(t, e);
                        n = o.node.type;
                        ht(t.el, o.node.el)
                    }
                }
            }

            function It(t, e) {
                if (t.el == null) if (t.type === M) {
                    t.el = e || it(t.tag, t.ns);
                    if (t.attrs != null) Et(t, c, true);
                    if ((t.flags & z) === z) t.body.body(t);
                    if (p(t.body)) Mt(t); else if (t.body != null && t.body !== "") t.el.textContent = t.body
                } else if (t.type === l) t.el = e || nt(t.body); else if (t.type === I) t.el = e || ot(t.body);
                t.el._node = t;
                return t.el
            }

            function Dt(t, e) {
                return e[t.idx + 1]
            }

            function Ot(t, e) {
                return e[t.idx - 1]
            }

            function At(t) {
                return t.parent
            }

            window.lisMove = Lt;
            var Pt = 1, Tt = 2;

            function Rt(l, c, u, d, h, f, p, g) {
                return function (t, e, i, n, o, r) {
                    var s, a;
                    if (n[d] != null) {
                        if ((s = n[d]._node) == null) {
                            n[d] = l(n[d]);
                            return
                        }
                        if (At(s) !== t) {
                            a = l(n[d]);
                            s.vm != null ? s.vm.unmount(true) : ct(e, n[d]);
                            n[d] = a;
                            return
                        }
                    }
                    if (n[h] == o) return Tt; else if (n[h].el == null) {
                        u(e, It(n[h]), n[d]);
                        n[h] = c(n[h], i)
                    } else if (n[h].el === n[d]) {
                        n[h] = c(n[h], i);
                        n[d] = l(n[d])
                    } else if (!r && s === n[p]) {
                        a = n[d];
                        n[d] = l(a);
                        g(e, a, n[f]);
                        n[f] = a
                    } else {
                        if (r && n[d] != null) return Lt(l, c, u, d, h, e, i, s, n);
                        return Pt
                    }
                }
            }

            function Lt(t, e, i, n, o, r, s, a, l) {
                if (a._lis) {
                    i(r, l[o].el, l[n]);
                    l[o] = e(l[o], s)
                } else {
                    var c = w(a.idx, l.tombs);
                    a._lis = true;
                    var u = t(l[n]);
                    i(r, l[n], c != null ? s[l.tombs[c]].el : c);
                    if (c == null) l.tombs.push(a.idx); else l.tombs.splice(c, 0, a.idx);
                    l[n] = u
                }
            }

            var Ht = Rt(rt, Dt, ht, "lftSib", "lftNode", "rgtSib", "rgtNode", ft),
                Ft = Rt(st, Ot, ft, "rgtSib", "rgtNode", "lftSib", "lftNode", ht);

            function jt(t, e) {
                var i = e.body, n = t.el, o = t.body, r = {
                    lftNode: o[0],
                    rgtNode: o[o.length - 1],
                    lftSib: (i[0] || c).el,
                    rgtSib: (i[i.length - 1] || c).el
                };
                t:while (1) {
                    while (1) {
                        var s = Ht(t, n, o, r, null, false);
                        if (s === Pt) break;
                        if (s === Tt) break t
                    }
                    while (1) {
                        var a = Ft(t, n, o, r, r.lftNode, false);
                        if (a === Pt) break;
                        if (a === Tt) break t
                    }
                    Nt(t, n, o, r);
                    break
                }
            }

            function Nt(t, e, i, n) {
                var o = Array.prototype.slice.call(e.childNodes);
                var r = [];
                for (var s = 0; s < o.length; s++) {
                    var a = o[s]._node;
                    if (a.parent === t) r.push(a.idx)
                }
                var l = x(r).map(function (t) {
                    return r[t]
                });
                for (var c = 0; c < l.length; c++) i[l[c]]._lis = true;
                n.tombs = l;
                while (1) {
                    var u = Ht(t, e, i, n, null, true);
                    if (u === Tt) break
                }
            }

            function $t(t) {
                return t.el._node.parent !== t.parent
            }

            function Vt(t, e, i) {
                return e[i]
            }

            function zt(t, e, i) {
                for (; i < e.length; i++) {
                    var n = e[i];
                    if (n.vm != null) {
                        if (t.type === D && n.vm.view === t.view && n.vm.key === t.key || t.type === O && n.vm === t.vm) return n
                    } else if (!$t(n) && t.tag === n.tag && t.type === n.type && t.key === n.key && (t.flags & ~N) === (n.flags & ~N)) return n
                }
                return null
            }

            function Wt(t, e, i) {
                return e[e._keys[t.key]]
            }

            function Bt(t, e) {
                Z(e.hooks, "willRecycle", e, t);
                var i = t.el = e.el;
                var n = e.body;
                var o = t.body;
                i._node = t;
                if (t.type === l && o !== n) {
                    i.nodeValue = o;
                    return
                }
                if (t.attrs != null || e.attrs != null) Et(t, e, false);
                var r = p(n);
                var s = p(o);
                var a = (t.flags & z) === z;
                if (r) {
                    if (s || a) Gt(t, e); else if (o !== n) if (o != null) i.textContent = o; else dt(e)
                } else if (s) {
                    dt(e);
                    Mt(t)
                } else if (o !== n) if (i.firstChild) i.firstChild.nodeValue = o; else i.textContent = o;
                Z(e.hooks, "didRecycle", e, t)
            }

            function Gt(t, e) {
                var i = t.body, n = i.length, o = e.body, r = o.length, s = (t.flags & z) === z,
                    a = (t.flags & $) === $, l = (t.flags & V) === V, c = !a && t.type === M, u = true,
                    d = l ? Wt : a || s ? Vt : zt;
                if (l) {
                    var h = {};
                    for (var f = 0; f < o.length; f++) h[o[f].key] = f;
                    o._keys = h
                }
                if (c && n === 0) {
                    dt(e);
                    if (s) t.body = [];
                    return
                }
                var p, g, _, v = 0, m = false, y = 0;
                if (s) {
                    var b = {key: null};
                    var x = Array(n)
                }
                for (var f = 0; f < n; f++) {
                    if (s) {
                        var w = false;
                        var C = null;
                        if (u) {
                            if (l) b.key = i.key(f);
                            p = d(b, o, y)
                        }
                        if (p != null) {
                            _ = p.idx;
                            C = i.diff(f, p);
                            if (C === true) {
                                g = p;
                                g.parent = t;
                                g.idx = f;
                                g._lis = false
                            } else w = true
                        } else w = true;
                        if (w) {
                            g = i.tpl(f);
                            U(g, t, f);
                            g._diff = C != null ? C : i.diff(f);
                            if (p != null) Bt(g, p)
                        } else ;
                        x[f] = g
                    } else {
                        var g = i[f];
                        var S = g.type;
                        if (S <= I) {
                            if (p = u && d(g, o, y)) {
                                Bt(g, p);
                                _ = p.idx
                            }
                        } else if (S === D) {
                            if (p = u && d(g, o, y)) {
                                _ = p.idx;
                                var E = p.vm._update(g.data, t, f)
                            } else var E = kt(g.view, g.data, g.key, g.opts)._redraw(t, f, false);
                            S = E.node.type
                        } else if (S === O) {
                            var k = A(g.vm);
                            var E = g.vm._update(g.data, t, f, k);
                            S = E.node.type
                        }
                    }
                    if (!l && p != null) {
                        if (_ === y) {
                            y++;
                            if (y === r && n > r) {
                                p = null;
                                u = false
                            }
                        } else m = true;
                        if (r > 100 && m && ++v % 10 === 0) while (y < r && $t(o[y])) y++
                    }
                }
                if (s) t.body = x;
                c && jt(t, e)
            }

            function Ut(t, e, i, n) {
                var o = this;
                o.view = t;
                o.data = e;
                o.key = i;
                if (n) {
                    o.opts = n;
                    o.config(n)
                }
                var r = s(t) ? t : t.call(o, o, e, i, n);
                if (d(r)) o.render = r; else {
                    o.render = r.render;
                    o.config(r)
                }
                o._redrawAsync = y(function (t) {
                    return o.redraw(true)
                });
                o._updateAsync = y(function (t) {
                    return o.update(t, true)
                });
                o.init && o.init.call(o, o, o.data, o.key, n)
            }

            var Yt = Ut.prototype = {
                constructor: Ut,
                _diff: null,
                init: null,
                view: null,
                key: null,
                data: null,
                state: null,
                api: null,
                opts: null,
                node: null,
                hooks: null,
                onevent: i,
                refs: null,
                render: null,
                mount: Kt,
                unmount: Xt,
                config: function (t) {
                    var e = this;
                    if (t.init) e.init = t.init;
                    if (t.diff) e.diff = t.diff;
                    if (t.onevent) e.onevent = t.onevent;
                    if (t.hooks) e.hooks = f(e.hooks || {}, t.hooks);
                    if (t.onemit) e.onemit = f(e.onemit || {}, t.onemit)
                },
                parent: function () {
                    return T(this.node.parent)
                },
                root: function () {
                    var t = this.node;
                    while (t.parent) t = t.parent;
                    return t.vm
                },
                redraw: function (t) {
                    var e = this;
                    t ? e._redraw(null, null, A(e)) : e._redrawAsync();
                    return e
                },
                update: function (t, e) {
                    var i = this;
                    e ? i._update(t, null, null, A(i)) : i._updateAsync(t);
                    return i
                },
                _update: Zt,
                _redraw: Jt,
                _redrawAsync: null,
                _updateAsync: null
            };

            function Kt(t, e) {
                var i = this;
                if (e) {
                    dt({el: t, flags: 0});
                    i._redraw(null, null, false);
                    if (t.nodeName.toLowerCase() !== i.node.tag) {
                        It(i.node);
                        ht(t.parentNode, i.node.el, t);
                        t.parentNode.removeChild(t)
                    } else ht(t.parentNode, It(i.node, t), t)
                } else {
                    i._redraw(null, null);
                    if (t) ht(t, i.node.el)
                }
                if (t) Q(i);
                return i
            }

            function Xt(t) {
                var e = this;
                var i = e.node;
                var n = i.el.parentNode;
                ct(n, i.el);
                if (!t) Q(e)
            }

            function qt(t, e, i, n) {
                if (i != null) {
                    i.body[n] = e;
                    e.idx = n;
                    e.parent = i;
                    e._lis = false
                }
                return t
            }

            function Jt(t, e, i) {
                var n = t == null;
                var o = this;
                var r = o.node && o.node.el && o.node.el.parentNode;
                var s = o.node, a, l;
                if (o.diff != null) {
                    a = o._diff;
                    o._diff = l = o.diff(o, o.data);
                    if (s != null) {
                        var c = p(a) ? m : v;
                        var u = a === l || c(a, l);
                        if (u) return qt(o, s, t, e)
                    }
                }
                r && Z(o.hooks, "willRedraw", o, o.data);
                var d = o.render.call(o, o, o.data, a, l);
                if (d === s) return qt(o, s, t, e);
                o.refs = null;
                if (o.key != null && d.key !== o.key) d.key = o.key;
                o.node = d;
                if (t) {
                    U(d, t, e, o);
                    t.body[e] = d
                } else if (s && s.parent) {
                    U(d, s.parent, s.idx, o);
                    s.parent.body[s.idx] = d
                } else U(d, null, null, o);
                if (i !== false) if (s) if (s.tag !== d.tag || s.key !== d.key) {
                    s.vm = d.vm = null;
                    var h = s.el.parentNode;
                    var f = rt(s.el);
                    ct(h, s.el);
                    ht(h, It(d), f);
                    s.el = d.el;
                    d.vm = o
                } else Bt(d, s); else It(d);
                r && Z(o.hooks, "didRedraw", o, o.data);
                if (n && r) Q(o);
                return o
            }

            function Zt(t, e, i, n) {
                var o = this;
                if (t != null) if (o.data !== t) {
                    Z(o.hooks, "willUpdate", o, t);
                    o.data = t
                }
                return o._redraw(e, i, n)
            }

            function Qt(t, e, i, n) {
                var o, r;
                if (i == null) if (s(e)) o = e; else r = e; else {
                    o = e;
                    r = i
                }
                return W(t, o, r, n)
            }

            var te = "http://www.w3.org/2000/svg";

            function ee(t, e, i, n) {
                var o = Qt(t, e, i, n);
                o.ns = te;
                return o
            }

            function ie(t) {
                var e = new R;
                e.type = I;
                e.body = t;
                return e
            }

            function ne(t, e, i, n) {
                this.view = t;
                this.data = e;
                this.key = i;
                this.opts = n
            }

            function oe(t, e, i, n) {
                return new ne(t, e, i, n)
            }

            function re(t) {
                this.vm = t
            }

            function se(t) {
                return new re(t)
            }

            function ae(t) {
                var e = new R;
                e.type = M;
                e.el = e.key = t;
                return e
            }

            function le(r, s) {
                var o = r.length;
                var a = {
                    items: r, length: o, key: function (t) {
                        return s.key(r[t], t)
                    }, diff: function (t, e) {
                        var i = s.diff(r[t], t);
                        if (e == null) return i;
                        var n = e._diff;
                        var o = i === n || p(n) ? m(i, n) : v(i, n);
                        return o || i
                    }, tpl: function (t) {
                        return s.tpl(r[t], t)
                    }, map: function (t) {
                        s.tpl = t;
                        return a
                    }, body: function (t) {
                        var e = Array(o);
                        for (var i = 0; i < o; i++) {
                            var n = a.tpl(i);
                            n._diff = a.diff(i);
                            e[i] = n;
                            U(n, t, i)
                        }
                        t.body = e
                    }
                };
                return a
            }

            ne.prototype = {
                constructor: ne,
                type: D,
                view: null,
                data: null,
                key: null,
                opts: null
            }, re.prototype = {constructor: re, type: O, vm: null};
            var ce = {
                config: mt,
                ViewModel: Ut,
                VNode: R,
                createView: kt,
                defineElement: Qt,
                defineSvgElement: ee,
                defineText: L,
                defineComment: ie,
                defineView: oe,
                injectView: se,
                injectElement: ae,
                lazyList: le,
                FIXED_BODY: $,
                DEEP_REMOVE: N,
                KEYED_LIST: V,
                LAZY_LIST: z
            };

            function ue(t, e) {
                !function (t, e, i) {
                    {
                        var n, o;
                        null != e.type ? null == t.vm && (U(e, t.parent, t.idx, null), Bt(t.parent.body[t.idx] = e, t), i && k(e), Q(T(e))) : ((n = Object.create(t)).attrs = f({}, t.attrs), o = f(t.attrs, e), null != t._class && (e = o.class, o.class = null != e && "" !== e ? t._class + " " + e : t._class), Et(t, n), i && k(t))
                    }
                }(this, t, e)
            }

            function de(t, e, i) {
                if (null != e.type) null == t.vm && (U(e, t.parent, t.idx, null), Bt(t.parent.body[t.idx] = e, t), i && k(e), Q(T(e))); else {
                    var n = Object.create(t);
                    (n = Object.create(t)).attrs = f({}, t.attrs);
                    var o = f(t.attrs, e), s;
                    null != t._class && (e = o.class, o.class = null != e && "" !== e ? t._class + " " + e : t._class), Et(t, n), i && k(t)
                }
            }

            function he(t, e) {
                var i = t.body;
                if (p(i)) for (var n = 0; n < i.length; n++) {
                    var o = i[n];
                    if (o.vm != null) e.push(o.vm); else he(o, e)
                }
                return e
            }

            function fe(t) {
                var e = arguments;
                var i = e.length;
                var n, o;
                if (i > 1) {
                    var r = 1;
                    if (s(e[1])) {
                        o = e[1];
                        r = 2
                    }
                    if (i === r + 1 && (a(e[r]) || p(e[r]) || o && (o._flags & z) === z)) n = e[r]; else n = _(e, r)
                }
                return W(t, o, n)
            }

            function pe() {
                var t = fe.apply(null, arguments);
                return t.ns = te, t
            }

            return n.patch = function (t, e) {
                !function (t, e, i) {
                    {
                        var n, o;
                        null != e.type ? null == t.vm && (U(e, t.parent, t.idx, null), Bt(t.parent.body[t.idx] = e, t), i && k(e), Q(T(e))) : ((n = Object.create(t)).attrs = f({}, t.attrs), o = f(t.attrs, e), null != t._class && (e = o.class, o.class = null != e && "" !== e ? t._class + " " + e : t._class), Et(t, n), i && k(t))
                    }
                }(this, t, e)
            }, Yt.emit = function (t) {
                var e = this, i = e, n = _(arguments, 1).concat(i, i.data);
                do {
                    var o = e.onemit, o = o ? o[t] : null;
                    if (o) {
                        o.apply(e, n);
                        break
                    }
                } while (e = e.parent());
                pt[t] && pt[t].apply(e, n)
            }, Yt.onemit = null, Yt.body = function () {
                return function t(e, i) {
                    var n = e.body;
                    if (p(n)) for (var o = 0; o < n.length; o++) {
                        var r = n[o];
                        null != r.vm ? i.push(r.vm) : t(r, i)
                    }
                    return i
                }(this.node, [])
            }, ce.defineElementSpread = fe, ce.defineSvgElementSpread = function () {
                var t = fe.apply(null, arguments);
                return t.ns = te, t
            }, ce
        }()
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var l = i(32), c = i(0), u = i(33);
        e.getPicker = function (t, e, i) {
            var n = l.HSVtoRGB(e.hsv);
            e.background = l.RGBToHex(n);
            var o = l.RGBToHex(l.HSVtoRGB({h: e.hsv.h, s: 1, v: 1})), r = t.getRootView(),
                s = (a = r.refs ? r.refs.picker_palette.el.getBoundingClientRect() : {
                    height: 200,
                    width: 218,
                    x: 0,
                    y: 0
                }).height - 2, n = a.width - 2, r = s - e.hsv.v * s - 4, s = e.hsv.s * n - 4,
                a = (n = a.width - 6) - (360 - e.hsv.h) / 360 * n,
                n = (l.isHex(e.customHex) ? e.customHex : e.background).replace("#", "");
            return c.el(".dhx_colorpicker-picker", {}, [c.el(".dhx_colorpicker-picker__palette", {
                style: {
                    height: 132,
                    background: o
                },
                onmousedown: i.mousedown,
                ontouchstart: i.touchstart,
                dhx_id: "picker_palette",
                _ref: "picker_palette"
            }, [c.el(".dhx_palette_grip", {
                style: {
                    top: r,
                    left: s
                }
            })]), c.el(".dhx_colorpicker-hue-range", {
                style: {height: 16},
                onmousedown: i.mousedown,
                ontouchstart: i.touchstart,
                dhx_id: "hue_range",
                _key: "hue_range",
                _ref: "hue_range"
            }, [c.el(".dhx_colorpicker-hue-range__grip", {style: {left: a}})]), c.el(".dhx_colorpicker-value", [c.el(".dhx_colorpicker-value__color", {style: {background: e.background}}), c.el(".dhx_colorpicker-value__input__wrapper", [c.el("input", {
                class: "dhx_colorpicker-value__input",
                value: n,
                oninput: i.oninput,
                maxlength: "7",
                _key: "hex_input",
                "aria-label": "type color in HEX format"
            })])]), c.el(".dhx_colorpicker-picker__buttons", [!t.config.pickerOnly && c.el("button", {
                class: "dhx_button dhx_button--size_medium dhx_button--view_link dhx_button--color_primary",
                onclick: [i.buttonsClick, "cancel"]
            }, u.default.cancel), c.el("button", {
                class: "dhx_button dhx_button--size_medium dhx_button--view_flat dhx_button--color_primary",
                onclick: [i.buttonsClick, "apply"]
            }, u.default.select)])])
        }, e.calculatePaletteGrip = function (t, e, i) {
            var t = (n = t.refs.picker_palette.el.getBoundingClientRect()).height, n = n.width;
            e = e < 0 ? 0 : t < e ? t : e, i = i < 0 ? 0 : n < i ? n : i, n = Math.round(i / (n / 100)), t = 100 - Math.round(e / (t / 100)), this._pickerState.hsv.s = n / 100, this._pickerState.hsv.v = t / 100
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), e.calculatePaletteGrip = function (t, e, i) {
            var n = t.height, t = t.width;
            return e = e < 0 ? 0 : n < e ? n : e, i = i < 0 ? 0 : t < i ? t : i, {
                s: Math.round(i / (t / 100)) / 100,
                v: (100 - Math.round(e / (n / 100))) / 100
            }
        }, e.calculateRangeGrip = function (t, e) {
            return t = t.width, e = e < 0 ? 0 : t < e ? t : e, {h: Math.round(e / t * 360), rangeLeft: e}
        }
    }, function (t, i, n) {
        "use strict";
        (function (s) {
            var l = this && this.__assign || function () {
                return (l = Object.assign || function (t) {
                    for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                    return t
                }).apply(this, arguments)
            };
            Object.defineProperty(i, "__esModule", {value: !0});
            var c = n(14), u = n(13), t = (e.prototype.load = function (t, e) {
                var i = this;
                if (!t.config || this._parent.events.fire(u.DataEvents.beforeLazyLoad, [])) return this._parent.loadData = t.load().then(function (t) {
                    return t ? i.parse(t, e) : []
                }).catch(function (t) {
                    i._parent.events.fire(u.DataEvents.loadError, [t])
                })
            }, e.prototype.parse = function (t, e) {
                var n = this;
                if (void 0 === e && (e = "json"), "json" !== e || c.hasJsonOrArrayStructure(t) || this._parent.events.fire(u.DataEvents.loadError, ["Uncaught SyntaxError: Unexpected end of input"]), !((t = (e = c.toDataDriver(e)).toJsonArray(t)) instanceof Array)) {
                    var i = t.total_count - 1, o = t.from;
                    if (t = t.data, 0 !== this._parent.getLength()) return t.forEach(function (t, e) {
                        var i = o + e, e = n._parent.getId(i);
                        e ? (i = n._parent.getItem(e)) && i.$empty && (n._parent.changeId(e, t.id, !0), n._parent.update(t.id, l(l({}, t), {$empty: void 0}), !0)) : c.dhxWarning("item not found")
                    }), this._parent.events.fire(u.DataEvents.afterLazyLoad, [o, t.length]), this._parent.events.fire(u.DataEvents.change), t;
                    for (var r = [], s = 0, a = 0; s <= i; s++) o <= s && s <= o + t.length - 1 ? (r.push(t[a]), a++) : r.push({$empty: !0});
                    t = r
                }
                return this._parent.getInitialData() && this._parent.removeAll(), this._parent.$parse(t), t
            }, e.prototype.save = function (o) {
                for (var r = this, e = this, t = 0, i = this._changes.order; t < i.length; t++) !function (i) {
                    var n, t;
                    i.saving || i.pending ? c.dhxWarning("item is saving") : (n = e._findPrevState(i.id)) && n.saving ? (t = new s(function (t, e) {
                        n.promise.then(function () {
                            i.pending = !1, t(r._setPromise(i, o))
                        }).catch(function (t) {
                            r._removeFromOrder(n), r._setPromise(i, o), c.dhxWarning(t), e(t)
                        })
                    }), e._addToChain(t), i.pending = !0) : e._setPromise(i, o)
                }(i[t]);
                this._changes.order.length && this._parent.saveData.then(function () {
                    r._saving = !1
                })
            }, e.prototype.updateChanges = function (t) {
                this._changes = t
            }, e.prototype._setPromise = function (e, t) {
                var i = this;
                return e.promise = t.save(e.obj, e.status), e.promise.then(function () {
                    i._removeFromOrder(e)
                }).catch(function (t) {
                    e.saving = !1, e.error = !0, c.dhxError(t)
                }), e.saving = !0, this._saving = !0, this._addToChain(e.promise), e.promise
            }, e.prototype._addToChain = function (t) {
                this._parent.saveData && this._saving ? this._parent.saveData = this._parent.saveData.then(function () {
                    return t
                }) : this._parent.saveData = t
            }, e.prototype._findPrevState = function (t) {
                for (var e = 0, i = this._changes.order; e < i.length; e++) {
                    var n = i[e];
                    if (n.id === t) return n
                }
                return null
            }, e.prototype._removeFromOrder = function (e) {
                this._changes.order = this._changes.order.filter(function (t) {
                    return !c.isEqualObj(t, e)
                })
            }, e);

            function e(t, e) {
                this._parent = t, this._changes = e
            }

            i.Loader = t
        }).call(this, n(9))
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(89);
        o.prototype.toJsonArray = function (t) {
            return this.getRows(t)
        }, o.prototype.toJsonObject = function (t) {
            var e;
            return "string" == typeof t && (e = this._fromString(t)), function t(e, i) {
                i = i || {};
                var n = e.attributes;
                if (n && n.length) for (var o = 0; o < n.length; o++) i[n[o].name] = n[o].value;
                for (var r, s = e.childNodes, o = 0; o < s.length; o++) 1 === s[o].nodeType && (i[r = s[o].tagName] ? ("function" != typeof i[r].push && (i[r] = [i[r]]), i[r].push(t(s[o], {}))) : i[r] = t(s[o], {}));
                return i
            }(e)
        }, o.prototype.serialize = function (t) {
            return n.jsonToXML(t)
        }, o.prototype.getFields = function (t) {
            return t
        }, o.prototype.getRows = function (t) {
            if ("string" == typeof t && (t = this._fromString(t)), t) {
                t = t.childNodes && t.childNodes[0] && t.childNodes[0].childNodes;
                return t && t.length ? this._getRows(t) : null
            }
            return []
        }, o.prototype._getRows = function (t) {
            for (var e = [], i = 0; i < t.length; i++) "item" === t[i].tagName && e.push(this._nodeToJS(t[i]));
            return e
        }, o.prototype._fromString = function (t) {
            try {
                return (new DOMParser).parseFromString(t, "text/xml")
            } catch (t) {
                return null
            }
        }, o.prototype._nodeToJS = function (t) {
            var e = {};
            if (this._haveAttrs(t)) for (var i = t.attributes, n = 0; n < i.length; n++) {
                var o = i[n], r = o.name, o = o.value;
                e[r] = this._toType(o)
            }
            if (3 === t.nodeType) return e.value = e.value || this._toType(t.textContent), e;
            var s = t.childNodes;
            if (s) for (n = 0; n < s.length; n++) {
                var a = s[n], l = a.tagName;
                l && ("items" === l && a.childNodes ? e[l] = this._getRows(a.childNodes) : this._haveAttrs(a) ? e[l] = this._nodeToJS(a) : e[l] = this._toType(a.textContent))
            }
            return e
        }, o.prototype._toType = function (t) {
            return "false" === t || "true" === t ? "true" === t : isNaN(t) ? t : Number(t)
        }, o.prototype._haveAttrs = function (t) {
            return t.attributes && t.attributes.length
        }, i = o;

        function o() {
        }

        e.XMLDriver = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = 4;

        function s(t) {
            return " ".repeat(t)
        }

        e.jsonToXML = function (t, e) {
            void 0 === e && (e = "root");
            for (var i = '<?xml version="1.0" encoding="iso-8859-1"?>\n<' + e + ">", n = 0; n < t.length; n++) i += "\n" + function e(t, i) {
                void 0 === i && (i = r);
                var n, o = s(i) + "<item>\n";
                for (n in t) Array.isArray(t[n]) ? (o += s(i + r) + "<" + n + ">\n", o += t[n].map(function (t) {
                    return e(t, i + 2 * r)
                }).join("\n") + "\n", o += s(i + r) + "</" + n + ">\n") : o += s(i + r) + ("<" + n + ">" + t[n]) + "</" + n + ">\n";
                return o += s(i) + "</item>"
            }(t[n]);
            return i + "\n</" + e + ">"
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = i(14), i = (n.prototype.sort = function (t, e, i) {
            this._createSorter(e), i === e && (e = null), (i || e) && this._sort(t, i, e)
        }, n.prototype._createSorter = function (i) {
            var n = this;
            i && !i.rule && (i.rule = function (t, e) {
                t = n._checkVal(i.as, t[i.by]), e = n._checkVal(i.as, e[i.by]);
                return o.naturalCompare(t.toString(), e.toString())
            })
        }, n.prototype._checkVal = function (t, e) {
            return t ? t.call(this, e) : e
        }, n.prototype._sort = function (t, n, o) {
            var r = this, s = {asc: 1, desc: -1};
            return t.sort(function (t, e) {
                var i = 0;
                return n && (i = n.rule.call(r, t, e) * (s[n.dir] || s.asc)), 0 === i && o && (i = o.rule.call(r, t, e) * (s[o.dir] || s.asc)), i
            })
        }, n);

        function n() {
        }

        e.Sort = i
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), r = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var u = i(1), s = i(46), a = i(18), d = i(14), f = i(13);

        function l(t, e, i, n) {
            void 0 !== n && -1 !== n && t[i] && t[i][n] ? t[i].splice(n, 0, e) : (t[i] || (t[i] = []), t[i].push(e))
        }

        var c, o = (c = s.DataCollection, o(h, c), h.prototype.add = function (t, i, n) {
            var o = this;
            return void 0 === i && (i = -1), void 0 === n && (n = this._root), "object" != typeof t && (t = {value: t}), Array.isArray(t) ? t.map(function (t, e) {
                return o._add(t, i, n, e)
            }) : this._add(t, i, n)
        }, h.prototype.getRoot = function () {
            return this._root
        }, h.prototype.getParent = function (t, e) {
            if (void 0 === e && (e = !1), !this._pull[t]) return null;
            t = this._pull[t].parent;
            return e ? this._pull[t] : t
        }, h.prototype.getItems = function (t) {
            return this._childs && this._childs[t] ? this._childs[t] : []
        }, h.prototype.getLength = function (t) {
            return void 0 === t && (t = this._root), this._childs[t] ? this._childs[t].length : null
        }, h.prototype.removeAll = function (t) {
            if (t) {
                if (this._childs[t]) for (var e = 0, i = r(this._childs[t]); e < i.length; e++) {
                    var n = i[e];
                    this.remove(n.id)
                }
            } else {
                c.prototype.removeAll.call(this);
                var o = this._root;
                this._initChilds = null, this._childs = ((t = {})[o] = [], t)
            }
        }, h.prototype.getIndex = function (e) {
            var t = this.getParent(e);
            return t && this._childs[t] ? u.findIndex(this._childs[t], function (t) {
                return t.id === e
            }) : -1
        }, h.prototype.sort = function (t) {
            var e = this;
            if (t) {
                for (var i in this._childs) this._sort.sort(this._childs[i], t);
                if (this._initChilds && Object.keys(this._initChilds).length) for (var i in this._initChilds) this._sort.sort(this._initChilds[i], t)
            } else if (this._childs = {}, this._parse_data(Object.keys(this._pull).map(function (t) {
                return e._pull[t]
            })), this._filters) for (var i in this._filters) {
                var n = this._filters[i];
                this.filter(n.rule, n.config)
            }
            this.events.fire(f.DataEvents.change)
        }, h.prototype.filter = function (t, e) {
            var n, o = this;
            void 0 === e && (e = {}), t ? (this._initChilds || (this._initChilds = this._childs), e.type = e.type || f.TreeFilterType.all, this._filters = {}, this._filters._ = {
                rule: t,
                config: e
            }, n = {}, this._recursiveFilter(t, e, this._root, 0, n), Object.keys(n).forEach(function (t) {
                for (var e = o.getParent(t), i = o.getItem(t); e;) n[e] || (n[e] = []), i && !n[e].find(function (t) {
                    return t.id === i.id
                }) && n[e].push(i), i = o.getItem(e), e = o.getParent(e)
            }), this._childs = n, this.events.fire(f.DataEvents.change)) : this.restoreOrder()
        }, h.prototype.restoreOrder = function () {
            this._initChilds && (this._childs = this._initChilds, this._initChilds = null), this.events.fire(f.DataEvents.change)
        }, h.prototype.copy = function (t, i, n, o) {
            var r = this;
            return void 0 === n && (n = this), void 0 === o && (o = this._root), t instanceof Array ? t.map(function (t, e) {
                return r._copy(t, i, n, o, e)
            }) : this._copy(t, i, n, o)
        }, h.prototype.move = function (t, i, n, o) {
            var r = this;
            return void 0 === n && (n = this), void 0 === o && (o = this._root), t instanceof Array ? t.map(function (t, e) {
                return r._move(t, i, n, o, e)
            }) : this._move(t, i, n, o)
        }, h.prototype.forEach = function (t, e, i) {
            if (void 0 === e && (e = this._root), void 0 === i && (i = 1 / 0), this.haveItems(e) && !(i < 1)) for (var n = this._childs[e], o = 0; o < n.length; o++) t.call(this, n[o], o, n), this.haveItems(n[o].id) && this.forEach(t, n[o].id, --i)
        }, h.prototype.eachChild = function (t, e, i, n) {
            if (void 0 === i && (i = !0), void 0 === n && (n = function () {
                return !0
            }), this.haveItems(t)) for (var o = 0; o < this._childs[t].length; o++) e.call(this, this._childs[t][o], o), i && n(this._childs[t][o]) && this.eachChild(this._childs[t][o].id, e, i, n)
        }, h.prototype.getNearId = function (t) {
            return t
        }, h.prototype.loadItems = function (e, i) {
            var n = this;
            void 0 === i && (i = "json");
            var t = this.config.autoload + "?id=" + e;
            new a.DataProxy(t).load().then(function (t) {
                t = (i = d.toDataDriver(i)).toJsonArray(t), n._parse_data(t, e), n.events.fire(f.DataEvents.change)
            })
        }, h.prototype.refreshItems = function (t, e) {
            void 0 === e && (e = "json"), this.removeAll(t), this.loadItems(t, e)
        }, h.prototype.eachParent = function (t, e, i) {
            void 0 === i && (i = !1);
            t = this.getItem(t);
            t && (i && e.call(this, t), t.parent !== this._root && (i = this.getItem(t.parent), e.call(this, i), this.eachParent(t.parent, e)))
        }, h.prototype.haveItems = function (t) {
            return t in this._childs
        }, h.prototype.canCopy = function (e, t) {
            if (e === t) return !1;
            var i = !0;
            return this.eachParent(t, function (t) {
                return t.id === e ? i = !1 : null
            }), i
        }, h.prototype.serialize = function (t, e) {
            void 0 === t && (t = f.DataDriver.json);
            e = this._serialize(this._root, e), t = d.toDataDriver(t);
            if (t) return t.serialize(e)
        }, h.prototype.getId = function (t, e) {
            if (void 0 === e && (e = this._root), this._childs[e] && this._childs[e][t]) return this._childs[e][t].id
        }, h.prototype.map = function (t, e, i) {
            void 0 === e && (e = this._root), void 0 === i && (i = !0);
            var n = [];
            if (!this.haveItems(e)) return n;
            for (var o, r = 0; r < this._childs[e].length; r++) n.push(t.call(this, this._childs[e][r], r, this._childs)), i && (o = this.map(t, this._childs[e][r].id, i), n = n.concat(o));
            return n
        }, h.prototype.getRawData = function (t, e, i, n, o) {
            o = (o = o || this._root) === this._root ? c.prototype.getRawData.call(this, t, e, this._childs[o]) : this._childs[o];
            return 2 === n ? this.flatten(o) : o
        }, h.prototype.flatten = function (t) {
            var i = this, n = [];
            return t.forEach(function (t) {
                n.push(t);
                var e = i._childs[t.id];
                e && t.$opened && (n = n.concat(i.flatten(e)))
            }), n
        }, h.prototype._add = function (t, e, i, n) {
            void 0 === e && (e = -1), void 0 === i && (i = this._root), t.parent = t.parent ? t.parent.toString() : i, 0 < n && -1 !== e && (e += 1);
            e = c.prototype._add.call(this, t, e);
            if (Array.isArray(t.items)) for (var o = 0, r = t.items; o < r.length; o++) {
                var s = r[o];
                this.add(s, -1, t.id)
            }
            return e
        }, h.prototype._copy = function (t, e, i, n, o) {
            if (void 0 === i && (i = this), void 0 === n && (n = this._root), !this.exists(t)) return null;
            var r = this._childs[t];
            if (o && (e = -1 === e ? -1 : e + o), i === this && !this.canCopy(t, n)) return null;
            o = d.copyWithoutInner(this.getItem(t), {items: !0});
            if (i.exists(t) && (o.id = u.uid()), d.isTreeCollection(i)) {
                if (this.exists(t) && (o.parent = n, i !== this && n === this._root && (o.parent = i.getRoot()), i.add(o, e), t = o.id), r) for (var s = 0, a = r; s < a.length; s++) {
                    var l = a[s].id, c = this.getIndex(l);
                    "string" == typeof t && this.copy(l, c, i, t)
                }
                return t
            }
            i.add(o, e)
        }, h.prototype._move = function (t, e, i, n, o) {
            if (void 0 === i && (i = this), void 0 === n && (n = this._root), !this.exists(t)) return null;
            if (o && (e = -1 === e ? -1 : e + o), i !== this) {
                if (!d.isTreeCollection(i)) return i.add(d.copyWithoutInner(this.getItem(t)), e), void this.remove(t);
                var r = this.copy(t, e, i, n);
                return this.remove(t), r
            }
            if (!this.canCopy(t, n)) return null;
            i = this.getParent(t), r = this.getIndex(t), r = this._childs[i].splice(r, 1)[0];
            return r.parent = n, this._childs[i].length || delete this._childs[i], this.haveItems(n) || (this._childs[n] = []), -1 === e ? e = this._childs[n].push(r) : this._childs[n].splice(e, 0, r), this.events.fire(f.DataEvents.change, [t, "update", this.getItem(t)]), t
        }, h.prototype._reset = function (t) {
            if (t) for (var e = 0, i = r(this._childs[t]); e < i.length; e++) {
                var n = i[e];
                this.remove(n.id)
            } else {
                c.prototype._reset.call(this);
                var o = this._root;
                this._initChilds = null, this._childs = ((t = {})[o] = [], t)
            }
        }, h.prototype._removeCore = function (e) {
            var t;
            this._pull[e] && (t = this.getParent(e), this._childs[t] = this._childs[t].filter(function (t) {
                return t.id !== e
            }), t === this._root || this._childs[t].length || delete this._childs[t], this._initChilds && this._initChilds[t] && (this._initChilds[t] = this._initChilds[t].filter(function (t) {
                return t.id !== e
            }), t === this._root || this._initChilds[t].length || delete this._initChilds[t]), this._fastDeleteChilds(this._childs, e), this._initChilds && this._fastDeleteChilds(this._initChilds, e))
        }, h.prototype._addToOrder = function (t, e, i) {
            var n = this._childs, o = this._initChilds, r = e.parent;
            this._pull[e.id] = e, c.prototype._addToOrder.call(this, t, e, i), l(n, e, r, i), o && l(o, e, r, i)
        }, h.prototype._parse_data = function (t, e) {
            void 0 === e && (e = this._root);
            for (var i = this._order.length, n = 0, o = t; n < o.length; n++) {
                var r = o[n];
                this.config.init && (r = this.config.init(r)), "object" != typeof r && (r = {value: r}), r.id = r.id ? r.id.toString() : u.uid(), r.parent = void 0 === r.parent || null === r.parent || r.parent && r.$items ? e : r.parent.toString(), this._pull[r.id] && d.dhxError("Item already exist"), this._pull[r.id] = r, this._order[i++] = r, this._childs[r.parent] || (this._childs[r.parent] = []), this._childs[r.parent].push(r), r.items && r.items instanceof Object && this._parse_data(r.items, r.id)
            }
        }, h.prototype._fastDeleteChilds = function (t, e) {
            if (this._pull[e] && delete this._pull[e], t[e]) {
                for (var i = 0; i < t[e].length; i++) this._fastDeleteChilds(t, t[e][i].id);
                delete t[e]
            }
        }, h.prototype._recursiveFilter = function (e, i, t, n, o) {
            var r = this, s = this._childs[t];
            if (s) {
                var a, l, c = function (t) {
                    switch (i.type) {
                        case f.TreeFilterType.all:
                            return !0;
                        case f.TreeFilterType.level:
                            return n === i.level;
                        case f.TreeFilterType.leafs:
                            return !r.haveItems(t.id)
                    }
                };
                "function" == typeof e ? (a = function (t) {
                    return c(t) && e(t)
                }, (l = s.filter(a)).length && (o[t] = l)) : e.by && e.match && (a = function (t) {
                    return c(t) && t[e.by] && -1 !== t[e.by].toString().toLowerCase().indexOf(e.match.toString().toLowerCase())
                }, (l = s.filter(a)).length && (o[t] = l));
                for (var u = 0, d = s; u < d.length; u++) {
                    var h = d[u];
                    this._recursiveFilter(e, i, h.id, n + 1, o)
                }
            }
        }, h.prototype._serialize = function (t, n) {
            var o = this;
            return void 0 === t && (t = this._root), this.map(function (t) {
                var e, i = {};
                for (e in t) "parent" === e || "items" === e || e.startsWith("$") || (i[e] = t[e]);
                return n && (i = n(i)), o.haveItems(t.id) && (i.items = o._serialize(t.id, n)), i
            }, t, !1)
        }, h);

        function h(t, e) {
            var i = c.call(this, t, e) || this;
            i._childs = {};
            e = i._root = t && t.rootId || "_ROOT_" + u.uid();
            return i._childs = ((t = {})[e] = [], t), i._initChilds = null, i
        }

        e.TreeCollection = o
    }, function (t, e, i) {
        "use strict";
        var v = this && this.__assign || function () {
            return (v = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var h = i(2), m = i(35), f = i(127), p = i(13), y = i(14);
        var n = (o.prototype.setItem = function (t, e) {
            f.collectionStore.setItem(t, e)
        }, o.prototype.onMouseDown = function (t, e, i) {
            var n, o, r, s;
            1 !== t.which && !t.targetTouches || (t.targetTouches ? (document.addEventListener("touchmove", this._onMouseMove, !1), document.addEventListener("touchend", this._onMouseUp, !1)) : (document.addEventListener("mousemove", this._onMouseMove), document.addEventListener("mouseup", this._onMouseUp)), o = (n = h.locateNode(t, "dhx_id")) && n.getAttribute("dhx_id"), r = h.locate(t, "dhx_widget_id"), e && e.includes(o) && 1 < e.length ? (this._transferData.source = e, this._itemsForGhost = i) : (this._transferData.source = [o], this._itemsForGhost = null), o && r && (e = (s = h.getBox(n)).left, i = s.top, s = (t.targetTouches ? t.targetTouches[0] : t).pageX, t = (t.targetTouches ? t.targetTouches[0] : t).pageY, this._transferData.initXOffset = s - e, this._transferData.initYOffset = t - i, this._transferData.x = s, this._transferData.y = t, this._transferData.componentId = r, this._transferData.start = o, this._transferData.item = n))
        }, o.prototype.isDrag = function () {
            return this._isDrag
        }, o.prototype._moveGhost = function (t, e) {
            this._transferData.ghost && (this._transferData.ghost.style.left = t - this._transferData.initXOffset + "px", this._transferData.ghost.style.top = e - this._transferData.initYOffset + "px")
        }, o.prototype._removeGhost = function () {
            document.body.removeChild(this._transferData.ghost)
        }, o.prototype._onDrop = function (t) {
            var e, i, n, o, r;
            this._canMove && (r = (o = this._transferData).start, i = o.source, e = o.target, n = o.dropComponentId, i = {
                start: r,
                source: i,
                target: e,
                dropPosition: o.dropPosition
            }, n = (o = f.collectionStore.getItem(n)) && o.config, o && "source" !== n.dragMode && o.events.fire(p.DragEvents.beforeDrop, [i, t]) && (o = {
                id: e,
                component: o
            }, r = {
                id: r,
                component: this._transferData.component
            }, this._move(r, o), o.component.events.fire(p.DragEvents.afterDrop, [i, t]))), this._endDrop(t)
        }, o.prototype._onDragStart = function (t, e, i) {
            var n = f.collectionStore.getItem(e), o = n.config, r = this._transferData,
                e = {start: r.start, source: r.source, target: r.target};
            if ("target" === o.dragMode) return null;
            r = function (t, e, i) {
                void 0 === i && (i = !1);
                var n = t.getBoundingClientRect(), o = document.createElement("div"), r = t.cloneNode(!0);
                return r.style.width = n.width + "px", r.style.height = n.height + "px", r.style.maxHeight = n.height + "px", r.style.fontSize = window.getComputedStyle(t.parentElement).fontSize, r.style.opacity = "0.8", r.style.fontSize = window.getComputedStyle(t.parentElement).fontSize, i && e && e.length || o.appendChild(r), e && e.length && e.forEach(function (t, e) {
                    t = t.cloneNode(!0);
                    t.style.width = n.width + "px", t.style.height = n.height + "px", t.style.maxHeight = n.height + "px", t.style.top = 12 * (e + 1) - n.height - n.height * e + "px", t.style.left = 12 * (e + 1) + "px", t.style.opacity = "0.6", t.style.zIndex = "" + (-e - 1), o.appendChild(t)
                }), o.className = "dhx_drag-ghost", o
            }(this._transferData.item, this._itemsForGhost, "column" === o.dragItem);
            return n.events.fire(p.DragEvents.beforeDrag, [e, i, r]) && t ? (n.events.fire(p.DragEvents.dragStart, [e, i]), this._isDrag = !0, this._toggleTextSelection(!0), this._transferData.component = n, this._transferData.dragConfig = o, r) : null
        }, o.prototype._onDrag = function (t) {
            var e = (t.targetTouches ? t.targetTouches[0] : t).clientX,
                i = (t.targetTouches ? t.targetTouches[0] : t).clientY, n = document.elementFromPoint(e, i),
                o = h.locate(n, "dhx_widget_id");
            if (o) {
                var r = f.collectionStore.getItem(o),
                    s = !!h.locateNodeByClassName(n, "dhx_grid-header") || !!h.locateNodeByClassName(n, "dhx_grid-footer"),
                    a = r.config.columns ? r.config : void 0,
                    l = a && ("complex" === a.dragItem || "column" === a.dragItem);
                if (!s || l) {
                    var c = h.locate(n, "dhx_id"), u = h.locate(n, "dhx_root_id");
                    if (!c && !u) return this._cancelCanDrop(t), this._transferData.dropComponentId = o, this._transferData.target = null, void this._canDrop(t);
                    var d = this._transferData, e = d.dropComponentId, i = d.start, a = d.source, s = d.target,
                        l = d.componentId, n = d.dropPosition;
                    if ("complex" === r.config.dropBehaviour) {
                        d = function (t) {
                            var e = t.clientY;
                            if (!(t = h.locateNode(t))) return null;
                            if (t = t.childNodes[0]) {
                                t = t.getBoundingClientRect();
                                return (e - t.top) / t.height
                            }
                        }(t);
                        this._transferData.dropPosition = d <= .25 ? "top" : .75 <= d ? "bottom" : "in"
                    } else if ((s === c || s === u) && e === o) return;
                    e = {id: i, component: this._transferData.component};
                    "source" !== r.config.dragMode && (e.component.events.fire(p.DragEvents.dragOut, [{
                        start: i,
                        source: a,
                        target: s
                    }, t]), o !== l || !y.isTreeCollection(e.component.data) || y.isTreeCollection(e.component.data) && e.component.data.canCopy(e.id, c) ? (this._cancelCanDrop(t), this._transferData.target = c || u, this._transferData.dropComponentId = o, e.component.events.fire(p.DragEvents.dragIn, [{
                        start: i,
                        source: a,
                        target: s,
                        dropPosition: n
                    }, t]) && this._canDrop(t)) : this._cancelCanDrop(t))
                } else this._canMove && this._cancelCanDrop(t)
            } else this._canMove && this._cancelCanDrop(t)
        }, o.prototype._move = function (i, e) {
            var n = i.component.data, o = e.component.data, r = 0, s = e.id,
                t = y.isTreeCollection(o) ? e.component.config.dropBehaviour : void 0,
                a = i.component.config.columns ? i.component.config : void 0,
                a = a && ("complex" === a.dragItem || "column" === a.dragItem) && a.columns.map(function (t) {
                    return t.id
                }).filter(function (t) {
                    return t === i.id || t === e.id
                }).length;
            if (a && i.component === e.component && i.id !== e.id) {
                var l = (u = (d = i.component).config.columns.map(function (t) {
                    return v({}, t)
                })).findIndex(function (t) {
                    return t.id === i.id
                }), c = u.findIndex(function (t) {
                    return t.id === e.id
                });
                return u.splice(c, 0, u.splice(l, 1)[0]), d.setColumns(u), void d.paint()
            }
            if (a && i.component instanceof m.ProGrid && e.component instanceof m.ProGrid) {
                var u, d = i.component, h = e.component, l = (u = d.config.columns.map(function (t) {
                    return v({}, t)
                })).findIndex(function (t) {
                    return t.id === i.id
                }), a = h.config.columns.map(function (t) {
                    return v({}, t)
                }), c = a.findIndex(function (t) {
                    return t.id === e.id
                }), f = 0 <= a.findIndex(function (t) {
                    return t.id === i.id
                }) ? i.id + "_copy" : i.id, p = [];
                d.data.forEach(function (t) {
                    var e;
                    p.push(((e = {})[f] = t[i.id], e))
                }), h.data.forEach(function (t, e) {
                    h.data.update(t.id, v(v({}, t), p[e]))
                });
                l = u.splice(l, 1)[0];
                return l.id = f, a.splice(c, 0, l), h.setColumns(a), h.paint(), d.setColumns(u), void d.paint()
            }
            var g = e.id === e.component.config.rootParent;
            switch (t) {
                case"child":
                    break;
                case"sibling":
                    s = o.getParent(s), r = o.getIndex(e.id) + 1;
                    break;
                case"complex":
                    var _ = this._transferData.dropPosition;
                    g ? (s = e.id, r = o.getLength()) : "top" === _ ? (s = o.getParent(s), r = o.getIndex(e.id)) : "bottom" === _ && (s = o.getParent(s), r = o.getIndex(e.id) + 1);
                    break;
                default:
                    r = e.id ? i.component === e.component && o.getIndex(i.id) < o.getIndex(e.id) ? o.getIndex(e.id) - 1 : o.getIndex(e.id) : -1
            }
            this._transferData.dragConfig.dragCopy ? this._transferData.source instanceof Array && 1 < this._transferData.source.length ? this._transferData.source.map(function (t) {
                n.copy(t, r, o, s), -1 < r && r++
            }) : n.copy(i.id, r, o, s) : this._transferData.source instanceof Array && 1 < this._transferData.source.length ? this._transferData.source.map(function (t) {
                n.move(t, r, o, s), -1 < r && r++
            }) : n.move(i.id, r, o, s)
        }, o.prototype._endDrop = function (t) {
            var e;
            this._toggleTextSelection(!1), this._transferData.component && (e = {
                start: (e = this._transferData).start,
                source: e.source,
                target: e.target
            }, this._transferData.component.events.fire(p.DragEvents.afterDrag, [e, t])), this._cancelCanDrop(t), this._canMove = !0, this._transferData = {}, this._transferData.target = null, this._transferData.dropComponentId = null
        }, o.prototype._cancelCanDrop = function (t) {
            this._canMove = !1, this._isDrag = !1;
            var e = this._transferData, i = e.start, n = e.source, o = e.target, e = e.dropComponentId,
                n = {start: i, source: n, target: o}, e = f.collectionStore.getItem(e);
            e && o && e.events.fire(p.DragEvents.cancelDrop, [n, t]), this._transferData.dropComponentId = null, this._transferData.target = null
        }, o.prototype._canDrop = function (t) {
            this._canMove = !0;
            var e = this._transferData,
                i = {start: e.start, source: e.source, target: e.target, dropPosition: e.dropPosition},
                e = f.collectionStore.getItem(this._transferData.dropComponentId);
            e && this._transferData.target && e.events.fire(p.DragEvents.canDrop, [i, t])
        }, o.prototype._toggleTextSelection = function (t) {
            t ? document.body.classList.add("dhx_no-select") : document.body.classList.remove("dhx_no-select")
        }, o);

        function o() {
            var a = this;
            this._transferData = {}, this._canMove = !0, this._isDrag = !1, this._onMouseMove = function (t) {
                if (a._transferData.start) {
                    var e = (t.targetTouches ? t.targetTouches[0] : t).pageX,
                        i = (t.targetTouches ? t.targetTouches[0] : t).pageY, n = a._transferData, o = n.x, r = n.y,
                        s = n.start, n = n.componentId;
                    if (!a._transferData.ghost) {
                        if (Math.abs(o - e) < 3 && Math.abs(r - i) < 3) return;
                        n = a._onDragStart(s, n, t);
                        if (!n) return void a._endDrop(t);
                        a._transferData.ghost = n, document.body.appendChild(a._transferData.ghost)
                    }
                    a._moveGhost(e, i), a._onDrag(t)
                }
            }, this._onMouseUp = function (t) {
                a._transferData.x && (a._transferData.ghost ? (a._removeGhost(), a._onDrop(t)) : a._endDrop(t), t.targetTouches ? (document.removeEventListener("touchmove", a._onMouseMove), document.removeEventListener("touchend", a._onMouseUp)) : (document.removeEventListener("mousemove", a._onMouseMove), document.removeEventListener("mouseup", a._onMouseUp)))
            }
        }

        i = window.dhxHelpers = window.dhxHelpers || {};
        i.dragManager = i.dragManager || new n, e.dragManager = i.dragManager
    }, function (t, e, i) {
        "use strict";
        var n = this && this.__assign || function () {
            return (n = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        }, a = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var v = i(11), l = i(7), o = i(1);
        r.prototype.xlsx = function (t) {
            return this._export(t)
        }, r.prototype.csv = function (t) {
            var e;
            void 0 === t && (t = {}), t = n({
                asFile: !0,
                rowDelimiter: "\n",
                columnDelimiter: ",",
                skipHeader: 0
            }, t), e = "getRoot" in this._view.data && t.flat ? this.getFlatCSV(t) : this._getCSV(t);
            var i = t.name || "grid_export";
            return t.asFile && o.downloadFile(e, i + ".csv", "text/csv"), e
        }, r.prototype._export = function (t) {
            void 0 === t && (t = {});
            for (var c = this._view.config.columns.filter(function (t) {
                return !t.hidden
            }), u = {}, e = v.transpose(c.map(function (t) {
                return t.header.map(function (t) {
                    return t.text || " "
                })
            })), d = [], h = {
                default: {
                    color: "#000000",
                    background: "#FFFFFF",
                    fontSize: 14
                }
            }, f = [], n = {}, i = this._view.data.serialize().map(function (i, t) {
                return u[i.id] = t, c.map(function (t, e) {
                    return n[t.id] = e, v.removeHTMLTags(i[t.id])
                })
            }), p = [], g = this._view.content, _ = this, o = 0, r = c; o < r.length; o++) !function (t) {
                var n, e, o, i, r;
                for (r in t.footer && (n = t.id, i = e = _._view.data.serialize().reduce(function (t, e) {
                    return void 0 === e[n] || "" === e[n] || isNaN(e[n]) || t.push(parseFloat(e[n])), t
                }, []), "tree" === _._view.config.type && (i = (o = _._view.data).serialize().reduce(function (t, e) {
                    var i;
                    return 0 === e.$level && (void 0 === e[n] || "" === e[n] || isNaN(e[n]) ? (i = 0, o.eachChild(e.id, function (t) {
                        o.haveItems(t.id) || (i += parseFloat(t[n]))
                    }), t.push(i)) : t.push(parseFloat(e[n]) || 0)), t
                }, [])), t.footer[0].content ? (i = g[t.footer[0].content].calculate(e, i), p.push(i)) : p.push(t.footer[0].css || t.footer[0].text || " ")), d.push({width: t.width}), t.$cellCss) {
                    var s, a = t.$cellCss[r], l = a.split("").reduce(function (t, e) {
                        e = (t << 5) - t + e.charCodeAt(0);
                        return Math.abs(e & e)
                    }, 0).toString();
                    h[l] || (s = document.body, (s = v.getStyleByClass(a, s, "dhx_grid-row", h.default)) && (h[l] = s)), h[l] && f.push([u[r], c.indexOf(t), l])
                }
            }(r[o]);
            p.length && i.push(p);
            var s, i = {name: t.name || "data", columns: d, header: e, data: i, styles: {cells: f, css: h}};
            return t.url && ((s = document.createElement("form")).setAttribute("target", "_blank"), s.setAttribute("action", t.url), s.setAttribute("method", "POST"), s.style.visibility = "hidden", (t = document.createElement("textarea")).setAttribute("name", "data"), t.value = JSON.stringify(i), s.appendChild(t), document.body.appendChild(s), s.submit(), setTimeout(function () {
                s.parentNode.removeChild(s)
            }, 100)), i
        }, r.prototype.getFlatCSV = function (o) {
            var e = this._view.data, t = e.getRoot(), r = this._view.config.columns[0], s = e.getMaxLevel(), i = "";
            e.eachChild(t, function (n) {
                var t = function (t, e) {
                    for (var i, n = [], o = 0; o <= s; o++) t && t[r.id] ? (n[t.$level] = t[r.id], t = (i = e.getParent(t.id, !0)) && i.id ? i : null) : n[o] = "";
                    return n
                }(n, e).join(o.columnDelimiter);
                i += t + Object.keys(n).reduce(function (t, e, i) {
                    return "id" === e || "parent" === e || e.startsWith("$") || 0 === i ? t : t + o.columnDelimiter + (null === n[e] ? "" : n[e])
                }, ""), i += o.rowDelimiter
            });
            var t = this._export(o), n = function (t, e) {
                for (var i = 0; i < t.length; i++) t[i] = e;
                return t
            }(new Array(s + 1), ""), t = t.header.map(function (t) {
                return t.splice.apply(t, a([0, 1], n)), t
            });
            return new l.CsvDriver(o).serialize(t, !0) + o.rowDelimiter + i
        }, r.prototype._getCSV = function (t) {
            var e = this._export(t), i = e.header, t = new l.CsvDriver(t);
            return t.serialize(i, !0) + "\n" + t.serialize(e.data, !0)
        }, i = r;

        function r(t) {
            this._view = t
        }

        e.Exporter = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var h = i(0), r = i(1), o = i(7), n = i(5), f = i(4), i = (s.prototype.setCell = function (e, i, t, n) {
            var o, r, s, a, l, c, u, d = this;
            void 0 === t && (t = !1), void 0 === n && (n = !1), this.config.disabled || this._grid.config.$editable || !this._multiselection && this._oldSelectedCell && this._oldSelectedCell.row.id === (e && e.id || e) && this._oldSelectedCell.column.id === (i && i.id || i) || this._multiselection && 1 === this._selectedCells.length && this._selectedCells[0].row.id === (e && e.id || e) && this._selectedCells[0].column.id === (i && i.id || i) || ((!this._multiselection || t || n) && this._multiselection || this._selectedCells.length && this._removeCells(), this._multiselection && "cell" === this._type && this._selectedCells.find(function (t) {
                return t.row.id === (e && e.id || e) && t.column.id === (i && i.id || i)
            }) ? this.removeCell(e && e.id || e, i && i.id || i) : (l = this._oldSelectedCell || void 0, e = this._grid.data.getItem(e && e.id || e), o = this._grid.config.columns.filter(function (t) {
                return !t.hidden
            }), i = i || o[0], (i = this._grid.getColumn(i.id || i)) && e && (i = i.id ? i : this._grid.getColumn(i), this.events.fire(f.GridSelectionEvents.beforeSelect, [e, i]) && (this._selectedCell = {
                row: e,
                column: i
            }, this.events.fire(f.GridSelectionEvents.afterSelect, [e, i]), this._multiselection && n && l ? this._oldSelectedCell = l : this._oldSelectedCell = this._selectedCell, this._multiselection ? n && !t && 0 < this._selectedCells.length ? (r = this._grid.data.getIndex(this._oldSelectedCell.row.id), (s = this._grid.data.getIndex(e.id)) < r && (a = r, r = s, s = a), this._selectedCells = [this._oldSelectedCell], "cell" === this._type ? (l = (c = o.map(function (t) {
                return t.id
            })).indexOf(l.column.id), c = c.indexOf(i.id), -1 !== l && -1 !== c && (c < l && (a = l, l = c, c = a), u = o.slice(l, c + 1), this._grid.data.mapRange(r, s, function (e) {
                u.forEach(function (t) {
                    t = {row: e, column: t};
                    -1 === d._findIndex(t) && d._selectedCells.push(t)
                })
            }))) : this._grid.data.mapRange(r, s, function (t) {
                t = {row: t, column: i};
                -1 === d._findIndex(t) && d._selectedCells.push(t)
            })) : t && !n ? -1 === (n = this._findIndex()) ? this._selectedCells.push({
                row: this._selectedCell.row,
                column: this._selectedCell.column
            }) : 1 < this._selectedCells.length && this._selectedCells.splice(n, 1) : this._selectedCells = [this._selectedCell] : this._selectedCells = [this._selectedCell], h.awaitRedraw().then(function () {
                d._grid.paint()
            })))))
        }, s.prototype.getCell = function () {
            return this._selectedCell
        }, s.prototype.getCells = function () {
            return this._selectedCells
        }, s.prototype.toHTML = function () {
            var n = this;
            if (!this._isUnselected()) {
                if (this._multiselection) {
                    var o = [];
                    return this._selectedCells.forEach(function (t, e, i) {
                        o.push(n._toHTML(t.row, t.column, e === i.length - 1 || "cell" === n._type))
                    }), o
                }
                return this._toHTML(this._selectedCell.row, this._selectedCell.column, !0)
            }
        }, s.prototype.disable = function () {
            this.removeCell(), this.config.disabled = !0, this._grid.paint()
        }, s.prototype.enable = function () {
            this.config.disabled = !1, this._grid.paint()
        }, s.prototype.removeCell = function (i, n) {
            var t, o = this;
            i && n && "cell" === this._type ? (t = this._selectedCells.find(function (t) {
                var e = t.row, t = t.column;
                return e.id === i && t.id === n
            })) && this._removeCell(t.row, t.column) : i ? this._selectedCells.filter(function (t) {
                return t.row.id === i
            }).forEach(function (t) {
                var e = t.row, t = t.column;
                o._removeCell(e, t)
            }) : this._removeCells(), h.awaitRedraw().then(function () {
                o._grid.paint()
            })
        }, s.prototype._removeCell = function (e, i) {
            var t;
            e && i && e.id && i.id && this.events.fire(f.GridSelectionEvents.beforeUnSelect, [e, i]) && (t = this._selectedCells.findIndex(function (t) {
                return t.row.id === e.id && t.column.id === i.id
            }), this._selectedCells.splice(t, 1), this._selectedCell && i.id === this._selectedCell.column.id && e.id === this._selectedCell.row.id && (this._selectedCell = this._selectedCells[this._selectedCells.length - 1] || void 0), this.events.fire(f.GridSelectionEvents.afterUnSelect, [e, i]))
        }, s.prototype._removeCells = function () {
            var e = this;
            this._selectedCells.forEach(function (t) {
                e._removeCell(t && t.row, t && t.column)
            }), this._selectedCells.length && this._removeCells()
        }, s.prototype._init = function () {
            var n = this;
            this._grid.events.on(f.GridEvents.cellClick, function (t, e, i) {
                n.setCell(t, e, i.ctrlKey || i.metaKey, i.shiftKey)
            }), this._grid.data.events.on(o.DataEvents.beforeRemove, function (t) {
                var e;
                t && n._selectedCell && n._selectedCell.row && (e = n._grid.data.getIndex(String(n._selectedCell.row.id)), (t = n._grid.data.getId(e + 1)) ? n.setCell(t) : (e = n._grid.data.getId(e - 1)) && n.setCell(e), n._grid.paint())
            })
        }, s.prototype._toHTML = function (t, e, i) {
            void 0 === i && (i = !1);
            var n, o = this._grid.config.columns.filter(function (t) {
                return !t.hidden
            }), r = this._grid.config.leftSplit ? o.slice(0, this._grid.config.leftSplit) : [], s = r.map(function (t) {
                return t.id
            }), a = r.reduce(function (t, e) {
                return t + e.$width
            }, 0), l = this._grid.getCellRect(t.id, e.id), o = this._grid.getScrollState();
            s.includes(e.id) && i && (n = h.el(".dhx_grid-selected-cell", {
                style: {
                    width: this._grid.config.leftSplit === s.indexOf(e.id) + 1 ? l.width - 1 : l.width,
                    height: l.height,
                    top: l.y,
                    left: l.x + o.x,
                    position: "absolute",
                    zIndex: 10
                }
            }));
            t = r.length && a > l.x - o.x, s = l.width;
            t && (s -= a - (l.x - o.x));
            e = this._grid.config.$totalWidth;
            return h.el(".dhx_grid-selection", {style: {zIndex: n || "row" === this._grid.config.selection || "complex" === this._grid.config.selection ? 20 : 10}}, [("row" === this._type || "complex" === this._type) && h.el(".dhx_grid-selected-row", {
                style: {
                    width: r.length ? e - o.x : e,
                    height: l.height - 1,
                    top: l.y,
                    left: r.length ? o.x : 0,
                    position: "absolute"
                }
            }), ("cell" === this._type || "complex" === this._type) && n || ("cell" === this._type || "complex" === this._type) && i && h.el(".dhx_grid-selected-cell", {
                style: {
                    width: s,
                    height: l.height - 1,
                    top: l.y,
                    left: t ? a + o.x : l.x,
                    position: "absolute",
                    display: 0 < s ? "flex" : "none",
                    borderLeft: t ? "none" : null
                }
            })])
        }, s.prototype._isUnselected = function () {
            return !this._selectedCell || !this._selectedCell.row || !this._selectedCell.column || 0 === this._selectedCells.length
        }, s.prototype._findIndex = function (i) {
            var n = this;
            void 0 === i && (i = this._selectedCell);
            var o = -1;
            return this._selectedCells.some(function (t, e) {
                if ("cell" === n._type) {
                    if (r.compare(t.row, i.row) && r.compare(t.column, i.column)) return o = e, !0
                } else if ("row" === n._type && r.compare(t.row, i.row)) return o = e, !0
            }), o
        }, s);

        function s(t, e, i) {
            this._grid = t, this.config = e, this._selectedCell = void 0, this._oldSelectedCell = void 0, this._selectedCells = [], this._type = ["cell", "row", "complex"].includes(this._grid.config.selection) ? this._grid.config.selection : "complex", this._multiselection = t.config.multiselection && "complex" !== this._type, this.events = i || new n.EventSystem(this), this._init()
        }

        e.Selection = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var o, r = i(4), s = i(96), a = i(97), l = i(98), c = i(112), u = i(113), d = i(121),
            h = {cell: {row: null, col: null}, editor: null, gridId: null};
        e.getEditor = function (t, e, i) {
            var n = "boolean" === e.type ? "checkbox" : i.$editable.editorType;
            if (void 0 === n && (n = i.autoHeight ? "textarea" : "input"), h.cell.row === t.id && h.cell.col === e.id && h.gridId === i.gridId) return h.editor;
            switch ("checkbox" !== n && (h = {
                cell: {row: t.id, col: e.id},
                editor: h.editor,
                gridId: i.gridId
            }), o || (o = function () {
                h = {cell: {row: null, col: null}, editor: null, gridId: null}
            }, i.events.on(r.GridEvents.afterEditEnd, o)), n) {
                case"input":
                    return h.editor = new s.InputEditor(t, e, i);
                case"textarea":
                    return h.editor = new d.TextAreaEditor(t, e, i);
                case"select":
                    return h.editor = new a.SelectEditor(t, e, i);
                case"datePicker":
                    return h.editor = new l.DateEditor(t, e, i);
                case"checkbox":
                    return new c.CheckboxEditor(t, e, i);
                case"combobox":
                    return h.editor = new u.ComboboxEditor(t, e, i);
                default:
                    return h.editor = new s.InputEditor(t, e, i)
            }
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(0), o = i(4), r = i(1), i = (s.prototype.endEdit = function (t) {
            var e;
            t || (e = this._input.value), this._config.events.fire(o.GridEvents.beforeEditEnd, [e, this._cell.row, this._cell.col]) ? (this._input.removeEventListener("blur", this._handlers.onBlur), this._input.removeEventListener("change", this._handlers.onChange), "string" !== this._cell.col.type && r.isNumeric(e) && (e = parseFloat(e)), this._cell.row = this._config.datacollection.getItem(this._cell.row.id), this._config.events.fire(o.GridEvents.afterEditEnd, [e, this._cell.row, this._cell.col])) : this._input.focus()
        }, s.prototype.toHTML = function () {
            var t = this._cell.row[this._cell.col.id];
            return this._input && (t = this._input.value), this._config.$editable.editor = this, n.el("input.dhx_cell-editor.dhx_cell-editor__input", {
                _hooks: {didInsert: this._handlers.didInsert},
                _key: "cell_editor",
                dhx_id: "cell_editor",
                value: t
            })
        }, s.prototype._initHandlers = function () {
            var e = this;
            this._handlers = {
                onBlur: function () {
                    e.endEdit()
                }, onChange: function () {
                    e.endEdit()
                }, didInsert: function (t) {
                    t = t.el;
                    (e._input = t).focus(), t.setSelectionRange(0, t.value.length), t.addEventListener("change", e._handlers.onChange), t.addEventListener("blur", e._handlers.onBlur)
                }
            }
        }, s);

        function s(t, e, i) {
            this._config = i, this._cell = {row: t, col: e}, this._initHandlers()
        }

        e.InputEditor = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(0), o = i(4), i = (r.prototype.endEdit = function (t) {
            var e;
            t || (e = this._input.value), this._config.events.fire(o.GridEvents.beforeEditEnd, [e, this._cell.row, this._cell.col]) ? (this._input.removeEventListener("blur", this._handlers.onBlur), this._cell.row = this._config.datacollection.getItem(this._cell.row.id), this._config.events.fire(o.GridEvents.afterEditEnd, [e, this._cell.row, this._cell.col])) : this._input.focus()
        }, r.prototype.toHTML = function () {
            var t = this._cell.col.options || [], e = this._cell.row[this._cell.col.id];
            this._input && (e = this._input.options[this._input.selectedIndex].value);
            t = t.map(function (t) {
                return n.el("option", {selected: t === e}, t)
            });
            return this._config.$editable.editor = this, n.el("select.dhx_cell-editor.dhx_cell-editor__select", {
                _hooks: {didInsert: this._handlers.didInsert},
                _key: "cell_editor",
                dhx_id: "cell_editor"
            }, t)
        }, r.prototype._initHandlers = function () {
            var e = this;
            this._handlers = {
                onBlur: function () {
                    e.endEdit()
                }, didInsert: function (t) {
                    t = t.el;
                    (e._input = t).focus(), t.addEventListener("blur", e._handlers.onBlur)
                }
            }
        }, r);

        function r(t, e, i) {
            this._config = i, this._cell = {row: t, col: e}, this._initHandlers()
        }

        e.SelectEditor = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(0), o = i(4), r = i(99), s = i(24), a = i(20), i = (l.prototype.endEdit = function (t, e) {
            if (this._handlers) {
                var i = this._calendar.config.dateFormat, n = this._cell.row[this._cell.col.id];
                if (!t) {
                    if (n instanceof Date || e) return this._value = this._calendar.getValue(), this._input.value = this._value, void this._popup.hide();
                    s.stringToDate(this._input.value, i, !0) && this._input.value.length === n.length && (this._value = this._input.value)
                }
                this._config.events.fire(o.GridEvents.beforeEditEnd, [this._value, this._cell.row, this._cell.col]) ? (this._input.removeEventListener("focus", this._handlers.onFocus), this._input.removeEventListener("change", this._handlers.onChange), document.removeEventListener("mousedown", this._handlers.onOuterClick), this._popup.destructor(), this._calendar.destructor(), this._cell.row = this._config.datacollection.getItem(this._cell.row.id), this._config.events.fire(o.GridEvents.afterEditEnd, [this._value, this._cell.row, this._cell.col])) : this._input.focus()
            }
        }, l.prototype.toHTML = function () {
            var t = this._cell.row[this._cell.col.id];
            return this._config.$editable.editor = this, document.addEventListener("mousedown", this._handlers.onOuterClick), n.el("input.dhx_cell-editor.dhx_cell-editor__input.dhx_cell-editor__datepicker", {
                _hooks: {didInsert: this._handlers.didInsert},
                _key: "cell_editor",
                dhx_id: "cell_editor",
                value: t
            })
        }, l.prototype._initHandlers = function () {
            var i = this;
            this._handlers = {
                onFocus: function () {
                    n.awaitRedraw().then(function () {
                        i._popup.show(i._input, {centering: !0, mode: "bottom"})
                    })
                }, onChange: function () {
                    i.endEdit()
                }, onOuterClick: function (t) {
                    var e;
                    t.target instanceof Node && (e = i._input && i._input.contains(t.target), t = i._popup && i._popup.getRootNode() && i._popup.getRootNode().contains(t.target), e || t || i._popup.hide())
                }, didInsert: function (t) {
                    t = t.el;
                    i._input = t, i._input.addEventListener("focus", i._handlers.onFocus), i._input.addEventListener("change", i._handlers.onChange), t.focus(), t.setSelectionRange(t.value.length, t.value.length)
                }
            }
        }, l);

        function l(t, e, i) {
            var n = this;
            this._config = i, this._cell = {
                row: t,
                col: e
            }, this._calendar = new r.Calendar(null, {dateFormat: e.format});
            t = this._cell.row[this._cell.col.id], e = this._calendar.config.dateFormat;
            (s.stringToDate(t, e, !0) || t instanceof Date) && (this._calendar.setValue(t), this._value = this._calendar.getValue(), this._cell.row[this._cell.col.id] = this._value), this._popup = new a.Popup({css: "dhx_widget--bordered"}), this._popup.attach(this._calendar), this._calendar.events.on(r.CalendarEvents.change, function () {
                n.endEdit(!1, !0)
            }), this._popup.events.on(a.PopupEvents.afterHide, function () {
                n.endEdit()
            }), this._initHandlers()
        }

        e.DateEditor = i
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(100)), n(e(55))
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), f = this && this.__assign || function () {
            return (f = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        }, p = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r, s = i(1), g = i(0), a = i(5), l = i(6), c = i(101), u = i(111), _ = i(24), d = i(55),
            o = (r = l.View, o(h, r), h.prototype.setValue = function (t) {
                if (!t || t instanceof Array && 0 === t.length) return !1;
                this._selected = [];
                var e = t instanceof Array ? t[0] : t, i = _.DateHelper.toDateObject(e, this.config.dateFormat),
                    e = _.DateHelper.copy(this._getSelected());
                return !!this.events.fire(d.CalendarEvents.beforeChange, [i, e, !1]) && (this._setSelected(t), this._timepicker && (this._timepicker.setValue(i), this._time = this._timepicker.getValue()), this.showDate(this._getSelected()), this.events.fire(d.CalendarEvents.change, [i, e, !1]), this.paint(), !0)
            }, h.prototype.getValue = function (t) {
                var e = this;
                return void 0 === t && (t = !1), this._selected[0] ? this.config.range ? t ? this._selected.map(function (t) {
                    return _.DateHelper.copy(t)
                }) : this._selected.map(function (t) {
                    return _.getFormattedDate(e.config.dateFormat, t)
                }) : t ? _.DateHelper.copy(this._selected[0]) : _.getFormattedDate(this.config.dateFormat, this._selected[0]) : ""
            }, h.prototype.getCurrentMode = function () {
                return this._currentViewMode
            }, h.prototype.showDate = function (t, e) {
                t && (this._currentDate = _.DateHelper.copy(t)), e && (this._currentViewMode = e), this.paint()
            }, h.prototype.destructor = function () {
                this._linkedCalendar && this._unlink(), this._timepicker && this._timepicker.destructor(), this.events && this.events.clear(), this.config = this.events = null, this._uid = this._selected = this._currentDate = this._currentViewMode = this._handlers = this._timepicker = this._time = null, this.unmount()
            }, h.prototype.clear = function () {
                var t = this.getValue(!0);
                this.config.timePicker && (this._timepicker.clear(), this._time = this._timepicker.getValue()), this._selected = [], this.showDate(null, this.config.mode), this.events.fire(d.CalendarEvents.change, [this.getValue(!0), t, !1])
            }, h.prototype.link = function (t) {
                var e = this;
                this._linkedCalendar && this._unlink(), this._linkedCalendar = t;
                var i = this.getValue(!0), n = t.getValue(!0), o = i && _.DateHelper.dayStart(i),
                    r = n && _.DateHelper.dayStart(n);
                this.config.$rangeMark && this._linkedCalendar.config.$rangeMark || (this.config.$rangeMark = this._linkedCalendar.config.$rangeMark = function (t) {
                    if (o && r) return o <= t && t <= r && function (t) {
                        if (_.DateHelper.isSameDay(r, o)) return null;
                        var e = "dhx_calendar-day--in-range";
                        return _.DateHelper.isSameDay(t, o) && (e += " dhx_calendar-day--first-date"), _.DateHelper.isSameDay(t, r) && (e += " dhx_calendar-day--last-date"), e
                    }(t)
                }), this.config.disabledDates && this._linkedCalendar.config.disabledDates || (this.config.disabledDates = function (t) {
                    if (r) return r < t
                }, this._linkedCalendar.config.disabledDates = function (t) {
                    if (o) return t < o
                }), this.config.thisMonthOnly = !0, t.config.thisMonthOnly = !0, this.events.on(d.CalendarEvents.change, function (t) {
                    o = _.DateHelper.dayStart(t), e._linkedCalendar.paint()
                }, "link"), this._linkedCalendar.events.on(d.CalendarEvents.change, function (t) {
                    r = _.DateHelper.dayStart(t), e.paint()
                }, "link"), this._linkedCalendar.paint(), this.paint()
            }, h.prototype._unlink = function () {
                this._linkedCalendar && (this.config.$rangeMark = this._linkedCalendar.config.$rangeMark = null, this.config.disabledDates = this._linkedCalendar.config.disabledDates = null, this.events.detach(d.CalendarEvents.change, "link"), this._linkedCalendar.events.detach(d.CalendarEvents.change, "link"), this._linkedCalendar.paint(), this.paint(), this._linkedCalendar = null)
            }, h.prototype._setSelected = function (t) {
                var i, n = this, e = t instanceof Array ? t[0] : t,
                    e = _.DateHelper.toDateObject(e, this.config.dateFormat);
                t instanceof Array && this.config.range ? (i = [], t.forEach(function (t, e) {
                    e < 2 && i.push(_.DateHelper.toDateObject(t, n.config.dateFormat))
                }), 2 === i.length && i[0] < i[1] ? i.forEach(function (t) {
                    return n._selected.push(t)
                }) : this._selected[0] = i[0]) : this._selected[0] = e
            }, h.prototype._getSelected = function () {
                return this._selected[this._selected.length - 1]
            }, h.prototype._draw = function () {
                switch (this._currentViewMode) {
                    case"calendar":
                        return this.events.fire(d.CalendarEvents.modeChange, ["calendar"]), this._drawCalendar();
                    case"month":
                        return this.events.fire(d.CalendarEvents.modeChange, ["month"]), this._drawMonthSelector();
                    case"year":
                        return this.events.fire(d.CalendarEvents.modeChange, ["year"]), this._drawYearSelector();
                    case"timepicker":
                        return this.events.fire(d.CalendarEvents.modeChange, ["timepicker"]), this._drawTimepicker()
                }
            }, h.prototype._initHandlers = function () {
                var s = this;
                this._handlers = {
                    onclick: {
                        ".dhx_calendar-year, .dhx_calendar-month, .dhx_calendar-day": function (t, e) {
                            var i = e.attrs._date, n = _.DateHelper.copy(s._getSelected());
                            switch (s._currentViewMode) {
                                case"calendar":
                                    var o = s.config.timePicker ? _.DateHelper.mergeHoursAndMinutes(i, s._getSelected() || s._currentDate) : i;
                                    if (!s.events.fire(d.CalendarEvents.beforeChange, [o, n, !0])) return;
                                    s.config.range && 1 === s._selected.length && s._selected[0] < o ? s._selected.push(o) : (s._selected = [], s._selected[0] = o), s.showDate(s._getSelected()), s.events.fire(d.CalendarEvents.change, [i, n, !0]);
                                    break;
                                case"month":
                                    if ("month" !== s.config.mode) _.DateHelper.setMonth(s._currentDate, i), s.showDate(null, "calendar"), s.events.fire(d.CalendarEvents.monthSelected, [i]); else {
                                        var r = _.DateHelper.fromYearAndMonth(s._currentDate.getFullYear() || s._getSelected().getFullYear(), i);
                                        if (!s.events.fire(d.CalendarEvents.beforeChange, [r, n, !0])) return;
                                        s._currentDate = r, s._selected[0] = r, s.events.fire(d.CalendarEvents.change, [s._getSelected(), n, !0]), s.events.fire(d.CalendarEvents.monthSelected, [i]), s.paint()
                                    }
                                    break;
                                case"year":
                                    if ("year" !== s.config.mode) _.DateHelper.setYear(s._currentDate, i), s.showDate(null, "month"), s.events.fire(d.CalendarEvents.yearSelected, [i]); else {
                                        r = _.DateHelper.fromYear(i);
                                        if (!s.events.fire(d.CalendarEvents.beforeChange, [r, n, !0])) return;
                                        s._currentDate = r, s._selected[0] = r, s.events.fire(d.CalendarEvents.change, [s._getSelected(), n, !0]), s.events.fire(d.CalendarEvents.yearSelected, [i]), s.paint()
                                    }
                            }
                        }, ".dhx_calendar-action__cancel": function () {
                            s.showDate(s._getSelected(), "calendar"), s.events.fire(d.CalendarEvents.cancelClick, [])
                        }, ".dhx_calendar-action__show-month": function () {
                            return s.showDate(null, "month")
                        }, ".dhx_calendar-action__show-year": function () {
                            return s.showDate(null, "year")
                        }, ".dhx_calendar-action__next": function () {
                            var t;
                            switch (s._currentViewMode) {
                                case"calendar":
                                    t = _.DateHelper.addMonth(s._currentDate, 1);
                                    break;
                                case"month":
                                    t = _.DateHelper.addYear(s._currentDate, 1);
                                    break;
                                case"year":
                                    t = _.DateHelper.addYear(s._currentDate, 12)
                            }
                            s.showDate(t)
                        }, ".dhx_calendar-action__prev": function () {
                            var t;
                            switch (s._currentViewMode) {
                                case"calendar":
                                    t = _.DateHelper.addMonth(s._currentDate, -1);
                                    break;
                                case"month":
                                    t = _.DateHelper.addYear(s._currentDate, -1);
                                    break;
                                case"year":
                                    t = _.DateHelper.addYear(s._currentDate, -12)
                            }
                            s.showDate(t)
                        }, ".dhx_calendar-action__show-timepicker": function () {
                            s._currentViewMode = "timepicker", s.paint()
                        }
                    }, onmouseover: {
                        ".dhx_calendar-day": function (t, e) {
                            s.events.fire(d.CalendarEvents.dateMouseOver, [new Date(e.attrs._date), t]), s.events.fire(d.CalendarEvents.dateHover, [new Date(e.attrs._date), t])
                        }
                    }
                }
            }, h.prototype._getData = function (r) {
                for (var s = this, t = "monday" === this.config.weekStart ? 1 : 0, e = [], i = 6, a = _.DateHelper.weekStart(_.DateHelper.monthStart(r), t); i--;) {
                    for (var n = _.DateHelper.getWeekNumber(a), l = 0, o = 7, c = [], u = function () {
                        var t, e = _.DateHelper.isWeekEnd(a), i = r.getMonth() === a.getMonth(),
                            n = d.config.disabledDates && d.config.disabledDates(a), o = [];
                        d.config.range && d._selected[0] && d._selected[1] && (t = function () {
                            if (s._selected[0] && s._selected[1]) {
                                var t = _.DateHelper.dayStart(s._selected[0]),
                                    e = _.DateHelper.dayStart(s._selected[1]);
                                return t <= a && a <= e && (_.DateHelper.isSameDay(s._selected[0], s._selected[1]) ? null : "dhx_calendar-day--in-range")
                            }
                        }, d.config.$rangeMark = t), e && i && o.push("dhx_calendar-day--weekend"), i || (d.config.thisMonthOnly ? (l++, o.push("dhx_calendar-day--hidden")) : o.push("dhx_calendar-day--muffled")), !d.config.mark || (i = d.config.mark(a)) && o.push(i), d.config.$rangeMark && (t = d.config.$rangeMark(a)) && o.push(t), n && (e ? o.push("dhx_calendar-day--weekend-disabled") : o.push("dhx_calendar-day--disabled")), d._selected.forEach(function (t, e) {
                            t && _.DateHelper.isSameDay(t, a) && (t = "dhx_calendar-day--selected", s.config.range && (t += " dhx_calendar-day--selected-" + (0 === e ? "first " : "last")), o.push(t))
                        }), c.push({date: a, day: a.getDate(), css: o.join(" ")}), a = _.DateHelper.addDay(a)
                    }, d = this; o--;) u();
                    e.push({weekNumber: n, days: c, disabledWeekNumber: 7 === l})
                }
                return e
            }, h.prototype._drawCalendar = function () {
                for (var t, e = this._currentDate, i = this.config, n = i.weekStart, o = i.thisMonthOnly, r = i.css, s = i.timePicker, i = i.width, n = ("monday" === n ? p(_.locale.daysShort.slice(1), [_.locale.daysShort[0]]) : _.locale.daysShort).map(function (t) {
                    return g.el(".dhx_calendar-weekday", t)
                }), a = [], l = [], c = 0, u = this._getData(e); c < u.length; c++) {
                    var d = u[c], h = d.days.map(function (t) {
                        return g.el("div.dhx_calendar-day", {class: t.css, _date: t.date, tabIndex: 1}, t.day)
                    });
                    !this.config.weekNumbers || d.disabledWeekNumber && o || l.push(g.el("div", {class: "dhx_calendar-week-number"}, d.weekNumber)), a = a.concat(h)
                }
                this.config.weekNumbers && (t = g.el(".dhx_calendar__week-numbers", l));
                r = "dhx_calendar dhx_widget" + (r ? " " + r : "") + (s ? " dhx_calendar--with_timepicker" : "") + (this.config.weekNumbers ? " dhx_calendar--with_week-numbers" : "");
                return g.el("div", f({
                    class: r,
                    style: {width: this.config.weekNumbers ? "calc(" + i + " + 48px )" : i}
                }, this._handlers), [g.el(".dhx_calendar__wrapper", [this._drawHeader(g.el("button.dhx_calendar-action__show-month.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--circle", _.locale.months[e.getMonth()] + " " + e.getFullYear())), this.config.weekNumbers && g.el(".dhx_calendar__dates-wrapper", [g.el(".dhx_calendar__weekdays", n), g.el(".dhx_calendar__days", a), t]), !this.config.weekNumbers && g.el(".dhx_calendar__weekdays", n), !this.config.weekNumbers && g.el(".dhx_calendar__days", a), s ? g.el(".dhx_timepicker__actions", [g.el("button.dhx_calendar__timepicker-button.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--width_full.dhx_button--circle.dhx_calendar-action__show-timepicker", [g.el("span.dhx_button__icon.dxi.dxi-clock-outline"), g.el("span.dhx_button__text", this._time)])]) : null])])
            }, h.prototype._drawMonthSelector = function () {
                var i = this._currentDate, n = i.getMonth(),
                    o = this._getSelected() ? this._getSelected().getFullYear() : null, t = this.config, e = t.css,
                    r = t.timePicker, s = t.weekNumbers, a = t.width, t = t.mode,
                    r = "dhx_calendar dhx_widget" + (e ? " " + e : "") + (r ? " dhx_calendar--with_timepicker" : "") + (s ? " dhx_calendar--with_week-numbers" : "");
                return g.el("div", f({
                    class: r,
                    style: {width: s ? "calc(" + a + " + 48px)" : a}
                }, this._handlers), [g.el(".dhx_calendar__wrapper", [this._drawHeader(g.el("button.dhx_calendar-action__show-year.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--circle", i.getFullYear())), g.el(".dhx_calendar__months", _.locale.monthsShort.map(function (t, e) {
                    return g.el("div", {
                        class: "dhx_calendar-month" + (n === e && o === i.getFullYear() ? " dhx_calendar-month--selected" : ""),
                        tabIndex: 1,
                        _date: e
                    }, t)
                })), "month" !== t ? g.el(".dhx_calendar__actions", [g.el("button.dhx_button.dhx_button--color_primary.dhx_button--view_link.dhx_button--size_small.dhx_button--width_full.dhx_button--circle.dhx_calendar-action__cancel", _.locale.cancel)]) : null])])
            }, h.prototype._drawYearSelector = function () {
                var e = this, t = this._currentDate, i = _.DateHelper.getTwelweYears(t), n = this.config, o = n.css,
                    r = n.timePicker, s = n.weekNumbers, t = n.width, n = n.mode,
                    r = "dhx_calendar dhx_widget" + (o ? " " + o : "") + (r ? " dhx_calendar--with_timepicker" : "") + (s ? " dhx_calendar--with_week-numbers" : "");
                return g.el("div", f({
                    class: r,
                    style: {width: s ? "calc(" + t + " + 48px)" : t}
                }, this._handlers), [g.el(".dhx_calendar__wrapper", [this._drawHeader(g.el("button.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--circle", i[0] + "-" + i[i.length - 1])), g.el(".dhx_calendar__years", i.map(function (t) {
                    return g.el("div", {
                        class: "dhx_calendar-year" + (e._getSelected() && t === e._getSelected().getFullYear() ? " dhx_calendar-year--selected" : ""),
                        _date: t,
                        tabIndex: 1
                    }, t)
                })), "year" !== n && "month" !== n ? g.el(".dhx_calendar__actions", [g.el("button.dhx_button.dhx_button--color_primary.dhx_button--view_link.dhx_button--size_small.dhx_button--width_full.dhx_button--circle.dhx_calendar-action__cancel", _.locale.cancel)]) : null])])
            }, h.prototype._drawHeader = function (t) {
                return g.el(".dhx_calendar__navigation", [g.el("button.dhx_calendar-navigation__button.dhx_calendar-action__prev" + u.linkButtonClasses + ".dhx_button--icon.dhx_button--circle", {"aria-label": "prev"}, [g.el(".dhx_button__icon.dxi.dxi-chevron-left")]), t, g.el("button.dhx_calendar-navigation__button.dhx_calendar-action__next" + u.linkButtonClasses + ".dhx_button--icon.dhx_button--circle", {"aria-label": "next"}, [g.el(".dhx_button__icon.dxi.dxi-chevron-right")])])
            }, h.prototype._drawTimepicker = function () {
                var t = this.config, e = t.css, i = t.weekNumbers, t = t.width;
                return g.el(".dhx_widget.dhx-calendar", {
                    class: e ? " " + e : "",
                    style: {width: i ? "calc(" + t + " + 48px)" : t}
                }, [g.inject(this._timepicker.getRootView())])
            }, h);

        function h(t, e) {
            void 0 === e && (e = {});
            var o = r.call(this, t, s.extend({
                weekStart: "sunday",
                thisMonthOnly: !1,
                dateFormat: window && window.dhx && window.dhx.dateFormat,
                width: "250px"
            }, e)) || this;
            switch (o._selected = [], o.events = new a.EventSystem, o.config.disabledDates = o.config.disabledDates || o.config.block, o.config.mode = o.config.mode || o.config.view, o.config.dateFormat || (o.config.timePicker ? 12 === o.config.timeFormat ? o.config.dateFormat = "%d/%m/%y %h:%i %A" : o.config.dateFormat = "%d/%m/%y %H:%i" : o.config.dateFormat = "%d/%m/%y"), o.config.value && o._setSelected(o.config.value), o.config.date ? o._currentDate = _.DateHelper.toDateObject(o.config.date, o.config.dateFormat) : o._getSelected() ? o._currentDate = _.DateHelper.copy(o._getSelected()) : o._currentDate = new Date, o.config.mode) {
                case"month":
                    o._currentViewMode = "month";
                    break;
                case"year":
                    o._currentViewMode = "year";
                    break;
                default:
                    o._currentViewMode = "calendar"
            }
            o._initHandlers(), o.config.timePicker && (o._timepicker = new c.Timepicker(null, {
                timeFormat: o.config.timeFormat,
                controls: !0
            }), e = o._getSelected() || new Date, o._timepicker.setValue(e), o._time = o._timepicker.getValue(), o._timepicker.events.on(c.TimepickerEvents.afterClose, function () {
                o._timepicker.setValue(o._time), o.showDate(null, "calendar")
            }), o._timepicker.events.on(c.TimepickerEvents.afterApply, function () {
                var t = o._timepicker.getValue(!0), e = t.hour, i = t.minute, n = t.AM, t = o._getSelected(),
                    n = _.DateHelper.withHoursAndMinutes(o._getSelected() || new Date, e, i, n);
                o.events.fire(d.CalendarEvents.beforeChange, [n, t, !0]) && (o._selected[o._selected.length - 1] = n, o.events.fire(d.CalendarEvents.change, [n, t, !0])), o._time = o._timepicker.getValue(), o.showDate(null, "calendar")
            }));
            return o.mount(t, g.create({
                render: function () {
                    return o._draw()
                }
            })), o
        }

        e.Calendar = o
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(102)), n(e(54))
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), r = this && this.__assign || function () {
            return (r = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var s = i(1), a = i(0), l = i(5), c = i(6), u = i(25), d = i(106), h = i(109), f = i(110), p = i(54);

        function g(t, e) {
            return isNaN(t) ? 0 : Math.min(e, Math.max(0, t))
        }

        var _, o = (_ = c.View, o(v, _), v.prototype.getValue = function (t) {
            12 === this.config.timeFormat && (this._time.hour = this._time.hour % 12 || 12);
            var e = this._time, i = e.hour, n = e.minute, e = e.AM;
            if (t) {
                t = {hour: i, minute: n};
                return 12 === this.config.timeFormat && (t.AM = e), t
            }
            return (i < 10 ? "0" + i : i) + ":" + (n < 10 ? "0" + n : n) + (12 === this.config.timeFormat ? e ? "AM" : "PM" : "")
        }, v.prototype.setValue = function (t) {
            this._setValue(t), this._hoursSlider.setValue(this._time.hour), this._minutesSlider.setValue(this._time.minute), this._inputsView.paint()
        }, v.prototype.clear = function () {
            24 === this.config.timeFormat ? this.setValue("00:00") : this.setValue("12:00AM")
        }, v.prototype.destructor = function () {
            this._minutesSlider && this._minutesSlider.destructor(), this._hoursSlider && this._hoursSlider.destructor(), this.events && this.events.clear(), this.layout && this.layout.destructor(), this.config = this.events = null, this._handlers = this._time = this._inputsView = this._minutesSlider = this._hoursSlider = null, this.unmount()
        }, v.prototype.getRootView = function () {
            return this.layout.getRootView()
        }, v.prototype._setValue = function (t) {
            var e, i, n = 0, o = 0;
            return "number" == typeof t && (t = new Date(t)), t instanceof Date ? (n = t.getMinutes(), o = t.getHours()) : Array.isArray(t) ? (o = g(t[0], 23), n = g(t[1], 59), t[2] && "pm" === t[2].toLowerCase() && (e = !0)) : "string" == typeof t ? (o = g(+(i = t.match(/\d+/g))[0], 23), n = g(+i[1], 59), t.toLowerCase().includes("pm") && (e = !0)) : "object" == typeof t && t.hasOwnProperty("hour") && t.hasOwnProperty("minute") && (o = t.hour, n = t.minute, e = !t.AM), e && o < 12 && (o += 12), 12 === this.config.timeFormat && !f.isTimeCheck(t) && 12 <= o && (e = !0), this._time = {
                hour: o,
                minute: n,
                AM: !e
            }
        }, v.prototype._initUI = function (t) {
            var e = this, i = {
                gravity: !1,
                css: "dhx_widget dhx_timepicker " + (this.config.css || "") + (this.config.controls ? " dhx_timepicker--with-controls" : ""),
                rows: [{id: "timepicker", css: "dhx_timepicker__inputs"}, {
                    id: "hour-slider",
                    css: "dhx_timepicker__hour"
                }, {id: "minute-slider", css: "dhx_timepicker__minute"}]
            };
            this.config.controls && (i.rows.unshift({
                id: "close-action",
                css: "dhx_timepicker__close"
            }), i.rows.push({id: "save-action", css: "dhx_timepicker__save"}));
            var n = this.layout = new u.Layout(t, i), o = a.create({
                render: function () {
                    return e._draw()
                }
            }), t = this._inputsView = c.toViewLike(o), i = this._minutesSlider = new d.Slider(null, {
                min: 0,
                max: 59,
                step: 1,
                tooltip: !1,
                labelPosition: "top",
                label: h.default.minutes,
                value: this.config.value ? this._time.minute : 0
            }), o = this._hoursSlider = new d.Slider(null, {
                min: 0,
                max: 23,
                step: 1,
                tooltip: !1,
                labelPosition: "top",
                label: h.default.hours,
                value: !this.config.value || 12 === this._time.hour && this._time.AM ? 0 : this._time.hour
            });
            n.getCell("timepicker").attach(t), n.getCell("hour-slider").attach(o), n.getCell("minute-slider").attach(i), this.config.controls && (n.getCell("save-action").attach(function () {
                return a.el("button.dhx_timepicker__button-save.dhx_button.dhx_button--view_flat.dhx_button--color_primary.dhx_button--size_small.dhx_button--circle.dhx_button--width_full", {onclick: e._outerHandlers.save}, h.default.save)
            }), n.getCell("close-action").attach(function () {
                return a.el("button.dhx_timepicker__button-close.dhx_button.dhx_button--view_link.dhx_button--size_medium.dhx_button--view_link.dhx_button--color_secondary.dhx_button--icon.dhx_button--circle", {
                    onclick: e._outerHandlers.close,
                    "aria-label": "close timepicker"
                }, [a.el("span.dhx_button__icon.dxi.dxi-close")])
            }))
        }, v.prototype._initHandlers = function () {
            var i = this;
            this._handlers = {
                onchange: {
                    ".dhx_timepicker-input--hour": function (t) {
                        var e = g(parseInt(t.target.value, 10), 23);
                        t.target.value = e, i._hoursSlider.setValue(e)
                    }, ".dhx_timepicker-input--minutes": function (t) {
                        var e = g(parseInt(t.target.value, 10), 59);
                        t.target.value = e, i._minutesSlider.setValue(e)
                    }
                }
            }, this._outerHandlers = {
                close: function () {
                    i.events.fire(p.TimepickerEvents.beforeClose, [i.getValue("timeObject" === i.config.valueFormat)]) && (i.events.fire(p.TimepickerEvents.afterClose, [i.getValue("timeObject" === i.config.valueFormat)]), i.events.fire(p.TimepickerEvents.close, []))
                }, save: function () {
                    i.events.fire(p.TimepickerEvents.beforeApply, [i.getValue("timeObject" === i.config.valueFormat)]) && (i.events.fire(p.TimepickerEvents.afterApply, [i.getValue("timeObject" === i.config.valueFormat)]), i.events.fire(p.TimepickerEvents.apply, [i.getValue()]), i.events.fire(p.TimepickerEvents.save, [i._time]))
                }
            }
        }, v.prototype._initEvents = function () {
            var e = this;
            this._hoursSlider.events.on(d.SliderEvents.change, function (t) {
                t < e._hoursSlider.config.min || t > e._hoursSlider.config.max || (12 === e.config.timeFormat ? (e._time.AM = t < 12, e._time.hour = t % 12 || 12) : e._time.hour = t, e.events.fire(p.TimepickerEvents.change, [e.getValue("timeObject" === e.config.valueFormat)]), e._inputsView.paint())
            }), this._minutesSlider.events.on(d.SliderEvents.change, function (t) {
                t < e._minutesSlider.config.min || t > e._minutesSlider.config.max || (e._time.minute = t, e.events.fire(p.TimepickerEvents.change, [e.getValue("timeObject" === e.config.valueFormat)]), e._inputsView.paint())
            })
        }, v.prototype._draw = function () {
            return a.el(".dhx_timepicker-inputs", r({}, this._handlers), [a.el("input.dhx_timepicker-input.dhx_timepicker-input--hour", {
                _key: "hour",
                value: 1 < this.getValue(!0).hour.toString().length ? this.getValue(!0).hour : "0" + this.getValue(!0).hour,
                "aria-label": "hours"
            }), a.el("span.dhx_timepicker-delimer", ":"), a.el("input.dhx_timepicker-input.dhx_timepicker-input--minutes", {
                _key: "minute",
                value: 1 < this.getValue(!0).minute.toString().length ? this.getValue(!0).minute : "0" + this.getValue(!0).minute,
                "aria-label": "minutes"
            }), 12 === this.config.timeFormat ? a.el(".dhx_timepicker-ampm", this._time.AM ? "AM" : "PM") : null])
        }, v);

        function v(t, e) {
            void 0 === e && (e = {});
            e = _.call(this, t, s.extend({
                timeFormat: 24,
                controls: !1,
                valueFormat: "string",
                actions: !1
            }, e)) || this;
            return e.events = new l.EventSystem(e), e._time = {
                hour: 0,
                minute: 0,
                AM: !0
            }, 12 === e.config.timeFormat && (e._time.hour = 12), e.config.controls = e.config.controls || e.config.actions, e.config.value && e._setValue(e.config.value), e._initUI(t), e._initHandlers(), e._initEvents(), e
        }

        e.Timepicker = o
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        });
        Object.defineProperty(e, "__esModule", {value: !0});
        var r, s = i(104), a = i(26), l = i(0), o = (r = s.Cell, o(c, r), c.prototype.destructor = function () {
            for (var t in this._all) {
                var e;
                Object.prototype.hasOwnProperty.call(this._all, t) && ((e = this._all[t]).getWidget() && "function" == typeof e.getWidget().destructor && e.getWidget().destructor(), e.destructor())
            }
            this.config = this._cells = this._root = this._xLayout = this._isViewLayout = null, this._all = {}, this.unmount()
        }, c.prototype.toVDOM = function () {
            if (this._isViewLayout) {
                var t = [this.getCell(this.config.activeView).toVDOM()];
                return r.prototype.toVDOM.call(this, t)
            }
            var e = [];
            return this._inheritTypes(), this._cells.forEach(function (t) {
                t = t.toVDOM();
                Array.isArray(t) ? e = e.concat(t) : e.push(t)
            }), r.prototype.toVDOM.call(this, e)
        }, c.prototype.removeCell = function (e) {
            if (this.events.fire(a.LayoutEvents.beforeRemove, [e])) {
                var t = this.config.parent || this;
                if (t !== this) return t.removeCell(e);
                t = this.getCell(e);
                t && (t = t.getParent(), delete this._all[e], t._cells = t._cells.filter(function (t) {
                    return t.id !== e
                }), t.paint()), this.events.fire(a.LayoutEvents.afterRemove, [e])
            }
        }, c.prototype.addCell = function (t, e) {
            var i;
            void 0 === e && (e = -1), this.events.fire(a.LayoutEvents.beforeAdd, [t.id]) && (i = this._createCell(t), e < 0 && (e = this._cells.length + e + 1), this._cells.splice(e, 0, i), this.paint(), this.events.fire(a.LayoutEvents.afterAdd, [t.id]))
        }, c.prototype.getId = function (t) {
            return t < 0 && (t = this._cells.length + t), this._cells[t] ? this._cells[t].id : void 0
        }, c.prototype.getRefs = function (t) {
            return this._root.getRootView().refs[t]
        }, c.prototype.getCell = function (t) {
            return this._root._all[t]
        }, c.prototype.forEach = function (t, e, i) {
            if (void 0 === i && (i = 1 / 0), this._haveCells(e) && !(i < 1)) for (var n = (e ? this._root._all[e] : this._root)._cells, o = 0; o < n.length; o++) {
                var r = n[o];
                t.call(this, r, o, n), this._haveCells(r.id) && r.forEach(t, r.id, --i)
            }
        }, c.prototype.cell = function (t) {
            return this.getCell(t)
        }, c.prototype._getCss = function (t) {
            var e = this._xLayout ? "dhx_layout-columns" : "dhx_layout-rows",
                i = this.config.align ? " " + e + "--" + this.config.align : "";
            if (t) return e + " dhx_layout-cell" + (this.config.align ? " dhx_layout-cell--" + this.config.align : "");
            var n = this.config.parent ? r.prototype._getCss.call(this) : "dhx_widget dhx_layout",
                t = this.config.parent ? "" : " dhx_layout-cell";
            return n + (this.config.full ? t : " " + e) + i
        }, c.prototype._parseConfig = function () {
            var e = this, t = this.config, i = t.rows || t.cols || t.views || [];
            this._xLayout = !t.rows, this._cells = i.map(function (t) {
                return e._createCell(t)
            })
        }, c.prototype._createCell = function (t) {
            var e = t.rows || t.cols || t.views ? (t.parent = this._root, new c(this, t)) : new s.Cell(this, t);
            return this._root._all[e.id] = e, t.init && t.init(e, t), e
        }, c.prototype._haveCells = function (t) {
            if (t) {
                t = this._root._all[t];
                return t._cells && 0 < t._cells.length
            }
            return 0 < Object.keys(this._all).length
        }, c.prototype._inheritTypes = function (t) {
            var e, i = this;
            void 0 === t && (t = this._cells), Array.isArray(t) ? t.forEach(function (t) {
                return i._inheritTypes(t)
            }) : ((e = t.config).rows || e.cols) && (t = t.getParent(), !e.type && t && (t.config.type ? e.type = t.config.type : this._inheritTypes(t)))
        }, c);

        function c(t, e) {
            var i = r.call(this, t, e) || this;
            return i._root = i.config.parent || i, i._all = {}, i._parseConfig(), i.config.activeTab && (i.config.activeView = i.config.activeTab), i.config.views && (i.config.activeView = i.config.activeView || i._cells[0].id, i._isViewLayout = !0), e.parent || (e = l.create({
                render: function () {
                    return i.toVDOM()
                }
            }, i), i.mount(t, e)), i
        }

        e.Layout = o
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), l = this && this.__assign || function () {
            return (l = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r, c = i(1), u = i(0), s = i(6), d = i(26), h = i(105), a = i(5),
            o = (r = s.View, o(f, r), f.prototype.paint = function () {
                var t;
                this.isVisible() && ((t = this.getRootView()) ? t.redraw() : this._parent.paint())
            }, f.prototype.isVisible = function () {
                if (!this._parent) return !(!this._container || !this._container.tagName) || Boolean(this.getRootNode());
                var t = this._parent.config.activeView;
                return (!t || t === this.id) && (!this.config.hidden && (!this._parent || this._parent.isVisible()))
            }, f.prototype.hide = function () {
                this.events.fire(d.LayoutEvents.beforeHide, [this.id]) && (this.config.hidden = !0, this._parent && this._parent.paint && this._parent.paint(), this.events.fire(d.LayoutEvents.afterHide, [this.id]))
            }, f.prototype.show = function () {
                this.events.fire(d.LayoutEvents.beforeShow, [this.id]) && (this._parent && this._parent.config && void 0 !== this._parent.config.activeView ? this._parent.config.activeView = this.id : this.config.hidden = !1, this._parent && !this._parent.isVisible() && this._parent.show(), this.paint(), this.events.fire(d.LayoutEvents.afterShow, [this.id]))
            }, f.prototype.expand = function () {
                this.events.fire(d.LayoutEvents.beforeExpand, [this.id]) && (this.config.collapsed = !1, this.events.fire(d.LayoutEvents.afterExpand, [this.id]), this.paint())
            }, f.prototype.collapse = function () {
                this.events.fire(d.LayoutEvents.beforeCollapse, [this.id]) && (this.config.collapsed = !0, this.events.fire(d.LayoutEvents.afterCollapse, [this.id]), this.paint())
            }, f.prototype.toggle = function () {
                this.config.collapsed ? this.expand() : this.collapse()
            }, f.prototype.getParent = function () {
                return this._parent
            }, f.prototype.destructor = function () {
                this.events && this.events.clear(), this.config = this.events = this.id = null, this._parent = this._handlers = this._uid = this._disabled = this._resizerHandlers = null, this.unmount()
            }, f.prototype.getWidget = function () {
                return this._ui
            }, f.prototype.getCellView = function () {
                return this._parent && this._parent.getRefs(this._uid)
            }, f.prototype.attach = function (t, e) {
                return this.config.html = null, "object" == typeof t ? this._ui = t : "string" == typeof t ? this._ui = new window.dhx[t](null, e) : "function" == typeof t && (t.prototype instanceof s.View ? this._ui = new t(null, e) : this._ui = {
                    getRootView: function () {
                        return t(e)
                    }
                }), this.paint(), this._ui
            }, f.prototype.attachHTML = function (t) {
                this.config.html = t, this.paint()
            }, f.prototype.toVDOM = function (t) {
                if (null === this.config && (this.config = {}), !this.config.hidden) {
                    var e, i = this._calculateStyle(),
                        n = c.isDefined(this.config.padding) ? isNaN(Number(this.config.padding)) ? {padding: this.config.padding} : {padding: this.config.padding + "px"} : "",
                        i = this.config.full || this.config.html ? i : l(l({}, i), n);
                    this.config.html || (e = this._ui ? ((o = this._ui.getRootView()).render && (o = u.inject(o)), [o]) : t || null);
                    var o = !this.config.resizable || this._isLastCell() || this.config.collapsed ? null : u.el(".dhx_layout-resizer." + (this._isXDirection() ? "dhx_layout-resizer--x" : "dhx_layout-resizer--y"), l(l({}, this._resizerHandlers), {_ref: "resizer_" + this._uid}), [u.el("span.dhx_layout-resizer__icon", {class: "dxi " + (this._isXDirection() ? "dxi-dots-vertical" : "dxi-dots-horizontal")})]),
                        r = {};
                    if (this.config.on) for (var s in this.config.on) r["on" + s] = this.config.on[s];
                    var a = "", t = this.config.cols || this.config.rows;
                    if (this.config.type && t) switch (this.config.type) {
                        case"line":
                            a = " dhx_layout-line";
                            break;
                        case"wide":
                            a = " dhx_layout-wide";
                            break;
                        case"space":
                            a = " dhx_layout-space"
                    }
                    n = u.el("div", l(l(((t = {
                        _key: this._uid,
                        _ref: this._uid
                    })["aria-label"] = this.config.id ? "tab-content-" + this.config.id : null, t), r), {
                        class: this._getCss(!1) + (this.config.css ? " " + this.config.css : "") + (this.config.collapsed ? " dhx_layout-cell--collapsed" : "") + (this.config.resizable ? " dhx_layout-cell--resizable" : "") + (this.config.type && !this.config.full ? a : ""),
                        style: i
                    }), this.config.full ? [u.el("div", {
                        tabindex: this.config.collapsable ? "0" : "-1",
                        class: "dhx_layout-cell-header" + (this._isXDirection() ? " dhx_layout-cell-header--col" : " dhx_layout-cell-header--row") + (this.config.collapsable ? " dhx_layout-cell-header--collapseble" : "") + (this.config.collapsed ? " dhx_layout-cell-header--collapsed" : "") + (((this.getParent() || {}).config || {}).isAccordion ? " dhx_layout-cell-header--accordion" : ""),
                        style: {height: this.config.headerHeight},
                        onclick: this._handlers.toggle,
                        onkeydown: this._handlers.enterCollapse
                    }, [this.config.headerIcon && u.el("span.dhx_layout-cell-header__icon", {class: this.config.headerIcon}), this.config.headerImage && u.el(".dhx_layout-cell-header__image-wrapper", [u.el("img", {
                        src: this.config.headerImage,
                        class: "dhx_layout-cell-header__image"
                    })]), this.config.header && u.el("h3.dhx_layout-cell-header__title", this.config.header), this.config.collapsable ? u.el("div.dhx_layout-cell-header__collapse-icon", {class: this._getCollapseIcon()}) : u.el("div.dhx_layout-cell-header__collapse-icon", {class: "dxi dxi-empty"})]), this.config.collapsed ? null : u.el("div", {
                        style: l(l({}, n), {height: "calc(100% - " + (this.config.headerHeight || 37) + "px)"}),
                        ".innerHTML": this.config.html,
                        class: this._getCss(!0) + " dhx_layout-cell-content" + (this.config.type ? a : "")
                    }, e)] : !this.config.html || this.config.rows && this.config.cols && this.config.views ? e : [u.el(".dhx_layout-cell-content", {
                        ".innerHTML": this.config.html,
                        style: n
                    })]);
                    return o ? [n, o] : n
                }
            }, f.prototype._getCss = function (t) {
                return "dhx_layout-cell"
            }, f.prototype._initHandlers = function () {
                function e(t) {
                    if (s.isActive) {
                        var e = (t.targetTouches ? t.targetTouches[0] : t).clientX,
                            t = (t.targetTouches ? t.targetTouches[0] : t).clientY,
                            i = s.xLayout ? e - s.range.min + window.pageXOffset : t - s.range.min + window.pageYOffset,
                            n = s.xLayout ? "width" : "height";
                        switch (i < 0 ? i = s.resizerLength / 2 : i > s.size && (i = s.size - s.resizerLength), s.mode) {
                            case d.resizeMode.pixels:
                                r.config[n] = i - s.resizerLength / 2 + "px", s.nextCell.config[n] = s.size - i - s.resizerLength / 2 + "px";
                                break;
                            case d.resizeMode.mixedpx1:
                                r.config[n] = i - s.resizerLength / 2 + "px";
                                break;
                            case d.resizeMode.mixedpx2:
                                s.nextCell.config[n] = s.size - i - s.resizerLength / 2 + "px";
                                break;
                            case d.resizeMode.percents:
                                r.config[n] = i / s.size * s.percentsum + "%", s.nextCell.config[n] = (s.size - i) / s.size * s.percentsum + "%";
                                break;
                            case d.resizeMode.mixedperc1:
                                r.config[n] = i / s.size * s.percentsum + "%";
                                break;
                            case d.resizeMode.mixedperc2:
                                s.nextCell.config[n] = (s.size - i) / s.size * s.percentsum + "%";
                                break;
                            case d.resizeMode.unknown:
                                r.config[n] = i - s.resizerLength / 2 + "px", s.nextCell.config[n] = s.size - i - s.resizerLength / 2 + "px", r.config.$fixed = !0
                        }
                        r.paint(), r.events.fire(d.LayoutEvents.resize, [r.id])
                    }
                }

                function i(t) {
                    var e, i, n, o;
                    t.targetTouches && t.preventDefault(), 3 !== t.which && (s.isActive && a(t), r.events.fire(d.LayoutEvents.beforeResizeStart, [r.id]) && (document.body.classList.add("dhx_no-select--resize"), i = r.getCellView(), n = (e = r._getNextCell()).getCellView(), t = r._getResizerView(), i = i.el.getBoundingClientRect(), t = t.el.getBoundingClientRect(), n = n.el.getBoundingClientRect(), s.xLayout = r._isXDirection(), s.left = i.left + window.pageXOffset, s.top = i.top + window.pageYOffset, s.margin = h.getMarginSize(r.getParent().config, s.xLayout), s.range = h.getBlockRange(i, n, s.xLayout), s.size = s.range.max - s.range.min - s.margin, s.isActive = !0, s.nextCell = e, s.resizerLength = s.xLayout ? t.width : t.height, s.mode = h.getResizeMode(s.xLayout, r.config, e.config), s.mode === d.resizeMode.percents && (o = s.xLayout ? "width" : "height", s.percentsum = parseFloat(r.config[o].slice(0, -1)) + parseFloat(e.config[o].slice(0, -1))), s.mode === d.resizeMode.mixedperc1 && (o = s.xLayout ? "width" : "height", s.percentsum = 1 / (i[o] / (s.size - s.resizerLength)) * parseFloat(r.config[o].slice(0, -1))), s.mode === d.resizeMode.mixedperc2 && (o = s.xLayout ? "width" : "height", s.percentsum = 1 / (n[o] / (s.size - s.resizerLength)) * parseFloat(e.config[o]))))
                }

                var r = this, s = {
                    left: null,
                    top: null,
                    isActive: !(this._handlers = {
                        enterCollapse: function (t) {
                            13 === t.keyCode && r._handlers.toggle()
                        }, collapse: function () {
                            r.config.collapsable && r.collapse()
                        }, expand: function () {
                            r.config.collapsable && r.expand()
                        }, toggle: function () {
                            r.config.collapsable && r.toggle()
                        }
                    }),
                    range: null,
                    xLayout: null,
                    nextCell: null,
                    size: null,
                    resizerLength: null,
                    mode: null,
                    percentsum: null,
                    margin: null
                }, a = function (t) {
                    s.isActive = !1, document.body.classList.remove("dhx_no-select--resize"), t.targetTouches ? (document.removeEventListener("touchend", a), document.removeEventListener("touchmove", e)) : (document.removeEventListener("mouseup", a), document.removeEventListener("mousemove", e)), r.events.fire(d.LayoutEvents.afterResizeEnd, [r.id])
                };
                this._resizerHandlers = {
                    onmousedown: function (t) {
                        i(t), document.addEventListener("mouseup", a), document.addEventListener("mousemove", e)
                    }, ontouchstart: function (t) {
                        i(t), document.addEventListener("touchend", a), document.addEventListener("touchmove", e)
                    }, ondragstart: function (t) {
                        return t.preventDefault()
                    }
                }
            }, f.prototype._getCollapseIcon = function () {
                return this._isXDirection() && this.config.collapsed ? "dxi dxi-chevron-right" : this._isXDirection() && !this.config.collapsed ? "dxi dxi-chevron-left" : !this._isXDirection() && this.config.collapsed ? "dxi dxi-chevron-up" : this._isXDirection() || this.config.collapsed ? void 0 : "dxi dxi-chevron-down"
            }, f.prototype._isLastCell = function () {
                var t = this._parent;
                return t && t._cells.indexOf(this) === t._cells.length - 1
            }, f.prototype._getNextCell = function () {
                var t = this._parent, e = t._cells.indexOf(this);
                return t._cells[e + 1]
            }, f.prototype._getResizerView = function () {
                return this._parent.getRefs("resizer_" + this._uid)
            }, f.prototype._isXDirection = function () {
                return this._parent && this._parent._xLayout
            }, f.prototype._calculateStyle = function () {
                var t = this.config;
                if (t) {
                    var e = {}, i = !1, n = !1;
                    isNaN(Number(t.width)) || (t.width = t.width + "px"), isNaN(Number(t.height)) || (t.height = t.height + "px"), isNaN(Number(t.minWidth)) || (t.minWidth = t.minWidth + "px"), isNaN(Number(t.minHeight)) || (t.minHeight = t.minHeight + "px"), isNaN(Number(t.maxWidth)) || (t.maxWidth = t.maxWidth + "px"), isNaN(Number(t.maxHeight)) || (t.maxHeight = t.maxHeight + "px"), "content" === t.width && (i = !0), "content" === t.height && (n = !0);
                    var o = t.width, r = t.height, s = t.cols, a = t.rows, l = t.minWidth, c = t.minHeight,
                        u = t.maxWidth, d = t.maxHeight, h = t.gravity, f = t.collapsed, p = t.$fixed,
                        g = -1 === Math.sign(h) ? 0 : h;
                    "boolean" == typeof h && (g = h ? 1 : 0);
                    var _ = "boolean" == typeof h ? !h : -1 === Math.sign(h);
                    this._isXDirection() ? (p || o || void 0 === h && (l || u)) && (_ = !0) : (p || r || void 0 === h && (c || d)) && (_ = !0);
                    var v, _ = _ ? 0 : g || 1, g = this._isXDirection() ? "x" : "y";
                    return void 0 !== l && (e.minWidth = l), void 0 !== c && (e.minHeight = c), void 0 !== u && (e.maxWidth = u), void 0 !== d && (e.maxHeight = d), void 0 === this._parent && (g = !0), void 0 !== o && "content" !== o ? e.width = o : !0 === g ? e.width = "100%" : "x" === g && (i ? e.flex = "0 0 auto" : (v = this._isXDirection() ? "1px" : "auto", e.flex = _ + " " + (s || a ? "0 " + v : "1 auto"))), void 0 !== r && "content" !== r ? e.height = r : !0 === g ? e.height = "100%" : "y" === g && (n ? e.flex = "0 0 auto" : (v = this._isXDirection() ? "auto" : "1px", e.flex = _ + " " + (s || a ? "0 " + v : "1 auto"))), !0 === g && void 0 === t.width && void 0 === t.height && (e.flex = _ + " 1 auto"), f && (this._isXDirection() ? e.width = "auto" : e.height = "auto", e.flex = "0 0 auto"), e
                }
            }, f);

        function f(t, e) {
            e = r.call(this, t, e) || this;
            return e._disabled = [], t && t.isVisible && (e._parent = t), e._parent && e._parent.events ? e.events = e._parent.events : e.events = new a.EventSystem(e), e.config.full = void 0 === e.config.full ? Boolean(e.config.header || e.config.collapsable || e.config.headerHeight || e.config.headerIcon || e.config.headerImage) : e.config.full, e._initHandlers(), e.id = e.config.id || c.uid(), e
        }

        e.Cell = o
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(26);
        e.getResizeMode = function (t, e, i) {
            var n = e[o = t ? "width" : "height"] && e[o].includes("%"), t = i[o] && i[o].includes("%"),
                e = e[o] && e[o].includes("px"), o = i[o] && i[o].includes("px");
            return n && t ? r.resizeMode.percents : e && o ? r.resizeMode.pixels : e && !o ? r.resizeMode.mixedpx1 : o && !e ? r.resizeMode.mixedpx2 : n ? r.resizeMode.mixedperc1 : t ? r.resizeMode.mixedperc2 : r.resizeMode.unknown
        }, e.getBlockRange = function (t, e, i) {
            return void 0 === i && (i = !0), i ? {
                min: t.left + window.pageXOffset,
                max: e.right + window.pageXOffset
            } : {min: t.top + window.pageYOffset, max: e.bottom + window.pageYOffset}
        }, e.getMarginSize = function (t, e) {
            return t && ("space" === t.type || "wide" === t.type && e) ? 10 : 0
        }
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(107)), n(e(53))
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), l = this && this.__assign || function () {
            return (l = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(1), c = i(0), s = i(5), a = i(19), u = i(6), d = i(20), h = i(53), f = i(2);

        function p(t, e, i) {
            return t < e ? e : i < t ? i : t
        }

        var g, o = (g = u.View, o(_, g), _.prototype.disable = function () {
            this._disabled = !0, this.paint()
        }, _.prototype.enable = function () {
            this._disabled = !1, this.paint()
        }, _.prototype.isDisabled = function () {
            return this._disabled
        }, _.prototype.focus = function (t) {
            this.getRootView().refs[t ? "extraRunner" : "runner"].el.focus()
        }, _.prototype.getValue = function () {
            var t, e;
            return this.config.range ? (t = this._getValue(this._currentPosition)) < (e = this._getValue(this._extraCurrentPosition)) ? [t, e] : [e, t] : [this._getValue(this._currentPosition)]
        }, _.prototype.setValue = function (t) {
            var e = this._getValue(this._currentPosition);
            if (Array.isArray(t) && 1 < t.length) {
                var i = this._getValue(this._extraCurrentPosition);
                this._setValue(t[0], !1), this.events.fire(h.SliderEvents.change, [t[0], e, !1]), this._setValue(t[1], !0), this.events.fire(h.SliderEvents.change, [t[1], i, !0])
            } else {
                if (t = parseFloat(t), isNaN(t)) throw new Error("Wrong value type, for more info check documentation https://docs.dhtmlx.com/suite/slider__api__slider_setvalue_method.html");
                this._setValue(t), this.events.fire(h.SliderEvents.change, [t, e, !1])
            }
            this.paint()
        }, _.prototype.destructor = function () {
            this._keyManager && this._keyManager.destructor(), document.body.contains(this._tooltip) && document.body.removeChild(this._tooltip), this._tooltip = null, this.unmount()
        }, _.prototype._calcSliderPosition = function () {
            var t = this.getRootView();
            t && (t = t.refs.track.el.getBoundingClientRect(), this._offsets = {
                left: t.left + window.pageXOffset,
                top: t.top + window.pageYOffset
            }, this._length = "horizontal" === this.config.mode ? t.width : t.height)
        }, _.prototype._initHotkeys = function () {
            var t, e = this, i = {
                arrowLeft: function (t) {
                    t.preventDefault(), e._move(-e.config.step, t.target.classList.contains("dhx_slider__thumb--extra"))
                }, arrowRight: function (t) {
                    t.preventDefault(), e._move(e.config.step, t.target.classList.contains("dhx_slider__thumb--extra"))
                }, arrowUp: function (t) {
                    t.preventDefault(), e._move(e.config.step, t.target.classList.contains("dhx_slider__thumb--extra"))
                }, arrowDown: function (t) {
                    t.preventDefault(), e._move(-e.config.step, t.target.classList.contains("dhx_slider__thumb--extra"))
                }
            };
            for (t in i) this._keyManager.addHotKey(t, i[t])
        }, _.prototype._move = function (t, e) {
            this.config.inverse && (t = -t);
            var i = this.config, n = i.max, o = i.min,
                r = e ? this._getValue(this._extraCurrentPosition) : this._getValue(this._currentPosition), i = r + t;
            this._setValue(r + t, e), (n < i || i < o) && (i = r), this.events.fire(h.SliderEvents.change, [i, r, e]), this.paint()
        }, _.prototype._initStartPosition = function () {
            var t, e, i = this.config, n = i.max, o = i.min, r = i.range,
                i = (t = this.config.value, e = this.config.min, i = this.config.max, (t = void 0 === t ? [] : Array.isArray(t) ? t : "string" == typeof t ? t.split(",").map(function (t) {
                    return parseInt(t, 10)
                }) : [t])[0] = void 0 === t[0] ? e : p(t[0], e, i), t[1] = void 0 === t[1] ? i : p(t[1], e, i), t),
                t = i[0], i = i[1];
            this._currentPosition = (t - o) / (n - o) * 100, r && (this._extraCurrentPosition = (n - i) / (n - o) * 100), this._currentPosition = (t - o) / (n - o) * 100, r && (this._extraCurrentPosition = (i - o) / (n - o) * 100), this._isInverse() && (this._currentPosition = 100 - this._currentPosition, r && (this._extraCurrentPosition = 100 - this._extraCurrentPosition))
        }, _.prototype._getValue = function (t) {
            this._isInverse() && (t = 100 - t);
            var e = this.config, i = e.min, n = e.max, e = e.step;
            if (100 === t) return n;
            if (0 === t) return i;
            t = t * (n - i) / 100, n = t % e, e = e / 2 <= n ? e : 0;
            return +(Number(i) + Number(t) - n + e).toFixed(5)
        }, _.prototype._setValue = function (t, e) {
            void 0 === e && (e = !1);
            var i = this.config, n = i.max, i = i.min;
            if (n < t || t < i) return !1;
            i = (t - i) / (n - i) * 100, i = this._isInverse() ? 100 - i : i;
            e ? this._extraCurrentPosition = i : this._currentPosition = i
        }, _.prototype._initHandlers = function () {
            function e(t) {
                if (t.targetTouches || t.preventDefault(), t = ((t.targetTouches ? t.targetTouches[0] : t)[n._axis] - n._getBegining()) / n._length * 100, n._findNewDirection) {
                    if (Math.abs(n._currentPosition - t) < 1) return;
                    t > n._currentPosition ? n._possibleRange = [n._currentPosition, 100] : n._possibleRange = [0, n._currentPosition], n._findNewDirection = null
                }
                n._inSide(t) && n._updatePosition(t, n._isExtraActive), n.paint()
            }

            function i(t) {
                var e, i;
                n._disabled || 3 === t.which || (n.events.fire(h.SliderEvents.mousedown, [t]), n._isMouseMoving = !0, e = t.target.classList.contains("dhx_slider__thumb--extra") ? (n._isExtraActive = !0, n._extraCurrentPosition) : (n._isExtraActive = !1, n._currentPosition), n._findNewDirection = null, n.config.range ? (t = (i = n._currentPosition > n._extraCurrentPosition ? [n._currentPosition, n._extraCurrentPosition] : [n._extraCurrentPosition, n._currentPosition])[0], i = i[1], n._currentPosition === n._extraCurrentPosition ? (n._findNewDirection = e, n._possibleRange = [0, 100]) : n._possibleRange = e < t ? [0, t] : [i, 100]) : n._possibleRange = [0, 100])
            }

            var n = this, o = function (t) {
                n.events.fire(h.SliderEvents.mouseup, [t]), setTimeout(function () {
                    n._isMouseMoving = !1, n.paint()
                }, 4), t.targetTouches ? (document.removeEventListener("touchend", o), document.removeEventListener("touchmove", e)) : (document.removeEventListener("mouseup", o), document.removeEventListener("mousemove", e))
            };
            this.config.helpMessage && (this._helper = new d.Popup({css: "dhx_tooltip dhx_tooltip--forced dhx_tooltip--light"}), this._helper.attachHTML(this.config.helpMessage)), this._handlers = {
                showHelper: function (t) {
                    t.preventDefault(), t.stopPropagation(), n._helper.show(t.target)
                }, onmousedown: function (t) {
                    i(t), document.addEventListener("mousemove", e), document.addEventListener("mouseup", o)
                }, ontouchstart: function (t) {
                    n._setTooltip(t), n._mouseIn = !1, i(t), document.addEventListener("touchmove", e), document.addEventListener("touchend", o), n.paint()
                }, ontouchend: function (t) {
                    n._setTooltip(t), n._mouseIn = !1, n.paint()
                }, onlabelClick: function () {
                    n.getRootView().refs.runner.el.focus()
                }, onclick: function (t) {
                    var e;
                    n._disabled || n._isMouseMoving || 3 === t.which || (e = (t[n._axis] - n._getBegining()) / n._length * 100, t = n.getRootView().refs, !n.config.range || Math.abs(n._currentPosition - e) < Math.abs(n._extraCurrentPosition - e) ? (n._updatePosition(e, !1), t.runner.el.focus()) : (n._updatePosition(e, !0), t.extraRunner.el.focus()), n.paint())
                }, onmouseover: function (t) {
                    n._setTooltip(t), n._mouseIn = !0, n.paint()
                }, onmouseout: function (t) {
                    n._setTooltip(t), n._mouseIn = !1, n.paint()
                }, onfocus: function (t) {
                    n._setTooltip(t), n._focusIn = !0, n.paint()
                }, onblur: function (t) {
                    n._setTooltip(t), n._focusIn = !1, n.paint()
                }
            }
        }, _.prototype._getBegining = function () {
            return "horizontal" === this.config.mode ? this._offsets.left - window.pageXOffset : this._offsets.top - window.pageYOffset
        }, _.prototype._inSide = function (t) {
            var e = this._possibleRange;
            return t < e[0] ? (this._updatePosition(e[0], this._isExtraActive), !1) : !(t > e[1]) || (this._updatePosition(e[1], this._isExtraActive), !1)
        }, _.prototype._updatePosition = function (t, e) {
            void 0 === e && (e = !1), 100 < t && (t = 100), t < 0 && (t = 0);
            var i = this.config, n = i.max, o = i.min, i = e ? this._extraCurrentPosition : this._currentPosition,
                i = this._getValue(i), t = this._getValue(t);
            i !== t && (o = (t - o) / (n - o) * 100, o = this._isInverse() ? 100 - o : o, e ? this._extraCurrentPosition = o : this._currentPosition = o, this.events.fire(h.SliderEvents.change, [t, i, e]))
        }, _.prototype._getRunnerStyle = function (t) {
            void 0 === t && (t = !1);
            var e = "horizontal" === this.config.mode ? "left" : "top",
                i = t ? this._extraCurrentPosition : this._currentPosition;
            return (t = {})[e] = i + "%", t
        }, _.prototype._isInverse = function () {
            return this.config.inverse && "horizontal" === this.config.mode || !this.config.inverse && "vertical" === this.config.mode
        }, _.prototype._getRunnerCss = function (t) {
            return void 0 === t && (t = !1), "dhx_slider__thumb" + (t ? " dhx_slider__thumb--extra" : "") + (this._isMouseMoving && (t && this._isExtraActive || !t && !this._isExtraActive) ? " dhx_slider__thumb--active" : "") + (this._disabled ? " dhx_slider__thumb--disabled" : "") + (this._isNullable(t ? this._extraCurrentPosition : this._currentPosition) && !this.config.range ? " dhx_slider__thumb--nullable" : "")
        }, _.prototype._draw = function () {
            var t = this.config, e = t.labelPosition, i = t.mode, n = t.hiddenLabel, o = t.tick, r = t.majorTick,
                s = t.css, a = t.helpMessage, t = f.getLabelStyle(l(l({}, this.config), {required: !1}));
            return !this._tooltip || this._mouseIn && this._focusIn && this._isMouseMoving || document.body.contains(this._tooltip) && document.body.removeChild(this._tooltip), c.el("div", {class: "dhx_slider dhx_slider--mode_" + i + ("left" === e ? " dhx_slider--label-inline" : "") + (n ? " dhx_slider--label_sr" : "") + (o ? " dhx_slider--ticks" : "") + (r ? " dhx_slider--major-ticks" : "") + (s ? " " + s : "") + (this._disabled ? " dhx_slider--disabled" : "")}, [t ? c.el("label.dhx_label.dhx_slider__label", {
                style: t.style,
                class: a ? "dhx_label--with-help" : "",
                onclick: this._handlers.onlabelClick
            }, a ? [t.label && c.el("span.dhx_label__holder", t.label), c.el("span.dhx_label-help.dxi.dxi-help-circle-outline", {
                tabindex: "0",
                role: "button",
                onclick: this._handlers.showHelper
            })] : t.label) : null, this._drawSlider()])
        }, _.prototype._drawSlider = function () {
            return c.el(".dhx_widget.dhx_slider__track-holder", {dhx_widget_id: this._uid}, [c.el(".dhx_slider__track", {
                _ref: "track",
                onmouseover: this._handlers.onmouseover,
                onmouseout: this._handlers.onmouseout,
                onclick: this._handlers.onclick
            }, [this._getDetector(), c.el("div", {
                _ref: "runner",
                class: this._getRunnerCss(),
                ontouchstart: this._handlers.ontouchstart,
                ontouchend: this._handlers.ontouchend,
                onmousedown: this._handlers.onmousedown,
                onfocus: this._handlers.onfocus,
                onblur: this._handlers.onblur,
                style: this._getRunnerStyle(),
                tabindex: 0
            }), this.config.tooltip && (this._mouseIn || this._focusIn || this._isMouseMoving) ? this._drawTooltip() : null, this.config.tooltip && this.config.range && (this._mouseIn || this._focusIn || this._isMouseMoving) ? this._drawTooltip(!0) : null, this.config.range ? c.el("div", {
                _ref: "extraRunner",
                class: this._getRunnerCss(!0),
                ontouchstart: this._handlers.ontouchstart,
                ontouchend: this._handlers.ontouchend,
                onmousedown: this._handlers.onmousedown,
                onfocus: this._handlers.onfocus,
                onblur: this._handlers.onblur,
                style: this._getRunnerStyle(!0),
                tabindex: 0
            }) : null]), this.config.tick ? this._drawTicks() : null])
        }, _.prototype._getDetector = function () {
            var t;
            if (this._disabled) return c.el(".dhx_slider__range");
            var e = "horizontal" === this.config.mode ? "left" : "top",
                i = "horizontal" === this.config.mode ? "width" : "height";
            if (this.config.range) {
                var n = this._currentPosition > this._extraCurrentPosition ? [this._currentPosition, this._extraCurrentPosition] : [this._extraCurrentPosition, this._currentPosition],
                    o = n[0], r = n[1];
                return c.el(".dhx_slider__range", {style: ((n = {})[e] = r + "%", n[i] = o - r + "%", n)})
            }
            return this._isInverse() ? c.el(".dhx_slider__range", {style: ((t = {})[e] = this._currentPosition + "%", t[i] = 100 - this._currentPosition + "%", t)}) : c.el(".dhx_slider__range", {style: ((t = {})[e] = 0, t[i] = this._currentPosition + "%", t)})
        }, _.prototype._drawTooltip = function (t) {
            var e, i, n;
            void 0 === t && (t = !1), "none" !== this._activeTooltip && (e = "extraTooltip" === this._activeTooltip ? this._extraCurrentPosition : this._currentPosition, i = "horizontal" === this.config.mode ? "left" : "top", n = "", (t && this._isExtraActive || !t && !this._isExtraActive) && (n += " dhx_slider__thumb-label--active"), this._tooltip || (this._tooltip = document.createElement("div")), t = ("tooltip" === this._activeTooltip ? this.getRootView().refs.runner : this.getRootView().refs.extraRunner).el.getBoundingClientRect(), this._tooltip.className = "dhx_slider__thumb-label" + n, this._tooltip.style.left = t.x + ("left" == i ? 6 : -30) + window.pageXOffset + "px", this._tooltip.style.top = t.y + ("left" == i ? -30 : 6) + window.pageYOffset + "px", this._tooltip.innerText = this._getValue(e).toString(), document.body.appendChild(this._tooltip))
        }, _.prototype._getTicks = function () {
            for (var t = this.config, e = t.max, i = t.min, n = t.step, o = t.tick, r = t.majorTick, s = e - i, a = n * o / s, l = [], c = 0, u = 0; c < 1;) {
                var d = +(Number(i) + c * s).toFixed(5), h = u % r == 0;
                l.push({
                    position: (this._isInverse() ? 100 * (1 - c) : 100 * c) + "%",
                    isMultiple: h,
                    label: h && "function" == typeof this.config.tickTemplate ? this.config.tickTemplate(d) : null
                }), c += a, u++
            }
            return l.push({
                position: (this._isInverse() ? 0 : 100) + "%",
                isMultiple: !0,
                label: "function" == typeof this.config.tickTemplate ? this.config.tickTemplate(e) : null
            }), l
        }, _.prototype._drawTicks = function () {
            var i = "horizontal" === this.config.mode ? "left" : "top";
            return c.el(".dhx_slider__ticks-holder", this._getTicks().map(function (t) {
                var e;
                return c.el("div", {
                    class: "dhx_slider__tick" + (t.isMultiple ? " dhx_slider__tick--major" : ""),
                    style: ((e = {})[i] = t.position, e)
                }, void 0 !== t.label ? [c.el(".dhx_slider__tick-label", t.label)] : null)
            }))
        }, _.prototype._isNullable = function (t) {
            return this._isInverse() ? 100 === t : 0 === t
        }, _.prototype._setTooltip = function (t) {
            t.target.classList.contains("dhx_slider__thumb--extra") ? this._activeTooltip = "extraTooltip" : t.target.classList.contains("dhx_slider__thumb") ? this._activeTooltip = "tooltip" : this._activeTooltip = "none"
        }, _);

        function _(t, e) {
            var i = g.call(this, t, r.extend({mode: "horizontal", min: 0, max: 100, step: 1, tooltip: !0}, e)) || this;
            i._disabled = !1, i.config.helpMessage = i.config.helpMessage || i.config.help, void 0 !== i.config.thumbLabel && (i.config.tooltip = i.config.thumbLabel), i.config.labelInline && (i.config.labelPosition = "left"), i.events = new s.EventSystem(i), i._axis = "horizontal" === i.config.mode ? "clientX" : "clientY", i._initStartPosition(), i._keyManager = new a.KeyManager(function () {
                var t;
                return document.activeElement === (null === (t = i.getRootView().refs[i._isExtraActive ? "extraRunner" : "runner"]) || void 0 === t ? void 0 : t.el)
            }), i._initHotkeys();
            e = c.create({
                render: function () {
                    return i._draw()
                }, hooks: {
                    didMount: function () {
                        return i._calcSliderPosition()
                    }, didRedraw: function () {
                        return i._calcSliderPosition()
                    }
                }
            });
            return i._initHandlers(), i.mount(t, e), i
        }

        e.Slider = o
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), s = this && this.__assign || function () {
            return (s = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r, a = i(1), l = i(0), c = i(5), u = i(2), d = i(6), h = i(52),
            o = (r = d.View, o(f, r), f.prototype.show = function (t, e, i) {
                var n = this;
                void 0 === e && (e = {}), this.events.fire(h.PopupEvents.beforeShow, [t]) && (t = u.toNode(t), this._isActive ? this._setPopupSize(t, e) : (i && this.attach(i), this._popup.style.left = "0", this._popup.style.top = "0", l.awaitRedraw().then(function () {
                    n._setPopupSize(t, e), n._popup.style.position = "fixed", document.body.appendChild(n._popup), n._isActive = !0
                }).then(function () {
                    n._popup.style.position = "absolute", n.events.fire(h.PopupEvents.afterShow, [t]), n._outerClickDestructor = n._detectOuterClick(t)
                })))
            }, f.prototype.hide = function () {
                this._hide(!1, null)
            }, f.prototype.isVisible = function () {
                return this._isActive
            }, f.prototype.attach = function (t, e) {
                return this._html = null, "object" == typeof t ? this._ui = t : "string" == typeof t ? this._ui = new window.dhx[t](null, e) : "function" == typeof t && (t.prototype instanceof d.View ? this._ui = new t(null, e) : this._ui = {
                    getRootView: function () {
                        return t(e)
                    }
                }), this.paint(), this._ui
            }, f.prototype.attachHTML = function (t) {
                this._html = t, this.paint()
            }, f.prototype.getWidget = function () {
                return this._ui
            }, f.prototype.getContainer = function () {
                return this.getRootView().refs.content.el
            }, f.prototype.toVDOM = function () {
                var t;
                return this._html ? t = l.el(".dhx_popup__inner-html-content", {".innerHTML": this._html}) : (t = this._ui ? this._ui.getRootView() : null) && t.render && (t = l.inject(t)), l.el("div", {
                    class: "dhx_popup-content",
                    onclick: this._clickEvent,
                    _key: this._uid,
                    _ref: "content"
                }, [t])
            }, f.prototype.destructor = function () {
                this.hide(), this._outerClickDestructor && this._outerClickDestructor(), this._popup = null
            }, f.prototype._setPopupSize = function (t, e, i) {
                var n = this;
                void 0 === i && (i = 3);
                var o = this._popup.getBoundingClientRect(), r = o.width, o = o.height;
                if (this._timeout && (clearTimeout(this._timeout), this._timeout = null), !i || 0 !== r && 0 !== o) {
                    r = u.fitPosition(t, s(s({centering: !0, mode: "bottom"}, e), {
                        width: r,
                        height: o
                    })), o = r.left, r = r.top;
                    if (this._popup.style.left = o, this._popup.style.top = r, e.indent && 0 !== e.indent) switch (e.mode) {
                        case"top":
                            this._popup.style.top = parseInt(this._popup.style.top.slice(0, -2), null) - parseInt(e.indent.toString(), null) + "px";
                            break;
                        case"bottom":
                            this._popup.style.top = parseInt(this._popup.style.top.slice(0, -2), null) + parseInt(e.indent.toString(), null) + "px";
                            break;
                        case"left":
                            this._popup.style.left = parseInt(this._popup.style.left.slice(0, -2), null) - parseInt(e.indent.toString(), null) + "px";
                            break;
                        case"right":
                            this._popup.style.left = parseInt(this._popup.style.left.slice(0, -2), null) + parseInt(e.indent.toString(), null) + "px";
                            break;
                        default:
                            this._popup.style.top = parseInt(this._popup.style.top.slice(0, -2), null) + parseInt(e.indent.toString(), null) + "px"
                    }
                } else this._timeout = setTimeout(function () {
                    n._isActive && (n._setPopupSize(t, e, i - 1), n._timeout = null)
                })
            }, f.prototype._detectOuterClick = function (i) {
                var n = this, o = function (t) {
                    for (var e = t.target; e;) {
                        if (e === i || e === n._popup) return;
                        e = e.parentNode
                    }
                    n._hide(!0, t) && document.removeEventListener("mousedown", o)
                };
                return document.addEventListener("mousedown", o), function () {
                    return document.removeEventListener("mousedown", o)
                }
            }, f.prototype._hide = function (t, e) {
                if (this._isActive) return !!this.events.fire(h.PopupEvents.beforeHide, [t, e]) && (document.body.removeChild(this._popup), this._isActive = !1, this._outerClickDestructor && (this._outerClickDestructor(), this._outerClickDestructor = null), this.events.fire(h.PopupEvents.afterHide, [e]), !0)
            }, f);

        function f(t) {
            void 0 === t && (t = {});
            var e = r.call(this, null, a.extend({}, t)) || this, i = e._popup = document.createElement("div");
            return i.className = "dhx_widget dhx_popup" + (e.config.css ? " " + e.config.css : ""), i.style.position = "absolute", i.setAttribute("role", "dialog"), i.setAttribute("aria-modal", "true"), i.setAttribute("aria-live", "polite"), e.mount(i, l.create({
                render: function () {
                    return e.toVDOM()
                }
            })), e._clickEvent = function (t) {
                return e.events.fire(h.PopupEvents.click, [t])
            }, e.events = t.events || new c.EventSystem(e), e._isActive = !1, e
        }

        e.Popup = o
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        e.default = {hours: "Hours", minutes: "Minutes", save: "Save"}
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), e.isTimeCheck = function (t) {
            return /(^12:[0-5][0-9]?AM$)/i.test(t)
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), e.linkButtonClasses = ".dhx_button.dhx_button--view_link.dhx_button--icon.dhx_button--size_medium.dhx_button--color_secondary"
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(0), o = i(4), i = (r.prototype.endEdit = function () {
            var t = this._checked;
            this._config.events.fire(o.GridEvents.beforeEditEnd, [t, this._cell.row, this._cell.col]) ? (this._cell.row = this._config.datacollection.getItem(this._cell.row.id), this._config.events.fire(o.GridEvents.afterEditEnd, [t, this._cell.row, this._cell.col])) : this._input.checked = !t
        }, r.prototype.toHTML = function () {
            return void 0 === this._checked && (this._checked = this._cell.row[this._cell.col.id]), n.el("label.dhx_checkbox.dhx_cell-editor__checkbox", [n.el("input.dhx_checkbox__input", {
                type: "checkbox",
                _hooks: {didInsert: this._handlers.didInsert},
                _key: "cell_editor",
                dhx_id: "cell_editor",
                checked: this._checked,
                style: {userSelect: "none"}
            }), n.el("span.dhx_checkbox__visual-input")])
        }, r.prototype._initHandlers = function () {
            var e = this;
            this._handlers = {
                onChange: function (t) {
                    t = t.target.checked;
                    e._config.events.fire(o.GridEvents.beforeEditStart, [e._cell.row, e._cell.col, "checkbox"]) ? (e._checked = t, e._config.events.fire(o.GridEvents.afterEditStart, [e._cell.row, e._cell.col, "checkbox"]), e.endEdit()) : e._input.checked = !t
                }, didInsert: function (t) {
                    e._checkbox = t.el.parentNode.lastChild, e._input = t.el.parentNode.firstChild, e._input.addEventListener("change", e._handlers.onChange)
                }
            }
        }, r);

        function r(t, e, i) {
            this._config = i, this._cell = {row: t, col: e}, this._initHandlers()
        }

        e.CheckboxEditor = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(0), o = i(4), r = i(56), s = i(10), i = (a.prototype.endEdit = function (t) {
            var e;
            t || (e = this._input.getValue()), this._config.events.fire(o.GridEvents.beforeEditEnd, [e, this._cell.row, this._cell.col]) ? (this._input.popup.hide(), document.removeEventListener("mousedown", this._handlers.onOuterClick), this._cell.row = this._config.datacollection.getItem(this._cell.row.id), s.focusManager.setFocusId(this._config.gridId), this._config.events.fire(o.GridEvents.afterEditEnd, [e, this._cell.row, this._cell.col])) : this._input.focus()
        }, a.prototype.toHTML = function () {
            var e = this, t = this._cell.col.options.map(function (t) {
                return {id: "" + t, value: t}
            }) || [];
            return this._input || (this._input = new r.Combobox(null, {
                readOnly: !0,
                cellHeight: 37,
                css: "dhx_cell-editor__combobox"
            }), this._input.data.parse(t), this._input.setValue(this._cell.row[this._cell.col.id])), document.addEventListener("mousedown", this._handlers.onOuterClick), this._config.$editable.editor = this, n.awaitRedraw().then(function () {
                var t = e._input.getRootView().refs.holder.el;
                e._input.popup.getContainer().style.width = t.offsetWidth + "px", e._input.popup.show(t)
            }), s.focusManager.setFocusId(this._input._uid), n.inject(this._input.getRootView())
        }, a.prototype._initHandlers = function () {
            var i = this;
            this._handlers = {
                onOuterClick: function (t) {
                    var e;
                    t.target instanceof Node && (e = i._input && i._input.getRootNode() && i._input.getRootNode().contains(t.target), t = i._input.popup && i._input.popup.getRootNode() && i._input.popup.getRootNode().contains(t.target), e || t || i.endEdit())
                }
            }
        }, a);

        function a(t, e, i) {
            this._config = i, this._cell = {row: t, col: e}, this._initHandlers()
        }

        e.ComboboxEditor = i
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), d = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(1), h = i(0), s = i(5), f = i(2), a = i(115), l = i(6), c = i(7), u = i(25), p = i(57), g = i(20),
            _ = i(119), v = i(59), m = i(27), y = i(120), b = i(60);

        function x(t) {
            return t.icon ? '<span class="' + t.icon + ' dhx_combobox-options__icon"></span> <span class="dhx_combobox-options__value">' + t.value + "</span>" : t.src ? '<img src="' + t.src + '" class="dhx_combobox-options__image" alt=' + t.value + '></img> <span class="dhx_combobox-options__value">' + t.value + "</span>" : '<span class="dhx_combobox-options__value">' + t.value + "</span>"
        }

        var w, o = (w = l.View, o(C, w), C.prototype.focus = function () {
            if (this.config.disabled) return !1;
            this.getRootView().refs.input.el.focus()
        }, C.prototype.enable = function () {
            this.config.disabled = !1, this.paint()
        }, C.prototype.disable = function () {
            this.config.disabled = !0, this.paint()
        }, C.prototype.isDisabled = function () {
            return this.config.disabled
        }, C.prototype.clear = function () {
            if (this.config.disabled) return !1;
            this.list.selection.remove(), this._state.value = "", this._filter(), this.paint()
        }, C.prototype.getValue = function (t) {
            var e = this.list.selection.getId();
            return t ? r.wrapBox(e) : Array.isArray(e) ? e.join(",") : e
        }, C.prototype.setValue = function (t) {
            return this._setValue(t)
        }, C.prototype.destructor = function () {
            this.popup && this.popup.destructor(), this.events && this.events.clear(), this.list && this.list.destructor(), this._helper && this._helper.destructor(), this._layout && this._layout.destructor(), this.config = this.events = this.list = this.popup = null, this._helper = this._keyListener = this._handlers = this._state = this._uid = this._isPopupConfiqureted = null, this.unmount()
        }, C.prototype.setState = function (t) {
            switch (t) {
                case"success":
                    this._state.currentState = b.ComboState.success;
                    break;
                case"error":
                    this._state.currentState = b.ComboState.error;
                    break;
                default:
                    this._state.currentState = b.ComboState.default
            }
            this.paint()
        }, C.prototype._setValue = function (t, e) {
            var i = this;
            if (void 0 === e && (e = !1), this.config.disabled || !this._exsistId(t)) return !1;
            this._filter(), this.config.multiselection || (this.list.selection.remove(), this._state.value = ""), this.config.multiselection ? ("string" == typeof t && (t = t.split(",")), t.forEach(function (t) {
                i.list.selection.add(t, !1, !1, e)
            })) : (t = r.unwrapBox(t), this.list.selection.add(t, !1, !1, e), (t = this.data.getItem(t)) && (this._state.value = this._getItemText(t))), this.paint()
        }, C.prototype._createLayout = function () {
            var t = this.list = new p.List(null, {
                template: this.config.template,
                virtual: this.config.virtual,
                keyNavigation: !1,
                multiselection: this.config.multiselection,
                itemHeight: this.config.itemHeight,
                height: this.config.listHeight,
                data: this.data
            }), e = this._layout = new u.Layout(this.popup.getContainer(), {
                css: "dhx_combobox-options dhx_combobox__options",
                rows: [{
                    id: "select-unselect-all",
                    hidden: !this.config.multiselection || !this.config.selectAllButton
                }, {id: "list", css: "dhx_layout-cell--gravity", height: "content"}, {id: "not-found", hidden: !0}],
                on: {click: {".dhx_combobox__action-select-all": this._handlers.selectAll}}
            });
            e.getCell("list").attach(t), this.config.multiselection && this.config.selectAllButton && e.getCell("select-unselect-all").attach(y.selectAllView)
        }, C.prototype._initHandlers = function () {
            var i = this;
            this.config.helpMessage && (this._helper = new g.Popup({css: "dhx_tooltip dhx_tooltip--forced dhx_tooltip--light"}), this._helper.attachHTML(this.config.helpMessage)), this._handlers = {
                showHelper: function (t) {
                    t.preventDefault(), t.stopPropagation(), i._helper.show(t.target, {mode: "left" === i.config.labelPosition ? "bottom" : "right"})
                }, selectAll: function () {
                    i._state.unselectActive ? (i.list.selection.remove(), i.config.selectAllButton && (i._layout.getCell("select-unselect-all").attach(y.selectAllView), i._state.unselectActive = !1)) : (i.data.filter(), i.list.selection.add(), i.config.selectAllButton && (i._layout.getCell("select-unselect-all").attach(y.unselectAllView), i._state.unselectActive = !0)), i._changePopupPosition(), i.paint()
                }, onkeydown: function (t) {
                    "Tab" === t.key && i.popup.isVisible() ? i._hideOptions() : (i.popup.isVisible() || t.which !== a.KEY_CODES.DOWN_ARROW || i._showOptions(), i.popup.isVisible() && t.which === a.KEY_CODES.RIGHT_ARROW && i.config.readOnly && !i.config.multiselection && (i.list.moveFocus(p.MOVE_DOWN), t.preventDefault()), i.popup.isVisible() && t.which === a.KEY_CODES.LEFT_ARROW && i.config.readOnly && !i.config.multiselection && (i.list.moveFocus(p.MOVE_UP), t.preventDefault()), i.popup.isVisible() && t.which === a.KEY_CODES.DOWN_ARROW && (i.list.moveFocus(p.MOVE_DOWN), t.preventDefault()), i.popup.isVisible() && t.which === a.KEY_CODES.UP_ARROW && (i.list.moveFocus(p.MOVE_UP), t.preventDefault()), i.popup.isVisible() && t.which === a.KEY_CODES.ESC && i._hideOptions(), i.popup.isVisible() && t.which === a.KEY_CODES.ENTER && (i.setValue(i.list.getFocus()), i.config.multiselection || i._hideOptions()))
                }, onkeyup: function (t) {
                    i.config.multiselection && !i.config.itemsCount && (i._state.ignoreNext ? i._state.ignoreNext = !1 : t.which === a.KEY_CODES.BACKSPACE && i._state.canDelete && i.list.selection.getId().length && (t = (t = i.list.selection.getId())[t.length - 1], i.list.selection.remove(t), i.paint()))
                }, oninput: function (t) {
                    i.config.disabled || (t = t.target.value, i.events.fire(b.ComboboxEvents.input, [t]), i._state.value = t, i._filter(), t.length ? i._state.canDelete = !1 : (i._state.ignoreNext = !0, i._state.canDelete = !0), i.config.multiselection || (i.list.selection.remove(), i.paint()), i.popup.isVisible() || i._showOptions())
                }, oninputclick: function (t) {
                    if (!i.config.disabled) {
                        if (i.focus(), t.target.classList.contains("dhx_combobox__action-remove")) {
                            var e = f.locate(t);
                            return e ? (i.list.selection.remove(e), i._changePopupPosition(), void i.paint()) : void 0
                        }
                        if (t.target.classList.contains("dhx_combobox__action-clear-all")) return i.list.selection.getId().forEach(function (t) {
                            return i.list.selection.remove(t)
                        }), i.config.selectAllButton && i._state.unselectActive && (i._layout.getCell("select-unselect-all").attach(y.selectAllView), i._state.unselectActive = !1), void i.paint();
                        t.preventDefault(), i.popup.isVisible() ? i.focus() : i._showOptions()
                    }
                }, toggleIcon: function () {
                    i.focus(), i.popup.isVisible() ? i._hideOptions() : i._showOptions()
                }
            }
        }, C.prototype._initEvents = function () {
            var i = this;
            this.data.events.on(c.DataEvents.load, function () {
                i.config.value && i._setValue(i.config.value, !0)
            }), this.list.events.on(p.ListEvents.click, function () {
                i.config.multiselection || i._hideOptions(), i._changePopupPosition()
            }), this.list.selection.events.on(m.SelectionEvents.afterSelect, function () {
                var t = i.getValue(i.config.multiselection);
                i.events.fire(b.ComboboxEvents.change, [t]), i._updateSelectedItem(t)
            }), this.list.selection.events.on(m.SelectionEvents.afterUnSelect, function () {
                var t = i.config.multiselection, e = i.getValue(t);
                i.events.fire(b.ComboboxEvents.change, [e]), t && i._updateSelectedItem(e)
            }), this.popup.events.on(g.PopupEvents.beforeShow, function () {
                if (!i.popup.isVisible() && !i._isPopupConfiqureted) return i._configurePopup(), !1
            }), this.config.readOnly && this.popup.events.on(g.PopupEvents.afterShow, function () {
                var t;
                i._state.value ? (t = i.list.selection.getId(), i.list.setFocus(t)) : i.list.setFocus(i.data.getId(0)), i._keyListener.startNewListen(function (t) {
                    return i._findBest(t)
                })
            })
        }, C.prototype._showOptions = function () {
            this._state.value.length && (this._state.canDelete = !0), this._filter(), this._configurePopup() && this.events.fire(b.ComboboxEvents.open)
        }, C.prototype._configurePopup = function () {
            this._isPopupConfiqureted = !0;
            var t = this.getRootView();
            return !!(t && t.refs && t.refs.holder) && (this.popup.isVisible() || (t = t.refs.holder.el, this.popup.getContainer().style.width = t.offsetWidth + "px", this.popup.show(t, {mode: "bottom"})), !0)
        }, C.prototype._hideOptions = function () {
            var t = this;
            this.events.fire(b.ComboboxEvents.beforeClose) && (this.config.readOnly && this._keyListener.endListen(), this.list.setFocus(this.data.getId(0)), this.config.multiselection || this.config.readOnly || this.list.selection.contains() || (this._state.value = ""), h.awaitRedraw().then(function () {
                return t.popup.isVisible() && t.popup.hide()
            }), this.events.fire(b.ComboboxEvents.afterClose), this.events.fire(b.ComboboxEvents.close), this._filter(), this.paint())
        }, C.prototype._filter = function () {
            var t, e = this;
            this.config.readOnly || (this.data.filter(function (t) {
                return e.config.filter ? e.config.filter(t, e._state.value) : r.isEqualString(e._state.value, e._getItemText(t))
            }), this.config.multiselection ? this.list.setFocus(this.data.getId(0)) : (t = this.data.getIndex(this.list.selection.getId()), this.list.setFocus(this.data.getId(-1 < t ? t : 0))), 0 === this.data.getLength() ? (this.config.multiselection && this.config.selectAllButton && this._layout.getCell("select-unselect-all").hide(), this._layout.getCell("list").hide(), this._layout.getCell("not-found").attach(y.emptyListView), this._layout.getCell("not-found").show()) : (this.config.multiselection && this.config.selectAllButton && this._layout.getCell("select-unselect-all").show(), this._layout.getCell("not-found").isVisible() && (this._layout.getCell("list").show(), this._layout.getCell("not-found").hide())))
        }, C.prototype._findBest = function (e) {
            var i = this, t = this.data.find(function (t) {
                return r.isEqualString(e, i._getItemText(t))
            });
            t && this.list.selection.getId() !== t.id && (this.list.setFocus(t.id), this.paint())
        }, C.prototype._exsistId = function (t) {
            var e = this;
            return t instanceof Array ? t.every(function (t) {
                return e.data.exists(t)
            }) : "string" == typeof t ? this.data.exists(t) : void 0
        }, C.prototype._draw = function () {
            var t = this.config, e = t.multiselection, i = t.labelPosition, n = t.hiddenLabel, o = t.required,
                r = t.disabled, s = t.css, a = t.helpMessage, l = t.readOnly, c = t.placeholder,
                u = e ? null : this.data.getItem(this.list.selection.getId()),
                t = !this.list.selection.getId() || 0 === this.list.selection.getId().length,
                e = f.getLabelStyle(this.config);
            return h.el("div", {
                dhx_widget_id: this._uid,
                onkeydown: this._handlers.onkeydown,
                onkeyup: this._handlers.onkeyup,
                class: "dhx_widget dhx_combobox" + ("left" === i ? " dhx_combobox--label-inline" : "") + (n ? " dhx_combobox--sr_only" : "") + (o ? " dhx_combobox--required" : "") + (r ? " dhx_combobox--disabled" : "") + (s ? " " + s : "")
            }, [e ? h.el("label.dhx_label.dhx_combobox__label", {
                style: e.style,
                class: a ? "dhx_label--with-help" : "",
                onclick: this._handlers.oninputclick
            }, a ? [(e.label || o) && h.el("span.dhx_label__holder", e.label), h.el("span.dhx_label-help.dxi.dxi-help-circle-outline", {
                tabindex: "0",
                role: "button",
                onclick: this._handlers.showHelper,
                id: "dhx_label__help_" + this._uid
            })] : e.label) : null, h.el("div.dhx_combobox-input-box" + (r ? ".dhx_combobox-input-box--disabled" : "") + (l ? ".dhx_combobox-input-box--readonly" : "") + (this._state.currentState === b.ComboState.error ? ".dhx_combobox-input-box--state_error" : "") + (this._state.currentState === b.ComboState.success ? ".dhx_combobox-input-box--state_success" : ""), {_ref: "holder"}, [h.el("div.dhx_combobox-input__icon", {onclick: this._handlers.toggleIcon}, [h.el("span" + (this.popup.isVisible() ? ".dxi.dxi-menu-up" : ".dxi.dxi-menu-down"))]), h.el("div.dhx_combobox-input-list-wrapper", {onclick: this._handlers.oninputclick}, [h.el("ul.dhx_combobox-input-list", d(this._drawSelectedItems(), [h.el("li.dhx_combobox-input-list__item.dhx_combobox-input-list__item--input", [h.el("input.dhx_combobox-input", {
                oninput: this._handlers.oninput,
                _ref: "input",
                _key: this._uid,
                type: "text",
                placeHolder: t && c ? c : void 0,
                value: l && u ? this._getItemText(u) : this._state.value,
                readOnly: l || r,
                required: o,
                "aria-label": l ? "Select value" : "Type or select value",
                "aria-describedby": a ? "dhx_label__help_" + this._uid : null,
                "aria-expanded": !0
            })])]))])])])
        }, C.prototype._drawSelectedItems = function () {
            var t, i = this;
            if (!this.config.multiselection) return [];
            if (this.config.itemsCount) {
                var e = this.list.selection.getId().length;
                return e ? [h.el("li.dhx_combobox-input-list__item.dhx_combobox-tag", [h.el("span.dhx_combobox-tag__value", (t = e, "function" == typeof (e = this.config.itemsCount) ? e(t) : t + " " + v.default.selectedItems)), h.el("button.dhx_button.dhx_combobox-tag__action.dhx_combobox__action-clear-all", {"aria-label": "clear all"}, [h.el("span.dhx_button__icon.dxi.dxi-close-circle")])])] : []
            }
            return this.list.selection.getId().map(function (t) {
                var e = i.data.getItem(t);
                return e ? h.el("li.dhx_combobox-input-list__item.dhx_combobox-tag", {dhx_id: t}, [i._drawImageOrIcon(e), h.el("span.dhx_combobox-tag__value", i._getItemText(e)), h.el("button.dhx_button.dhx_button--icon.dhx_combobox-tag__action.dhx_combobox__action-remove", {
                    type: "button",
                    "aria-label": "remove"
                }, [h.el("span.dhx_button__icon.dxi.dxi-close-circle")])]) : null
            })
        }, C.prototype._drawImageOrIcon = function (t) {
            return t.src ? h.el("img.dhx_combobox-tag__image", {
                src: t.src,
                alt: ""
            }) : t.icon ? h.el("span.dhx_combobox-tag__icon", {class: t.icon}) : null
        }, C.prototype._getItemText = function (t) {
            return t ? t.value : null
        }, C.prototype._updateSelectedItem = function (t) {
            this.config.multiselection ? (this.config.selectAllButton && !this._state.unselectActive && this.data.getLength() === t.length ? (this._layout.getCell("select-unselect-all").attach(y.unselectAllView), this._state.unselectActive = !0) : this.config.selectAllButton && this._state.unselectActive && (this._layout.getCell("select-unselect-all").attach(y.selectAllView), this._state.unselectActive = !1), this._state.value.length || (this._state.canDelete = 0 === t.length)) : this._state.value = this._getItemText(this.data.getItem(t)) || "", this.paint()
        }, C.prototype._changePopupPosition = function () {
            var e = this;
            this.config.multiselection && h.awaitRedraw().then(function () {
                var t = e.getRootView().refs.holder.el;
                e.popup.getContainer().style.width = t.offsetWidth + "px", e.popup.show(t, {mode: "bottom"})
            })
        }, C);

        function C(t, e) {
            var i = w.call(this, t, r.extend({
                template: x,
                listHeight: 224,
                itemHeight: 36,
                disabled: !1,
                readOnly: !1
            }, e)) || this;
            i.config.itemsCount = i.config.itemsCount || i.config.showItemsCount, i.config.helpMessage = i.config.helpMessage || i.config.help, i.config.cellHeight && 32 === i.config.itemHeight && (i.config.itemHeight = i.config.cellHeight), i.config.labelInline && (i.config.labelPosition = "left"), Array.isArray(i.config.data) ? (i.events = new s.EventSystem(i), i.data = new c.DataCollection({}), i.data.parse(i.config.data)) : i.config.data ? (i.data = i.config.data, i.events = new s.EventSystem(i), i.events.context = i) : (i.events = new s.EventSystem(i), i.data = new c.DataCollection({})), i.popup = new g.Popup, i.popup.events.on(g.PopupEvents.afterShow, function () {
                i.paint()
            }), i.popup.events.on(g.PopupEvents.afterHide, function () {
                i.config.multiselection && (i._state.value = ""), i.paint()
            }), i.popup.events.on(g.PopupEvents.beforeHide, function (t) {
                t && i._hideOptions()
            }), (i.config.readonly || i.config.readOnly) && (i.config.readOnly = i.config.readOnly || i.config.readonly, i._keyListener = new _.KeyListener), i._state = {
                value: "",
                ignoreNext: !1,
                canDelete: !1,
                unselectActive: !1,
                currentState: b.ComboState.default
            }, i._initHandlers(), i._createLayout(), i.config.value && i._setValue(i.config.value, !0), i._initEvents();
            e = h.create({
                render: function () {
                    return i._draw()
                }, hooks: {
                    didRedraw: function () {
                        i.popup.isVisible() && (i.focus(), i._configurePopup())
                    }
                }
            });
            return i.mount(t, e), i
        }

        e.Combobox = o
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), e.KEY_CODES = {
            BACKSPACE: 8,
            ENTER: 13,
            ESC: 27,
            DOWN_ARROW: 40,
            UP_ARROW: 38,
            LEFT_ARROW: 37,
            RIGHT_ARROW: 39
        }
    }, function (t, r, e) {
        "use strict";
        var n, i = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), s = this && this.__assign || function () {
            return (s = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        }, a = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(r, "__esModule", {value: !0});
        var l = e(1), c = e(7), u = e(0), d = e(19), h = e(10), f = e(27), o = e(6), p = e(58), g = e(2), _ = e(38),
            v = e(117);
        r.MOVE_UP = 1, r.MOVE_DOWN = 2;
        var m, i = (m = o.View, i(y, m), y.prototype._didRedraw = function (t) {
        }, y.prototype._dblClick = function (t) {
            var e = g.locate(t);
            e && (this.config.editable && this.editItem(e), this.events.fire(_.ListEvents.doubleClick, [e, t]))
        }, y.prototype._clearTouchTimer = function () {
            this._touch.timer && (clearTimeout(this._touch.timer), this._touch.timer = null)
        }, y.prototype._dragStart = function (t) {
            var e = this;
            this._touch.start = !0;
            var i = [], n = g.locateNode(t, "dhx_id"), o = n && n.getAttribute("dhx_id"), n = this.selection.getId();
            return this.config.multiselection && n instanceof Array && (n.map(function (t) {
                t !== o && e.getRootView().refs[t] && i.push(e.getRootView().refs[t].el)
            }), n = a(n)), "string" == typeof n && (n = [n]), this.config.dragMode && !this._edited ? c.dragManager.onMouseDown(t, n || [o], i) : null
        }, y.prototype.disableSelection = function () {
            this.selection.disable()
        }, y.prototype.enableSelection = function () {
            this.selection.enable()
        }, y.prototype.editItem = function (t) {
            this._edited = t, this.data.getItem(this._edited) && this.events.fire(_.ListEvents.beforeEditStart, [t]) ? (this._getHotkeys(), this.paint(), this.events.fire(_.ListEvents.afterEditStart, [t])) : this._edited = null
        }, y.prototype.editEnd = function (t, e) {
            var i;
            this._edited && (null !== t && (i = this.data.getItem(e), this.data.update(e, s(s({}, i), {value: t}))), this._edited = null, this.paint())
        }, y.prototype.getFocusItem = function () {
            return this.data.getItem(this._focus)
        }, y.prototype.setFocus = function (t) {
            this._focus != t && this.data.exists(t) && (this._focus = t, this.showItem(t), this.events.fire(_.ListEvents.focusChange, [this.data.getIndex(this._focus), this._focus]), this.paint())
        }, y.prototype.getFocus = function () {
            return this._focus
        }, y.prototype.destructor = function () {
            this.events && this.events.clear(), this.keyManager && this.keyManager.destructor(), this.selection && this.selection.destructor(), this.config = this.events = this.selection = this.keyManager = null, this._handlers = this._focus = this._edited = this._events = this._topOffset = this._visibleHeight = this._touch = null, this.unmount()
        }, y.prototype.showItem = function (t) {
            var e, i, n, o = this.getRootView();
            o && o.node && o.node.el && void 0 !== t && ((e = this.getRootNode()) && (i = this.config.virtual, n = this.data.getIndex(t), o = Math.floor(n / e.children.length) || 0, t = e.children[n - e.children.length * o], (i || t) && (o = i ? parseInt(this.config.itemHeight) : t.clientHeight, (t = i ? n * o : t.offsetTop) >= e.scrollTop + e.clientHeight - o ? e.scrollTo(0, t - e.clientHeight + o) : t < e.scrollTop && e.scrollTo(0, t))))
        }, y.prototype._renderItem = function (t, e) {
            var i = this.config.itemHeight;
            if (t.$empty) return u.el("li", {class: "dhx_list-item", style: {height: i}});
            var n = this.config.template && this.config.template(t) || t.html, o = t.id === this._focus;
            if (t.id === this._edited) return v.getEditor(t, this).toHTML();
            var r = this.data.getMetaMap(t), o = s(s(s(s({}, this._events), {
                class: "dhx_list-item" + (r && r.selected ? " dhx_list-item--selected" : "") + (o ? " dhx_list-item--focus" : "") + (r && r.drop && !this._edited ? " dhx_list-item--drophere" : "") + (r && r.drag && !this._edited ? " dhx_list-item--dragtarget" : "") + (this.config.dragMode && !this._edited ? " dhx_list-item--drag" : "") + (t.css ? " " + t.css : ""),
                dhx_id: t.id,
                _ref: t.id.toString(),
                style: {height: i},
                _key: t.id,
                ".innerHTML": n
            }), this.getItemAriaAttrs(this, t)), {tabindex: o ? 0 : -1});
            return n ? (o[".innerHTML"] = n, u.el("li", o)) : (o.class += " dhx_list-item--text", u.el("li", o, t.text || t.value))
        }, y.prototype._renderList = function () {
            var i = this, t = this._getRange(), e = this.data.getRawData(t[0], t[1]).map(function (t, e) {
                return i._renderItem(t, e)
            });
            return this.config.virtual && (e = a([u.el(".div", {style: {height: t[2] + "px"}})], e, [u.el(".div", {style: {height: t[3] + "px"}})])), u.el("ul.dhx_widget.dhx_list", s(s({
                style: {
                    "min-height": this.config.itemHeight,
                    "max-height": this.config.height,
                    position: "relative"
                },
                class: (this.config.css || "") + (this.config.multiselection && this.selection.getItem() ? " dhx_no-select--pointer" : ""),
                dhx_widget_id: this._uid
            }, this._handlers), this.getListAriaAttrs(this.config, this.data.getLength())), e)
        }, y.prototype.moveFocus = function (t, e) {
            var i, n, o = this.data.getLength();
            o && (n = (i = this._focus) ? this.data.getIndex(i) : -1, e = e || 1, t === r.MOVE_DOWN ? i = this.data.getId(Math.min(n + e, o - 1)) : t === r.MOVE_UP && (i = this.data.getId(Math.max(n - e, 0))), this.setFocus(i))
        }, y.prototype._getRange = function () {
            if (this.config.virtual) {
                var t = this._visibleHeight || parseInt(this.config.height), e = parseInt(this.config.itemHeight),
                    i = this.data.getLength(), n = this.data.getLength() * e, o = this._topOffset,
                    o = Math.max(0, Math.min(o, n - t)), r = Math.floor(o / e),
                    t = Math.min(i - r, Math.floor(t / e) + 5);
                return this._topOffset = o, [r, t + r, r * e, n - e * (t + r)]
            }
            return [0, -1, 0, 0]
        }, y.prototype._getHotkeys = function () {
            var e = this;
            return {
                arrowDown: function (t) {
                    e.moveFocus(r.MOVE_DOWN), t.preventDefault()
                }, arrowUp: function (t) {
                    e.moveFocus(r.MOVE_UP), t.preventDefault()
                }, escape: function () {
                    e.editEnd(null)
                }, enter: function (t) {
                    e.selection.add(e._focus), e.events.fire(_.ListEvents.click, [e._focus, t])
                }, "shift+enter": function (t) {
                    e.selection.add(e._focus, !1, !0), e.events.fire(_.ListEvents.click, [e._focus, t])
                }, "ctrl+enter": function (t) {
                    e.selection.add(e._focus, !0, !1), e.events.fire(_.ListEvents.click, [e._focus, t])
                }, "ctrl+a": function (t) {
                    e.config.multiselection && (t.preventDefault(), e.selection.remove(), e.data.map(function (t) {
                        return t.id
                    }).forEach(function (t) {
                        "ctrlClick" === e.config.multiselection ? e.selection.add(t, !0) : e.selection.add(t)
                    }))
                }
            }
        }, y.prototype._initHotKey = function () {
            var t, e = this._getHotkeys();
            for (t in e) this.keyManager.addHotKey(t, e[t]);
            for (t in this.config.hotkeys) this.keyManager.addHotKey(t, this.config.hotkeys[t])
        }, y.prototype.getItemAriaAttrs = function (t, e) {
            var i, n, o;
            return s(s({
                role: "option",
                "aria-selected": e.$selected ? "true" : "false"
            }, (o = e, (n = t).config.dragMode && !n._edited ? {"aria-grabbed": Boolean(o.$dragtarget && !n._edited).toString()} : {})), (i = t).config.editable ? {"aria-roledescription": i._edited ? "Press Enter to stop editing" : "Double click to edit content"} : {})
        }, y.prototype.getListAriaAttrs = function (t, e) {
            return {
                role: "listbox",
                "aria-label": "Listbox " + (t.title || "") + ", count of options = " + e + "." + (t.editable ? " Content is editable." : ""),
                "aria-multiselectable": t.selection && t.multiselection ? "true" : "false",
                "aria-readonly": t.editable ? "false" : "true"
            }
        }, y);

        function y(t, e) {
            void 0 === e && (e = {});
            var n = this, i = e.itemHeight || (e.virtual ? 37 : null);
            i && "number" == typeof i && (i = i.toString() + "px"), (n = m.call(this, t, l.extend({
                itemHeight: i,
                keyNavigation: !0,
                editable: !1,
                selection: !0
            }, e)) || this)._touch = {duration: 350, dblDuration: 300, timer: null, start: !1, timeStamp: null};
            e = n.config.data;
            e instanceof c.DataCollection ? (n.data = e, n.events = e.events) : (n.data = new c.DataCollection({}), n.events = n.data.events, e && n.data.parse(e)), n.selection = new p.Selection({
                disabled: !n.config.selection,
                multiselection: n.config.multiselection
            }, n.data, n.events), n.config.keyNavigation && (n.keyManager = new d.KeyManager(function (t, e) {
                return e === n._uid && (!n._edited || n._edited && "escape" !== t.key)
            }), n._initHotKey(), h.focusManager.setFocusId(n._uid)), n.events.on(c.DataEvents.change, function (t, e, i) {
                "setPage" === e && n.showItem(n.data.getId(i[0])), n.paint()
            }), n.events.on(f.SelectionEvents.afterUnSelect, function () {
                return n.paint()
            }), n.events.on(f.SelectionEvents.afterSelect, function () {
                return n.paint()
            }), n.events.on(_.ListEvents.afterEditEnd, n.editEnd.bind(n));
            e = function (e) {
                return function (t) {
                    n.data.setMeta(n.data.getItem(t.target), "drop", e), n.paint()
                }
            };
            n.events.on(c.DragEvents.canDrop, e(!0)), n.events.on(c.DragEvents.cancelDrop, e(!1));
            e = function (e) {
                return function (t) {
                    t.source.map(function (t) {
                        return n.data.setMeta(n.data.getItem(t), "drag", e)
                    }), n.paint()
                }
            };
            n.events.on(c.DragEvents.dragStart, e(!0)), n.events.on(c.DragEvents.afterDrag, e(!1)), n._handlers = {
                onmousedown: function (t) {
                    n._dragStart(t)
                }, ontouchstart: function (t) {
                    n._touch.timer = setTimeout(function () {
                        n._dragStart(t)
                    }, n._touch.duration), n._touch.timeStamp ? (n._touch.dblDuration >= n._touch.timeStamp - +t.timeStamp.toFixed() && (t.preventDefault(), n._dblClick(t)), n._touch.timeStamp = null) : n._touch.timeStamp = +t.timeStamp.toFixed(), setTimeout(function () {
                        n._touch.timeStamp = null
                    }, n._touch.dblDuration)
                }, ontouchmove: function (t) {
                    n._touch.start && t.preventDefault(), n._clearTouchTimer()
                }, ontouchend: function () {
                    n._touch.start = !1, n._clearTouchTimer()
                }, ondragstart: function () {
                    return !(n.config.dragMode && !n._edited) && null
                }, oncontextmenu: function (t) {
                    var e = g.locate(t);
                    e && n.events.fire(_.ListEvents.itemRightClick, [e, t])
                }, onclick: function (t) {
                    var e = g.locate(t);
                    e && (n.selection.add(e, t.ctrlKey || t.metaKey, t.shiftKey), n.events.fire(_.ListEvents.click, [e, t]), n._focus = e, n.paint())
                }, ondblclick: function (t) {
                    n._dblClick(t)
                }, onscroll: function (t) {
                    n.config.virtual && (n._topOffset = t.target.scrollTop, n._visibleHeight = t.target.offsetHeight, n.paint())
                }, onmouseover: function (t) {
                    var e = g.locate(t);
                    e && e !== g.locate(t.relatedTarget) && n.events.fire(_.ListEvents.itemMouseOver, [e, t])
                }
            };
            e = n.config.eventHandlers;
            if (e) for (var o = 0, r = Object.entries(e); o < r.length; o++) {
                var s = r[o], a = s[0], s = s[1];
                n._handlers[a] = g.eventHandler(function (t) {
                    return g.locate(t)
                }, s, n._handlers[a])
            }
            n.config.dragMode && c.dragManager.setItem(n._uid, n), n._topOffset = n._visibleHeight = 0;
            e = u.create({
                render: function () {
                    return n._renderList()
                }, hooks: {
                    didMount: function (t) {
                        n.config.virtual && (n._visibleHeight = t.node.el.offsetHeight)
                    }, didRedraw: function (t) {
                        return n._didRedraw(t)
                    }
                }
            });
            return n.mount(t, e), n
        }

        r.List = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(118);
        e.getEditor = function (t, e) {
            return new n.InputEditor(t, e)
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(0), o = i(38), i = (r.prototype.endEdit = function () {
            var t;
            this._input && (t = this._input.value, this._list.events.fire(o.ListEvents.beforeEditEnd, [t, this._item.id]) ? (this._input.removeEventListener("blur", this._handlers.onBlur), this._input.removeEventListener("change", this._handlers.onChange), this._handlers = {}, this._mode = !1, this._list.events.fire(o.ListEvents.afterEditEnd, [t, this._item.id])) : this._input.focus())
        }, r.prototype.toHTML = function () {
            this._mode = !0;
            var t = this._config.itemHeight;
            return n.el(".dhx_input__wrapper", {role: "presentation"}, [n.el("div.dhx_input__container", {role: "presentation"}, [n.el("input.dhx_input", {
                class: this._item.css ? " " + this._item.css : "",
                style: {height: t, width: "100%", padding: "8px, 12px"},
                _hooks: {didInsert: this._handlers.didInsert},
                _key: this._item.id,
                dhx_id: this._item.id
            })])])
        }, r.prototype._initHandlers = function () {
            var e = this;
            this._handlers = {
                onBlur: function () {
                    e.endEdit()
                }, onChange: function () {
                    e.endEdit()
                }, didInsert: function (t) {
                    t = t.el;
                    (e._input = t).focus(), t.value = e._item.value, t.setSelectionRange(0, t.value.length), t.addEventListener("change", e._handlers.onChange), t.addEventListener("blur", e._handlers.onBlur)
                }
            }
        }, r);

        function r(t, e) {
            var i = this;
            this._list = e, this._config = e.config, this._item = t, this._list.events.on(o.ListEvents.focusChange, function (t, e) {
                i._mode && e !== i._item.id && i.endEdit()
            }), this._initHandlers()
        }

        e.InputEditor = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = (o.prototype.startNewListen = function (t) {
            this._isActive = !0, this._sequence = "", this._currentAction = t
        }, o.prototype.endListen = function () {
            this._currentAction = null, this.reset(), this._isActive = !1
        }, o.prototype.reset = function () {
            this._sequence = ""
        }, o.prototype._change = function () {
            this._currentAction(this._sequence), this._addClearTimeout()
        }, o.prototype._addClearTimeout = function () {
            var t = this;
            this._clearTimeout && clearTimeout(this._clearTimeout), this._clearTimeout = setTimeout(function () {
                t.reset(), t._clearTimeout = null
            }, 2e3)
        }, o);

        function o() {
            var e = this;
            this._sequence = "", document.addEventListener("keydown", function (t) {
                e._isActive && ("Backspace" === (t = t.key) && 0 < e._sequence.length && (e._sequence = e._sequence.slice(0, e._sequence.length - 1), e._change()), t.length < 2 && (e._sequence += t, e._change()))
            })
        }

        e.KeyListener = n
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(0), o = i(59);
        e.selectAllView = function () {
            return n.el(".dhx_list-item.dhx_combobox-options__item.dhx_combobox-options__item--select-all.dhx_combobox__action-select-all", o.default.selectAll)
        }, e.unselectAllView = function () {
            return n.el(".dhx_list-item.dhx_combobox-options__item.dhx_combobox-options__item--select-all.dhx_combobox__action-select-all", o.default.unselectAll)
        }, e.emptyListView = function () {
            return n.el("ul.dhx_list", [n.el("li.dhx_list-item.dhx_combobox-options__item", {}, o.default.notFound)])
        }
    }, function (t, e, i) {
        "use strict";
        var r = this && this.__assign || function () {
            return (r = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(0), s = i(4), o = i(1), a = i(15), i = (l.prototype.endEdit = function (t) {
            var e;
            t || (e = this._editor.value), this._config.events.fire(s.GridEvents.beforeEditEnd, [e, this._cell.row, this._cell.col]) ? (this._editor.removeEventListener("blur", this._handlers.onBlur), this._editor.removeEventListener("change", this._handlers.onChange), this._editor.removeEventListener("input", this._handlers.onInput), "string" !== this._cell.col.type && o.isNumeric(e) && (e = parseFloat(e)), this._cell.row = this._config.datacollection.getItem(this._cell.row.id), this._config.events.fire(s.GridEvents.afterEditEnd, [e, this._cell.row, this._cell.col])) : this._editor.focus()
        }, l.prototype.toHTML = function () {
            var t = this._cell.row[this._cell.col.id];
            this._editor && (t = this._editor.value);
            var e = void 0 !== (this._config.$editable.editor = this)._cell.row.height || this._cell.col.htmlEnable ? "dhx_cell-editor dhx_cell-editor__textarea_constant-height" : "dhx_cell-editor dhx_cell-editor__textarea";
            return n.el("textarea", {
                _hooks: {didInsert: this._handlers.didInsert},
                _ref: "textarea",
                _key: "cell_editor",
                dhx_id: "cell_editor",
                value: t,
                class: e,
                style: {width: this._width}
            })
        }, l.prototype._initHandlers = function () {
            var o = this;
            this._handlers = {
                onBlur: function () {
                    o.endEdit()
                }, onChange: function () {
                    o.endEdit()
                }, onInput: function (t) {
                    if (void 0 === o._cell.row.height && !o._cell.col.htmlEnable) {
                        var e = o._getCurrentHeight(o._editor.value, {
                            width: o._cell.col.$width - 2,
                            maxHeight: o._config.rowHeight
                        });
                        o._cell.row[o._cell.col.id] = o._editor.value;
                        var i = a.getCalculatedRowHeight(a.getMaxRowHeight(o._cell.row, o._config.columns)),
                            n = a.getCalculatedRowHeight(a.getMaxRowHeight(((n = {})[o._cell.col.id] = o._cell.row[o._cell.col.id], n), o._config.columns));
                        if (o._minHeight = i === n ? o._config.rowHeight : i, e >= o._minHeight && e !== o._prevHeight) {
                            if (!o._config.events.fire(s.GridEvents.beforeRowResize, [o._cell.row, t, e])) return;
                            o._config.events.fire(s.GridEvents.afterRowResize, [o._cell.row, t, e])
                        }
                        o._prevHeight = e
                    }
                }, didInsert: function (t) {
                    o._editor = t.el, o._editor.focus(), o._editor.setSelectionRange(0, o._editor.value.length), o._editor.addEventListener("change", o._handlers.onChange), o._editor.addEventListener("blur", o._handlers.onBlur), o._editor.addEventListener("input", o._handlers.onInput)
                }
            }
        }, l.prototype._getCurrentHeight = function (t, e) {
            e = r({width: 100, maxHeight: 40, lineHeight: 20}, e);
            var i = document.createElement("textarea");
            i.className = "dhx_cell-editor dhx_cell-editor__textarea", i.value = t, i.style.width = e.width + "px", i.style.lineHeight = e.lineHeight + "px", i.style.maxHeight = e.maxHeight + "px", i.style.boxSizing = "border-box", document.body.appendChild(i);
            var n = this._getElementHeight(i), o = i.value.split("\n").length, t = Math.round(n / e.lineHeight),
                n = n < e.maxHeight ? e.maxHeight : n;
            return document.body.removeChild(i), 1 === o && o === t ? e.maxHeight : n
        }, l.prototype._getElementHeight = function (t) {
            return t.scrollHeight
        }, l);

        function l(t, e, i) {
            this._config = i, this._cell = {row: t, col: e}, this._width = this._cell.col.$width;
            e = 0;
            this._config.firstColId === this._cell.col.id && this._cell.row.hasOwnProperty("$level") && (e = a.getTreeCellWidthOffset(this._cell.row)), this._width -= e - 4, this._initHandlers()
        }

        e.TextAreaEditor = i
    }, function (t, e, i) {
        "use strict";
        var h = this && this.__assign || function () {
            return (h = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        }, f = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var p = i(0), g = i(2), _ = i(36), v = i(61), m = i(11);
        e.getFixedColsHeader = function (t, e) {
            if ("number" == typeof t.leftSplit) {
                for (var i = 0, n = 0; n < t.leftSplit; n++) t.columns[n].hidden && i++;
                if (i !== t.leftSplit) {
                    for (var o = t.columns.slice(0, t.leftSplit - i), r = 0, s = 0, a = o; s < a.length; s++) r += a[s].$width;
                    o = 0 <= t.leftSplit && v.getFixedRows(h(h({}, t), {
                        currentColumns: o,
                        $positions: h(h({}, t.$positions), {xStart: 0, xEnd: t.leftSplit}),
                        scroll: {top: 0, left: 0},
                        columns: o
                    }), h(h({}, e), {
                        name: "header",
                        position: "top",
                        shifts: {x: 0, y: 0}
                    })), e = h(h({}, e), {name: "header", position: "top"});
                    return o && p.el(".dhx_" + e.name + "-fixed-cols", {
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            maxWidth: r,
                            overflow: "hidden"
                        }, role: "rowgroup", "aria-rowcount": o.length
                    }, o.body)
                }
            }
        }, e.getFixedCols = function (t, e) {
            if ("number" == typeof t.leftSplit) {
                for (var i = 0, n = 0; n < t.leftSplit; n++) t.columns[n].hidden && i++;
                if (i !== t.leftSplit) {
                    var o = t.$totalWidth <= e.wrapper.width ? 0 : g.getScrollbarWidth(),
                        r = t.$totalHeight + t.headerHeight + t.footerHeight, s = r - (r > e.gridBodyHeight ? o : null),
                        a = t.columns.slice(0, t.leftSplit - i);
                    t.fixedColumnsWidth = m.getTotalWidth(a);
                    var l = _.getCells(h(h({}, t), {
                            columns: a,
                            $positions: h(h({}, t.$positions), {xStart: 0, xEnd: t.leftSplit})
                        })), c = e.sticky, u = h(h({}, e), {name: "footer", position: "bottom"}),
                        r = 0 <= t.leftSplit && v.getRows(h(h({}, t), {
                            currentColumns: a,
                            $positions: h(h({}, t.$positions), {xStart: 0, xEnd: t.leftSplit})
                        }), h(h({}, e), {name: "footer", position: "bottom"})), d = 0;
                    r && r.forEach(function (t) {
                        return d += t.attrs.style.height
                    });
                    a = c ? r && p.el(".dhx_" + u.name + "-fixed-cols", {
                        style: {
                            position: "absolute",
                            top: s < e.gridBodyHeight ? s - d : null,
                            left: 0,
                            bottom: s > e.gridBodyHeight ? 0 + (c ? o : 0) + "px" : null
                        }, role: "rowgroup", "aria-rowcount": r.length
                    }, r) : null, u = t.$positions, r = _.getSpans(t, !0);
                    return [p.el(".dhx_grid-fixed-cols-wrap", {
                        style: {
                            height: s > e.gridBodyHeight ? (c ? e.gridBodyHeight : e.gridBodyHeight + t.headerHeight) - o : s,
                            paddingTop: t.headerHeight,
                            overflow: "hidden",
                            width: t.fixedColumnsWidth
                        }, role: "presentation", "aria-label": "Fixed column"
                    }, [p.el(".dhx_grid-fixed-cols", h(h({
                        style: {
                            top: -t.scroll.top + t.headerHeight - 1 + "px",
                            paddingTop: e.shifts.y,
                            height: t.$totalHeight,
                            position: "absolute"
                        }, _flags: p.KEYED_LIST
                    }, _.getHandlers(u.yStart, u.xStart, t)), {
                        role: "rowgroup",
                        "aria-rowcount": t.data.length
                    }), f([r && p.el(".dhx_span-spans", {role: "presentation"}, [r])], l)), p.el(".dhx_frozen-cols-border", {role: "presentation"})]), t.$footer ? a : null]
                }
            }
        }
    }, function (t, e, i) {
        "use strict";
        var o = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var s, r = i(0), a = i(56), l = i(7), c = i(4), n = i(15), u = i(2);

        function d(e, i, n, o, r) {
            function t() {
                var t = (u.isIE() || u.isSafari() ? r.target : r.path ? r.path[0] : r.explicitOriginalTarget).value;
                o.value[i] = t, e.fire(c.GridEvents.filterChange, [t, i, n]), e.fire(c.GridEvents.headerInput, [t, i, n])
            }

            "selectFilter" !== n ? (s && clearTimeout(s), s = setTimeout(t, 250)) : t()
        }

        function h(t, n, e, i) {
            if (t && n && e) {
                var o = t.id, t = i ? i(o, n.data) : n.data.reduce(function (t, e) {
                    return void 0 === e[o] || "" === e[o] || isNaN(e[o]) || t.push(parseFloat(e[o])), t
                }, []), i = t;
                return "tree" === n.type && (i = n.data.reduce(function (t, e) {
                    var i;
                    return 0 === e.$level && (void 0 === e[o] || "" === e[o] || isNaN(e[o]) ? (i = 0, n.datacollection.eachChild(e.id, function (t) {
                        n.datacollection.haveItems(t.id) || (i += parseFloat(t[o]))
                    }), t.push(i)) : t.push(parseFloat(e[o]) || 0)), t
                }, [])), e(t, i)
            }
        }

        e.getContent = function () {
            var i = this;
            return {
                inputFilter: {
                    element: {}, toHtml: function (t, e) {
                        var i = t.id.toString();
                        return this.element[i] = r.el("label.dhx_grid-filter__label.dxi.dxi-magnify", {
                            "aria-label": "Type to search",
                            _ref: t.id + "_filter"
                        }, [r.el("input", {
                            type: "text",
                            class: "dhx_input dhx_grid-filter",
                            oninput: [d, e.events, t.id, "inputFilter", this],
                            _key: t.id,
                            value: this.value[t.id] || ""
                        })]), this.element[i]
                    }, match: function (t, e) {
                        for (var i = "", n = 0; n < e.length; n++) {
                            var o = e.charCodeAt(n);
                            i += 32 < o && o < 48 || 63 === o || 90 < o && o < 95 || 124 === o ? "\\" + e[n] : e[n]
                        }
                        return new RegExp("" + i, "i").test(t)
                    }, value: {}
                }, selectFilter: {
                    element: {}, toHtml: function (e, t) {
                        var i = this, n = e.id.toString();
                        return this.element[n] = r.el("label.dhx_grid-filter__label.dxi.dxi-menu-down", {_ref: e.id + "_filter"}, [r.el("select.dxi.dxi-menu-down", {
                            type: "text",
                            class: "dhx_input dhx_grid-filter dhx_grid-filter--select",
                            onchange: [d, t.events, e.id, "selectFilter", this],
                            _key: e.id
                        }, o([r.el("option", {value: ""}, "")], e.$uniqueData.map(function (t) {
                            return t && r.el("option", {value: t, selected: i.value[e.id] === t.toString()}, t)
                        })))]), this.element[n]
                    }, match: function (t, e) {
                        return !e || t.toString() == e
                    }, value: {}
                }, comboFilter: {
                    element: {}, toHtml: function (t, i) {
                        var e, n, o = t.id.toString();
                        return this.element[o] ? n = this.element[t.id] : (e = t.header.filter(function (t) {
                            return void 0 !== t.filterConfig
                        })[0], (n = e && e.filterConfig ? new a.Combobox(null, JSON.parse(JSON.stringify(e.filterConfig))) : new a.Combobox(null, {})).data.parse(t.$uniqueData.map(function (t) {
                            return {value: t}
                        })), i.events.on(l.DataEvents.load, function () {
                            n.data.parse(t.$uniqueData.map(function (t) {
                                return {value: t}
                            }))
                        }), (this.element[o] = n).events.on("change", function (t) {
                            var e;
                            t && (e = void 0, n.data.getItem(t) ? (e = n.list.selection.getItem().value, i.events.fire(c.GridEvents.filterChange, [e, o, "comboFilter"]), i.events.fire(c.GridEvents.headerInput, [e, o, "comboFilter"])) : (i.events.fire(c.GridEvents.filterChange, ["", o, "comboFilter"]), i.events.fire(c.GridEvents.headerInput, ["", o, "comboFilter"])))
                        }), i.events.on(c.GridEvents.scroll, function () {
                            n._hideOptions()
                        }), n.popup.events.on("afterHide", function () {
                            n.list.selection.getItem() || (n.clear(), i.events.fire(c.GridEvents.filterChange, ["", o, "comboFilter"]), i.events.fire(c.GridEvents.headerInput, ["", o, "comboFilter"]))
                        })), r.inject(n.getRootView())
                    }, match: function (t, e) {
                        return !e || t === e
                    }, destroy: function () {
                        if (i.content && i.content.comboFilter.element) {
                            var t, e = i.content.comboFilter.element;
                            for (t in e) e[t].destructor(), delete e[t]
                        }
                    }, value: {}
                }, sum: {
                    calculate: function (t, e) {
                        return e.reduce(function (t, e) {
                            return t + (parseFloat(e) || 0)
                        }, 0)
                    }, toHtml: function (t, e) {
                        e = h(t, e, this.calculate);
                        return t.format || "percent" === t.type ? n.toFormat(e, t.type, t.format) : e ? e.toFixed(3) : null
                    }
                }, avg: {
                    calculate: function (t, e) {
                        return t.length ? e.reduce(function (t, e) {
                            return t + e
                        }, 0) / t.length : null
                    }, toHtml: function (t, e) {
                        e = h(t, e, this.calculate);
                        return t.format || "percent" === t.type ? n.toFormat(e, t.type, t.format) : e ? e.toFixed(3) : null
                    }
                }, min: {
                    calculate: function (t) {
                        return t.length ? Math.min.apply(Math, t) : null
                    }, toHtml: function (t, e) {
                        e = h(t, e, this.calculate);
                        return t.format || "percent" === t.type ? n.toFormat(e, t.type, t.format) : e ? e.toFixed(3) : null
                    }
                }, max: {
                    calculate: function (t) {
                        return t.length ? Math.max.apply(Math, t) : null
                    }, toHtml: function (t, e) {
                        e = h(t, e, this.calculate);
                        return t.format || "percent" === t.type ? n.toFormat(e, t.type, t.format) : e ? e.toFixed(3) : null
                    }
                }, count: {
                    calculate: function (t, e) {
                        return e.reduce(function (t, e) {
                            return t + e
                        }, 0)
                    }, validate: function (i, t) {
                        return t.reduce(function (t, e) {
                            return void 0 !== e[i] && "" !== e[i] && (isNaN(e) ? t.push(1) : t.push(e)), t
                        }, [])
                    }, toHtml: function (t, e) {
                        return h(t, e, this.calculate, this.validate)
                    }
                }
            }
        }
    }, function (t, e, i) {
        "use strict";
        var h = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var f = i(1), p = i(4), g = i(2);
        e.startResize = function (a, l, t, e) {
            t.targetTouches && t.preventDefault();
            var c = (t.targetTouches ? t.targetTouches[0] : t).clientX, u = a.config.columns.filter(function (t) {
                return !t.hidden
            }), d = 0;

            function i(t) {
                var e, i, n = f.findIndex(u, function (t) {
                        return t.id === l
                    }), o = (t.targetTouches ? t.targetTouches[0] : t).clientX,
                    r = o - a.getRootNode().getBoundingClientRect().left,
                    s = a.config.$totalHeight > a.config.height ? g.getScrollbarWidth() : 0;
                a.config.leftSplit === n + 1 && r >= a.config.width - s - 2 || (d = d || u[n].$width, e = u[n].minWidth || 40, r = u[n].maxWidth, s = o - c, o = h(u), s = d + s, r && r <= s || s <= e ? (s <= e && (i = e), r <= s && (i = r)) : i = s, o[n].$width = i, o[n].$fixed = !0, a.events.fire(p.GridEvents.resize, [u[n], t]), a.paint())
            }

            a.config.$resizing = l;
            var n = function () {
                t.targetTouches ? (document.removeEventListener("touchmove", i), document.removeEventListener("touchend", n)) : (document.removeEventListener("mousemove", i), document.removeEventListener("mouseup", n)), e()
            };
            t.targetTouches ? (document.addEventListener("touchmove", i), document.addEventListener("touchend", n)) : (document.addEventListener("mousemove", i), document.addEventListener("mouseup", n)), a.paint()
        }
    }, function (t, e, i) {
        "use strict";
        var o = this && this.__assign || function () {
            return (o = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(4), u = i(2);

        function s(t, e, i, n, o, r, s) {
            var a, l, c;
            void 0 === o && (o = !1), void 0 === r && (r = !1), void 0 === s && (s = !1), e.config.$editable || !e.config.selection || u.locateNodeByClassName(t, "dhx_grid-header-cell") || (t && t.preventDefault(), a = e.selection.getCell(), t = e.config.columns.filter(function (t) {
                return !t.hidden
            }), e.data.filter(function (t) {
                return !t.hidden
            }), a && ("vertical" === i ? o ? (l = 1 === n ? e.data.getItem(e.data.getId(e.data.getLength() - 1)) : e.data.getItem(e.data.getId(0)), e.selection.setCell(l.id, a.column.id, r, s), e.scrollTo(l.id.toString(), a.column.id.toString())) : 0 <= (c = e.data.getIndex(a.row.id.toString())) + n && c + n < e.data.getLength() && (l = e.data.getItem(e.data.getId(c + n)), e.selection.setCell(l.id, a.column.id, r, s), e.scrollTo(l.id.toString(), a.column.id.toString())) : o ? (l = 1 === n ? t[t.length - 1] : t[0], e.selection.setCell(a.row.id, l.id, r, s), e.scrollTo(a.row.id.toString(), l.id.toString())) : 0 <= (c = t.indexOf(a.column)) + n && c + n < t.length && (e.scrollTo(a.row.id.toString(), t[c + n].id.toString()), e.selection.setCell(a.row.id, t[c + n].id, r, s))))
        }

        e.selectionMove = s, e.getKeysHandlers = function (n) {
            var e, i = "cell" === n.config.selection || "complex" === n.config.selection || !0 === n.config.selection,
                t = {};
            return n.getRootView() && (e = n.getRootView().refs.grid_body.el, t = {
                pageUp: function (t) {
                    t.preventDefault(), e.scrollTop -= e.clientHeight
                }, pageDown: function (t) {
                    t.preventDefault(), e.scrollTop += e.clientHeight
                }, home: function (t) {
                    t.preventDefault(), e.scrollTop = 0
                }, end: function (t) {
                    t.preventDefault(), e.scrollTop += e.scrollHeight
                }
            }), o({
                enter: function () {
                    var t;
                    i ? (t = n.selection.getCell()) && (!1 !== t.column.editable && n.config.editable || t.column.editable) && (n.config.$editable ? n.editEnd() : "boolean" !== t.column.type ? n.editCell(t.row.id, t.column.id, t.column.editorType) : n.events.fire(r.GridEvents.afterEditEnd, [!t.row[t.column.id], t.row, t.column])) : n.config.$editable && n.editEnd()
                }, space: function (t) {
                    var e;
                    !i || !n.config.editable || n.config.$editable || (e = n.selection.getCell()) && "boolean" === e.column.type && (t.preventDefault(), n.events.fire(r.GridEvents.afterEditEnd, [!e.row[e.column.id], e.row, e.column]))
                }, escape: function () {
                    n.config.$editable && n.editEnd(!0)
                }, tab: function (t) {
                    var e, i;
                    n.config.selection && !u.locateNodeByClassName(t, "dhx_grid-header-cell") && (t && t.preventDefault(), n.config.$editable && n.editEnd(), i = n.selection.getCell(), e = n.config.columns.filter(function (t) {
                        return !t.hidden
                    }), i && (0 <= (t = e.indexOf(i.column) + 1) && t < e.length ? (n.selection.setCell(i.row.id, e[t].id), n.scrollTo(i.row.id.toString(), e[t].id.toString())) : 0 <= t && ((i = n.data.getIndex(i.row.id.toString()) + 1) < n.data.getLength() && (n.selection.setCell(n.data.getId(i), e[0].id), n.scrollTo(n.data.getId(i).toString(), e[0].id.toString())))))
                }, "shift+tab": function (t) {
                    var e, i;
                    n.config.selection && !u.locateNodeByClassName(t, "dhx_grid-header-cell") && (t && t.preventDefault(), n.config.$editable && n.editEnd(), i = n.selection.getCell(), e = n.config.columns.filter(function (t) {
                        return !t.hidden
                    }), i && (0 <= (t = e.indexOf(i.column) - 1) && t < e.length ? (n.selection.setCell(i.row.id, e[t].id), n.scrollTo(i.row.id.toString(), e[t].id.toString())) : t < n.data.getLength() && (0 <= (i = n.data.getIndex(i.row.id.toString()) - 1) && (n.selection.setCell(n.data.getId(i), e[e.length - 1].id), n.scrollTo(n.data.getId(i).toString(), e[e.length - 1].id.toString())))))
                }, arrowUp: function (t) {
                    s(t, n, "vertical", -1)
                }, "ctrl+arrowUp": function (t) {
                    s(t, n, "vertical", -1, !0)
                }, "shift+arrowUp": function (t) {
                    n.config.multiselection && s(t, n, "vertical", -1, !1, !1, !0)
                }, "ctrl+shift+arrowUp": function (t) {
                    n.config.multiselection && s(t, n, "vertical", -1, !0, !1, !0)
                }, arrowDown: function (t) {
                    s(t, n, "vertical", 1)
                }, "ctrl+arrowDown": function (t) {
                    s(t, n, "vertical", 1, !0)
                }, "shift+arrowDown": function (t) {
                    n.config.multiselection && s(t, n, "vertical", 1, !1, !1, !0)
                }, "ctrl+shift+arrowDown": function (t) {
                    n.config.multiselection && s(t, n, "vertical", 1, !0, !1, !0)
                }, arrowRight: function (t) {
                    s(t, n, "horizontal", 1)
                }, "ctrl+arrowRight": function (t) {
                    s(t, n, "horizontal", 1, !0)
                }, "shift+arrowRight": function (t) {
                    n.config.multiselection && s(t, n, "horizontal", 1, !1, !1, !0)
                }, "ctrl+shift+arrowRight": function (t) {
                    n.config.multiselection && s(t, n, "horizontal", 1, !0, !1, !0)
                }, arrowLeft: function (t) {
                    s(t, n, "horizontal", -1)
                }, "ctrl+arrowLeft": function (t) {
                    s(t, n, "horizontal", -1, !0)
                }, "shift+arrowLeft": function (t) {
                    n.config.multiselection && s(t, n, "horizontal", -1, !1, !1, !0)
                }, "ctrl+shift+arrowLeft": function (t) {
                    n.config.multiselection && s(t, n, "horizontal", -1, !0, !1, !0)
                }
            }, t)
        }
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), r = this && this.__assign || function () {
            return (r = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var s, a = i(50), l = i(4), c = i(7), u = i(2), d = i(15), h = i(51),
            o = (s = a.Grid, o(f, s), f.prototype._setEventHandlers = function () {
                var r = this;
                s.prototype._setEventHandlers.call(this), this.events.on(l.GridEvents.headerCellMouseDown, function (t, e) {
                    e.targetTouches ? r._touch.timer = setTimeout(function () {
                        r._dragStartColumn(e, t)
                    }, r._touch.duration) : r._dragStartColumn(e, t)
                }), this._events.on(l.GridSystemEvents.headerCellTouchMove, function (t, e) {
                    r._touch.start && e.preventDefault(), r._clearTouchTimer()
                }), this._events.on(l.GridSystemEvents.headerCellTouchEnd, function () {
                    r._touch.start = !1, r._clearTouchTimer()
                }), this.events.on(l.GridEvents.resize, function () {
                    r._parseColumns(), r._checkFilters()
                }), this.events.on(l.GridEvents.afterResizeEnd, function () {
                    r.config.autoHeight && (r.config.data = r.data.map(function (t) {
                        var e = d.getMaxRowHeight(t, r.config.columns);
                        return t.$height = d.getCalculatedRowHeight(e, {rowHeight: r.config.rowHeight, padding: 8}), t
                    }))
                }), this.events.on(l.GridEvents.afterRowResize, function (t, e, i) {
                    var n = r.data.getItem(t.id), o = n.id, t = n.height, n = n.$height;
                    t && t !== n && r.data.update(o, {height: i}), r.data.update(o, {$height: i}, !0), r.config.data = r.data.map(function (t) {
                        return t
                    }), r.paint()
                }), this.events.on(l.GridEvents.scroll, function () {
                    r._lazyLoad()
                })
            }, f.prototype._prepareData = function (t) {
                var i = this;
                return this._adjustColumns(), t.map(function (t) {
                    var e;
                    return i.config.autoHeight && void 0 === t.height ? (e = d.getMaxRowHeight(t, i.config.columns), t.$height = d.getCalculatedRowHeight(e, {
                        rowHeight: i.config.rowHeight,
                        padding: 8
                    }) || i.config.rowHeight) : t.$height = t.height || i.config.rowHeight, t
                })
            }, f.prototype._prepareDataFromTo = function (t, e, i) {
                var n = this;
                return t.mapRange(e, i, function (t) {
                    var e = d.getMaxRowHeight(t, n.config.columns);
                    return t.$height = d.getCalculatedRowHeight(e, {
                        rowHeight: n.config.rowHeight,
                        padding: 8
                    }) || n.config.rowHeight, t
                })
            }, f.prototype._lazyLoad = function () {
                var t, e, i, n, o = this, r = this.data.dataProxy;
                r && r.config && (t = this.data.getRawData(0, -1, null, 2), e = h.getRenderConfig(this, t, {
                    width: this.config.width,
                    height: this.config.height
                }), i = this.data.getIndex(null === (t = e.currentRows[0]) || void 0 === t ? void 0 : t.id.toString()), n = this.data.getIndex(null === (e = e.currentRows[e.currentRows.length - 1]) || void 0 === e ? void 0 : e.id.toString()), !this.data.isDataLoaded(i, n) && this.data.events.fire(c.DataEvents.beforeLazyLoad, []) && (r.updateUrl(null, {
                    from: i,
                    limit: r.config.limit
                }), this.data.load(r).then(function () {
                    o.config.autoHeight && o._prepareDataFromTo(o.data, i, n)
                })))
            }, f.prototype._getColumnGhost = function (t) {
                var e = this._container.querySelector(".dhx_header-row"),
                    i = e.querySelector('.dhx_grid-header-cell[dhx_id="' + t.id + '"]'),
                    i = Array.from(e.childNodes).indexOf(i) + 1,
                    t = this._container.querySelectorAll('.dhx_grid-header-cell[dhx_id="' + t.id + '"]'),
                    i = this._container.querySelectorAll(".dhx_grid_data .dhx_grid-cell:nth-child(" + i + ")"),
                    n = document.createElement("div");
                return t.forEach(function (t) {
                    return n.appendChild(t.cloneNode(!0))
                }), i.forEach(function (t) {
                    return n.appendChild(t.cloneNode(!0))
                }), n
            }, f.prototype._dragStartColumn = function (t, e) {
                function i(t) {
                    return t.classList.contains("dhx_grid-custom-content-cell")
                }

                var n = t.target;
                i(n.parentElement) || i(n.parentElement.parentElement) || !(e.draggable || "column" === this.config.dragItem && !1 !== e.draggable) || u.locateNodeByClassName(t, "dhx_resizer_grip_wrap") || (t.targetTouches && (this._touch.start = !0), c.dragManager.onMouseDown(t, e.id, [this._getColumnGhost(e)]))
            }, f);

        function f(t, e) {
            return s.call(this, t, r({autoHeight: !1}, e)) || this
        }

        e.ProGrid = o
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = (o.prototype.setItem = function (t, e) {
            this._store[t] = e
        }, o.prototype.getItem = function (t) {
            return this._store[t] || null
        }, o);

        function o() {
            this._store = {}
        }

        var r = window.dhxHelpers = window.dhxHelpers || {};
        r.collectionStore = r.collectionStore || new n, e.collectionStore = r.collectionStore
    }, function (t, l, c) {
        "use strict";
        (function (t) {
            var n, e = this && this.__extends || (n = function (t, e) {
                return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                    t.__proto__ = e
                } || function (t, e) {
                    for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                })(t, e)
            }, function (t, e) {
                function i() {
                    this.constructor = t
                }

                n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
            });
            Object.defineProperty(l, "__esModule", {value: !0});
            var o, i = c(18), r = c(1), s = c(34), e = (o = i.DataProxy, e(a, o), a.prototype.load = function () {
                var e = this;
                return new t(function (t) {
                    e._timeout ? (clearTimeout(e._timeout), e._timeout = setTimeout(function () {
                        s.ajax.get(e.url, {responseType: "text"}).then(t), e._cooling = !0
                    }, e.config.delay), e._cooling && (t(null), e._cooling = !1)) : (s.ajax.get(e.url, {responseType: "text"}).then(t), e._cooling = !0, e._timeout = setTimeout(function () {
                    }))
                })
            }, a);

            function a(t, e) {
                var i = o.call(this, t) || this;
                return i.config = r.extend({
                    from: 0,
                    limit: 50,
                    delay: 50,
                    prepare: 0
                }, e), i.updateUrl(t, {from: i.config.from, limit: i.config.limit}), i
            }

            l.LazyDataProxy = e
        }).call(this, c(9))
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = i(5), n = i(27), r = i(13), i = (s.prototype.getId = function () {
            return this._selected
        }, s.prototype.getItem = function () {
            return this._selected ? this._data.getItem(this._selected) : null
        }, s.prototype.remove = function (t) {
            return !(t = t || this._selected) || !!this.events.fire(n.SelectionEvents.beforeUnSelect, [t]) && (this._data.update(t, {$selected: !1}, !0), this._selected = null, this.events.fire(n.SelectionEvents.afterUnSelect, [t]), !0)
        }, s.prototype.add = function (t) {
            this._selected !== t && !this.config.disabled && this._data.exists(t) && (this.remove(), this._addSingle(t))
        }, s.prototype.enable = function () {
            this.config.disabled = !1
        }, s.prototype.disable = function () {
            this.remove(), this.config.disabled = !0
        }, s.prototype._addSingle = function (t) {
            this.events.fire(n.SelectionEvents.beforeSelect, [t]) && (this._selected = t, this._data.update(t, {$selected: !0}, !0), this.events.fire(n.SelectionEvents.afterSelect, [t]))
        }, s);

        function s(t, e, i) {
            var n = this;
            this.events = i || new o.EventSystem(this), this._data = e, this.config = t, this._data.events.on(r.DataEvents.removeAll, function () {
                n._selected = null
            }), this._data.events.on(r.DataEvents.change, function () {
                var t;
                !n._selected || (t = n._data.getNearId(n._selected)) !== n._selected && (n._selected = null, t && n.add(t))
            })
        }

        e.Selection = i
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), r = this && this.__assign || function () {
            return (r = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var s, a = i(1), l = i(0), c = i(2), u = i(17), d = i(21),
            o = (s = d.Navbar, o(h, s), h.prototype.getState = function (t) {
                if (!t || this.data.getItem(t.toString())) {
                    var e, i = {};
                    for (e in this.data.eachChild(this.data.getRoot(), function (t) {
                        t.twoState && !t.group ? i[t.id] = t.active : "input" !== t.type && "selectButton" !== t.type || (i[t.id] = t.value)
                    }, !1), this._groups) this._groups[e].active && (i[e] = this._groups[e].active);
                    return t ? i[t] : i
                }
            }, h.prototype.setState = function (t) {
                for (var e in t) {
                    var i;
                    this._groups && this._groups[e] ? this._groups[e].active && (this.data.update(this._groups[e].active, {active: !1}), this._groups[e].active = t[e], this.data.update(t[e], {active: !0})) : "input" === (i = this.data.getItem(e)).type || "selectButton" === i.type ? this.data.update(e, {value: t[e]}) : this.data.update(e, {active: t[e]})
                }
            }, h.prototype._customHandlers = function () {
                var i = this;
                return {
                    input: function (t) {
                        var e = c.locate(t);
                        i.data.update(e, {value: t.target.value})
                    }, tooltip: function (t) {
                        var e = c.locateNode(t);
                        e && (t = e.getAttribute("dhx_id"), (t = i.data.getItem(t)).tooltip && u.tooltip(t.tooltip, {
                            node: e,
                            position: u.Position.bottom
                        }))
                    }
                }
            }, h.prototype._getFactory = function () {
                return d.createFactory({
                    widget: this,
                    defaultType: "navItem",
                    allowedTypes: ["button", "imageButton", "selectButton", "navItem", "menuItem", "separator", "spacer", "title", "input", "customHTML", "customHTMLButton"],
                    widgetName: "toolbar"
                })
            }, h.prototype._draw = function (t) {
                var i = this;
                return l.el("nav.dhx_widget.dhx_toolbar", {class: this.config.css || ""}, [l.el("ul.dhx_navbar.dhx_navbar--horizontal", r(r({
                    dhx_widget_id: this._uid,
                    tabindex: 0
                }, {role: "toolbar", "aria-label": t || ""}), {
                    onclick: this._handlers.onclick,
                    onmousedown: this._handlers.onmousedown,
                    oninput: this._handlers.input,
                    onmouseover: this._handlers.tooltip,
                    _hooks: {
                        didInsert: function (t) {
                            t.el.addEventListener("keyup", function (t) {
                                var e;
                                9 !== t.which || (e = c.locateNode(document.activeElement)) && (t = e.getAttribute("dhx_id"), (t = i.data.getItem(t)).tooltip && u.tooltip(t.tooltip, {
                                    node: e,
                                    position: u.Position.bottom,
                                    force: !0
                                }))
                            }, !0)
                        }
                    }
                }), this.data.map(function (t) {
                    return i._factory(t)
                }, this.data.getRoot(), !1))])
            }, h.prototype._getMode = function (t, e) {
                return t.id === e ? "bottom" : "right"
            }, h.prototype._close = function (t) {
                this._activePosition = null, this._currentRoot = null, s.prototype._close.call(this, t)
            }, h.prototype._setRoot = function (t) {
                this.data.getParent(t) === this.data.getRoot() && (this._currentRoot = t)
            }, h);

        function h(t, e) {
            var i = s.call(this, t, a.extend({navigationType: "click"}, e)) || this;
            i._currentRoot = null;
            return i.mount(t, l.create({
                render: function () {
                    return i._draw(t)
                }
            })), i
        }

        e.Toolbar = o
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        }), u = this && this.__assign || function () {
            return (u = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(1), d = i(0), a = i(5), h = i(2), l = i(19), s = i(6), c = i(7), f = i(39);
        var p, o = (p = s.View, o(g, p), g.prototype.paint = function () {
            p.prototype.paint.call(this), this._isContextMenu && !this._vpopups && this._init(), this._vpopups && this._vpopups.redraw()
        }, g.prototype.disable = function (t) {
            var e = this;
            void 0 !== t ? this._setProp(t, "disabled", !0) : this.data.forEach(function (t) {
                t = t.id;
                return e._setProp(t, "disabled", !0)
            })
        }, g.prototype.enable = function (t) {
            var e = this;
            void 0 !== t ? this._setProp(t, "disabled", !1) : this.data.forEach(function (t) {
                t = t.id;
                return e._setProp(t, "disabled", !1)
            })
        }, g.prototype.isDisabled = function (t) {
            t = this.data.getItem(t);
            if (t) return t.disabled || !1
        }, g.prototype.show = function (t) {
            var e = this;
            void 0 !== t ? this._setProp(t, "hidden", !1) : this.data.forEach(function (t) {
                t = t.id;
                return e._setProp(t, "hidden", !1)
            })
        }, g.prototype.hide = function (t) {
            var e = this;
            void 0 !== t ? this._setProp(t, "hidden", !0) : this.data.forEach(function (t) {
                t = t.id;
                return e._setProp(t, "hidden", !0)
            })
        }, g.prototype.destructor = function () {
            this.events.clear(), this._keyManager && this._keyManager.destructor(), this._vpopups && this._vpopups.node && this._vpopups.unmount(), this.unmount()
        }, g.prototype.select = function (t, e) {
            var i = this;
            if (void 0 === e && (e = !0), !t) throw new Error("Function argument cannot be empty, for more info check documentation https://docs.dhtmlx.com");
            e && this.unselect(), this.data.update(t, {active: !0}), this.data.eachParent(t, function (t) {
                i.data.update(t.id, {active: !0})
            })
        }, g.prototype.unselect = function (t) {
            var e = this;
            t ? (this.data.update(t, {active: !1}), this.data.eachChild(t, function (t) {
                e.data.update(t.id, {active: !1})
            })) : this.data.forEach(function (t) {
                e.data.update(t.id, {active: !1})
            })
        }, g.prototype.isSelected = function (t) {
            if (t && this.data.getItem(t)) return !!this.data.getItem(t).active
        }, g.prototype.getSelected = function () {
            var e = [];
            return this.data.forEach(function (t) {
                t.active && e.push(t.id)
            }), e
        }, g.prototype._customHandlers = function () {
            return {}
        }, g.prototype._close = function (t) {
            var e = this;
            this._popupActive && this.events.fire(f.NavigationBarEvents.beforeHide, [this._activeMenu, t]) && (this._activeParents && this._activeParents.forEach(function (t) {
                return e.data.exists(t) && e.data.update(t, {$activeParent: !1})
            }), "click" === this.config.navigationType && (this._isActive = !1), clearTimeout(this._currentTimeout), this._popupActive = !1, this._activeMenu = null, this._vpopups.node && this._vpopups.unmount(), this._vpopups = null, this.events.fire(f.NavigationBarEvents.afterHide, [t]), this.paint())
        }, g.prototype._init = function () {
            var t = this;
            this._vpopups = d.create({
                render: function () {
                    return d.el("div", {
                        dhx_widget_id: t._uid,
                        class: (t._isContextMenu ? " dhx_context-menu" : "") + " " + (t.config.css ? t.config.css.split(" ").map(function (t) {
                            return t + "--context-menu"
                        }).join(" ") : ""),
                        onmousemove: t._handlers.onmousemove,
                        onmouseleave: t._handlers.onmouseleave,
                        onclick: t._handlers.onclick,
                        onmousedown: t._handlers.onmousedown
                    }, t._drawPopups())
                }
            }), this._vpopups.mount(document.body)
        }, g.prototype._initHandlers = function () {
            var a = this;
            this._isActive = "click" !== this.config.navigationType, this._handlers = u({
                onmousemove: function (t) {
                    var e, i;
                    !a._isActive || (i = h.locateNode(t)) && (e = i.getAttribute("dhx_id"), a._activeMenu !== e && (a.data.haveItems(e) && (a._vpopups || a._init(), i = h.getRealPosition(i), a.data.update(e, {$position: i}, !1)), a._activeItemChange(e, t)))
                }, onmouseleave: function (t) {
                    var e;
                    "click" !== a.config.navigationType && (a._popupActive && ((e = h.locateNode(t, "dhx_id", "relatedTarget")) ? (e = e.getAttribute("dhx_id"), a.data.getItem(e) || a._close(t)) : a._close(t)), a._activeItemChange(null, t))
                }, onclick: function (t) {
                    var e = h.locateNode(t);
                    if (e) {
                        var i = e.getAttribute("dhx_id");
                        if (!a.isDisabled(i)) {
                            var n = a.data.getItem(i);
                            if (!n.multiClick) if (a.data.haveItems(i)) a._vpopups || a._init(), i !== a._currentRoot && (a._isActive || (a._isActive = !0), a._setRoot(i), e = h.getRealPosition(e), a.data.update(i, {$position: e}, !1), a._activeItemChange(i, t)); else switch (n.type) {
                                case"input":
                                case"title":
                                    break;
                                case"menuItem":
                                case"selectButton":
                                    a._onMenuItemClick(i, t);
                                    break;
                                case"imageButton":
                                case"button":
                                case"customButton":
                                case"customHTML":
                                case"navItem":
                                    n.twoState && a.data.update(n.id, {active: !n.active}), a.events.fire(f.NavigationBarEvents.click, [i, t]), a._close(t);
                                    break;
                                default:
                                    a._close(t)
                            }
                        }
                    }
                }, onmousedown: function (t) {
                    var e, i, n, o, r, s = h.locateNode(t);
                    s && (e = s.getAttribute("dhx_id"), a.data.getItem(e).multiClick && (i = 365, r = function () {
                        clearTimeout(n), document.removeEventListener("mouseup", r)
                    }, (o = function () {
                        a.events.fire(f.NavigationBarEvents.click, [e, t]), 50 < i && (i -= 55), n = setTimeout(o, i)
                    })(), document.addEventListener("mouseup", r)))
                }
            }, this._customHandlers())
        }, g.prototype._initEvents = function () {
            var n = this, t = null;
            this.data.events.on(f.DataEvents.change, function () {
                n.paint(), t && clearTimeout(t), t = setTimeout(function () {
                    var i = {};
                    n.data.eachChild(n.data.getRoot(), function (t) {
                        var e;
                        t.group && (t.twoState = !0, (e = i)[(t = t).group] ? (t.active && (e[t.group].active = t.id), e[t.group].elements.push(t.id)) : e[t.group] = {
                            active: t.active ? t.id : null,
                            elements: [t.id]
                        })
                    }, !0), n._groups = i, n._resetHotkeys(), t = null, n.paint()
                }, 100)
            }), this.events.on(f.NavigationBarEvents.click, function (t) {
                var e = n.data.getItem(t), t = n.data.getItem(e.parent);
                t && "selectButton" === t.type && n.data.update(e.parent, {
                    value: e.value,
                    icon: e.icon
                }), e.group && ((t = n._groups[e.group]).active && n.data.update(t.active, {active: !1}), t.active = e.id, n.data.update(e.id, {active: !0}))
            }), this._customInitEvents()
        }, g.prototype._getMode = function (t, e, i) {
            return void 0 === i && (i = !1), t.parent === e ? "bottom" : "right"
        }, g.prototype._drawMenuItems = function (t, e) {
            var i = this;
            return void 0 === e && (e = !0), this.data.map(function (t) {
                return i._factory(t, e)
            }, t, !1)
        }, g.prototype._setRoot = function (t) {
        }, g.prototype._getParents = function (t, e) {
            var i = [], n = !1, o = this.data.getItem(t), o = o && o.disabled;
            return this.data.eachParent(t, function (t) {
                t.id === e ? (i.push(t.id), n = !0) : n || i.push(t.id)
            }, !o), this._isContextMenu && this._activePosition && i.push(e), i
        }, g.prototype._listenOuterClick = function () {
            this._documentHaveListener || (document.addEventListener("click", this._documentClick, !0), this._documentHaveListener = !0)
        }, g.prototype._customInitEvents = function () {
        }, g.prototype._drawPopups = function () {
            var a = this, t = this._activeMenu;
            if (!this._isContextMenu && !t) return null;
            var e = this.getRootNode(), e = e && e.offsetParent && e.offsetParent.offsetParent, l = null;
            e && e.classList.contains("dhx_popup--window") && e.classList.contains("dhx_popup--window_active") && (l = 2147483647);
            var c = this._currentRoot;
            if (this._isContextMenu && !this._activePosition) return null;
            t = this._getParents(t, c);
            return (this._activeParents = t).forEach(function (t) {
                return a.data.exists(t) && a.data.update(t, {$activeParent: !0}, !1)
            }), t.map(function (r) {
                if (!a.data.haveItems(r)) return null;
                var s = a.data.getItem(r) || a._rootItem;
                return a._popupActive = !0, d.el("ul", u({
                    class: "dhx_widget dhx_menu" + (a.config.menuCss ? " " + a.config.menuCss : ""),
                    _key: r,
                    _hooks: {
                        didInsert: function (t) {
                            var e = t.el.getBoundingClientRect(), i = e.width, n = e.height,
                                o = a._isContextMenu && a._activePosition && r === c ? a._activePosition : s.$position,
                                e = a._getMode(s, c, o === a._activePosition),
                                n = h.calculatePosition(o, {mode: e, width: i, height: n});
                            s.$style = u(u({}, n), {zIndex: a._activePosition && a._activePosition.zIndex || l}), t.patch({style: s.$style})
                        }, didRecycle: function (t, e) {
                            var i, n;
                            a._isContextMenu && a._activePosition && r === c && (i = (n = e.el.getBoundingClientRect()).width, n = n.height, n = h.calculatePosition(a._activePosition, {
                                mode: a._getMode(s, c, !0),
                                width: i,
                                height: n
                            }), s.$style = u(u({}, n), {zIndex: a._activePosition.zIndex || l}), e.patch({style: s.$style}))
                        }
                    },
                    tabindex: 0,
                    style: s.$style || {position: "absolute"}
                }, {role: "menu", "aria-labeledby": s.id, "aria-live": "polite"}), a._drawMenuItems(r))
            }).reverse()
        }, g.prototype._onMenuItemClick = function (t, e) {
            var i = this.data.getItem(t);
            i.disabled || (i.twoState && this.data.update(i.id, {active: !i.active}), this.events.fire(f.NavigationBarEvents.click, [t, e]), this._close(e))
        }, g.prototype._activeItemChange = function (t, e) {
            var i, n = this;
            this._activeParents && (i = this._getParents(t, this._currentRoot), this._activeParents.forEach(function (t) {
                n.data.exists(t) && !i.includes(t) && n.data.update(t, {$activeParent: !1}, !1)
            })), t && !this._documentHaveListener && this._listenOuterClick(), t && this.data.haveItems(t) ? (this._activeMenu === t && this._popupActive || this.events.fire(f.NavigationBarEvents.openMenu, [t]), clearTimeout(this._currentTimeout), this.paint()) : (clearTimeout(this._currentTimeout), this._currentTimeout = setTimeout(function () {
                return n.paint()
            }, 400)), this._activeMenu = t
        }, g.prototype._resetHotkeys = function () {
            var e = this;
            this._keyManager.removeHotKey(null, this), this.data.map(function (t) {
                t.hotkey && e._keyManager.addHotKey(t.hotkey, function () {
                    return e._onMenuItemClick(t.id, null)
                })
            })
        }, g.prototype._setProp = function (t, e, i) {
            var n = this;
            Array.isArray(t) ? t.forEach(function (t) {
                return n.data.update(t, ((t = {})[e] = i, t))
            }) : this.data.update(t, ((t = {})[e] = i, t))
        }, g);

        function g(t, e) {
            var s = p.call(this, t, r.extend({}, e)) || this;
            return s._isContextMenu = !1, s._documentHaveListener = !1, s._rootItem = {}, !Array.isArray(s.config.data) && s.config.data && s.config.data.events ? (s.data = s.config.data, s.events = s.data.events, s.events.context = s) : (s.events = new a.EventSystem(s), s.data = new c.TreeCollection({}, s.events)), s._documentClick = function (t) {
                var e, i, n, o, r;
                s._documentHaveListener && (e = h.locateNode(t), i = s.data.getRoot(), n = e && e.getAttribute("dhx_id"), o = s.data.getParent(n), r = "ontouchstart" in window || navigator.msMaxTouchPoints, document.removeEventListener("click", s._documentClick), s._documentHaveListener = !1, (!r || e) && s._isContextMenu || i !== o && o && s.data.getItem(n) || s._close(t))
            }, s._currentRoot = s.data.getRoot(), s._factory = s._getFactory(), s._initHandlers(), s._keyManager = new l.KeyManager(function (t, e) {
                return e === s._uid
            }), s._initEvents(), Array.isArray(s.config.data) && s.data.parse(s.config.data), s
        }

        e.Navbar = o
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var d = i(133), h = i(134), f = i(135), p = i(136), g = i(137), _ = i(138), v = i(139), m = i(140), y = i(141),
            b = i(22);
        e.createFactory = function (t) {
            for (var n = t.defaultType, e = t.allowedTypes, o = t.widgetName, t = t.widget, r = new Set, i = 0, s = e; i < s.length; i++) {
                var a = s[i];
                r.add(a)
            }
            var l = t.config, c = t.events, u = t.data;
            return function (t, e) {
                if (t.hidden) return null;
                if (!(t.type && "button" !== t.type && "navItem" !== t.type && "menuItem" !== t.type || t.value || t.icon || t.html)) return null;
                t.type = t.type || n, r && !r.has(t.type) && (t.type = n), "imageButton" === t.type && "ribbon" !== o && (t.active = !1), e && "spacer" !== t.type && "separator" !== t.type && "customHTML" !== t.type && (t.type = "menuItem"), u.haveItems(t.id) && function (t, e, i) {
                    switch (t) {
                        case"sidebar":
                        case"context-menu":
                            e.$openIcon = "right";
                            break;
                        case"toolbar":
                            e.parent === i.getRoot() ? e.$openIcon = "right" : e.$openIcon = "bottom";
                            break;
                        case"menu":
                            e.parent !== this.data.getRoot() && (e.$openIcon = "right");
                            break;
                        case"ribbon":
                            var n = i.getItem(e.parent);
                            n && "block" !== e.type && ("block" === n.type ? e.$openIcon = "bottom" : e.$openIcon = "right")
                    }
                }(o, t, u), "toolbar" === o && t.items && t.items.forEach(function (t) {
                    t.type || (t.type = "menuItem")
                });
                var i = "customHTML" !== t.type && function (t, e, i, n) {
                    switch (t.type) {
                        case"navItem":
                        case"selectButton":
                            return h.navItem(t, i, n.collapsed);
                        case"button":
                            return d.button(t, i);
                        case"title":
                            return y.title(t, i);
                        case"separator":
                            return v.separator(t, i);
                        case"spacer":
                            return m.spacer(t, i);
                        case"input":
                            return g.input(t, e, i);
                        case"imageButton":
                            return p.imageButton(t, i);
                        case"menuItem":
                            return _.menuItem(t, i, n.asMenuItem);
                        case"customHTMLButton":
                            return f.customHTMLButton(t, i, n.asMenuItem);
                        case"block":
                        default:
                            throw new Error("unknown item type " + t.type)
                    }
                }(t, c, o, {asMenuItem: e, collapsed: "sidebar" !== o || l.collapsed});
                return b.navbarComponentMixin(o, t, e, i)
            }
        }
    }, function (t, e, i) {
        "use strict";
        var s = this && this.__assign || function () {
            return (s = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var a = i(0), l = i(22);
        e.button = function (t, e) {
            var i, n, o = t.icon && !t.value,
                r = o ? " dhx_navbar-count--absolute" : " dhx_navbar-count--button-inline";
            return a.el("button.dhx_button", s({
                class: l.getNavbarButtonCSS(t, e),
                dhx_id: t.id,
                disabled: t.disabled,
                type: "button"
            }, (n = (i = t).active || i.$activeParent, e = {
                "aria-disabled": i.disabled ? "true" : "false",
                "aria-label": i.value || i.tooltip || i.id || " " + (i.count || "")
            }, i.items && (e.id = i.id, e["aria-haspopup"] = "menu", n && (e["aria-expanded"] = "true")), e)), [t.icon ? l.getIcon(t.icon, "button") : null, t.html ? a.el("div.dhx_button__text", {".innerHTML": t.html}) : t.value && a.el("span.dhx_button__text", t.value), 0 < t.count && l.getCount(t, r, o), t.value && t.$openIcon ? a.el("span.dhx_button__icon.dhx_button__icon--menu.dxi.dxi-menu-right", {"aria-hidden": "true"}) : null, t.loading && a.el("span.dhx_button__loading", {"aria-hidden": "true"}, [a.el("span.dhx_button__loading-icon.dxi.dxi-loading")])])
        }
    }, function (t, e, i) {
        "use strict";
        var s = this && this.__assign || function () {
            return (s = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var a = i(0), l = i(22);
        e.navItem = function (t, e, i) {
            var n, o, r, e = " dhx_" + e + "-button";
            return a.el("button", s({
                class: "dhx_button" + e + (t.active || t.$activeParent ? e + "--active" : "") + (t.disabled ? e + "--disabled" : "") + (t.$openIcon ? e + "--select" : "") + (t.circle ? e + "--circle" : "") + (t.size ? " " + e + "--" + t.size : "") + (!t.value && t.icon ? e + "--icon" : "") + (t.css ? " " + t.css : ""),
                dhx_id: t.id,
                disabled: t.disabled,
                type: "button"
            }, (o = {
                "aria-disabled": (n = t).disabled ? "true" : "false",
                "aria-label": n.value || " "
            }, r = n.active || n.$activeParent, "selectButton" === n.type || n.items ? (o.id = n.id, o["aria-haspopup"] = "menu", r && (o["aria-expanded"] = "true")) : ((n.twoState || r) && (o["aria-pressed"] = r ? "true" : "false"), !n.value && n.icon && n.tooltip && (o["aria-label"] = n.tooltip + " " + (n.count || ""))), o)), [t.icon && a.el("span", {
                class: t.icon + e + "__icon",
                "aria-hidden": "true"
            }), t.html && a.el("div", {
                class: e.trim() + "__html",
                ".innerHTML": t.html
            }), !t.html && t.value && a.el("span", {class: e.trim() + "__text"}, t.value), 0 < t.count && l.getCount(t, e + "__count", i), t.$openIcon && a.el("span.dxi.dxi-menu-right", {
                class: e + "__caret",
                "aria-hidden": "true"
            })])
        }
    }, function (t, e, i) {
        "use strict";
        var o = this && this.__assign || function () {
            return (o = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(0);
        e.customHTMLButton = function (t, e, i) {
            var n, i = i ? " dhx_button dhx_menu-button" : " dhx_button dhx_nav-menu-button";
            return r.el("button", o({
                class: "dhx_custom-button" + i + (t.$activeParent ? i + "--active" : ""),
                dhx_id: t.id,
                type: "button",
                ".innerHTML": t.html
            }, (i = {"aria-disabled": (n = t).disabled ? "true" : "false"}, (n.twoState || n.active || n.$activeParent) && (i["aria-pressed"] = n.active || n.$activeParent ? "true" : "false"), i)), t.html ? "" : t.value)
        }
    }, function (t, e, i) {
        "use strict";
        var r = this && this.__assign || function () {
            return (r = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var s = i(0), a = i(22);
        e.imageButton = function (t, e) {
            var i, n, o = "dhx_" + e + "-button-image", e = "ribbon" === e;
            return s.el("button.dhx_button", r({
                class: o + (t.size ? " " + o + "--" + t.size : "") + (!t.value && t.src ? " " + o + "--icon" : "") + (e && t.$openIcon ? " " + o + "--select" : "") + (t.active ? " " + o + "--active" : ""),
                dhx_id: t.id,
                type: "button"
            }, (n = {"aria-disabled": (i = t).disabled ? "true" : "false"}, (i.twoState || i.active) && (n["aria-pressed"] = i.active ? "true" : "false"), !i.value && i.src && i.tooltip && (n["aria-label"] = i.tooltip + " " + (i.count || "")), n)), [e && t.value && t.$openIcon && s.el("span.dxi.dxi-menu-right", {
                class: o + "__caret",
                "aria-hidden": "true"
            }), t.html ? s.el("div", {
                class: o + "__text",
                ".innerHTML": t.html
            }) : t.value && s.el("span", {class: o + "__text"}, t.value), t.src && s.el("span", {
                class: o + "__image",
                style: {backgroundImage: "url(" + t.src + ")"},
                role: "presentation"
            }), 0 < t.count && a.getCount(t, o + "__count", !0)])
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(0), o = i(39);

        function r(t, e) {
            t.fire(o.NavigationBarEvents.inputBlur, [e])
        }

        function s(t, e) {
            t.fire(o.NavigationBarEvents.inputFocus, [e])
        }

        e.input = function (e, i, t) {
            return n.el(".dhx_form-group.dhx_form-group--no-message-holder.dhx_form-group--label_sr.dhx_" + t + "__input", {
                style: {width: e.width || "200px"},
                role: "presentation"
            }, [e.label && n.el("label.dhx_label", {for: e.id}, e.label), n.el(".dhx_input__wrapper", {role: "presentation"}, [n.el("input.dhx_input", {
                placeholder: e.placeholder,
                class: e.icon ? "dhx_input--icon-padding" : "",
                value: e.value,
                disabled: e.disabled,
                onblur: [r, i, e.id],
                onfocus: [s, i, e.id],
                dhx_id: e.id,
                _hooks: {
                    didInsert: function (t) {
                        i && i.fire(o.NavigationBarEvents.inputCreated, [e.id, t.el])
                    }
                },
                _key: e.id,
                "aria-label": e.label || e.helpMessage || "type " + (e.placeholder ? "text like " + e.placeholder : "text")
            }), e.icon ? n.el(".dhx_input__icon", {class: e.icon, "aria-hidden": "true"}) : null])])
        }
    }, function (t, e, i) {
        "use strict";
        var r = this && this.__assign || function () {
            return (r = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var s = i(0), a = i(22);
        e.menuItem = function (t, e, i) {
            var n, o = i ? " dhx_menu-button" : " dhx_nav-menu-button";
            return s.el("button", r({
                class: "dhx_button" + o + (t.disabled ? o + "--disabled" : "") + (t.active || t.$activeParent ? o + "--active" : ""),
                disabled: t.disabled,
                dhx_id: t.id,
                type: "button"
            }, (o = {
                role: "menuitem",
                "aria-disabled": (n = t).disabled ? "true" : "false"
            }, n.items && (o["aria-haspopup"] = "true"), o)), i ? [t.icon || t.value || t.html ? s.el("span.dhx_menu-button__block.dhx_menu-button__block--left", [t.icon && s.el("span.dhx_menu-button__icon", {class: t.icon}), t.html ? s.el("div.dhx_menu-button__text", {".innerHTML": t.html}) : t.value && s.el("span.dhx_menu-button__text", t.value)]) : null, 0 < t.count || t.hotkey || t.items ? s.el("span.dhx_menu-button__block.dhx_menu-button__block--right", [0 < t.count && a.getCount(t, " dhx_menu-button__count", !1), t.hotkey && s.el("span.dhx_menu-button__hotkey", t.hotkey), t.items && s.el("span.dhx_menu-button__caret.dxi.dxi-menu-right")]) : null] : [t.icon && s.el("span.dhx_menu-button__icon", {class: t.icon}), t.html ? s.el("div.dhx_menu-button__text", {".innerHTML": t.html}) : t.value && s.el("span.dhx_nav-menu-button__text", t.value)])
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), e.separator = function (t, e) {
            return null
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), e.spacer = function (t, e) {
            return null
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(0);
        e.title = function (t, e) {
            return n.el("span", {
                class: "dhx_navbar-title dhx_navbar-title--" + e,
                dhx_id: t.id,
                ".innerHTML": t.html,
                "aria-label": t.value || ""
            }, t.html ? null : t.value)
        }
    }, function (t, i, e) {
        "use strict";

        function n(t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }

        Object.defineProperty(i, "__esModule", {value: !0}), n(e(143)), n(e(144))
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        });
        Object.defineProperty(e, "__esModule", {value: !0});
        var r, s = i(2), a = i(17), l = i(21), o = (r = l.Navbar, o(c, r), c.prototype.showAt = function (t, e) {
            void 0 === e && (e = "bottom"), t instanceof MouseEvent ? this._changeActivePosition({
                left: window.pageXOffset + t.x + 1,
                right: window.pageXOffset + t.x + 1,
                top: window.pageYOffset + t.y,
                bottom: window.pageYOffset + t.y,
                zIndex: a.getZIndex(t.currentTarget)
            }, e) : (t = s.toNode(t), this._changeActivePosition(s.getRealPosition(t), e))
        }, c.prototype._getFactory = function () {
            return l.createFactory({
                widget: this,
                defaultType: "menuItem",
                allowedTypes: ["menuItem", "spacer", "separator", "customHTML", "customHTMLButton"],
                widgetName: "context-menu"
            })
        }, c.prototype._close = function (t) {
            var e = this;
            this.events.on(l.NavigationBarEvents.afterHide, function () {
                e._activeMenu = null, e._changeActivePosition(null, null)
            }), r.prototype._close.call(this, t)
        }, c.prototype._getMode = function (t, e, i) {
            return i ? this._mode : "right"
        }, c.prototype._changeActivePosition = function (t, e) {
            this._activePosition = t, this._mode = e, this._listenOuterClick(), this.paint()
        }, c);

        function c() {
            var t = null !== r && r.apply(this, arguments) || this;
            return t._isContextMenu = !0, t
        }

        e.ContextMenu = o
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        });
        Object.defineProperty(e, "__esModule", {value: !0});
        var r, s = i(0), a = i(21), o = (r = a.Navbar, o(l, r), l.prototype._getFactory = function () {
            return a.createFactory({
                widget: this,
                defaultType: "menuItem",
                allowedTypes: ["navItem", "menuItem", "spacer", "separator", "customHTML", "customHTMLButton"],
                widgetName: "menu-nav"
            })
        }, l.prototype._draw = function () {
            return s.el("ul.dhx_widget", {
                dhx_widget_id: this._uid,
                onmousemove: this._handlers.onmousemove,
                onmouseleave: this._handlers.onmouseleave,
                onclick: this._handlers.onclick,
                onmousedown: this._handlers.onmousedown,
                class: "dhx_menu-nav " + (this.config.css || "")
            }, this._drawMenuItems(this.data.getRoot(), !1))
        }, l);

        function l(t, e) {
            var i = r.call(this, t, e) || this;
            return i.mount(t, s.create({
                render: function () {
                    return i._draw()
                }
            })), i
        }

        e.Menu = o
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(3), i = (o.prototype.do = function () {
            var t = this.config.cell;
            this._index || (this._index = n.getCellIndex(t).col - 1), this._store.getPage(this.activeSheetName).addColumn(this._index, 1), this.config.spreadsheet.selection.setSelectedCell(t)
        }, o.prototype.undo = function () {
            this._store.getPage(this.activeSheetName).removeColumn(this._index, 1), this.config.grid.paint(), this.config.spreadsheet.selection.setSelectedCell(this.config.cell)
        }, o);

        function o(t) {
            this.config = t, this._store = t.dataStore, this.activeSheetName = t.spreadsheet.getActiveSheet().name
        }

        e.AddColumn = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(3), i = (o.prototype.do = function () {
            var t = this.config.cell;
            this._index || (this._index = n.getCellIndex(t).row), this._store.getPage(this._activeSheetName).addRow(this._index, 1), this.config.grid.paint(), this.config.spreadsheet.selection.setSelectedCell(t)
        }, o.prototype.undo = function () {
            this._store.getPage(this._activeSheetName).removeRow(this._index, 1), this.config.grid.paint(), this.config.spreadsheet.selection.setSelectedCell(this.config.cell)
        }, o);

        function o(t) {
            this.config = t, this._store = t.dataStore, this._activeSheetName = t.spreadsheet.getActiveSheet().name
        }

        e.AddRow = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(8), i = (o.prototype.do = function () {
            var t = this.config, e = t.sheets, i = t.val;
            e.find(function (t) {
                return t.value === i
            }) || (this._store.addPage(i), this._store.getPage(i).setMeta({
                focusedCell: {cell: "A1"},
                selectedCells: ["A1"]
            }), t = this.config.spreadsheet.getActiveSheet().id, t = e.getIndex(t), this._id = e.add({
                value: i,
                id: this._id || null
            }, t + 1), this.config.spreadsheet.events.fire(n.SpreadsheetEvents.afterSheetAdd, [{
                name: i,
                id: this._id
            }]), this.config.spreadsheet._changeSheet(this._id), this.config.grid.paint())
        }, o.prototype.undo = function () {
            this._store.removePage(this.config.val), this.config.sheets.remove(this._id), this.config.spreadsheet._changeSheet(this.config.prev)
        }, o);

        function o(t) {
            this.config = t, this._store = t.dataStore
        }

        e.AddSheet = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = i(3), i = (n.prototype.do = function () {
            var t = this.config.cell, e = o.getCellIds(t).col;
            this._col || (this._col = e);
            var i = this._store.getPage(this._activeSheetName), n = i.getSize()[0];
            this._cells = i.getCellRange(0, e, n - 1, e), i.removeColumn(this._col, 1), this.config.spreadsheet.selection.setSelectedCell(t), this.config.grid.paint()
        }, n.prototype.undo = function () {
            var t = this._store.getPage(this._activeSheetName);
            t.addColumn(this._col, 1);
            for (var e = 0; e < this._cells.length; e++) this._cells[e] && t.setCell(e, this._col, this._cells[e]);
            this.config.spreadsheet.selection.setSelectedCell(this.config.cell), this.config.grid.paint()
        }, n);

        function n(t) {
            this.config = t, this._store = t.dataStore, this._activeSheetName = t.spreadsheet.getActiveSheet().name
        }

        e.DeleteColumn = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = i(3), i = (n.prototype.do = function () {
            var t = this.config.cell, e = o.getCellIds(t).row;
            this._row || (this._row = e);
            var i = this._store.getPage(this._activeSheetName), n = i.getSize()[1];
            this._cells = i.getCellRange(e, 0, e, n - 1), i.removeRow(this._row, 1), this.config.spreadsheet.selection.setSelectedCell(t), this.config.grid.paint()
        }, n.prototype.undo = function () {
            var t = this._store.getPage(this._activeSheetName);
            t.addRow(this._row, 1);
            for (var e = 0; e < this._cells.length; e++) this._cells[e] && t.setCell(this._row, e, this._cells[e]);
            this.config.spreadsheet.selection.setSelectedCell(this.config.cell)
        }, n);

        function n(t) {
            this.config = t, this._store = t.dataStore, this._activeSheetName = t.spreadsheet.getActiveSheet().name
        }

        e.DeleteRow = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = (o.prototype.do = function () {
            var t = this.config, e = t.sheets, i = t.prev, n = t.spreadsheet, o = t.val, t = this._store.getPage(o);
            this._data = t ? t.serialize() : [], this._sheetMeta = t ? t.getMeta() : {}, this._store.removePage(o);
            t = this._index = e.getIndex(i);
            o === this.config.spreadsheet.getActiveSheet().name && n._changeSheet(e.getId(1 === t ? t + 1 : t - 1)), e.remove(i), this.config.grid.paint()
        }, o.prototype.undo = function () {
            var t = this.config, e = t.sheets, i = t.spreadsheet, n = t.prev, t = t.val;
            this._store.addPage(t), e.add({id: n, value: t}, this._index);
            var o = this._store.getPage(t);
            o.setMeta(this._sheetMeta), this._data.forEach(function (t) {
                var e = t[0], i = t[1], t = t[2];
                o.setCell(e, i, t)
            }), this._store.getStore().recalculate(!0, o.getContext()), i._changeSheet(n), this.config.grid.paint()
        }, o);

        function o(t) {
            this.config = t, this._store = t.dataStore
        }

        e.DeleteSheet = n
    }, function (t, e, i) {
        "use strict";
        var a = this && this.__assign || function () {
            return (a = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var l = i(3), c = i(28), i = (n.prototype.do = function () {
            var o, r, s = this;
            this.config.spreadsheet;
            this._actions.length || (o = this.config.val, r = 0, Array.isArray(o) && (o = o[r]), this.config.spreadsheet.eachCell(function (t) {
                var e = l.getCellIds(t), i = e.row, n = e.col, e = l.getCellIds(t),
                    t = new c.actions[s.config.action](a(a({}, s.config), {
                        row: i || e.row,
                        col: n || e.col,
                        cell: t,
                        val: o
                    }));
                s._actions.push(t), Array.isArray(s.config.val) && (r + 1 >= s.config.val.length ? r = 0 : r += 1, o = s.config.val[r])
            }, this.config.cell));
            for (var t = 0, e = this._actions; t < e.length; t++) e[t].do()
        }, n.prototype.undo = function () {
            for (var t = 0, e = this._actions; t < e.length; t++) e[t].undo();
            var i = this.config.cell.split(":")[0];
            this.config.spreadsheet.selection.setSelectedCell(i)
        }, n);

        function n(t) {
            this.config = t, this._actions = []
        }

        e.GroupAction = i
    }, function (t, e, i) {
        "use strict";
        var r = this && this.__assign || function () {
            return (r = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var s = i(3), a = i(28), i = (n.prototype.do = function () {
            var i, n, o = this;
            this._actions.length || (i = s.getCellIds(this.config.cell).start.row, n = this.config.cell.split(":")[0], this.config.spreadsheet.eachCell(function (t) {
                var e = s.getCellIds(t), t = e.row, e = e.col;
                t === i && (e = new a.actions[o.config.action](r(r({}, o.config), {
                    row: t,
                    col: e,
                    cell: n
                })), o._actions.push(e))
            }, this.config.cell));
            for (var t = this._actions.length - 1; 0 <= t; t--) this._actions[t].do()
        }, n.prototype.undo = function () {
            for (var t = 0; t < this._actions.length; t++) this._actions[t].undo()
        }, n);

        function n(t) {
            this.config = t, this._actions = []
        }

        e.GroupColAction = i
    }, function (t, e, i) {
        "use strict";
        var r = this && this.__assign || function () {
            return (r = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var s = i(3), a = i(28), i = (n.prototype.do = function () {
            var i, n, o = this;
            this._actions.length || (i = s.getCellIds(this.config.cell).start.col, n = this.config.cell.split(":")[0], this.config.spreadsheet.eachCell(function (t) {
                var e = s.getCellIds(t), t = e.row, e = e.col;
                e === i && (e = new a.actions[o.config.action](r(r({}, o.config), {
                    row: t,
                    col: e,
                    cell: n
                })), o._actions.push(e))
            }, this.config.cell));
            for (var t = this._actions.length - 1; 0 <= t; t--) this._actions[t].do()
        }, n.prototype.undo = function () {
            for (var t = this._actions.length - 1; 0 <= t; t--) this._actions[t].undo()
        }, n);

        function n(t) {
            this.config = t, this._actions = []
        }

        e.GroupRowAction = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = i(3), r = i(8), i = (n.prototype.do = function () {
            var t = this.config, e = t.val, i = t.cell, n = o.getCellIds(i), t = n.row, n = n.col;
            this._page.setCell(t, n, {locked: e}), e ? this.config.editLine.lock() : this.config.editLine.unlock(), this.config.spreadsheet.events.fire(r.SpreadsheetEvents.afterFocusSet, [i])
        }, n.prototype.undo = function () {
            var t = this.config, e = t.val, i = t.cell, n = o.getCellIds(i), t = n.row, n = n.col;
            this._page.setCell(t, n, {locked: !e}), this.config.spreadsheet.events.fire(r.SpreadsheetEvents.afterFocusSet, [i]), e ? this.config.editLine.unlock() : this.config.editLine.lock()
        }, n);

        function n(t) {
            this.config = t, this._store = t.dataStore, this._page = t.page
        }

        e.LockCell = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = i(3), r = i(8), i = (n.prototype.do = function () {
            var t = this.config.cell, e = o.getCellIds(t), i = e.row, n = e.col, e = o.getCellInfo(t, this._page);
            e.locked || (this.config.prev = e.css, this._page.setCell(i, n, {css: ""}), this.config.spreadsheet.events.fire(r.SpreadsheetEvents.afterSelectionSet, [t]), this.config.spreadsheet.events.fire(r.SpreadsheetEvents.afterStyleChange, [t]))
        }, n.prototype.undo = function () {
            var t = this.config.cell, e = o.getCellIds(t), i = e.row, e = e.col;
            o.getCellInfo(t, this._page).locked || (this._page.setCell(i, e, {css: this.config.prev}), this.config.spreadsheet.events.fire(r.SpreadsheetEvents.afterStyleChange, [t]))
        }, n);

        function n(t) {
            this.config = t, this._page = t.page
        }

        e.RemoveCellStyles = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = (o.prototype.do = function () {
            var t = this.config, e = t.sheets, i = t.dataStore, n = t.val, o = t.prev, r = e.getItem(o),
                t = this.config.spreadsheet.getActiveSheet().name;
            r.prevValue || e.update(r.id, {prevValue: r.value}), t === r.prevValue && (this.config.spreadsheet._activeSheetName = {
                name: n,
                id: r.id
            }), i.renamePage(r.prevValue, n), e.update(o, {
                value: n,
                prevValue: r.prevValue
            }), this.config.grid.paint(), this.config.spreadsheet.selection.setFocusedCell(this.config.spreadsheet.selection.getFocusedCell())
        }, o.prototype.undo = function () {
            var t = this.config, e = t.sheets, i = t.dataStore, n = t.val, o = t.prev, t = e.getItem(o);
            i.renamePage(n, t.prevValue), this.config.spreadsheet.getActiveSheet().name === n && (this.config.spreadsheet._activeSheetName = {
                name: n,
                id: t.id
            }), e.update(o, {
                value: t.prevValue,
                prevValue: t.prevValue
            }), this.config.grid.paint(), this.config.spreadsheet.selection.setFocusedCell(this.config.spreadsheet.selection.getFocusedCell())
        }, o);

        function o(t) {
            this.config = t, this.page = t.activePage
        }

        e.RenameSheet = n
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var s = i(16), a = i(3), l = i(8), i = (n.prototype.do = function () {
            var t = this.config.cell, e = this.config.val, i = a.getCellIds(t), n = i.row, o = i.col,
                r = s.getFormat(e), e = r && r.mask || e, i = a.getCellInfo(t, this._page);
            i.locked || this.config.spreadsheet.events.fire(l.SpreadsheetEvents.beforeFormatChange, [t, e]) && (this.config.prev = i.format, r = this.config.spreadsheet.getFormula(t), "@" !== i.format && "@" === e && this._page.setValue(n, o, "" + (r ? "=" + r : i.value || ""), 1), "@" === i.format && "@" !== e && this._page.setValue(n, o, r ? "=" + r : i.value, 0), this._page.setCell(n, o, {format: e || "General"}), this.config.spreadsheet.events.fire(l.SpreadsheetEvents.afterFormatChange, [t, e]), this.config.grid.paint())
        }, n.prototype.undo = function () {
            var t = this.config.val, e = this.config.prev;
            this.config.val = e, this.config.prev = t, this.do(), this.config.val = t, this.config.prev = e
        }, n);

        function n(t) {
            this.config = t, this._page = t.page
        }

        e.SetCellFormat = i
    }, function (t, e, i) {
        "use strict";
        var r = this && this.__assign || function () {
            return (r = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var s = i(3), a = i(8), i = (n.prototype.do = function () {
            var t, e = this.config.cell, i = s.getCellIds(e), n = i.row, o = i.col, i = s.getCellInfo(e, this._page);
            i.locked || (null === this.config.val && (this.config.val = ""), "string" != typeof this.config.val && (t = dhx.css.get(i.css) || {}, Array.isArray(this.config.val) && (this.config.val = this.config.val[0]), t = dhx.css.add(r(r({}, t), this.config.val)), this.config.val = t), t = this.config.val, this.config.spreadsheet.events.fire(a.SpreadsheetEvents.beforeStyleChange, [e, dhx.css.get(t)]) && (this.config.prev = i.css, this._page.setCell(n, o, {css: t}), this.config.spreadsheet.events.fire(a.SpreadsheetEvents.afterStyleChange, [this.config.cell, dhx.css.get(t)]), this.config.grid.paint()))
        }, n.prototype.undo = function () {
            var t = this.config.val, e = this.config.prev;
            this.config.val = e || "", this.config.prev = t || "", this.do(), this.config.val = t, this.config.prev = e
        }, n);

        function n(t) {
            this.config = t, this._page = t.page
        }

        e.SetCellStyle = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var s = i(16), a = i(3), l = i(8), i = (n.prototype.do = function () {
            var t = this.config.cell, e = a.getCellIds(t), i = e.row, n = e.col, o = this.config.val,
                r = this.config.spreadsheet;
            if (!r.isLocked(t) && r.events.fire(l.SpreadsheetEvents.beforeValueChange, [t, o])) {
                e = r.getFormula(t);
                this.config.prev = e ? "=" + e : r.getValue(t);
                e = a.getCellInfo(t, this._page).format;
                if (e || (e = "General", this._page.setCell(i, n, {format: e})), "string" == typeof o && o.startsWith("=") && "@" !== e) try {
                    this._page.setValue(+i, +n, o)
                } catch (t) {
                } else e.includes("%") && o.toString().endsWith("%") ? (t = s.getCleanValue(o), t = +(parseFloat(t) / 100).toFixed(4), this._page.setValue(+i, +n, t)) : "@" !== e ? (e = parseFloat(o), this._page.setValue(+i, +n, e == o ? e : o)) : this._page.setValue(+i, +n, o, 1);
                this._page.setCell(i, n, {
                    nextValue: void 0,
                    edited: !1
                }), this._page.setMeta({inserted: !0}), this.config.grid.paint(), r.events.fire(l.SpreadsheetEvents.afterValueChange, [this.config.cell, o])
            }
        }, n.prototype.undo = function () {
            var t = this.config.val, e = this.config.prev;
            this.config.val = e, this.config.prev = t, this.do(), this.config.val = t, this.config.prev = e
        }, n);

        function n(t) {
            this.config = t, this._page = t.page
        }

        e.SetCellValue = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(12);
        e.getContextMenuStruct = function () {
            return [{id: "lock", value: n.default.lockCell, icon: "dxi dxi-key"}, {
                id: "clear",
                value: n.default.clear,
                icon: "dxi dxi-eraser",
                items: [{id: "clear-value", value: n.default.clearValue}, {
                    id: "clear-styles",
                    value: n.default.clearStyles
                }, {id: "clear-all", value: n.default.clearAll}]
            }, {
                id: "columns",
                value: n.default.columns,
                icon: "dxi dxi-table-column",
                items: [{
                    id: "add-col",
                    value: n.default.addColumn,
                    icon: "dxi dxi-table-column-plus-before"
                }, {id: "remove-col", value: n.default.removeColumn, icon: "dxi dxi-table-column-remove"}]
            }, {
                id: "rows",
                value: n.default.rows,
                icon: "dxi dxi-table-row",
                items: [{
                    id: "add-row",
                    value: n.default.addRow,
                    icon: "dxi dxi-table-row-plus-before"
                }, {id: "remove-row", value: n.default.removeRow, icon: "dxi dxi-table-row-remove"}]
            }]
        }, e.getSheetsContextMenuStruct = function (t) {
            return [{
                id: "delete",
                value: n.default.deleteSheet,
                icon: "dxi dxi-delete-forever",
                disabled: !t
            }, {id: "rename", value: n.default.renameSheet, icon: "dxi dxi-pencil"}]
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(29), o = i(12);
        e.getMenuStruct = function (t) {
            return [{
                id: "file",
                open: !0,
                value: o.default.file,
                items: [{
                    id: "import",
                    value: o.default.importAs,
                    icon: "dxi dxi-file-import",
                    items: [{id: "import-xlsx", value: "Microsoft Excel(.xlsx)", icon: "dxi dxi-file-excel"}]
                }, {
                    id: "download",
                    value: o.default.downloadAs,
                    icon: "dxi dxi-file-export",
                    items: [{id: "export-xlsx", value: "Microsoft Excel(.xlsx)", icon: "dxi dxi-file-excel"}]
                }]
            }, {
                id: "edit",
                value: o.default.edit,
                items: [{id: "undo", value: o.default.undo, icon: "dxi dxi-undo"}, {
                    id: "redo",
                    value: o.default.redo,
                    icon: "dxi dxi-redo"
                }, {type: "separator"}, {
                    id: "lock",
                    value: o.default.lockCell,
                    icon: "dxi dxi-key"
                }, {type: "separator"}, {
                    id: "clear",
                    value: o.default.clear,
                    icon: "dxi dxi-eraser",
                    items: [{id: "clear-value", value: o.default.clearValue}, {
                        id: "clear-styles",
                        value: o.default.clearStyles
                    }, {id: "clear-all", value: o.default.clearAll}]
                }]
            }, {
                id: "insert",
                value: o.default.insert,
                items: [{
                    id: "columns",
                    value: o.default.columns,
                    icon: "dxi dxi-table-column",
                    items: [{
                        id: "add-col",
                        value: o.default.addColumn,
                        icon: "dxi dxi-table-column-plus-before"
                    }, {id: "remove-col", value: o.default.removeColumn, icon: "dxi dxi-table-column-remove"}]
                }, {
                    id: "rows",
                    value: o.default.rows,
                    icon: "dxi dxi-table-row",
                    items: [{
                        id: "add-row",
                        value: o.default.addRow,
                        icon: "dxi dxi-table-row-plus-before"
                    }, {id: "remove-row", value: o.default.removeRow, icon: "dxi dxi-table-row-remove"}]
                }]
            }, {
                id: "configuration",
                value: o.default.format,
                items: [{
                    id: "font-weight-bold",
                    value: o.default.bold,
                    icon: "dxi dxi-format-bold"
                }, {
                    id: "font-style-italic",
                    value: o.default.italic,
                    icon: "dxi dxi-format-italic"
                }, {
                    id: "text-decoration-underline",
                    value: o.default.underline,
                    icon: "dxi dxi-format-underline"
                }, {type: "separator"}, {
                    id: "align",
                    value: o.default.align,
                    items: [{
                        id: "align-left",
                        value: o.default.left,
                        icon: "dxi dxi-format-align-left"
                    }, {
                        id: "align-center",
                        value: o.default.center,
                        icon: "dxi dxi-format-align-center"
                    }, {id: "align-right", value: o.default.right, icon: "dxi dxi-format-align-right"}]
                }, {id: "format", type: "navItem", value: o.default.numberFormat, items: n.getFormatsDropdown(t)}]
            }, {id: "help", value: o.default.help}]
        }
    }, function (t, e, i) {
        "use strict";
        var n = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(29), s = i(12), o = {undo: "z", redo: "y", bold: "b", italic: "i", underline: "u"};

        function a(t) {
            return !navigator.platform.match(/(Mac)/i) ? "ctrl+" + o[t] : "âŒ˜+" + o[t]
        }

        e.getHotKey = a, e.getToolbarStruct = function (t, e) {
            var o = {
                undo: [{
                    id: "undo",
                    type: "navItem",
                    icon: "dxi dxi-undo",
                    tooltip: s.default.undo + " (" + a("undo") + ")"
                }, {
                    id: "redo",
                    type: "navItem",
                    icon: "dxi dxi-redo",
                    tooltip: s.default.redo + " (" + a("redo") + ")"
                }],
                colors: [{
                    id: "color",
                    css: "dhx_button-toolbar-colorPicker",
                    type: "HTMLButton",
                    html: r.getColorpickerTemplate("#4C4C4C", "format-color-text"),
                    tooltip: s.default.textColor
                }, {
                    id: "background",
                    css: "dhx_button-toolbar-colorPicker",
                    type: "HTMLButton",
                    html: r.getColorpickerTemplate("#FFF", "format-color-fill"),
                    tooltip: s.default.backgroundColor
                }],
                lock: [{id: "lock", type: "navItem", icon: "dxi dxi-key", tooltip: s.default.lockCell}],
                file: [{
                    id: "export",
                    type: "navItem",
                    icon: "dxi dxi-file-export",
                    tooltip: s.default.export,
                    items: [{id: "export-xlsx", value: "Microsoft Excel(.xlsx)", icon: "dxi dxi-file-excel"}]
                }, {
                    id: "import",
                    type: "navItem",
                    icon: "dxi dxi-file-import",
                    tooltip: s.default.import,
                    items: [{id: "import-xlsx", value: "Microsoft Excel(.xlsx)", icon: "dxi dxi-file-excel"}]
                }],
                columns: [{
                    id: "add-col",
                    type: "navItem",
                    icon: "dxi dxi-table-column-plus-before",
                    tooltip: s.default.addColumn
                }, {
                    id: "remove-col",
                    type: "navItem",
                    icon: "dxi dxi-table-column-remove",
                    tooltip: s.default.removeColumn
                }],
                rows: [{
                    id: "add-row",
                    type: "navItem",
                    icon: "dxi dxi-table-row-plus-before",
                    tooltip: s.default.addRow
                }, {id: "remove-row", type: "navItem", icon: "dxi dxi-table-row-remove", tooltip: s.default.removeRow}],
                clear: [{
                    type: "navItem",
                    icon: "dxi dxi-eraser",
                    id: "clear-group",
                    tooltip: s.default.clear,
                    items: [{id: "clear-value", value: s.default.clearValue}, {
                        id: "clear-styles",
                        value: s.default.clearStyles
                    }, {id: "clear-all", value: s.default.clearAll}]
                }],
                align: [{
                    id: "align-left",
                    type: "navItem",
                    icon: "dxi dxi-format-align-left",
                    tooltip: s.default.align + " " + s.default.left
                }, {
                    id: "align-center",
                    type: "navItem",
                    icon: "dxi dxi-format-align-center",
                    tooltip: s.default.align + " " + s.default.center
                }, {
                    id: "align-right",
                    type: "navItem",
                    icon: "dxi dxi-format-align-right",
                    tooltip: s.default.align + " " + s.default.right
                }],
                decoration: [{
                    id: "font-weight-bold",
                    type: "navItem",
                    icon: "dxi dxi-format-bold",
                    tooltip: s.default.bold + " (" + a("bold") + ")"
                }, {
                    id: "font-style-italic",
                    type: "navItem",
                    icon: "dxi dxi-format-italic",
                    tooltip: s.default.italic + " (" + a("italic") + ")"
                }, {
                    id: "text-decoration-underline",
                    type: "navItem",
                    icon: "dxi dxi-format-underline",
                    tooltip: s.default.underline + " (" + a("underline") + ")"
                }],
                help: [{id: "help", type: "navItem", icon: "dxi dxi-help-circle-outline", tooltip: s.default.help}],
                format: [{
                    id: "format",
                    type: "navItem",
                    tooltip: s.default.numberFormat,
                    css: "dhx_format-dropdown",
                    items: r.getFormatsDropdown(e)
                }]
            }, i = ["undo", "colors", "decoration", "align", "format", "help"];
            return -1 !== (e = (t = t || i).indexOf("default")) && t.splice.apply(t, n([e, 1], i)), (t = t.filter(function (t, e, i) {
                return i.indexOf(t) === e
            })).reduce(function (t, e, i, n) {
                return o[e] && (t.push.apply(t, o[e]), i !== n.length - 1 && t.push({type: "separator"})), t
            }, [])
        }
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        });
        Object.defineProperty(e, "__esModule", {value: !0});
        var r, s = i(0), a = i(6), u = i(8), l = i(3), d = i(23), c = i(164), h = i(1),
            o = (r = a.View, o(f, r), f.prototype._parse = function (t, e) {
                return void 0 === e && (e = this._activePage.getContext()), this._store.parse(t, e)
            }, f.prototype.navigate = function (t) {
                return "enter" === t && this._isMath && (this._presedEnter = !0), this._editMode && this._presedEnter ? (this.setCellMath(), !1) : this._suggest.navigate(t)
            }, f.prototype.setAtCursor = function (t, e, i, n) {
                i = this._value.substr(0, e) + t + this._value.substr(i);
                this._editMode ? this.setValue(i) : this.config.events.fire(u.SpreadsheetEvents.editLineInput, [i]), this._prevCursorPosition = e + n, this._input.setSelectionRange(e + n, e + n)
            }, f.prototype.focus = function () {
                this._input && this._input.focus()
            }, f.prototype.blur = function () {
                this._input && this._input.blur()
            }, f.prototype.lock = function () {
                this._locked = !0, this.paint()
            }, f.prototype.unlock = function () {
                this._locked = !1, this.paint()
            }, f.prototype.setValueAtRedactor = function (t) {
                var e = this._input && this._input.selectionStart;
                this.setAtCursor(t, e, e, t.length)
            }, f.prototype.setValue = function (t) {
                this.unlock(), this._setValue(t)
            }, f.prototype._setValue = function (t) {
                this._value = t, this._isMath = this._value && this._value.toString().startsWith("=") ? this._parse(this._value) : null, this._colored = this._parseColors(t), this._input && (this._input.value = t), this._presedEnter = !1, this._htmlEvents.onselectionchange(), this.paint()
            }, f.prototype.setCellMath = function () {
                var t, e, i;
                this._editMode && (this._removeStyles(), t = (i = l.getCellIds(this._editMode.cell)).row, e = i.col, i = this._editMode.page, this._editMode = null, i.setCell(t, e, {nextValue: this._value}), this.config.spreadsheet._changeSheet(i.getMeta().toolbarId), this.blur(), this._presedEnter = !1)
            }, f.prototype.getValue = function () {
                return this._value
            }, f.prototype.clean = function () {
                var t = this;
                setTimeout(function () {
                    t._setValue("")
                }, 1)
            }, f.prototype.destructor = function () {
                this._suggest.destructor()
            }, f.prototype.getInput = function () {
                return this._input
            }, f.prototype.setCursor = function (t) {
                this._input && this._input.setSelectionRange(t, t)
            }, f.prototype.isCellExpected = function (t, e, i) {
                if (!this._presedEnter) {
                    if (this._isMath && this._isEdit) {
                        var n = this._value, o = t.lastIndexOf(","),
                            r = i ? i.selectionStart : this._input ? this._input.selectionStart : this._value.length,
                            s = this._isMath.code;
                        -1 < o && (t = (12 === (i = this._parse(this._isMath.source.substr(0, r)).code.reverse())[2] ? i[5] : i[2]) !== d.T_OPERATOR ? t.substr(o) : t.substr(o + 1));
                        for (var a = 0; a < s.length; a += 3) {
                            var l = s[a + 1] + s[a + 2] == r, c = s[a] === d.T_SPACE ? s[a - 3] : s[a];
                            if (l && (c == d.T_OPERATOR && ")" !== n[s[a + 1]] || t.includes(","))) {
                                if (e) {
                                    l = this.config.spreadsheet.getActiveSheet().name;
                                    this._editMode && this._editMode.pageName !== l && (t = t.includes(",") ? ",'" + l + "'!" + t.substr(1) : "'" + l + "'!" + t);
                                    c = n.substr(0, r), l = c + t + n.substr(r);
                                    return this._editMode ? (this.setValue(l), this.setCursor(c.length + t.length)) : this.config.events.fire(u.SpreadsheetEvents.editLineInput, [l]), c.length + t.length
                                }
                                return r
                            }
                        }
                    }
                    return 0
                }
                this._presedEnter = !1
            }, f.prototype._render = function () {
                var e = this;
                return s.el(".dhx_edit_line", {}, [s.el(".input__wrapper", [s.el(".input_value", {
                    ".innerHTML": this._colored,
                    _ref: "input_wrapper"
                }), s.el("input.dhx_edit_line_input", {
                    _hooks: {
                        didInsert: function (t) {
                            e._input = t.el
                        }, didUnmount: function () {
                            document.removeEventListener("selectionchange", e._htmlEvents.onselectionchange)
                        }
                    },
                    oninput: this._htmlEvents.oninput,
                    onfocus: this._htmlEvents.onfocus,
                    onblur: this._htmlEvents.onblur,
                    onclick: this._htmlEvents.onclick,
                    value: this._value || "",
                    _ref: "input",
                    disabled: this._locked
                }), s.el(".input-animation")])])
            }, f.prototype._parseColors = function (o) {
                this._removeStyles();
                var r = 1, s = o;
                if (o && "=" === o[0]) {
                    for (var a = this._parse(o).code, s = "", l = 0, c = this, t = 0; t < a.length; t += 3) !function (t) {
                        switch (a[t]) {
                            case d.T_SPACE:
                                for (var e = 0; e < a[t + 2]; e++) s += "&nbsp;", l++;
                                break;
                            case d.T_ARG:
                            case d.T_RANGE:
                                var i = o.substr(a[t + 1], a[t + 2]), n = c._prevStyles.find(function (t) {
                                    return t && t.cell === i
                                });
                                r = 9 === r ? 1 : r, a[t + 1] > l && (s += o.substr(l, a[t + 1] - l)), l = a[t + 1] + a[t + 2], s += "<span class=text_range_" + (n ? n.styleNum : r) + ">" + i + "</span>", n || a[t - 3] === d.T_ERROR || (c._setStyles(i, r), c._prevStyles.push({
                                    cell: i,
                                    styleNum: r
                                }), ++r);
                                break;
                            case d.T_DATA:
                            case d.T_ERROR:
                                break;
                            case d.T_PAGE:
                                a[t + 3] !== d.T_ARG && a[t + 3] !== d.T_RANGE && a[t + 3] !== d.T_ERROR && (a[t + 1] !== l && (s += o.substr(l, a[t + 1] - l)), l = a[t + 1] + a[t + 2], s += o.substr(a[t + 1], a[t + 2]));
                                break;
                            default:
                                a[t + 1] > l && (s += o.substr(l, a[t + 1] - l)), l = a[t + 1] + a[t + 2], s += o.substr(a[t + 1], a[t + 2])
                        }
                    }(t);
                    l !== o.length && (s += o.substr(l, o.length - l))
                }
                return s
            }, f.prototype._setStyles = function (t, i) {
                t.includes("$") && (t = t.split("$").join("")), t.includes("!") || (t = (this._editMode ? this._editMode.pageName : this.config.spreadsheet.getActiveSheet().name) + "!" + t);
                var n = this.config.grid, e = this._parse(t).code;
                d.fromId(e[7])[2] === this._activePage.getID() && (t.includes("!") && (t = t.substr(t.indexOf("!") + 1)), -1 !== t.indexOf(":") ? this.config.spreadsheet.eachCell(function (t) {
                    var e = l.getCellIds(t), t = e.row, e = e.col;
                    n.addCellCss("" + (t + 1), "" + (e + 1), "range_" + i)
                }, t) : (t = (e = l.getCellIds(t)).row, e = e.col, n.addCellCss("" + (t + 1), "" + (e + 1), "range_" + i)))
            }, f.prototype._removeStyles = function () {
                for (var o = this, t = 0, e = this._prevStyles; t < e.length; t++) {
                    var i = function (i) {
                        if (!i) return {value: void 0};
                        var t, n = o.config.grid, e = i.cell;
                        e.includes("$") && (e = e.split("$").join("")), e.includes("!") && (e = e.substr(e.indexOf("!") + 1)), e.includes(":") ? o.config.spreadsheet.eachCell(function (t) {
                            var e = l.getCellIds(t), t = e.row, e = e.col;
                            n.removeCellCss("" + (t + 1), "" + (e + 1), "range_" + i.styleNum)
                        }, e) : (e = (t = l.getCellIds(e)).row, t = t.col, n.removeCellCss("" + (e + 1), "" + (t + 1), "range_" + i.styleNum))
                    }(e[t]);
                    if ("object" == typeof i) return i.value
                }
                this._prevStyles = []
            }, f);

        function f(t, e) {
            void 0 === e && (e = {});
            var o = r.call(this, t, e) || this;
            o._store = e.math, o._activePage = e.activePage, o._suggest = new c.default(function (t, e, i, n) {
                return o.setAtCursor(t, e, i, n)
            }), o._prevStyles = [], o._htmlEvents = {
                oninput: function (t) {
                    o._value = t.target.value, o._isMath = o._value && o._value.toString().startsWith("=") ? o._parse(o._value) : null, o._isMath && o._suggest.show(o._value, t.target, o._isMath), o._editMode ? o.setValue(o._value) : o.config.events.fire(u.SpreadsheetEvents.editLineInput, [t.target.value])
                }, onfocus: function (t) {
                    o._editMode || o.config.events.fire(u.SpreadsheetEvents.editLineFocus, [t.target.value, t])
                }, onblur: function (t) {
                    o._editMode ? o.focus() : o.config.events.fire(u.SpreadsheetEvents.editLineBlur, [t.target.value, t])
                }, onclick: function (t) {
                    var e = o._input.selectionStart;
                    e !== o._prevCursorPosition && o._isMath && (o._suggest.show(o._value, t.target, o._isMath), o._prevCursorPosition = e)
                }, onselectionchange: function () {
                    var t, e = o.getRootView(), i = e && e.refs && e.refs.input_wrapper, n = "0px";
                    o._isEdit && o._value && (t = o._input.selectionStart, e = h.getStringWidth(("" + o._value).substr(0, t)) + 12, t = o.getRootNode().offsetWidth, i && t < e && (n = t - e + "px")), i && (i.el.style.left = n, o.paint())
                }
            }, document.addEventListener("selectionchange", o._htmlEvents.onselectionchange), o.config.events.on(u.SpreadsheetEvents.cellInput, function (t, e) {
                o._setValue(e)
            }), o.config.events.on(u.SpreadsheetEvents.afterSheetChange, function () {
                o._activePage = o.config.spreadsheet._activePage;
                var t = o.config.spreadsheet._editMode, e = o._input && o._input.selectionStart;
                t ? (o._editMode = t, o._removeStyles(), o._setValue(o._value), o.focus(), o.setCursor(e), t.pageName === o.config.spreadsheet.getActiveSheet().name && (o._editMode = null)) : o._editMode = null
            }), o.config.events.on(u.SpreadsheetEvents.afterEditStart, function () {
                o._isEdit = !0
            }), o.config.events.on(u.SpreadsheetEvents.afterEditEnd, function () {
                o._isEdit = !1
            });
            return o.mount(t, s.create({
                render: function () {
                    return o._render()
                }
            })), o
        }

        e.EditLine = o
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(20), o = i(57), u = i(23), i = (r.prototype.isVisible = function () {
            return this._popup && this._popup.isVisible()
        }, r.prototype.hide = function () {
            this.isVisible() && this._popup.hide()
        }, r.prototype.destructor = function () {
            this._popup && this._popup.destructor()
        }, r.prototype.navigate = function (t) {
            if (!this.isVisible()) return !1;
            var e = this._list, i = e.data.getLength();
            if (!i) return !1;
            if ("arrowUp" === t || "arrowDown" === t) {
                var n = "arrowDown" === t ? 1 : -1, t = e.data.getIndex(e.getFocus());
                return void 0 === t && (t = -1 == n ? i : -1), this._list.setFocus(e.data.getId((t + n + i) % i)), !0
            }
            i = e.getFocusItem();
            return i || (e = this._list.data.getId(0), i = this._list.data.getItem(e)), this._insertSuggest(i.value), !0
        }, r.prototype.show = function (i, n, t, e) {
            for (var o = e || n.selectionStart, r = t.code, s = this._getPopup(), a = this, l = 0; l < r.length; l += 3) {
                var c = function (t) {
                    if (r[t] == u.T_NAME && o == r[t + 1] + r[t + 2]) {
                        var e = i.substr(r[t + 1], r[t + 2]).toUpperCase();
                        return a._list.data.filter(function (t) {
                            return t.value.startsWith(e)
                        }), a._list.data.getLength() ? (a._cursorStart = o, a._startTrim = r[t + 1], s.show(n, {centering: !1})) : s.hide(), {value: void 0}
                    }
                }(l);
                if ("object" == typeof c) return c.value
            }
            s.hide()
        }, r.prototype._insertSuggest = function (t) {
            this._suggestCallback(t + "()", this._startTrim, this._cursorStart, t.length + 1), this._popup.hide()
        }, r.prototype._getPopup = function () {
            var t, i = this;
            return this._popup || (t = Object.keys(u.methodGroups.number).concat(Object.keys(u.methodGroups.string)).map(function (t) {
                return {value: t}
            }), this._popup = new n.Popup({css: "dhx_suggest_list"}), this._list = new o.List(null), this._list.data.parse(t), this._list.events.on("Click", function (t) {
                var e = i._list.selection.getItem();
                i._insertSuggest(e.value), i._list.selection.remove(e.id)
            }), this._popup.attach(this._list)), this._popup
        }, r);

        function r(t) {
            this._suggestCallback = t
        }

        e.default = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var o = i(3);

        function r(t, e) {
            return '<div class="dhx_custom_header_cell">' + t + '\n\t<div class="dhx_resizer_grip_wrap">\n\t\t\t<div class="dhx_resizer_grip" dhx_id=' + e + '>\n\t\t\t\t<div class="dhx_resizer_grip_line"></div>\n\t\t\t</div>\n\t\t</div>\n\t</div>'
        }

        e.getHeaderCell = r, e.updateColumns = function (t) {
            var e = t.columns, n = 0;
            e.map(function (t, e) {
                var i;
                t.width = t.width || 120, n += t.hidden ? 0 : t.width, "$index" !== t.id && (i = o.getLetterFromNumber(e), t.header = [{
                    text: r(i, e),
                    css: ""
                }], t.$letter = i)
            }), t.$totalWidth = n
        }, e.updateRowsIndex = function (t) {
            t.map(function (t, e) {
                t.$index = e + 1
            })
        }, e.removeRowsCss = function (e) {
            e.data.map(function (t) {
                e.removeRowCss(t.id, "dhx_selected_row")
            })
        }
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var g = i(8), S = i(3), i = (n.prototype.store = function (t, e, i) {
            var n = this;
            void 0 === e && (e = null), void 0 === i && (i = null);
            var o = this._spreadsheet.selection.getFocusedCell(), e = S.getCellInfo(o, this._activePage),
                r = this._spreadsheet.selection.getSelectedCell();
            if (this._prevCopyPage && this._prevCopyPage.setMeta({inserted: !0}), !e.edited) {
                var i = S.isRangeId(r), s = [r];
                if (i && r.includes(",")) {
                    var a = (s = r.split(","))[s.length - 1];
                    if (r.includes(":")) if (a.includes(":")) {
                        for (var l = void 0, c = void 0, u = void 0, d = void 0, h = void 0, f = 0; f < s.length; f++) {
                            var p, g, _, v = s[f];
                            v.includes(":") && !l && (l = v, d = {
                                start: S.getCellIds(l.split(":")[0]),
                                end: S.getCellIds(l.split(":")[1])
                            }), f ? (v.includes(":") || c.includes(":") || (d.start.row === d.end.row || d.start.col === d.end.col ? (p = d.start.row === d.end.row ? "row" : "col", g = S.getCellIds(v)[p], d.start[p] === g[p] && u.push(v)) : (r = a, f = s.length, u = [r])), v.includes(":") && v !== l && (_ = S.getCellIds(v.split(":")[0]), g = S.getCellIds(v.split(":")[1]), p = _.row === d.start.row || _.row === d.end.row || _.col === d.start.col || _.col === d.end.col, g = g.row === d.start.row || g.row === d.end.row || g.col === d.start.col || g.col === d.end.col, g = p && g, _ = _.row === d.start.row ? "col" : "row", h = h || _, g && h === _ ? u.push(v) : (r = a, f = s.length, u = [r]))) : u = [v], c = v
                        }
                        1 < (s = u).length && (r = s.join())
                    } else s = [r = a]; else s = [r = a]
                }
                if (!S.isRangeId(r) || r.includes(":")) {
                    var m, y = [];
                    S.isRangeId(s[0]) && (e = S.getCellIds(s[0].split(":")[0]).row, x = S.getCellIds(s[0].split(":")[1]).row, i = s[1] && S.getCellIds(s[1].split(":")[0]).row, m = i && (i === e || i === x));
                    for (var b, x, w = 0, C = this, f = 0; f < s.length; f++) !function (t) {
                        var o, r = 0;
                        w = m ? 0 : w;
                        t = s[t];
                        C._spreadsheet.eachCell(function (t, e) {
                            var i, n;
                            e = e || " ", r ? (i = S.getCellIds(o), n = S.getCellIds(t), i.row === n.row ? y[w] ? y[w] += "\t" + e : y.push("" + e) : y[++w] ? y[w] += "\t" + e : y.push("" + e)) : y[w] ? y[w] += "\t" + e : y.push("" + e), o = t, r++
                        }, t), w++
                    }(f);
                    this._buffer.value = y.join("\n"), this._buffer.styles = this._spreadsheet.getStyle(r), S.isRangeId(r) ? (b = [], this._spreadsheet.eachCell(function (t) {
                        b.push(n._spreadsheet._getMath(t))
                    }, r), this._buffer.math = b) : (x = this._spreadsheet._getMath(r), this._buffer.math = [x]), this._buffer.cells = r, this._buffer.formats = this._spreadsheet.getFormat(r), this._buffer.cell = o, this._buffer.operation = t, this._activePage.setMeta({inserted: !1}), this._prevCopyPage = this._activePage, this._grid.paint()
                } else this._buffer.cell = null
            }
        }, n.prototype.paste = function () {
            var t, e, i, n, o, r, s, a, l, c, u, d, h, f, p = this;
            this._buffer.cell && (this._activePage.setMeta({inserted: !0}), r = this._buffer.cell, t = this._buffer.formats, e = r, u = !1, S.isRangeId(this._buffer.cells) && (u = !0, s = S.getRangeIndexes(this._buffer.cells), i = S.getCellIndex(r), n = s.end.row - s.start.row, s = s.end.col - s.start.col, s = S.getCellNameByIndex(i.row + n, i.col + s), S.isRangeId(r) ? (o = S.getCellsArray(this._buffer.cells).length, S.getCellsArray(r).length < o && (e = r.split(":")[0] + ":" + s)) : e += ":" + s), o = S.isRangeId(e), r = Array.isArray(this._buffer.styles) ? this._buffer.styles.map(function (t) {
                // return dhx.css.add(t)
                return true
            }) : dhx.css.add(this._buffer.styles), s = [], "cut" === this._buffer.operation && (s.push({
                cell: this._buffer.cells,
                action: g.Actions.setCellFormat,
                groupAction: o ? g.Actions.groupAction : null,
                val: "",
                page: this._activePage,
                dataStore: this._dataStore
            }, {
                cell: this._buffer.cells,
                action: g.Actions.setCellValue,
                val: "",
                page: this._activePage,
                groupAction: u ? g.Actions.groupAction : null,
                dataStore: this._dataStore
            }, {
                cell: this._buffer.cells,
                action: g.Actions.setCellStyle,
                val: "",
                page: this._activePage,
                groupAction: u ? g.Actions.groupAction : null,
                dataStore: this._dataStore
            }), this._buffer.operation = "copy"), a = u ? [].concat(this._buffer.value) : this._buffer.value, l = this._buffer.math, c = a.length, h = u ? (u = S.getRangeIndexes(this._buffer.cells), d = u.start, u.end.col - u.start.col + 1) : (d = S.getCellIndex(this._buffer.cells), 1), f = 0, this._spreadsheet.eachCell(function (t) {
                var e, i = f % c, n = a[i], o = l[i];
                o && (i = (i - (e = i % h)) / h, t = S.getCellIndex(t), n = "=" + p._math.transposeMath(o.source, t.row - d.row - i, t.col - d.col - e)), a[f] = n, f++
            }, e), s.push({
                cell: e,
                action: g.Actions.setCellFormat,
                groupAction: o ? g.Actions.groupAction : null,
                val: t,
                page: this._activePage,
                dataStore: this._dataStore
            }, {
                cell: e,
                action: g.Actions.setCellValue,
                val: a,
                page: this._activePage,
                groupAction: g.Actions.groupAction,
                dataStore: this._dataStore
            }, {
                cell: e,
                action: g.Actions.setCellStyle,
                val: r,
                page: this._activePage,
                groupAction: o ? g.Actions.groupAction : null,
                dataStore: this._dataStore
            }), this._callAction(s), this._spreadsheet.selection.setSelectedCell(e))
        }, n.prototype.getStruct = function () {
            return this._buffer
        }, n.prototype._setHandlers = function () {
            var t = this;
            this._spreadsheet.events.on(g.SpreadsheetEvents.afterSheetChange, function () {
                t._activePage = t._spreadsheet._activePage
            })
        }, n);

        function n(t, e, i, n, o) {
            this._spreadsheet = t, this._grid = e, this._activePage = n, this._math = o.getStore(), this._dataStore = o, this._callAction = i.bind(t), this._buffer = {
                value: "",
                math: [],
                styles: {},
                cell: "",
                cells: "",
                operation: "",
                inserted: !1,
                formats: []
            }, this._setHandlers()
        }

        e.BufferManager = i
    }, function (t, e, i) {
        "use strict";
        var n, o = this && this.__extends || (n = function (t, e) {
            return (n = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (t, e) {
                t.__proto__ = e
            } || function (t, e) {
                for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
            })(t, e)
        }, function (t, e) {
            function i() {
                this.constructor = t
            }

            n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
        });
        Object.defineProperty(e, "__esModule", {value: !0});
        var r, s = i(7), a = i(3), o = (r = s.CsvDriver, o(l, r), l.prototype.toJsonArray = function (t) {
            return r.prototype.toJsonArray.call(this, t).reduce(function (t, e, i) {
                for (var n in e) t.push({value: e[n], cell: a.getCellNameByIndex(i, parseFloat(n))});
                return t
            }, [])
        }, l);

        function l() {
            return null !== r && r.apply(this, arguments) || this
        }

        e.CustomCsvDriver = o
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(10), s = i(2);

        function a(t) {
            for (var e = t.toLowerCase().match(/\w+/g), i = 0, n = "", o = 0; o < e.length; o++) {
                var r = e[o];
                "ctrl" === r ? i += 4 : "shift" === r ? i += 2 : "alt" === r ? i += 1 : n = r
            }
            return i + n
        }

        var l = {
            Up: "arrowUp",
            Down: "arrowDown",
            Right: "arrowRight",
            Left: "arrowLeft",
            Esc: "escape",
            Spacebar: "space"
        }, i = (n.prototype.destructor = function () {
            document.removeEventListener("keydown", this._initHandler), this.removeHotKey()
        }, n.prototype.addHotKey = function (t, e) {
            t = a(t);
            this._keysStorage[t] || (this._keysStorage[t] = []), this._keysStorage[t].push({handler: e})
        }, n.prototype.removeHotKey = function (t, i) {
            var n, o, r = this;
            t ? t && i ? (n = a(t), o = function (t) {
                return t.toString().replace(/\n/g, "").replace(/\s/g, "")
            }, this._keysStorage[n].forEach(function (t, e) {
                o(t.handler) === o(i) && (delete r._keysStorage[n][e], r._keysStorage[n] = r._keysStorage[n].filter(function (t) {
                    return t
                }))
            })) : (t = a(t), delete this._keysStorage[t]) : this._keysStorage = {}
        }, n);

        function n(t) {
            var o = this;
            this._keysStorage = {}, this._initHandler = function (t) {
                var e;
                e = 48 <= t.which && t.which <= 57 || 65 <= t.which && t.which <= 90 ? String.fromCharCode(t.which) : (e = 32 === t.which ? t.code : t.key, s.isIE() && l[e] || e);
                var i = o._keysStorage[(t.ctrlKey || t.metaKey ? 4 : 0) + (t.shiftKey ? 2 : 0) + (t.altKey ? 1 : 0) + (e && e.toLowerCase())];
                if (i) for (var n = 0; n < i.length; n++) {
                    if (o._beforeCall && !1 === o._beforeCall(t, r.focusManager.getFocusId())) return;
                    i[n].handler(t)
                }
            }, t && (this._beforeCall = t), document.addEventListener("keydown", this._initHandler)
        }

        e.KeyManager = i
    }, function (t, e, i) {
        "use strict";
        var w = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var C = i(1), S = i(0), n = i(35), s = i(170), o = i(16), E = i(3), a = i(63), r = i(8),
            i = (l.prototype.setSelectedCell = function (t) {
                t && this._events.fire(r.SpreadsheetEvents.beforeSelectionSet, [t]) && (this._removeHeadersCss(), t = t.split(","), this._activePage.setMeta({selectedCells: t}), t = t[t.length - 1], E.isRangeId(t) && (t = t.split(":")[0]), this.setFocusedCell(t), this._setHeadersCss(), this._mousePressed ? this._grid.paint() : this._events.fire(r.SpreadsheetEvents.afterSelectionSet, [this.getSelectedCell()]))
            }, l.prototype.getSelectedCell = function () {
                var t = this._activePage.getMeta().selectedCells;
                if (t && t.length) return t.join(",")
            }, l.prototype.getFocusedCell = function () {
                var t = this._activePage.getMeta().focusedCell;
                if (t && t.cell) return t.cell
            }, l.prototype.setFocusedCell = function (t) {
                var e, i;
                t && (t = t.toUpperCase(), this._events.fire(r.SpreadsheetEvents.beforeFocusSet, [t]) && (e = (i = E.getCellIds(t)).row, i = i.col, this._activePage.setMeta({
                    focusedCell: {
                        row: e,
                        col: i,
                        cell: t,
                        edit: !1
                    }
                }), this._events.fire(r.SpreadsheetEvents.afterFocusSet, [t])))
            }, l.prototype._isInRange = function (t, e) {
                if (!e || !t || !e.includes(":")) return !1;
                var i = E.getCellIndex(t), n = i.row, o = i.col, t = E.getRangeIndexes(e), i = t.start, e = t.end,
                    t = function (t, e, i) {
                        return (t - e) * (t - i) <= 0
                    };
                return !(!i || !e) && (t(n, i.row, e.row) && t(o, i.col, e.col))
            }, l.prototype._removeHeadersCss = function () {
                var t, i = this;
                this.getSelectedCell() && (this._spreadsheet.eachCell(function (t) {
                    var e = E.getCellIndex(t), t = i._grid.data.getId(e.row);
                    void 0 !== t && i._grid.removeRowCss(t, "dhx_selected_row");
                    e = i._grid.config.columns[e.col];
                    void 0 !== e && (e.header[0].css = e.header[0].css.replace(" dhx_selected_header", ""))
                }), t = this._activePage.getMeta().focusedCell, this._grid.data.exists(t.row) && this._grid.removeRowCss(t.row, "dhx_selected_row"))
            }, l.prototype._setHeadersCss = function () {
                var i = this;
                this.getSelectedCell() && this._spreadsheet.eachCell(function (t) {
                    var e = E.getCellIndex(t), t = i._grid.data.getId(e.row);
                    void 0 !== t && i._grid.addRowCss(t, "dhx_selected_row");
                    e = i._grid.config.columns[e.col];
                    void 0 === e || e.header[0].css.includes("dhx_selected_header") || (e.header[0].css += " dhx_selected_header")
                })
            }, l.prototype._selectRow = function (t) {
                var e = this._grid.config.columns[1],
                    i = this._grid.config.columns[this._grid.config.columns.length - 1];
                this.setSelectedCell(E.getCellNameById(this._grid, t.id, e.id) + ":" + E.getCellNameById(this._grid, t.id, i.id))
            }, l.prototype._selectColumn = function (t) {
                var e = this._grid.data.getId(0), i = this._grid.data.getId(this._grid.data.getLength() - 1),
                    e = this._grid.data.getItem(e), i = this._grid.data.getItem(i);
                this.setSelectedCell(E.getCellNameById(this._grid, e.id, t.id) + ":" + E.getCellNameById(this._grid, i.id, t.id))
            }, l.prototype._setGroupSelectionHandlers = function () {
                var s = this;
                this._grid.events.on(n.GridEvents.cellMouseOver, function (t, e) {
                    var i, n, o, r;
                    E.getCellInfo(s.getFocusedCell(), s._activePage).edited || (i = (o = s._activePage.getMeta()).focusedCell, s._mousePressed && ("index" !== s._pressedArea && "$index" === e.id || ("header" !== s._pressedArea || "$index" === e.id ? (n = s._grid.config.columns[s._grid.config.columns.length - 1], t = E.getCellNameById(s._grid, t.id, ("index" === s._pressedArea ? n : e).id), n = i.cell, o = w(o.selectedCells), i.cell !== t && ("fillHandle" === s._pressedArea && (t = a.getLastCopyingCell(s._cellsToCopy, t), r = s._isInRange(t, s._cellsToCopy), t !== n && !r || (t = s._cellsToCopy.split(":")[1])), r = n + ":" + t, o[o.length - 1] = r, r = s.getFocusedCell(), s.setSelectedCell(o.join(",")), s.setFocusedCell(r))) : (r = s._grid.data.getId(s._grid.data.getLength() - 1), r = s._grid.data.getItem(r), s.setSelectedCell(i.cell + ":" + E.getCellNameById(s._grid, r.id, e.id))))))
                }), this._grid.events.on(n.GridEvents.headerCellMouseOver, function (t) {
                    var e, i;
                    "cell" !== s._pressedArea && s._mousePressed && "header" === s._pressedArea && "$index" !== t.id && (i = s._grid.data.getId(s._grid.data.getLength() - 1), e = s._grid.data.getItem(i), i = s._activePage.getMeta().focusedCell, s.setSelectedCell(i.cell + ":" + E.getCellNameById(s._grid, e.id, t.id.toString())))
                })
            }, l.prototype._setHandlers = function () {
                var d, i, b = this;
                S.awaitRedraw().then(function () {
                    d = b._grid.getRootView().node.el.getBoundingClientRect()
                });
                var x = function (t) {
                    i && clearTimeout(i);
                    var e = b._grid.getScrollState();
                    t.clientX > d.width + d.left - 50 && b._grid.scroll(e.x + 50, e.y), t.clientX < d.left + 50 && b._grid.scroll(e.x - 50, e.y), t.clientY > d.height + d.top - 50 && b._grid.scroll(e.x, e.y + 50), t.clientY < d.top + 50 && b._grid.scroll(e.x, e.y - 50), i = setTimeout(function () {
                        x(t)
                    }, 100)
                };
                document.addEventListener("mouseup", function () {
                    var t;
                    b._mousePressed && (b._mousePressed = !1, t = b.getSelectedCell(), "fillHandle" === b._pressedArea && (t !== b._cellsToCopy && b._events.fire(r.SpreadsheetEvents.groupFill, [b._cellsToCopy, t]), b._cellsToCopy = ""), b._pressedArea = null, document.removeEventListener("mousemove", x), i && clearTimeout(i), t && b._events.fire(r.SpreadsheetEvents.afterSelectionSet, [b.getSelectedCell()]), b._grid.paint())
                }), this._grid.events.on(n.GridEvents.cellMouseDown, function (t, e, i) {
                    b._mousePressed = !0, d = b._grid.getRootView().node.el.getBoundingClientRect(), document.addEventListener("mousemove", x);
                    var n = b._activePage.getMeta().selectedCells;
                    if ("$index" !== e.id) {
                        b._pressedArea = "cell";
                        var o = E.getCellNameById(b._grid, t.id, e.id), r = E.getCellInfo(o, b._activePage);
                        if (!(3 === i.which && b._isInRange(o, n[n.length - 1]) || r.edited)) {
                            var s = b.getFocusedCell();
                            if (!i.shiftKey || i.ctrlKey || i.metaKey) {
                                if (i.shiftKey && (i.ctrlKey || i.metaKey)) {
                                    n.length && n[n.length - 1] === s && n.pop();
                                    var a = b.getSelectedCell();
                                    b.setSelectedCell((a ? a + "," : "") + s + ":" + o)
                                } else if (!i.ctrlKey && !i.metaKey || i.shiftKey) b.setSelectedCell(o); else if (a = b.getSelectedCell()) {
                                    if (a && !E.getCellsArray(a).includes(o)) return b.setSelectedCell(a + "," + o);
                                    for (var l = a.split(","), c = 0; c < l.length; c++) {
                                        var u = l[c];
                                        E.isRangeId(u) || u !== o || b.setSelectedCell(l.filter(function (t) {
                                            return t !== o
                                        }).join(","))
                                    }
                                }
                            } else b.setSelectedCell(n[n.length - 1] + ":" + E.getCellNameById(b._grid, t.id, e.id))
                        }
                    } else (b._pressedArea = "index", i.shiftKey) ? (s = b.getSelectedCell(), a = [], E.isRangeId(s) && (a = s.split(":")), n = a[0] || s, e = E.getCellIds(a[1] || s), i = b._grid.config.columns, e = e.col === i[1].id, s = E.getCellIds(a[1] || s).col, s = E.getCellNameById(b._grid, t.id, e ? i[i.length - 1].id : s + 1), b.setSelectedCell(n + ":" + s)) : b._selectRow(t)
                }), this._grid.events.on(n.GridEvents.headerCellMouseDown, function (t, e) {
                    var i, n, o, r = e.target.getAttribute("dhx_id");
                    e.shiftKey ? (o = b.getSelectedCell(), i = [], E.isRangeId(o) && (i = o.split(":")), n = E.getCellIds(i[0] || o), n = E.getCellNameById(b._grid, b._grid.data.getId(0), n.col + 1), o = E.getCellIds(i[1] || o).row, o = E.getCellNameById(b._grid, o + 1, t.id), b.setSelectedCell(n + ":" + o)) : r ? "$index" !== r ? (b._resizedColumn = b._grid.config.columns[r].id, s.startResize(b._grid, b._resizedColumn, e, function () {
                        b._resizedColumn = null, b._grid.paint()
                    })) : (r = E.getCellNameByIndex(0, 1), e = E.getCellNameByIndex(b._grid.data.getLength() - 1, b._grid.config.columns.length - 1), b.setSelectedCell(r + ":" + e)) : (b._pressedArea = "header", b._selectColumn(t), b._mousePressed = !0)
                }), this._setGroupSelectionHandlers(), this._grid.events.on(n.GridEvents.cellDblClick, function (t, e, i) {
                    i.ctrlKey || i.metaKey ? b._grid.events.fire(n.GridEvents.cellClick, [t, e, i]) : "$index" !== e.id && b._spreadsheet.startEdit(E.getCellNameById(b._grid, t.id, e.id))
                }), this._grid.events.on(n.GridEvents.headerCellDblClick, function (t, e) {
                    var i, n;
                    e.target.getAttribute("dhx_id") && (e = b._activePage.getSize(), i = b._grid.config.columns.indexOf(t), i--, e = b._activePage.getRange(0, i, e[0], i), n = 40, e.forEach(function (t, e) {
                        t && (e = b._activePage.getCell(e, i), e = C.getStringWidth(o.getFormattedValue("" + t, e.format)), n < e && (n = e))
                    }), t.$width = n + 20, b._grid.setColumns(w(b._grid.config.columns)))
                }), this._spreadsheet.events.on(r.SpreadsheetEvents.afterSheetChange, function () {
                    b._removeHeadersCss(), b._activePage = b._spreadsheet._activePage;
                    var t = b._activePage.getMeta();
                    b.setSelectedCell(t.selectedCells ? t.selectedCells.join(",") : null), b.setFocusedCell(t.focusedCell ? t.focusedCell.cell : null)
                }), this._events.on(r.SpreadsheetEvents.gridRedraw, function (t) {
                    var e = b._activePage.getMeta(), f = e.selectedCells, i = e.focusedCell && e.focusedCell.cell;
                    if (f && i) {
                        var p = function (t) {
                                return {
                                    x: b._grid.config.columns.slice(0, t.col).reduce(function (t, e) {
                                        return t + e.$width
                                    }, 0) + 1,
                                    y: t.row * b._grid.config.rowHeight,
                                    width: b._grid.config.columns[t.col] ? b._grid.config.columns[t.col].$width - 1 : 0,
                                    height: b._grid.config.rowHeight - 1
                                }
                            }, g = function (t) {
                                var e = p(t.start), t = p(t.end);
                                return {x: e.x, y: e.y, width: t.x - e.x + t.width, height: t.y - e.y + t.height}
                            }, _ = b._spreadsheet.config.leftSplit, n = p(E.getCellIndex(f[f.length - 1])),
                            o = E.getCellIds(i), r = _ >= o.col + 1, s = 0, v = b._grid.getScrollState();
                        if (r) {
                            for (var a = 0; a < +o.col + 1; a++) s += b._grid.config.columns[a].$width;
                            s += v.x
                        }
                        var l, c = f.map(function (t) {
                            if (E.isRangeId(t)) {
                                var e = g(E.getRangeIndexes(t)), i = t.split(":")[1], n = t.split(":")[0],
                                    o = E.getCellIds(n), r = E.getCellIds(i), n = _ >= r.col + 1, i = _ >= o.col + 1,
                                    s = 0, a = 0;
                                if (i) {
                                    for (var l = 0; l < +o.col + 1; l++) a += b._grid.config.columns[l].$width;
                                    a += v.x
                                }
                                if (n || i) {
                                    var c = 0;
                                    if (i) for (l = +o.col + 1; l <= +_; l++) c += b._grid.config.columns[l].$width;
                                    var u = o.col > r.col;
                                    if (n && u) {
                                        c = 0;
                                        for (l = +r.col + 1; l <= +_; l++) c += b._grid.config.columns[l].$width;
                                        for (l = 0; l < +r.col + 1; l++) s += b._grid.config.columns[l].$width;
                                        s += v.x
                                    }
                                    return S.el(".dhx_group_selection", {
                                        style: {
                                            top: e.y,
                                            left: s || a,
                                            width: e.width - v.x,
                                            minWidth: o.col === r.col ? e.width : c,
                                            height: e.height,
                                            zIndex: 25
                                        }
                                    })
                                }
                                return S.el(".dhx_group_selection", {
                                    style: {
                                        top: e.y,
                                        left: e.x,
                                        width: e.width,
                                        height: e.height,
                                        zIndex: 10
                                    }
                                })
                            }
                            if (1 !== f.length) {
                                var d = E.getCellIds(t), h = 0, i = +_ >= +d.col;
                                if (i) {
                                    for (l = 0; l < d.col; l++) h += b._grid.config.columns[l].$width;
                                    h += v.x
                                }
                                n = p(E.getCellIndex(t)), u = n.x, e = n.y, t = n.width, n = n.height;
                                return S.el(".dhx_group_selection", {
                                    style: {
                                        width: t,
                                        height: n,
                                        top: e,
                                        left: i ? h : u,
                                        position: "absolute",
                                        pointerEvents: "none",
                                        zIndex: i ? 25 : 10
                                    }
                                })
                            }
                        }), i = S.el(".dhx_selected_cell", {
                            style: {
                                width: n.width,
                                height: n.height,
                                top: n.y,
                                left: r ? s : n.x,
                                position: "absolute",
                                pointerEvents: "none",
                                zIndex: r ? 25 : 10
                            }
                        }), n = [], r = b._bufferManager.getStruct();
                        r.cell && void 0 !== e.inserted && !e.inserted && (n = (r.cells.includes(",") ? r.cells.split(",") : [r.cells]).map(function (t) {
                            var e = E.getCellsArray(t), i = E.getCellIndex(e[0]), n = E.getCellIndex(e[e.length - 1]),
                                o = g({start: i, end: n}), r = E.getCellIds(e[0]), s = E.getCellIds(e[e.length - 1]),
                                t = r.col + 1 <= _, i = s.col + 1 <= _, n = t || i, e = r.col > s.col, a = 0, l = 0;
                            if (t) {
                                for (var c = 0; c < r.col + 1; c++) a += b._grid.config.columns[c].$width;
                                if (a += v.x, !i) for (c = r.col + 1; c <= _; c++) l += b._grid.config.columns[c].$width
                            }
                            if (i) if (e) {
                                for (c = a = 0; c < s.col + 1; c++) a += b._grid.config.columns[c].$width;
                                a += v.x;
                                for (c = s.col + 1; c <= _; c++) l += b._grid.config.columns[c].$width
                            } else for (c = r.col + 1; c <= s.col + 1; c++) l += b._grid.config.columns[c].$width;
                            return r.col === s.col && (l = b._grid.config.columns[r.col + 1].$width), S.el(".dhx_copy_selection", {
                                style: {
                                    top: o.y,
                                    left: n ? a : o.x,
                                    width: n ? o.width - v.x : o.width,
                                    minWidth: n ? l : o.width,
                                    height: o.height,
                                    zIndex: n ? 25 : 10
                                }
                            })
                        })), b._resizedColumn && (u = C.findIndex(b._grid.config.columns, function (t) {
                            return t.id === b._resizedColumn
                        }), l = p({
                            row: 0,
                            col: u
                        }), u = b._grid.config.$totalHeight, l = S.el(".resize_line", {
                            style: {
                                top: l.y,
                                left: l.x + l.width - 1.5,
                                height: u
                            }
                        }));
                        var u = f[f.length - 1];
                        E.isRangeId(u) && (u = (m = E.getRangeArray(u))[m.length - 1]);
                        var d, h = E.getCellIds(u).col + 1, m = b._spreadsheet.config.leftSplit >= h,
                            u = p(E.getCellIndex(u)), y = 0;
                        if (m) {
                            for (a = 0; a < +h; a++) y += b._grid.config.columns[a].$width;
                            y += b._grid.getScrollState().x
                        }
                        E.getCellInfo(b.getFocusedCell(), b._activePage).edited || (d = S.el(".dhx_selection_grip", {
                            dhx_id: "selection_grip",
                            style: {
                                position: "absolute",
                                left: (m ? y : u.x) + u.width - 6,
                                top: u.y + u.height - 6,
                                zIndex: m ? 25 : 10
                            },
                            onmousedown: function () {
                                b._mousePressed = !0, document.addEventListener("mousemove", x), b._pressedArea = "fillHandle";
                                var t = b.getSelectedCell().split(",");
                                b.setSelectedCell(t[t.length - 1]), b._cellsToCopy = b.getSelectedCell()
                            }
                        })), t.refs.selection.patch(S.el(".dhx_grid_selection", w(n, [i], c, [l, d])))
                    }
                })
            }, l);

        function l(t, e, i, n) {
            this._spreadsheet = t, this._grid = e, this._bufferManager = i, this._events = t.events, this._activePage = n, this._setHandlers()
        }

        e.Selection = i
    }, function (t, e, i) {
        "use strict";
        var l = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var c = i(1);
        e.startResize = function (n, o, t, e) {
            function i(t) {
                var e = c.findIndex(n.config.columns, function (t) {
                    return t.id === o
                });
                s = s || n.config.columns[e].$width;
                var i = t.clientX - r, t = l(n.config.columns), i = s + i;
                t[e].$width = i <= 20 ? 20 : i, n.setColumns(t), n.paint()
            }

            var r = t.clientX, s = 0, a = function () {
                document.removeEventListener("mousemove", i), document.removeEventListener("mouseup", a), e()
            };
            document.addEventListener("mousemove", i), document.addEventListener("mouseup", a), n.paint()
        }
    }, function (t, e, i) {
        "use strict";
        var h = this && this.__assign || function () {
            return (h = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        }, a = this && this.__spreadArrays || function () {
            for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
            for (var n = Array(t), o = 0, e = 0; e < i; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, o++) n[o] = r[s];
            return n
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var f = i(1), n = i(16), p = i(3), i = (o.prototype.xlsx = function () {
            var o = this;
            if (!p.isWasmSupported()) throw new Error("WebAssembly is not supported by your browser");
            var u = [{id: ""}], t = this._spreadsheet.serialize(), d = n.getDefaultFormats(), r = [],
                s = this._grid.config.columns.map(function (t) {
                    return {width: t.width}
                }).splice(1);
            t.sheets.forEach(function (t) {
                for (var e = o._spreadsheet._dataStore.getPage(t.name).getSize(), i = [], c = [], n = 0; n < e[1]; n++) i.push(null);
                for (n = 0; n < e[0]; n++) c.push(a(i));
                t.data.forEach(function (e) {
                    var i, n, t = null, o = p.getCellIds(e.cell), r = o.row, s = o.col, a = d.find(function (t) {
                        return t.id === e.format
                    }), o = a ? a.mask : "", a = e.css || "", l = o + a;
                    -1 === (t = f.findIndex(u, function (t) {
                        return t.id === l
                    })) && (i = {
                        "text-align": "align",
                        "font-size": "fontSize",
                        "font-weight": "fontWeight",
                        "font-style": "fontStyle",
                        "text-decoration": "textDecoration"
                    }, n = dhx.css.get(a) || {}, a = Object.keys(n).reduce(function (t, e) {
                        return t[i[e] || e] = n[e], t
                    }, {}), u.push(h(h({format: o}, a), {id: l})), t = u.length - 1);
                    t = {v: e.value ? "" + e.value : "", s: t};
                    c[r][s] = t
                }), r.push({name: t.name, cells: c, cols: s})
            });
            var e = {data: r, styles: u}, t = this._spreadsheet.config.exportModulePath;
            this._getXlsxWorker(t).postMessage({type: "convert", data: e})
        }, o.prototype._getXlsxWorker = function (t) {
            return this._xlsxWorker || (t = window.URL.createObjectURL(new Blob(["importScripts('" + t + "');"], {type: "text/javascript"})), this._xlsxWorker = new Worker(t), this._xlsxWorker.addEventListener("message", function (t) {
                var e;
                "ready" === t.data.type && ((e = document.createElement("a")).href = URL.createObjectURL(t.data.blob), e.download = "data.xlsx", document.body.appendChild(e), e.click(), document.body.removeChild(e))
            })), this._xlsxWorker
        }, o);

        function o(t, e) {
            this._spreadsheet = t, this._grid = e
        }

        e.Exporter = i
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var r = i(3), i = (n.prototype.toJsonArray = function (t) {
            var e = [], o = [], n = {};
            return t.styles.forEach(function (i, t) {
                var e = ["background", "color", "textAlign", "textDecoration", "fontWeight", "fontStyle"].reduce(function (t, e) {
                    return i[e] && (t[e] = i[e]), t
                }, {});
                o.push(i.format), n["imported_class" + t] = e
            }), t.data.forEach(function (t) {
                var n = [];
                t.cells.forEach(function (t, i) {
                    t.forEach(function (t, e) {
                        t && (t = {
                            cell: r.getCellNameByIndex(i, e + 1),
                            value: t.v,
                            css: ["imported_class" + t.s],
                            format: o[t.s]
                        }, n.push(t))
                    })
                }), e.push({name: t.name, data: n})
            }), {sheets: e, styles: n}
        }, n);

        function n() {
        }

        e.XlsxDriver = i
    }, function (t, o, r) {
        "use strict";
        (function (i) {
            Object.defineProperty(o, "__esModule", {value: !0});
            var n = r(3), t = (e.prototype.load = function (t) {
                var n = this;
                return new i(function (i) {
                    n._getFile(t).then(function (t) {
                        var e = n._spreadsheet.config.importModulePath, e = n._getXlsxWorker(e);
                        e.postMessage({type: "convert", data: t, formulas: !0}), e.onmessage = function (t) {
                            "ready" === t.data.type && i(t.data)
                        }
                    })
                })
            }, e.prototype._getXlsxWorker = function (t) {
                return this._xlsxWorker || (t = window.URL.createObjectURL(new Blob(["importScripts('" + t + "');"], {type: "text/javascript"})), this._xlsxWorker = new Worker(t)), this._xlsxWorker
            }, e.prototype._getFile = function (e) {
                return new i(function (i) {
                    if (e) return n.fetchFile(e, "GET", "arraybuffer").then(function (t) {
                        i(t)
                    });
                    var t = document.createElement("input");
                    t.type = "file", t.accept = ".xlsx", t.click(), t.addEventListener("change", function (t) {
                        var e = new FileReader;
                        e.onload = function () {
                            var t = e.result, t = new Uint8Array(t);
                            i(t)
                        }, e.readAsArrayBuffer(t.target.files[0])
                    })
                })
            }, e);

            function e(t) {
                this._spreadsheet = t
            }

            o.XlsxProxy = t
        }).call(this, r(9))
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0});
        var n = i(23);
        e.Store = n.Store, e.initMathStore = function (t) {
            var e = new n.DataStore;
            return t.forEach(function (t) {
                return e.addPage(t.value)
            }), e
        }
    }, function (t, i, e) {
        "use strict";
        Object.defineProperty(i, "__esModule", {value: !0}), function (t) {
            for (var e in t) i.hasOwnProperty(e) || (i[e] = t[e])
        }(e(176))
    }, function (t, p, g) {
        "use strict";
        (function (t) {
            Object.defineProperty(p, "__esModule", {value: !0});
            var l = g(1), e = g(0), n = g(5), o = g(19), c = g(10), r = g(25), s = g(62), f = g(64), u = g(177),
                a = g(21);

            function d(r) {
                return new t(function (e) {
                    var i = function () {
                        document.removeEventListener("mousemove", o), document.removeEventListener("mouseup", i), e(!1)
                    }, n = setTimeout(function () {
                        i()
                    }, 1e3), o = function (t) {
                        (4 < Math.abs(t.pageX - r.pageX) || 4 < Math.abs(t.pageY - r.pageY)) && (document.removeEventListener("mousemove", o), document.removeEventListener("mouseup", i), clearTimeout(n), e({
                            x: r.pageX,
                            y: r.pageY
                        }))
                    };
                    document.addEventListener("mousemove", o), document.addEventListener("mouseup", i)
                })
            }

            var i = (h.prototype.paint = function () {
                this._layout.paint()
            }, h.prototype.isFullScreen = function () {
                return this._fullScreen
            }, h.prototype.setFullScreen = function () {
                this._fullScreen || (this._fullScreen = !0, this.setSize(window.innerWidth, window.innerHeight), this.setPosition(window.pageXOffset, window.pageYOffset))
            }, h.prototype.unsetFullScreen = function () {
                this._fullScreen && (this._fullScreen = !1, this.setSize(this._oldSizes.width, this._oldSizes.height), this.setPosition(this._oldPosition.left, this._oldPosition.top))
            }, h.prototype.setSize = function (t, e) {
                this._oldSizes = {width: this._popup.offsetWidth, height: this._popup.offsetHeight};
                var i = {width: this._oldSizes.width, height: this._oldSizes.height};
                l.isDefined(t) && (this.config.width = i.width = t), l.isDefined(e) && (this.config.height = i.height = e), this._popup.style.width = i.width + "px", this._popup.style.height = i.height + "px", this.events.fire(f.WindowEvents.resize, [i, this._oldSizes, {
                    left: !0,
                    top: !0,
                    bottom: !0,
                    right: !0
                }])
            }, h.prototype.getSize = function () {
                return {width: this._popup.offsetWidth, height: this._popup.offsetHeight}
            }, h.prototype.setPosition = function (t, e) {
                this._oldPosition = {left: this._popup.offsetLeft, top: this._popup.offsetTop};
                var i = {left: this._oldPosition.left, top: this._oldPosition.top};
                l.isDefined(t) && (this.config.left = i.left = t), l.isDefined(e) && (this.config.top = i.top = e), this._popup.style.left = i.left + "px", this._popup.style.top = i.top + "px", this.events.fire(f.WindowEvents.resize, [i, this._oldPosition, {
                    left: !0,
                    top: !0,
                    bottom: !0,
                    right: !0
                }])
            }, h.prototype.getPosition = function () {
                return {left: this._popup.offsetLeft, top: this._popup.offsetTop}
            }, h.prototype.show = function (t, e) {
                if (void 0 === t && (t = this.config.left), void 0 === e && (e = this.config.top), this.events.fire(f.WindowEvents.beforeShow, [{
                    left: t,
                    top: e
                }])) {
                    this.isVisible() && this.hide(), u.default.setActive(this._uid), this._popup.className += " dhx_popup dhx_widget" + (this.config.modal ? " dhx_popup--window_modal" : " dhx_popup--window") + (this.config.css ? " " + this.config.css : ""), this._popup.style.position = this.config.modal ? "fixed" : "absolute", this._popup.setAttribute("dhx_widget_id", this._uid);
                    var i = this._getContainerParams(), n = i.containerInnerWidth, o = i.containerInnerHeight,
                        r = i.containerXOffset, s = i.containerYOffset,
                        a = this.config.width = this.config.width || this.config.minWidth || n / 2,
                        i = this.config.height = this.config.height || this.config.minHeight || o / 2;
                    if (this.config.left = t = l.isDefined(t) ? t : (n - a) / (this.config.modal ? 2 : 2 + r), this.config.top = e = l.isDefined(e) ? e : (o - i) / (this.config.modal ? 2 : 2 + s), this._isActive) return this._popup.style.left = t + "px", void (this._popup.style.top = e + "px");
                    this.config.viewportOverflow && u.default.openFreeWindow(this.config.node), this.config.modal && this._blockScreen(), this._popup.style.width = a + "px", this._popup.style.height = i + "px", this._popup.style.left = t + "px", this._popup.style.top = e + "px", this.config.node.appendChild(this._popup), this._popup.focus(), this._isActive = !0, this.events.fire(f.WindowEvents.afterShow, [{
                        left: t,
                        top: e
                    }]), c.focusManager.setFocusId(this._uid)
                }
            }, h.prototype.hide = function () {
                this._hide()
            }, h.prototype._hide = function (t) {
                this._isActive && this.events.fire(f.WindowEvents.beforeHide, [{
                    left: this.config.left,
                    top: this.config.top
                }, t]) && (this.config.viewportOverflow && u.default.closeFreeWindow(this.config.node), this._blocker && (this.config.node.removeChild(this._blocker), this.config.closable && this._keyManager.removeHotKey(null, this), this._blocker = null), this.config.node.removeChild(this._popup), this._isActive = !1, this.events.fire(f.WindowEvents.afterHide, [{
                    left: this.config.left,
                    top: this.config.top
                }, t]))
            }, h.prototype.isVisible = function () {
                return this._isActive
            }, h.prototype.getWidget = function () {
                return this._layout.getCell("content").getWidget()
            }, h.prototype.getContainer = function () {
                return this.getRootView().data._container
            }, h.prototype.attach = function (t, e) {
                this._layout.getCell("content").attach(t, e)
            }, h.prototype.attachHTML = function (t) {
                this._layout.getCell("content").attach(function () {
                    return e.el(".dhx_window__inner-html-content", {".innerHTML": t})
                })
            }, h.prototype.getRootView = function () {
                return this._layout.getRootView()
            }, h.prototype.destructor = function () {
                this._isActive && this.hide(), this.header && this.header.destructor(), this.footer && this.footer.destructor(), this.events && this.events.clear(), this._keyManager && this._keyManager.destructor(), this._layout && this._layout.destructor(), this.config = this.header = this.footer = this.events = null, this._popup = this._uid = this._handlers = this._isActive = this._keyManager = this._fullScreen = this._oldSizes = this._oldPosition = null
            }, h.prototype.fullScreen = function () {
                this.setFullScreen()
            }, h.prototype._initHandlers = function () {
                var i = this;
                this._handlers = {
                    headerDblClick: function (t) {
                        return i.events.fire(f.WindowEvents.headerDoubleClick, [t])
                    }, move: function (t) {
                        3 !== t.which && (t.preventDefault(), u.default.setActive(i._uid), d(t).then(function (t) {
                            t && i._startDrag(t.x, t.y)
                        }))
                    }, resize: {
                        ".dhx_window-resizer": function (e) {
                            3 !== e.which && (e.preventDefault(), u.default.setActive(i._uid), d(e).then(function (t) {
                                t && ((t = e.target.classList).contains("dhx_window-resizer--left") ? i._startResize({left: !0}) : t.contains("dhx_window-resizer--right") ? i._startResize({right: !0}) : t.contains("dhx_window-resizer--top") ? i._startResize({top: !0}) : t.contains("dhx_window-resizer--bottom") ? i._startResize({bottom: !0}) : t.contains("dhx_window-resizer--bottom_left") ? i._startResize({
                                    left: !0,
                                    bottom: !0
                                }) : t.contains("dhx_window-resizer--bottom_right") ? i._startResize({
                                    bottom: !0,
                                    right: !0
                                }) : t.contains("dhx_window-resizer--top_left") ? i._startResize({
                                    top: !0,
                                    left: !0
                                }) : t.contains("dhx_window-resizer--top_right") && i._startResize({
                                    top: !0,
                                    right: !0
                                }))
                            }))
                        }
                    }, setActive: function () {
                        u.default.setActive(i._uid)
                    }
                }
            }, h.prototype._initUI = function () {
                var i = this, t = [],
                    e = (this.config.header || this.config.title || this.config.closable || this.config.movable) && !1 !== this.config.header;
                e && t.push({
                    id: "header",
                    height: "content",
                    css: "dhx_window-header " + (this.config.movable ? "dhx_window-header--movable" : ""),
                    on: {mousedown: this.config.movable && this._handlers.move, dblclick: this._handlers.headerDblClick}
                }), t.push({
                    id: "content",
                    css: e ? "dhx_window-content" : "dhx_window-content-without-header"
                }), this.config.footer && t.push({
                    id: "footer",
                    height: "content",
                    css: "dhx_window-footer"
                }), this.config.resizable && t.push({id: "resizers", height: "content", css: "resizers"});
                var n, t = this._layout = new r.Layout(this._popup, {
                    css: "dhx_window" + (this.config.modal ? " dhx_window--modal" : ""),
                    rows: t,
                    on: {click: this._handlers.setActive},
                    id: this._uid
                });
                e && (n = this.header = new s.Toolbar, this.config.title && (this.header.data.add({
                    type: "title",
                    value: this.config.title,
                    id: "title",
                    css: "title_max"
                }), this._popup.setAttribute("aria-label", this.config.title)), this.config.closable && (this.header.data.add({type: "spacer"}), this.header.data.add({
                    id: "close",
                    type: "button",
                    view: "link",
                    size: "medium",
                    color: "secondary",
                    circle: !0,
                    icon: "dxi dxi-close"
                }), n.events.on(a.NavigationBarEvents.click, function (t, e) {
                    "close" === t && i._hide(e)
                })), t.getCell("header").attach(n)), this.config.footer && (n = this.footer = new s.Toolbar, t.getCell("footer").attach(n)), this.config.resizable && t.getCell("resizers").attach(function () {
                    return i._drawResizers()
                })
            }, h.prototype._drawResizers = function () {
                return e.el(".dhx-resizers", {onmousedown: this._handlers.resize}, [e.el(".dhx_window-resizer.dhx_window-resizer--left", {_ref: "left"}), e.el(".dhx_window-resizer.dhx_window-resizer--right", {_ref: "right"}), e.el(".dhx_window-resizer.dhx_window-resizer--bottom", {_ref: "bottom"}), e.el(".dhx_window-resizer.dhx_window-resizer--top", {_ref: "top"}), e.el(".dhx_window-resizer.dhx_window-resizer--bottom_right", {_ref: "bottomRight"}), e.el(".dhx_window-resizer.dhx_window-resizer--bottom_left", {_ref: "bottomLeft"}), e.el(".dhx_window-resizer.dhx_window-resizer--top_right", {_ref: "topRight"}), e.el(".dhx_window-resizer.dhx_window-resizer--top_left", {_ref: "topLeft"})])
            }, h.prototype._startDrag = function (t, e) {
                var a = this;
                this.config.node.classList.add("dhx_window--stop_selection");

                function i(t) {
                    var e, i, n, o = {left: a._popup.offsetLeft, top: a._popup.offsetTop}, r = t.pageX - l,
                        s = t.pageY - c;
                    a.config.viewportOverflow || (e = (n = a._getContainerParams()).containerXOffset, i = n.containerYOffset, t = n.containerInnerWidth, n = n.containerInnerHeight, r < e ? r = e : e + t - u < r && (r = e + t - u), s < i ? s = i : i + n - d < s && (s = i + n - d)), a.config.left = r, a.config.top = s, a._popup.style.left = r + "px", a._popup.style.top = s + "px", s = {
                        left: r,
                        top: s
                    }, a.events.fire(f.WindowEvents.move, [s, o, {left: !0, top: !0, bottom: !0, right: !0}])
                }

                var l = t - this._popup.offsetLeft, c = e - this._popup.offsetTop, u = this._popup.offsetWidth,
                    d = this._popup.offsetHeight, n = function () {
                        document.removeEventListener("mouseup", n), document.removeEventListener("mousemove", i), a.config.node.classList.remove("dhx_window--stop_selection")
                    };
                document.addEventListener("mouseup", n), document.addEventListener("mousemove", i)
            }, h.prototype._startResize = function (r) {
                var t, e, s = this, a = 100 | this.config.minWidth, l = 100 | this.config.minHeight,
                    c = this._popup.offsetLeft, u = this._popup.offsetTop, d = this._popup.offsetWidth,
                    h = this._popup.offsetHeight, i = this.getRootView().refs;
                switch (!0) {
                    case r.bottom && r.left:
                        e = "dhx_window-body-pointer--bottom_left", t = i.bottomLeft;
                        break;
                    case r.bottom && r.right:
                        e = "dhx_window-body-pointer--bottom_right", t = i.bottomLeft;
                        break;
                    case r.top && r.left:
                        e = "dhx_window-body-pointer--top_left", t = i.bottomLeft;
                        break;
                    case r.top && r.right:
                        e = "dhx_window-body-pointer--top-right", t = i.right;
                        break;
                    case r.top:
                        e = "dhx_window-body-pointer--top", t = i.bottomLeft;
                        break;
                    case r.bottom:
                        e = "dhx_window-body-pointer--bottom", t = i.bottomLeft;
                        break;
                    case r.left:
                        e = "dhx_window-body-pointer--left", t = i.bottomLeft;
                        break;
                    case r.right:
                        e = "dhx_window-body-pointer--right", t = i.right
                }
                t.el.classList.add("dhx_window-resizer--active"), this.config.node.classList.add("dhx_window--stop_selection"), this.config.node.classList.add(e);

                function n(t) {
                    var e = (o = s._getContainerParams()).containerInnerWidth, i = o.containerInnerHeight,
                        n = o.containerXOffset, o = o.containerYOffset, t = {
                            width: s._notInNode() ? t.pageX - c : t.pageX - s.config.node.offsetLeft - c,
                            height: s._notInNode() ? t.pageY - u : t.pageY - s.config.node.offsetTop - u,
                            left: s._notInNode() ? t.pageX : t.pageX - s.config.node.offsetLeft,
                            top: s._notInNode() ? t.pageY : t.pageY - s.config.node.offsetTop
                        };
                    r.right && (t.width < a ? t.width = a : t.width > n + e - c && (t.width = n + e - c), s._popup.style.width = t.width + "px"), r.bottom && (t.height < l ? t.height = l : t.height > o + i - u && (t.height = o + i - u), s._popup.style.height = t.height + "px"), r.left && (c + d - t.left < a && (t.left = c + d - a), t.width = c + d - t.left, s.config.left = t.left, s._popup.style.left = t.left + "px", s._popup.style.width = t.width + "px"), r.top && (t.top < o ? t.top = o : u + h - t.top < l && (t.top = u + h - l), t.height = u + h - t.top, s.config.top = t.top, s._popup.style.top = t.top + "px", s._popup.style.height = t.height + "px"), s.config.width = s._popup.offsetWidth, s.config.height = s._popup.offsetHeight, s.events.fire(f.WindowEvents.resize, [t, {
                        left: c,
                        top: u,
                        height: h,
                        width: d
                    }, r])
                }

                var o = function () {
                    document.removeEventListener("mouseup", o), document.removeEventListener("mousemove", n), s.config.node.classList.remove("dhx_window--stop_selection"), s.config.node.classList.remove(e), t.el.classList.remove("dhx_window-resizer--active")
                };
                document.addEventListener("mouseup", o), document.addEventListener("mousemove", n)
            }, h.prototype._blockScreen = function () {
                var n = this, t = document.createElement("div");
                t.className = "dhx_window__overlay", this.config.node.appendChild(t), this._blocker = t, this.config.closable && (t.addEventListener("click", function (t) {
                    return n._hide(t)
                }), this._keyManager.addHotKey("escape", function (t) {
                    var e = Array.prototype.slice.call(document.querySelectorAll(".dhx_popup--window_modal")),
                        i = Array.prototype.slice.call(document.querySelectorAll(".dhx_popup--window")),
                        i = e.concat(i);
                    1 !== i.length ? (i.sort(function (t, e) {
                        return +window.getComputedStyle(e).zIndex - +window.getComputedStyle(t).zIndex
                    }), i[i.length - 1] === n._popup && n._hide(t)) : n._hide(t)
                }))
            }, h.prototype._notInNode = function () {
                return this.config.node === document.body || this.config.modal
            }, h.prototype._getContainerParams = function () {
                var t = this._notInNode();
                return {
                    containerInnerWidth: t ? window.innerWidth : this.config.node.offsetWidth,
                    containerInnerHeight: t ? window.innerHeight : this.config.node.offsetHeight,
                    containerXOffset: t ? window.pageXOffset : this.config.node.scrollLeft,
                    containerYOffset: t ? window.pageYOffset : this.config.node.scrollTop
                }
            }, h);

            function h(t) {
                var i = this;
                this.config = l.extend({
                    movable: !1,
                    resizable: !1,
                    closable: t.modal
                }, t), this.config.node && "string" == typeof this.config.node ? this.config.node = document.getElementById(this.config.node) : this.config.node || (this.config.node = document.body), this._uid = l.uid(), this.events = new n.EventSystem(this);
                t = this._popup = document.createElement("div");
                t.tabIndex = 1, t.setAttribute("role", "dialog"), t.setAttribute("aria-modal", "" + (this.config.modal || !1)), this.config.modal || u.default.add(this._uid, this._popup), this._fullScreen = !1, this._isActive = !1, this._keyManager = new o.KeyManager(function (t, e) {
                    return e === i._uid
                }), this._initHandlers(), this._initUI(), this.config.html && this.attachHTML(this.config.html)
            }

            p.Window = i
        }).call(this, g(9))
    }, function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {value: !0}), e.default = {
            popups: {},
            lastActive: null,
            freeCount: 0,
            add: function (t, e) {
                this.lastActive && this.popups[this.lastActive].classList.remove("dhx_popup--window_active"), this.lastActive = t, e.classList.add("dhx_popup--window_active"), this.popups[t] = e
            },
            setActive: function (t) {
                var e;
                t === this.lastActive || (e = this.popups[t]) && (this.lastActive && this.popups[this.lastActive].classList.remove("dhx_popup--window_active"), this.lastActive = t, e.classList.add("dhx_popup--window_active"))
            },
            openFreeWindow: function (t) {
                0 === this.freeCount && t.classList.add("dhx_window--no-scroll"), this.freeCount++
            },
            closeFreeWindow: function (t) {
                this.freeCount--, 0 === this.freeCount && t.classList.remove("dhx_window--no-scroll")
            }
        }
    }, function (t, e, i) {
        "use strict";
        var c = this && this.__assign || function () {
            return (c = Object.assign || function (t) {
                for (var e, i = 1, n = arguments.length; i < n; i++) for (var o in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        Object.defineProperty(e, "__esModule", {value: !0});
        var u = i(8), d = i(3), h = i(29), f = i(10);

        function p(t) {
            if (!(t.ctrlKey || t.altKey || t.metaKey)) {
                t = t.which || t.keyCode;
                return 65 <= t && t <= 90 || 48 <= t && t <= 57 || 96 <= t && t <= 105 || !!{
                    32: " ",
                    106: "*",
                    107: "+",
                    109: "-",
                    110: ".",
                    111: "/",
                    186: ";",
                    187: "=",
                    188: ",",
                    189: "-",
                    190: ".",
                    191: "/",
                    192: "`",
                    219: "[",
                    220: "\\",
                    221: "]",
                    222: "'"
                }[t] || !1
            }
        }

        function g(o) {
            var t = o.selection.getSelectedCell(), t = d.isRangeId(t) ? d.getRangeMatrix(t) : [[t]];
            return '\n\t\x3c!--StartFragment--\x3e\n\t\t<table id="customers">\n\t\t\t<tbody style="box-sizing: inherit;">\n\t\t\t\t' + t.reduce(function (t, e) {
                return t + '<tr style="box-sizing: inherit;">' + e.reduce(function (t, e) {
                    var i = o.getValue(e) || " ", n = o.getStyle(e) || {};
                    return t + ' <th style="' + Object.keys(n).reduce(function (t, e) {
                        return "" + t + e + ":" + n[e] + ";"
                    }, "") + '">\n\t\t\t' + i + "</th>"
                }, "") + "</tr>"
            }, "") + "\n\t\t\t</tbody>\n\t\t</table>\n\t\x3c!--EndFragment--\x3e"
        }

        function l(t, e) {
            return "row" === e ? {min: 0, max: t.data.getLength() - 1} : {min: 1, max: t.config.columns.length - 1}
        }

        function _(t, e, i, n, o, r) {
            var s;
            d.getCellInfo(t.selection.getFocusedCell(), n).edited || (s = d.getCellIndex(t.selection.getFocusedCell()), n = l(e, r), (i = o ? s[r] + o : i) >= n.min && i <= n.max && (s[r] = i), s = d.getCellNameByIndex(s.row, s.col), t.selection.setSelectedCell(s), s = d.getCellIds(s), e.scrollTo("" + (s.row + 1), "" + (s.col + 1)))
        }

        function v(t, e, i, n, o) {
            var r, s, a = t.selection.getFocusedCell();
            d.getCellInfo(a, o).edited || (r = d.getCellIndex(a), r = (o = t.selection.getSelectedCell().split(",")[0]).includes(":") ? (o = d.getRangeIndexes(o)).end[n] > r[n] ? (s = c({}, o.end), o.start) : (s = c({}, o.start), o.end) : (s = c({}, r), r), e = l(e, n), s[n] + i >= e.min && s[n] + i <= e.max && (s[n] += i, (s = d.getCellNameByIndex(s.row, s.col)) !== (r = d.getCellNameByIndex(r.row, r.col)) ? (t.selection.setSelectedCell(s + ":" + r), t.selection.setFocusedCell(a)) : t.selection.setSelectedCell(s)))
        }

        e.isPrintableKey = p, e.getHtmlData = g, e.getKeysHandlers = function (o, r, s, a) {
            var l, n;

            function i(t) {
                var e = s.getStruct(), i = o.selection.getSelectedCell(), n = d.getCellIndex(i),
                    n = d.getCellNameByIndex(n.row + t.rowsCount - 1, n.col + t.colsCount - 1),
                    i = d.isRangeId(i) ? i : i + ":" + n;
                e.cells = i, t.styles ? e.styles = t.styles : e.styles = o.getStyle(i), n = e.value, e.value = t.values, e.cell = i, s.paste(), e.value = n
            }

            o.events.on(u.SpreadsheetEvents.afterEditStart, function (t) {
                l = t
            }), o.events.on(u.SpreadsheetEvents.afterEditEnd, function () {
                l = null
            }), o.events.on(u.SpreadsheetEvents.afterSheetChange, function () {
                return n = o._activePage
            }), document.addEventListener("keydown", function (t) {
                var e;
                !p(t) || f.focusManager.getFocusId() !== o._uid && f.focusManager.getFocusId() !== r._uid || (e = o.selection.getFocusedCell()) && e !== l && (t.preventDefault(), o.startEdit(e, t.key))
            });
            var t = {};
            return window.clipboardData ? t = {
                "ctrl+c": function () {
                    l || (s.store("copy"), window.clipboardData && (window.clipboardData.setData("text/html", g(o)), window.clipboardData.setData("text/plain", s.getStruct().value), window.preventDefault()))
                }, "ctrl+x": function () {
                    l || (s.store("cut"), window.clipboardData && (window.clipboardData.setData("text/html", g(o)), window.clipboardData.setData("text/plain", s.getStruct().value), window.preventDefault()))
                }, "ctrl+v": function () {
                    var t;
                    l || window.clipboardData && (t = window.clipboardData.getData("text"), i(t))
                }
            } : (document.addEventListener("cut", function (t) {
                l || f.focusManager.getFocusId() !== o._uid && f.focusManager.getFocusId() !== r._uid || (s.store("cut"), t.clipboardData.setData("text/html", g(o)), t.clipboardData.setData("text/plain", s.getStruct().value), t.preventDefault())
            }), document.addEventListener("copy", function (t) {
                l || f.focusManager.getFocusId() !== o._uid && f.focusManager.getFocusId() !== r._uid || (s.store("copy"), t.clipboardData.setData("text/html", g(o)), t.clipboardData.setData("text/plain", s.getStruct().value), t.preventDefault())
            }), document.addEventListener("paste", function (t) {
                var e;
                l || f.focusManager.getFocusId() !== o._uid && f.focusManager.getFocusId() !== r._uid || (t.preventDefault(), e = t.clipboardData.getData("text/html"), t = d.parseFromText(t.clipboardData.getData("text")), e && e.includes("<table") && (t = d.parseHtmlTable(e)), i(t))
            })), c(c({}, t), {
                escape: function () {
                    var t = o.selection.getSelectedCell(), t = d.getCellInfo(t, n);
                    s.getStruct().inserted = !0, t.edited && (o.endEdit(!0), r.paint())
                }, delete: function () {
                    var t;
                    l || ((t = o.selection.getSelectedCell()) && o.setValue(t, ""), r.paint())
                }, enter: function () {
                    var t = o.selection.getSelectedCell(), e = o.selection.getFocusedCell(), i = o._editMode;
                    if (!a.navigate("enter")) if (l || i && i.cell) {
                        var n = d.getCellIndex(l || i.cell);
                        n.row = n.row + 1 === r.data.getLength() ? n.row : n.row + 1, o.selection.setSelectedCell(d.getCellNameByIndex(n.row, n.col)), l = "", d.isRangeId(t) && !i && (o.selection.setSelectedCell(t), o.selection.setFocusedCell(d.getNextRangeCell(t, e, "col")))
                    } else {
                        if (d.isRangeId(t)) return o.endEdit(), o.selection.setSelectedCell(t), void o.selection.setFocusedCell(d.getNextRangeCell(t, e, "col"));
                        o.startEdit(t)
                    }
                }, f2: function () {
                    o.startEdit(o.selection.getSelectedCell())
                }, pageUp: function (t) {
                    t.preventDefault();
                    t = r.getRootView().refs.grid_body;
                    t.el.scrollTop -= t.el.clientHeight
                }, pageDown: function (t) {
                    t.preventDefault();
                    t = r.getRootView().refs.grid_body;
                    t.el.scrollTop += t.el.clientHeight - r.config.rowHeight
                }, "ctrl+a": function (t) {
                    var e;
                    l || (t.preventDefault(), e = d.getCellNameByIndex(0, 1), t = d.getCellNameByIndex(r.data.getLength() - 1, r.config.columns.length - 1), o.selection.setSelectedCell(e + ":" + t))
                }, "shift+arrowLeft": function () {
                    v(o, r, -1, "col", n)
                }, "shift+arrowRight": function () {
                    v(o, r, 1, "col", n)
                }, "shift+arrowDown": function () {
                    v(o, r, 1, "row", n)
                }, "shift+arrowUp": function () {
                    v(o, r, -1, "row", n)
                }, "ctrl+enter": function () {
                    o.endEdit()
                }, "shift+enter": function () {
                    var t = o.selection.getSelectedCell();
                    if (d.isRangeId(t)) {
                        var e = o.selection.getFocusedCell();
                        return o.endEdit(), o.selection.setSelectedCell(t), void o.selection.setFocusedCell(d.getPrevRangeCell(t, e, "col"))
                    }
                    _(o, r, null, n, -1, "row")
                }, tab: function (t) {
                    t.preventDefault();
                    var e = o.selection.getSelectedCell();
                    if (d.isRangeId(e)) {
                        t = o.selection.getFocusedCell();
                        return o.endEdit(), o.selection.setSelectedCell(e), void o.selection.setFocusedCell(d.getNextRangeCell(e, t))
                    }
                    _(o, r, null, n, 1, "col")
                }, "shift+tab": function (t) {
                    t.preventDefault();
                    var e = o.selection.getSelectedCell();
                    if (d.isRangeId(e)) {
                        t = o.selection.getFocusedCell();
                        return o.endEdit(), o.selection.setSelectedCell(e), void o.selection.setFocusedCell(d.getPrevRangeCell(e, t))
                    }
                    _(o, r, null, n, -1, "col")
                }, arrowLeft: function (t) {
                    l || (t.preventDefault(), _(o, r, null, n, -1, "col"))
                }, arrowRight: function (t) {
                    l || (t.preventDefault(), _(o, r, null, n, 1, "col"))
                }, arrowDown: function (t) {
                    t.preventDefault(), a.navigate("arrowDown") || l || _(o, r, null, n, 1, "row")
                }, arrowUp: function (t) {
                    t.preventDefault(), a.navigate("arrowUp") || l || _(o, r, null, n, -1, "row")
                }, "ctrl+arrowLeft": function () {
                    _(o, r, 1, n, null, "col")
                }, "ctrl+arrowRight": function () {
                    _(o, r, r.config.columns.length - 1, n, null, "col")
                }, "ctrl+arrowDown": function () {
                    _(o, r, r.data.getLength() - 1, n, null, "row")
                }, "ctrl+arrowUp": function () {
                    _(o, r, 0, n, null, "row")
                }, home: function (t) {
                    l || (t.preventDefault(), _(o, r, 1, n, null, "col"))
                }, end: function (t) {
                    l || (t.preventDefault(), _(o, r, r.config.columns.length - 1, n, null, "col"))
                }, "ctrl+home": function () {
                    _(o, r, 0, n, null, "row"), _(o, r, 1, n, null, "col")
                }, "ctrl+end": function () {
                    _(o, r, r.data.getLength() - 1, n, null, "row"), _(o, r, r.config.columns.length - 1, n, null, "col")
                }, "ctrl+z": function (t) {
                    var e = o.selection.getFocusedCell(), i = d.getCellInfo(e, n);
                    e && i.edited || t.preventDefault(), o.undo()
                }, "ctrl+y": function (t) {
                    t.preventDefault(), o.redo()
                }, "ctrl+shift+z": function () {
                    o.redo()
                }, "ctrl+b": function () {
                    var t = o.selection.getSelectedCell(), t = h.getToggledValue(n, t, "font-weight", "bold");
                    o.setStyle(o.selection.getSelectedCell(), {"font-weight": t})
                }, "ctrl+i": function () {
                    var t = o.selection.getSelectedCell(), t = h.getToggledValue(n, t, "font-style", "italic");
                    o.setStyle(o.selection.getSelectedCell(), {"font-style": t})
                }, "ctrl+u": function (t) {
                    t.preventDefault();
                    t = o.selection.getSelectedCell(), t = h.getToggledValue(n, t, "text-decoration", "underline");
                    o.setStyle(o.selection.getSelectedCell(), {"text-decoration": t})
                }, backspace: function () {
                    l || o.setValue(o.selection.getSelectedCell(), "")
                }
            })
        }
    }], o.c = n, o.d = function (t, e, i) {
        o.o(t, e) || Object.defineProperty(t, e, {enumerable: !0, get: i})
    }, o.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(t, "__esModule", {value: !0})
    }, o.t = function (e, t) {
        if (1 & t && (e = o(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var i = Object.create(null);
        if (o.r(i), Object.defineProperty(i, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for (var n in e) o.d(i, n, function (t) {
            return e[t]
        }.bind(null, n));
        return i
    }, o.n = function (t) {
        var e = t && t.__esModule ? function () {
            return t.default
        } : function () {
            return t
        };
        return o.d(e, "a", e), e
    }, o.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, o.p = "/codebase/", o(o.s = 65);

    function o(t) {
        if (n[t]) return n[t].exports;
        var e = n[t] = {i: t, l: !1, exports: {}};
        return i[t].call(e.exports, e, e.exports, o), e.l = !0, e.exports
    }

    var i, n
}), window.dhx_legacy) {
    if (window.dhx) for (var key in dhx) dhx_legacy[key] = dhx[key];
    window.dhx = dhx_legacy, delete window.dhx_legacy
}
//# sourceMappingURL=spreadsheet.js.map